import"reflect-metadata";import e,{createGlobalStyle as t,keyframes as a,css as o,styled as n}from"styled-components";export{ServerStyleSheet}from"styled-components";import{setConfiguration as i,Hidden as l,Visible as r,Col as s,Row as d}from"react-grid-system";import c,{createContext as u,useState as p,useEffect as m,useContext as f,useMemo as g,useRef as h,useCallback as b,Fragment as x}from"react";import v from"axios";import{container as y,scoped as k,Lifecycle as w,inject as C,injectable as D}from"tsyringe";import S from"qs";import T from"react-datepicker";import{CountryDropdown as _}from"react-country-region-selector";import z from"react-phone-number-input";import E from"clsx";import{createPortal as N}from"react-dom";import M from"html-react-parser";import{Element as $}from"domhandler";import B from"react-slick";import{useSpring as A,animated as L}from"react-spring";import I from"@rooks/use-visibility-sensor";import F from"react-countdown";import{toPng as G}from"html-to-image";function P(e,t){var a={};for(var o in e)Object.prototype.hasOwnProperty.call(e,o)&&t.indexOf(o)<0&&(a[o]=e[o]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(o=Object.getOwnPropertySymbols(e);n<o.length;n++)t.indexOf(o[n])<0&&Object.prototype.propertyIsEnumerable.call(e,o[n])&&(a[o[n]]=e[o[n]])}return a}function O(e,t,a,o){var n,i=arguments.length,l=i<3?t:null===o?o=Object.getOwnPropertyDescriptor(t,a):o;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)l=Reflect.decorate(e,t,a,o);else for(var r=e.length-1;r>=0;r--)(n=e[r])&&(l=(i<3?n(l):i>3?n(t,a,l):n(t,a))||l);return i>3&&l&&Object.defineProperty(t,a,l),l}function j(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)}function R(e,t,a,o){return new(a||(a=Promise))((function(n,i){function l(e){try{s(o.next(e))}catch(e){i(e)}}function r(e){try{s(o.throw(e))}catch(e){i(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof a?t:new a((function(e){e(t)}))).then(l,r)}s((o=o.apply(e,t||[])).next())}))}function q(e){var t="function"==typeof Symbol&&Symbol.iterator,a=t&&e[t],o=0;if(a)return a.call(e);if(e&&"number"==typeof e.length)return{next:function(){return e&&o>=e.length&&(e=void 0),{value:e&&e[o++],done:!e}}};throw new TypeError(t?"Object is not iterable.":"Symbol.iterator is not defined.")}function H(e){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var t,a=e[Symbol.asyncIterator];return a?a.call(e):(e=q(e),t={},o("next"),o("throw"),o("return"),t[Symbol.asyncIterator]=function(){return this},t);function o(a){t[a]=e[a]&&function(t){return new Promise((function(o,n){(function(e,t,a,o){Promise.resolve(o).then((function(t){e({value:t,done:a})}),t)})(o,n,(t=e[a](t)).done,t.value)}))}}}"function"==typeof SuppressedError&&SuppressedError;const U=t`
  @font-face {
    font-family: 'ModeloRegular';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/6cdb925a-8882-4990-b29a-4ac8b838150b/modelo-regular.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'ModeloBlack';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/af04eee6-7440-40e6-9085-5f1e793b97ec/modelo-black.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'ModeloThin';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/b4718d54-8ce0-410f-ab26-b2017f98e25d/modelo-thin.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'ModeloLight';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/3c832d00-8683-4b86-ad93-5181a1db1b2a/modelo-light.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'ModeloBold';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/326a9e64-f3ec-461c-ab6c-4b041390fba9/modelo-bold.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'RyhmesTextRegular';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/8bd448f1-01e4-4236-b3c7-166f603aff6a/ryhmestext-regular.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'RyhmesTextBold';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/a813efd8-d33d-44ad-9565-9bd8d4acca86/ryhmestext-bold.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'RyhmesTextBold';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/a813efd8-d33d-44ad-9565-9bd8d4acca86/ryhmestext-bold.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'RyhmesTextLight';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/fc9f79b7-6f4d-42c9-b005-8c9723c511ca/ryhmestext-light.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'RyhmesTextSemiBold';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/356b979a-5643-4667-a439-bebf709366c1/ryhmestext-semibold.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'RyhmesTextThin';
    src: url('https://www.nnormal.com/cms/api/assets/tiers-banners-homes/f04ab0df-70e4-4323-a557-1bd48f53b44b/ryhmestext-thin.otf?version=0') format('opentype');
    font-weight: normal;
    font-style: normal;
  }

`,W={language:"es",country:"ES",urlBase:"https://www.nnormal.com",accessToken:"",showUnpublishedContent:!1,isPreview:!1,bearer:"",notificationadFolder:""};class Q{constructor(e){Object.assign(this,W,e)}}function Y(e){return"el"===e||"ru"===e}var V=Object.freeze({__proto__:null,CMSConfiguration:Q,IsArialLanguage:Y,defaultConfig:W});const X=Symbol("eshop-axios"),J=Symbol("public-eshop-axios");class K{constructor(e){this.scopedContainer=y.createChildContainer(),this.scopedContainer.registerInstance(Q,e);const t=v.create({baseURL:e.urlBase+"/eshop-api/",headers:{"Api-Token":"PCvmtXRSKB3YQXJh"}}),a=v.create({baseURL:e.urlBase+"/eshop-api/"});this.scopedContainer.registerInstance(X,t),this.scopedContainer.registerInstance(J,a)}resolve(e){return this.scopedContainer.resolve(e)}static prepare(e){return new K(e)}}const Z=u({support:{avif:!1,webp:!1},config:W,container:K.prepare(W)}),ee=({language:e,country:t,urlBase:a,loadFonts:o,children:n})=>{const[l,r]=p({support:{avif:!1,webp:!1},config:Object.assign(Object.assign({},W),{country:null!=t?t:W.country,language:null!=e?e:W.language,urlBase:null!=a?a:W.urlBase,isPreview:null!=o?o:W.isPreview}),container:K.prepare(Object.assign(Object.assign({},W),{urlBase:null!=a?a:W.urlBase,country:null!=t?t:W.country,language:null!=e?e:W.language,isPreview:null!=o?o:W.isPreview}))});return m((()=>{i({breakpoints:[576,768,992,1200,1600]})})),m((()=>{!function(){R(this,void 0,void 0,(function*(){const e=yield function(e=[]){var t,a,o,n;return R(this,void 0,void 0,(function*(){const i=[{type:"webp",url:"data:image/webp;base64,UklGRhwAAABXRUJQVlA4TBAAAAAvAAAAEAfQpv5HmQMR0f8A"},{type:"avif",url:"data:image/avif;base64,AAAAHGZ0eXBtaWYxAAAAAG1pZjFhdmlmbWlhZgAAAPFtZXRhAAAAAAAAACFoZGxyAAAAAAAAAABwaWN0AAAAAAAAAAAAAAAAAAAAAA5waXRtAAAAAAABAAAAHmlsb2MAAAAABEAAAQABAAAAAAEVAAEAAAAeAAAAKGlpbmYAAAAAAAEAAAAaaW5mZQIAAAAAAQAAYXYwMUltYWdlAAAAAHBpcHJwAAAAUWlwY28AAAAUaXNwZQAAAAAAAAABAAAAAQAAABBwYXNwAAAAAQAAAAEAAAAVYXYxQ4EgAAAKBzgABpAQ0AIAAAAQcGl4aQAAAAADCAgIAAAAF2lwbWEAAAAAAAAAAQABBAECg4QAAAAmbWRhdAoHOAAGkBDQAjITFkAAAEgAAAB5TNw9UxdXU6F6oA=="}].concat(e),l={},r=document.getElementsByTagName("html")[0],s=function(e){return new Promise((t=>{const a=new Image;a.src=e.url,a.onerror=function(a){const o=r.getAttribute("class");var n=new Set(o?o.split(" "):[]);l[e.type.toLowerCase()]=!1,t({[e.type.toLowerCase()]:!1}),n.add("no-"+e.type.toLowerCase()),r.setAttribute("class",[...n].join(" "))},a.onload=function(a){const o=r.getAttribute("class");var n=new Set(o?o.split(" "):[]);l[e.type.toLowerCase()]=!0,t({[e.type.toLowerCase()]:!0}),n.add(e.type.toLowerCase()),r.setAttribute("class",[...n].join(" "))}}))};try{for(var d,c=!0,u=H(i);d=yield u.next(),!(t=d.done);c=!0){n=d.value,c=!1;const e=n;yield s(e)}}catch(e){a={error:e}}finally{try{c||t||!(o=u.return)||(yield o.call(u))}finally{if(a)throw a.error}}return l}))}();r((t=>Object.assign(Object.assign({},t),{support:{avif:e.avif,webp:e.webp}})))}))}()}),[]),m((()=>{r((n=>n.config.language===e&&n.config.country===t&&n.config.urlBase===a&&n.config.isPreview===o?n:Object.assign(Object.assign({},n),{config:Object.assign(Object.assign({},W),{country:null!=t?t:W.country,language:null!=e?e:W.language,urlBase:null!=a?a:W.urlBase,isPreview:null!=o?o:W.isPreview}),container:K.prepare(Object.assign(Object.assign({},W),{urlBase:null!=a?a:W.urlBase,country:null!=t?t:W.country,language:null!=e?e:W.language,isPreview:null!=o?o:W.isPreview}))})))}),[e,t,a,o]),c.createElement(Z.Provider,{value:l},o&&c.createElement(U,null),n)};let te=class{constructor(e){this.config=e,this.cmsAxios=v.create(),this.cmsAxios.interceptors.request.use((t=>(t.baseURL=e.urlBase+"/cms/",t.headers.authorization=`Basic ${e.accessToken}`,t.headers["X-languages"]=e.language,t.headers["X-Flatten"]="true",e.showUnpublishedContent&&(t.headers["X-unpublished"]=e.showUnpublishedContent),t))),this.eshopAxios=v.create(),this.eshopAxios.interceptors.request.use((e=>(e.headers["Api-Token"]="PCvmtXRSKB3YQXJh",e)))}getBearerToken(){return R(this,void 0,void 0,(function*(){const e=yield this.cmsAxios.post(`${this.config.urlBase}/cms/identity-server/connect/token`,S.stringify({grant_type:"client_credentials",client_id:"tiers-banners-homes:default",client_secret:"y02jnu6ovow9exw1zsddr7t1rgz3qkn4o5fqxg1hzaax",scope:"squidex-api"}),{headers:{"Content-Type":"application/x-www-form-urlencoded"}});return this.config.bearer=e.data.access_token,e.data.access_token}))}cmsFetchAssetInfoByIds(e){return R(this,void 0,void 0,(function*(){return(yield this.cmsAxios.get(`api/apps/tiers-banners-homes/assets?ids=${e.join(",")}`)).data.items}))}cmsFetchRestGetByIds(e){return R(this,void 0,void 0,(function*(){return(yield this.cmsAxios.get(`api/content/tiers-banners-homes?ids=${e.join(",")}`)).data.items}))}cmsFetchRestGetQuery(e,t){return R(this,void 0,void 0,(function*(){return(yield this.cmsAxios.get(`api/content/tiers-banners-homes/${e}?q=${encodeURIComponent(JSON.stringify(t))}`)).data.items}))}cmsFetchGraphQL(e,t,a){return R(this,void 0,void 0,(function*(){const o=this.config.showUnpublishedContent?yield this.cmsAxios.post(`${this.config.urlBase}/cms/api/content/tiers-banners-homes/graphql`,{operationName:e,query:t,variables:a}):yield this.cmsAxios.get(`${this.config.urlBase}/cms/api/content/tiers-banners-homes/graphql?query=${encodeURI(t)}${a?`&variables=${JSON.stringify(a)}`:""}&contentlang=${this.config.language}`),n=Object.getOwnPropertyNames(o.data.data);return o.data.data[n[0]]}))}eshopFetch(e){return R(this,void 0,void 0,(function*(){try{return(yield this.eshopAxios.get(`${this.config.urlBase}/eshop-api/api/v1/management/tnm?countryId=${e}`)).data}catch(e){return{}}}))}eshopSecondLifeFetch(e){return R(this,void 0,void 0,(function*(){try{const t={headers:{"Content-Type":"application/json"}};return(yield this.eshopAxios.post(`${this.config.urlBase}/eshop-api/api/v1/afterSales/secondLife`,JSON.stringify(e),t)).data}catch(e){return{}}}))}cmsFetchRestGetById(e,t){return R(this,void 0,void 0,(function*(){return(yield this.cmsAxios.get(`api/content/tiers-banners-homes/${e}/${t}`)).data}))}};te=O([k(w.ContainerScoped),j("design:paramtypes",[Q])],te);let ae=class{constructor(e){this.fetchBannerById=e=>this.fetchService.cmsFetchGraphQL("GetBanner","query GetBanner($id:String!){findBannersContent(id:$id){flatData{name,onlyDesktop,bannerType{flatData{code,name,}},layoutMobile,campaign{flatData{name}},texts{textType{flatData{code,name}},literal{flatData{code,text}},upperCase,lowerCase,font{flatData{name}},fontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,backgroundColor,cta,tracking,slug{flatData{slug}},script},components{flatData{dynamic,componentType{flatData{code,name}},countdown{daysLiteral{flatData{code,text}},hoursLiteral{flatData{code,text}},minutesLiteral{flatData{code,text}},font{flatData{name}},fontColor,fontSizeTextDesktop,fontSizeTextTablet,fontSizeTextMobile,fontSizeNumbersDesktop,fontSizeNumbersTablet,fontSizeNumbersMobile,finalDate},images{tracking,trackingGA4,search,searchTracking,slug{flatData{slug}},script,assets{url,fileName,tags,metadata}},buttons{borderColor,underline,showCountriesModal,backgroundColor,backgroundColorTablet, backgroundColorMobile,boxShadowDesktop,boxShadowTablet,boxShadowMobile,selectedBackgroundColor,font{flatData{name}},fontColor, fontColorTablet, fontColorMobile, selectedFontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,literal{flatData{code,text}},upperCase,lowerCase,search,searchTracking,slug{flatData{slug}},script,tracking,trackingGA4},buttonsLayout,texts{textShadowDesktop,textShadowTablet,textShadowMobile,backgroundColor,cta,tracking,trackingGA4,slug{flatData{slug}},script,font{flatData{name}},marginTop,marginTopMobile,fontColor,fontColorMobile,fontColorTablet,fontSizeDesktop,fontSizeTablet,fontSizeMobile,literal{flatData{code,text}},upperCase,lowerCase,textType{flatData{code,name}}}}}}}}",{id:e}),this.fetchBannerTypeByName=e=>this.fetchService.cmsFetchGraphQL("GetBannerType",`query GetBannerType{queryBannerTypesContents(filter:"data/name/iv eq '${e}'"){id}}`),this.fetchBannerByType=(e,t)=>this.fetchService.cmsFetchGraphQL("GetBanner",`query GetBanner{queryBannersContents(filter:"status eq 'Published' and data/bannerType/iv eq '${e}' and data/countries/iv eq '${t}'",orderby:"created desc"){flatData{name,onlyDesktop,bannerType{flatData{code,name}},layoutMobile,texts{textType{flatData{code,name}},literal{flatData{code,text}},upperCase,lowerCase,font{flatData{name}},fontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,backgroundColor,cta,tracking,slug{flatData{slug}},script}components{flatData{dynamic,componentType{flatData{code,name}},countdown{daysLiteral{flatData{code,text}},hoursLiteral{flatData{code,text}},minutesLiteral{flatData{code,text}},font{flatData{name}},fontColor,fontSizeTextDesktop,fontSizeTextTablet,fontSizeTextMobile,fontSizeNumbersDesktop,fontSizeNumbersTablet,fontSizeNumbersMobile,finalDate},images{tracking,trackingGA4,search,searchTracking,slug{flatData{slug}},script,assets{url,fileName,tags,metadata}},buttons{borderColor,underline,showCountriesModal,backgroundColor,backgroundColorTablet,backgroundColorMobile,boxShadowDesktop,boxShadowTablet,boxShadowMobile,selectedBackgroundColor,font{flatData{name}},fontColor, fontColorTablet, fontColorMobile, selectedFontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,literal{flatData{code,text}},upperCase,lowerCase,search,searchTracking,slug{flatData{slug}},script,tracking,trackingGA4},buttonsLayout,texts{textShadowDesktop,textShadowTablet,textShadowMobile,backgroundColor,cta,tracking,trackingGA4,slug{flatData{slug}},script,font{flatData{name}},marginTop,marginTopMobile,fontColor,fontColorMobile,fontColorTablet,fontSizeDesktop,fontSizeTablet,fontSizeMobile,literal{flatData{code,text}},upperCase,lowerCase,textType{flatData{code,name}}}}}}}}`),this.fetchBannerDetail=e=>this.fetchService.cmsFetchGraphQL("GetBanner","query GetBanner($id: String!) {\n  findBannersContent(id: $id) {\n    flatData {\n      name\n      onlyDesktop\n      bannerType {\n        flatData {\n          code\n          name\n        }\n      }\n      campaign{\n        flatData{\n          name\n        }\n      }\n      texts{\n        textType{\n          flatData{\n            code\n            name\n          }\n        }\n        literal{\n          flatData{\n            code\n            text\n          }\n        }\n        font{\n          flatData{\n            name\n          }\n        }\n        fontColor\n        fontColorMobile\n        fontColorTablet\n        fontSizeDesktop\n        fontSizeMobile\n        backgroundColor\n        cta\n        tracking\n        slug{\n          flatData{\n            slug\n          }\n        }\n      }\n      components {\n        flatData {\n          dynamic\n          componentType {\n            flatData {\n              code\n              name\n            }\n          }\n          countdown{daysLiteral{flatData{code,text}},hoursLiteral{flatData{code,text}},minutesLiteral{flatData{code,text}},font{flatData{name}},fontColor,fontSizeTextDesktop,fontSizeTextTablet,fontSizeTextMobile,fontSizeNumbersDesktop,fontSizeNumbersTablet,fontSizeNumbersMobile,finalDate}\n          images {\n            tracking\n            trackingGA4\n            search\n            searchTracking,\n            slug{\n              flatData{\n                slug\n              }\n            }\n            assets {\n              url,\n              fileName,\n              tags,\n              metadata\n            }\n          }\n          buttons {\n            borderColor,\n            underline\n            showCountriesModal\n            backgroundColor\n            backgroundColorTablet\n            backgroundColorMobile\n            font {\n              flatData {\n                name\n              }\n            }\n            fontColor\n            fontColorTablet\n            fontColorMobile\n            fontSizeDesktop\n            fontSizeMobile\n            literal {\n              flatData {\n                code\n                text\n              }\n            }\n            search\n            searchTracking\n            slug{\n              flatData{\n                slug\n              }\n            }\n            tracking,\n            trackingGA4\n          }\n          texts {\n            backgroundColor\n            cta,\n            tracking\n            trackingGA4\n            slug{\n              flatData{\n                slug\n              }\n            }\n            font {\n              flatData {\n                name\n              }\n            }\n            fontColor\n            fontColorMobile\n            fontColorTablet\n            fontSizeDesktop\n            fontSizeMobile\n            marginTop\n            marginTopMobile\n            literal {\n              flatData {\n                code\n                text\n              }\n            }\n            textType {\n              flatData {\n                code\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",{id:e}),this.fetchService=e}};ae=O([k(w.ContainerScoped),j("design:paramtypes",[te])],ae);let oe=class{constructor(e){this.fetchCountryByCode=e=>this.fetchService.cmsFetchGraphQL("GetCountry",`query GetCountry{queryCountriesContents(filter:"data/code/iv eq '${e}'"){id,flatData{marketCode,translatedName{flatData{code,text}}}}}`),this.fetchCountries=()=>this.fetchService.cmsFetchGraphQL("GetCountry","query GetCountry {\n    queryCountriesContents {\n      id\n      flatData {\n        code\n        marketCode\n        translatedName {\n          flatData {\n            code\n            text\n          }\n        }\n        languages {\n          flatData {\n            code\n            translatedName\n          }\n        }\n      }\n    }\n  }"),this.fetchService=e}};oe=O([k(w.ContainerScoped),j("design:paramtypes",[te])],oe);let ne=class{constructor(e){this.fetchService=e}fetchLanguageByCode(e){return this.fetchService.cmsFetchGraphQL("GetLanguage",`query GetLanguage{queryLanguagesContents(filter:"data/code/iv eq '${e}'"){id,flatData{translatedName,code}}}`)}};ne=O([k(w.ContainerScoped),j("design:paramtypes",[te])],ne);let ie=class{constructor(e,t,a,o){this.getProps=e=>R(this,void 0,void 0,(function*(){const t=yield this.countryService.fetchCountryByCode(this.config.country);let a=null;if("storeLocator"===e||"search"===e){const o=yield this.bannerService.fetchBannerTypeByName("storeLocator"===e?"Store Locator":"Search");if(o&&o[0].id&&t[0].id){const e=yield this.bannerService.fetchBannerByType(o[0].id,t[0].id);a=e?e[0]:null}}else a=yield this.bannerService.fetchBannerById(e);return a?{data:null==a?void 0:a.flatData,market:t[0].flatData.marketCode,position:1,type:a.flatData.bannerType[0].flatData.name,blur:!1}:null})),this.config=o,this.languageService=a,this.countryService=t,this.bannerService=e}};function le(){const[e,t]=p({width:void 0,height:void 0});return m((()=>{if("undefined"!=typeof window)return window.addEventListener("resize",e),e(),()=>window.removeEventListener("resize",e);function e(){t({width:window.innerWidth,height:window.innerHeight})}}),[]),e}ie=O([k(w.ContainerScoped),j("design:paramtypes",[ae,oe,ne,Q])],ie);const re=e=>null==e?"0.75em":"number"==typeof e?`${e}em`:/[a-z]$/i.test(e)?e:`${e}em`;let se=class{constructor(e,t,a){this.fetchEshopByCountryCode=e=>this.fetchService.eshopFetch(e),this.fetchEshopSecondLife=e=>this.fetchService.eshopSecondLifeFetch(e),this.config=a,this.fetchService=e,this.publicAxios=t}getProducts(e,t,a,o=!1){return R(this,void 0,void 0,(function*(){let n={};n=null!=a&&null!=a&&"0"!=a?{"filter.id":t.join(","),order:"filter_id_pos",profile:`${this.config.language}_${this.config.country}`,"pager.offset":0,"pager.limit":t.length,targetId:e,family:a,square:o}:{"filter.id":t.join(","),order:"filter_id_pos",profile:`${this.config.language}_${this.config.country}`,"pager.offset":0,"pager.limit":t.length,targetId:e,square:o};return(yield this.publicAxios.get("api/v1/products/list",{params:n})).data}))}};var de,ce;se=O([k(w.ContainerScoped),(de=1,ce=C(J),function(e,t){ce(e,t,de)}),j("design:paramtypes",[te,Function,Q])],se);const ue=(e,t)=>{var a,o;if(!t)return"";if("string"==typeof t)return t;if("object"!=typeof t)return"";const n=Object.keys(t);return 0===n.length?"":null!==(o=null!==(a=t[e])&&void 0!==a?a:t.en)&&void 0!==o?o:t[n[0]]},pe=e.a`
  pointer-events: initial;
  color: #ffffff;
  font-family: ModerneRegular;
  background-color: black;
  font-size: 14px;
  font-weight: normal;
  white-space: normal;
  margin-top: 15px;
  margin-left: 4px;
  margin-bottom: 4px;
  text-decoration: none;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border: 1px solid #ffffff;

  &:hover {
    color: #000000;
    background-color: #dfdfdf;
  }
`,me=e.div`
  border: 4px solid rgba(255, 255, 255, 0.5);
  background-color: transparent !important;
  border-radius: 50%;
  border-top-color: white;
  opacity: 1;
  position: absolute;
  left: 2%;
  right: 72%;
  top: 25%;
  bottom: 25%;
  margin: auto;
  width: 16px;
  height: 16px;
  transition: opacity 250ms;
  animation: rotate-spinner 1s linear;
  animation-iteration-count: infinite;

  @keyframes rotate-spinner {
    100% {
      transform: rotate(360deg);
    }
  }
`,fe=c.forwardRef(((e,t)=>{var a=P(e,[]);const{config:o,container:n}=f(Z),[i,l]=p(!1),r=g((()=>a.text?ue(o.language,a.text):a.children),[a.text,a.children]),s=g((()=>n.resolve(se)),[n]);return c.createElement("div",{style:{position:"relative",width:"150px"}},c.createElement(pe,Object.assign({},a,{onClick:e=>{((e,t)=>{R(void 0,void 0,void 0,(function*(){var a,n,i,r,d,c,u,p;e.preventDefault();let m="";const f=document.getElementsByName(t.sendCamperShoesName);if(null!=f)for(let e=0;e<f.length;e++)(null===(a=f[e])||void 0===a?void 0:a.checked)&&(m=null===(n=f[e])||void 0===n?void 0:n.value);let g=null!=document.getElementsByName(t.numberPairsName)?document.getElementsByName(t.numberPairsName)[0].value:"",h=null!=document.getElementById(t.pair1CategoryId)?document.getElementById(t.pair1CategoryId).value:"",b=null!=document.getElementById(t.pair1TypeId)?document.getElementById(t.pair1TypeId).value:"",x=null!=document.getElementById(t.pair1SizeId)?document.getElementById(t.pair1SizeId).value:"",v=null!=document.getElementById(t.pair2CategoryId)?document.getElementById(t.pair2CategoryId).value:"",y=null!=document.getElementById(t.pair2TypeId)?document.getElementById(t.pair2TypeId).value:"",k=null!=document.getElementById(t.pair2SizeId)?document.getElementById(t.pair2SizeId).value:"",w=null!=document.getElementById(t.pair3CategoryId)?document.getElementById(t.pair3CategoryId).value:"",C=null!=document.getElementById(t.pair3TypeId)?document.getElementById(t.pair3TypeId).value:"",D=null!=document.getElementById(t.pair3SizeId)?document.getElementById(t.pair3SizeId).value:"",S=null!=document.getElementById(t.pair4CategoryId)?document.getElementById(t.pair4CategoryId).value:"",T=null!=document.getElementById(t.pair4TypeId)?document.getElementById(t.pair4TypeId).value:"",_=null!=document.getElementById(t.pair4SizeId)?document.getElementById(t.pair4SizeId).value:"",z=null!=document.getElementById(t.emailId)?document.getElementById(t.emailId).value:"";null!=document.getElementById(t.genderId)&&document.getElementById(t.genderId).value;let E=null!=document.getElementById(t.nameId)?document.getElementById(t.nameId).value:"",N=null!=document.getElementById(t.surnameId)?document.getElementById(t.surnameId).value:"";null!=document.getElementsByName(t.birthdayName)&&document.getElementsByName(t.birthdayName)[0].value,null!=document.getElementsByName(t.cityName)&&document.getElementsByName(t.cityName)[0].value;let M=null!=document.getElementsByName(t.countryName)?document.getElementsByName(t.countryName)[0].value:"",$=null!=document.getElementsByName(t.phoneName)?document.getElementsByName(t.phoneName)[0].value:"",B="";const A=document.getElementsByName(t.suscribeNewsletterName);if(null!=A)for(let e=0;e<A.length;e++)(null===(i=A[e])||void 0===i?void 0:i.checked)&&(B=null===(r=A[e])||void 0===r?void 0:r.value);const L=null===(d=document.getElementsByName(t.termsName)[0])||void 0===d?void 0:d.checked,I={category:h,type:b,size:parseInt(x)},F={category:v,type:y,size:parseInt(k)},G={category:w,type:C,size:parseInt(D)},P={category:S,type:T,size:parseInt(_)};let O=[];O[0]=I;let j=!1;(null===I.category||""===I.category||null===I.size||I.size<=0||null===I.type||""===I.type)&&(j=!0),parseInt(g)>1&&null!==F.category&&""!==F.category&&null!==F.size&&F.size>0&&null!==F.type&&""!==F.type&&(O[1]=F),parseInt(g)>2&&null!==G.category&&""!==G.category&&null!==G.size&&G.size>0&&null!==G.type&&""!==G.type&&(O[2]=G),parseInt(g)>3&&null!==P.category&&""!==P.category&&null!==P.size&&P.size>0&&null!==P.type&&""!==P.type&&(O[3]=P);let R=!1;m?document.getElementsByName("sendingCamperShoes").forEach((e=>{var t;null===(t=e.parentNode)||void 0===t||t.removeAttribute("style")})):document.getElementsByName("sendingCamperShoes").forEach((e=>{var t;null===(t=e.parentNode)||void 0===t||t.setAttribute("style","color:red")})),B?document.getElementsByName("suscribeNewsletter").forEach((e=>{var t;null===(t=e.parentNode)||void 0===t||t.removeAttribute("style")})):document.getElementsByName("suscribeNewsletter").forEach((e=>{var t;null===(t=e.parentNode)||void 0===t||t.setAttribute("style","color:red")})),L?null===(u=document.getElementsByClassName("check-error-label")[0])||void 0===u||u.setAttribute("style","display: none"):null===(c=document.getElementsByClassName("check-error-label")[0])||void 0===c||c.setAttribute("style","display: block"),L&&"0"!=m||(R=!0),z?function(e){return/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e)}(document.getElementById(t.emailId).value)||(document.getElementById(t.emailId).style.border="2px solid red",R=!0):(R=!0,document.getElementById(t.emailId).style.border="2px solid red"),E||(R=!0,document.getElementById(t.nameId).style.border="2px solid red"),N||(R=!0,document.getElementById(t.surnameId).style.border="2px solid red"),M||(R=!0,document.getElementsByName(t.countryName)[0].style.border="2px solid red"),j&&(R=!0,document.getElementById(t.pair1CategoryId).style.border="2px solid red",document.getElementById(t.pair1SizeId).style.border="2px solid red",document.getElementById(t.pair1TypeId).style.border="2px solid red");var q=document.getElementsByClassName("PhoneInput");if($){if(!function(e){let t=e.substring(e.indexOf(" ")+1);return/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im.test(t.replace(/\s/g,""))}(document.getElementById("selectPhoneNumber").value))for(R=!0,H=0;H<q.length;H++)q[H].style.border="2px solid red"}else{R=!0;for(var H=0;H<q.length;H++)q[H].style.border="2px solid red"}if(R)document.getElementById(t.errorMessageId).style.display="block",null===(p=document.getElementById(t.errorMessageId))||void 0===p||p.scrollIntoView({block:"end",behavior:"smooth"});else{l(!0);const e={username:E+" "+N,email:z,address:"",telephone:$||$},a={profile:`${o.language}_${o.country}`,isCamperShoes:"1"===m,pairs:O,account:e,subscribeNewsletter:"1"===B},n=yield s.fetchEshopSecondLife(a);let i=null;i=null!=n&&null!=n.status&&-1!==n.status.indexOf("OK")?`${o.urlBase}/${o.language}_${o.country}/`+t.urlRedirect+"?voucher="+n.reference:`${o.urlBase}/${o.language}_${o.country}/`+t.urlKO,null!=i&&(window.location.href=i)}}))})(e,a)},ref:t,className:i?"loading":"cenable",style:i?{pointerEvents:"none",cursor:"not-allowed",opacity:"0.5"}:void 0}),r),i&&c.createElement(me,Object.assign({},a)))})),ge=["AD_CA","AD_EN","AD_ES","AT_DE","AT_EN","BE_DE","BE_EN","BE_FR","BE_NL","CA_EN","CA_FR","CH_DE","CH_EN","CH_FR","CH_IT","DE_DE","DE_EN","ES_CA","ES_EN","ES_ES","FR_EN","FR_FR","GR_EL","GR_EN","IL_EN","IT_EN","IT_IT","MT_EN","NL_EN","NL_NL","PL_EN","PT_EN","UK_EN","US_EN","VF_EN","VF_PL","VF_PT"],he=["AD_CA","AD_EN","AD_ES","AT_DE","AT_EN","BE_DE","BE_EN","BE_FR","BE_NL","CA_EN","CA_FR","CH_DE","CH_EN","CH_FR","CH_IT","DE_DE","DE_EN","ES_CA","ES_EN","ES_ES","FR_EN","FR_FR","GB_EN","GR_EL","GR_EN","IL_EN","IT_EN","IT_IT","MT_EN","NL_EN","NL_NL","PL_EN","PL_PL","PT_EN","PT_PT","US_EN"],be=(e,t,a,o,n,i)=>{let l=o?o.startsWith("/")?`${a}/${t}_${e}${o}`:o.startsWith("http")?o:`${a}/${o}`:o;if(i){l=l.replace("XX_XX",e.toLocaleUpperCase()+"_"+t.toLocaleUpperCase());let a=!1;a=l.includes("privacy")?he.includes(e.toLocaleUpperCase()+"_"+t.toLocaleUpperCase()):ge.includes(e.toLocaleUpperCase()+"_"+t.toLocaleUpperCase()),a||(l=l.replace(e.toLocaleUpperCase()+"_"+t.toLocaleUpperCase(),"VF_EN"))}return l&&n?`${l}?lng=${t.toLocaleLowerCase()}&country=${e.toLocaleLowerCase()}`:l},xe=(e,t,a)=>`${a}/${t}_${e}`,ve=e=>{if("undefined"!=typeof window){let t,a,o,n=document.cookie.split(";");for(t=0;t<n.length;t++)if(a=n[t].substr(0,n[t].indexOf("=")),o=n[t].substr(n[t].indexOf("=")+1),a=a.replace(/^\s+|\s+$/g,""),a==e)return unescape(o)}return""},ye=(e,t,a)=>e?`eventGA|INTERNAL-CAMPAIGN|${e.replace("{market}",t).replace("{initial_banner_position}",a)}|BIG`:e,ke=(e,t,a,o)=>e?`${e.replace("{market}",t).replace("{initial_banner_position}",a).replace("{banner_type}",o)}`:e,we=(e,t)=>e?`eventGA|INTERNAL-CAMPAIGN|${e}|${t?"LOW_TIER":"TIER"}`:e,Ce=e=>e?`${e.url}${e.fileName}`:"",De=c.forwardRef((({className:e,children:t,href:a,hrefTranslated:o,target:n,onClick:i},l)=>{const{config:r}=f(Z),s=g((()=>a&&""!==a?a:o?be(r.country,r.language,r.urlBase,ue(r.language,o)):""),[a,o]);return c.createElement(Se,{ref:l,onClick:i,href:s,target:n,className:e},t)})),Se=e.a`
  text-decoration: none;
  display: inline-block;
`,Te=e.div`
  position: absolute;
  top: 5px;
  left: 17px;
  font-family: "ModerneRegular";
  pointer-events: none;
  font-size: 10px;
  color: gray;
`,_e=e.div`
  display: flex;
  align-items: center;
  width: ${e=>`${e.boxWidth}`};
  position: relative;
  border: solid 1px;
  height: ${e=>`${e.boxHeigth}`};

  /* datepicker.css */
  .react-date-picker {
    display: inline-flex;
    position: relative;
  }
  .react-date-picker,
  .react-date-picker *,
  .react-date-picker *:before,
  .react-date-picker *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-date-picker--disabled {
    background-color: #f0f0f0;
    color: #6d6d6d;
  }
  .react-date-picker__wrapper {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    border: thin solid gray;
  }
  .react-date-picker__inputGroup {
    min-width: calc((4px * 3) + 0.54em * 8 + 0.217em * 2);
    flex-grow: 1;
    padding: 0 2px;
    box-sizing: content-box;
  }
  .react-date-picker__inputGroup__divider {
    padding: 1px 0;
    white-space: pre;
  }
  .react-date-picker__inputGroup__input {
    min-width: 0.54em;
    height: 100%;
    position: relative;
    padding: 0 1px;
    border: 0;
    background: none;
    font: inherit;
    box-sizing: content-box;
    -moz-appearance: textfield;
  }
  .react-date-picker__inputGroup__input::-webkit-outer-spin-button,
  .react-date-picker__inputGroup__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .react-date-picker__inputGroup__input:invalid {
    background: rgba(255, 0, 0, 0.1);
  }
  .react-date-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
  }
  .react-date-picker__button {
    border: 0;
    background: transparent;
    padding: 4px 6px;
  }
  .react-date-picker__button:enabled {
    cursor: pointer;
  }
  .react-date-picker__button:enabled:hover .react-date-picker__button__icon,
  .react-date-picker__button:enabled:focus .react-date-picker__button__icon {
    stroke: #0078d7;
  }
  .react-date-picker__button:disabled .react-date-picker__button__icon {
    stroke: #6d6d6d;
  }
  .react-date-picker__button svg {
    display: inherit;
  }
  .react-date-picker__calendar {
    width: 350px;
    max-width: 100vw;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
  }
  .react-date-picker__calendar--closed {
    display: none;
  }
  .react-date-picker__calendar .react-calendar {
    border-width: thin;
  }

  /* calendar.css */
  .react-calendar {
    width: 350px;
    max-width: 100%;
    background: white;
    border: 1px solid #a0a096;
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.125em;
  }
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    display: flex;
    height: 44px;
    margin-bottom: 1em;
  }
  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__navigation button[disabled] {
    background-color: #f0f0f0;
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.75em;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    font-weight: bold;
    padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
  }
  .react-calendar__month-view__days__day--weekend {
    color: #d10000;
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
  }
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }
  .react-calendar__tile {
    max-width: 100%;
    text-align: center;
    padding: 0.75em 0.5em;
    background: none;
  }
  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__tile--now {
    background: #ffff76;
  }
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: #ffffa9;
  }
  .react-calendar__tile--hasActive {
    background: #76baff;
  }
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: #a9d4ff;
  }
  .react-calendar__tile--active {
    background: #006edc;
    color: white;
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: #1087ff;
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
  }

  .react-date-picker {
    display: inline-flex;
    position: relative;
  }
  .react-date-picker,
  .react-date-picker *,
  .react-date-picker *:before,
  .react-date-picker *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-date-picker--disabled {
    background-color: #f0f0f0;
    color: #6d6d6d;
  }
  .react-date-picker__wrapper {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    border: thin solid gray;
  }
  .react-date-picker__inputGroup {
    min-width: calc((4px * 3) + 0.54em * 8 + 0.217em * 2);
    flex-grow: 1;
    padding: 0 2px;
    box-sizing: content-box;
  }
  .react-date-picker__inputGroup__divider {
    padding: 1px 0;
    white-space: pre;
  }
  .react-date-picker__inputGroup__input {
    min-width: 0.54em;
    height: 100%;
    position: relative;
    padding: 0 1px;
    border: 0;
    background: none;
    font: inherit;
    box-sizing: content-box;
    -moz-appearance: textfield;
  }
  .react-date-picker__inputGroup__input::-webkit-outer-spin-button,
  .react-date-picker__inputGroup__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .react-date-picker__inputGroup__input:invalid {
    background: rgba(255, 0, 0, 0.1);
  }
  .react-date-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
  }
  .react-date-picker__button {
    border: 0;
    background: transparent;
    padding: 4px 6px;
  }
  .react-date-picker__button:enabled {
    cursor: pointer;
  }
  .react-date-picker__button:enabled:hover .react-date-picker__button__icon,
  .react-date-picker__button:enabled:focus .react-date-picker__button__icon {
    stroke: #0078d7;
  }
  .react-date-picker__button:disabled .react-date-picker__button__icon {
    stroke: #6d6d6d;
  }
  .react-date-picker__button svg {
    display: inherit;
  }
  .react-date-picker__calendar {
    width: 350px;
    max-width: 100vw;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
  }
  .react-date-picker__calendar--closed {
    display: none;
  }
  .react-date-picker__calendar .react-calendar {
    border-width: thin;
  }

  .react-calendar {
    border-radius: 4px;
    width: 350px;
    max-width: 100%;
    background: white;
    font: inherit;
    line-height: 1.125em;
    border: 0;
    overflow: hidden;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
    font: inherit;
    font-size: 0.8em;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: 0.5em;
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .react-calendar__navigation {
    height: 44px;
    margin-bottom: 10px;
  }
  .react-calendar__navigation button {
    min-width: 44px;
    background: none;
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__navigation button[disabled] {
    background-color: #f0f0f0;
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.75em;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 0.5em;
  }
  .react-calendar__month-view__weekNumbers {
    font-weight: bold;
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
  }
  .react-calendar__month-view__days__day--weekend {
    color: #d10000;
  }
  .react-calendar__month-view__days__day--neighboringMonth {
    color: #757575;
  }
  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 2em 0.5em;
  }
  .react-calendar__tile {
    max-width: 100%;
    text-align: center;
    padding: 0.75em 0.5em;
    background: none;
  }
  .react-calendar__tile:disabled {
    background-color: #f0f0f0;
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: #e6e6e6;
  }
  .react-calendar__tile--hasActive {
    background: #76baff;
  }
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: #a9d4ff;
  }
  .react-calendar__tile--active {
    background: #006edc;
    color: white;
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: #1087ff;
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: #e6e6e6;
  }
  .react-date-picker * {
    font-family: inherit;
  }
  .react-date-picker--closed {
    border-radius: 4px;
  }
  .react-date-picker--closed .react-date-picker__wrapper {
    border-radius: 4px;
  }
  .react-date-picker--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .react-date-picker--open .react-date-picker__wrapper {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .react-date-picker__wrapper {
    background: white;
    border: 0;
    border-radius: 4px;
  }
  .react-date-picker__inputGroup {
    min-width: calc(4px + (4px * 3) + 0.54em * 8 + 0.217em * 2);
    flex-grow: 1;
    display: flex;
    padding: 2px;
    align-items: baseline;
  }
  .react-date-picker__inputGroup__divider {
    padding: 1px;
  }
  .react-date-picker__inputGroup__input {
    -moz-appearance: textfield;
  }
  .react-date-picker__inputGroup__input::-webkit-outer-spin-button,
  .react-date-picker__inputGroup__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .react-date-picker__inputGroup__input:invalid {
    background: rgba(255, 0, 0, 0.1);
  }
  .react-date-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
  }
  .react-date-picker__calendar {
    border-radius: 4px;
    box-shadow: 0 30px 40px 0 rgba(16, 36, 94, 0.2);
    border-top-left-radius: 0;
  }
  .react-date-picker__calendar .react-calendar {
    border-top-left-radius: 0;
  }
  .react-date-picker__clock {
    border-radius: 4px;
    box-shadow: 0 30px 40px 0 rgba(16, 36, 94, 0.2);
    font-family: inherit;
    width: 220px;
    height: 220px;
    padding: 20px;
    border: 0;
    border-top-left-radius: 0;
  }
  .react-date-picker__clock .react-clock__second-hand {
    transition: transform cubic-bezier(0.68, 0, 0.27, 1.55) 0.2s;
  }
  .react-date-picker__clock .react-clock__second-hand__body:before {
    width: 5px;
    height: 5px;
  }
  .react-date-picker__clock .react-clock__second-hand__body:after {
    width: 15px;
    height: 15px;
  }

  /* Modified */
  .react-date-picker {
    font-size: 14px;
    font-family: ModerneRegular;
    font-weight: normal;
    border: none;
    outline: none;
    display: flex;
    width: 100%;
    margin-top: 8px;
    margin-left: 14px;
    margin-bottom: 0px;
    margin-right: 20px;
  }

  .react-date-picker__inputGroup__month:active,
  .react-date-picker__inputGroup__month:focus-visible,
  .react-date-picker__inputGroup__day:active,
  .react-date-picker__inputGroup__day:focus-visible,
  .react-date-picker__inputGroup__year:active,
  .react-date-picker__inputGroup__year:focus-visible {
    outline-color: unset;
    outline-style: none;
    outline-width: 0;
  }

  .react-date-picker__wrapper {
    border: none;
    background-color: transparent !important;
  }

  .react-calendar,
  .react-calendar__navigation__label {
    font-size: 14px !important;
    font-family: ModerneRegular !important;
  }

  .react-calendar__tile--active {
    background: #000000;
  }

  .react-calendar__month-view__weekdays__weekday abbr {
    text-decoration: none;
  }

  .react-calendar__tile abbr {
    font-size: 14px;
    font-family: ModerneRegular;
  }

  .react-calendar__month-view__days__day--weekend {
    color: black;
  }

  .react-date-picker__calendar {
    width: 305px;
  }

  .react-calendar__tile--active {
    color: white;
  }

  .react-calendar__tile--active:hover {
    background-color: #e6e6e6;
    color: black;
  }

  .react-calendar__tile--now {
    background: #f5f5f5;
    color: black;
  }

  .react-calendar__tile--now:hover {
    background: #e6e6e6;
    color: black;
  }

  .react-calendar__tile--hasActive {
    background: #f5f5f5;
    color: black;
  }

  .react-calendar__tile--hasActive:hover {
    background: #e6e6e6;
    color: black;
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: 1.4em 0.5em;
  }

  .react-calendar__navigation__arrow,
  .react-calendar__navigation__prev2-button {
    font-size: 22px !important;
    color: rgba(0, 0, 0, 0.25) !important;
  }

  .react-calendar__navigation__label__labelText,
  .react-calendar__navigation__label__labelText--from {
    color: black;
  }

  .react-date-picker__inputGroup__input:invalid {
    background-color: unset;
  }
`,ze=e=>{const{config:t}=f(Z),a=g((()=>{var a;return null===(a=ue(t.language,e.tag))||void 0===a?void 0:a.replace(/[\n\r]+/gm,"<br/>")}),[e.tag]),[o,n]=p(null),i=new Date;return c.createElement(_e,Object.assign({},e),c.createElement(T,{onChange:e=>{n(e)},value:null!=o?o:"",name:"userBirthdayInput",maxDate:i}),c.createElement(Te,null,a))},Ee=e.label`
  display: inline-flex;
  cursor: pointer;
  position: relative;
`,Ne=e.span``,Me=e.input`
  height: 24px;
  width: 24px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: 1px solid black;
  outline: none;
  transition-duration: 0.3s;
  background-color: white;
  cursor: pointer;

  :checked {
    border: 1px solid black;
    background-color: black;
  }
  :checked + span::before {
    content: "";
    display: block;
    width: 7px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
    position: absolute;
    left: 0.55rem;
    top: 0.4rem;
  }
  :active {
    border: 2px solid black;
  }
`,$e=e.div`
  color: red;
  display: none;
  font-family: ModerneRegular;
  font-weight: normal;
  font-size: 12px;
`,Be=c.forwardRef((({checkName:e,label:t,value:a},o)=>{const{config:n}=f(Z),i=g((()=>{var e;return null===(e=ue(n.language,t))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>")}),[t]);return c.createElement(c.Fragment,null,c.createElement(Ee,null,c.createElement(Me,{type:"checkbox",name:e,className:"check-input",value:a,onClick:t=>{var a;a=e,R(void 0,void 0,void 0,(function*(){document.getElementsByName(a)[0].checked?document.getElementsByClassName("check-error-label")[0].setAttribute("style","display: none"):document.getElementsByClassName("check-error-label")[0].setAttribute("style","display: block")}))},ref:o}),c.createElement(Ne,{className:"checkmark"})),c.createElement($e,{className:"check-error-label"},i))})),Ae=e.div`
  transition: 1s ease-in-out opacity;
  opacity: 0;
  &.fade-in-section--is-visible {
    opacity: 1;
  }
`,Le=c.forwardRef((({children:e,className:t,onClick:a,lazy:o,first:n},i)=>{if(!o)return c.createElement("div",{ref:i,className:t,onClick:a},e);const[l,r]=c.useState(!1);return m((()=>{let e=0;if(document&&document.location&&document.location.ancestorOrigins&&(e=document.location.ancestorOrigins.length),"IntersectionObserver"in window){const t=null!=i?i.current:null,a=null!=t&&null!=t?t.offsetTop:0,o=new IntersectionObserver((t=>{(n||1===e||window.pageYOffset>0&&window.pageYOffset+window.innerHeight>=a)&&t.forEach((e=>{e.isIntersecting&&r(!0)}))}));null!=t&&o.observe(t)}else r(!0)}),[]),c.createElement(Ae,{className:`${t} fade-in-section ${l?"fade-in-section--is-visible":""}`,ref:i},e)})),Ie=t=>{const{config:a}=f(Z),[o,n]=p(a.country);p("");const i=g((()=>{var e;return null===(e=ue(a.language,t.placeholderCountry))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>")}),[t.placeholderCountry]),l=g((()=>{var e;return null===(e=ue(a.language,t.placeholderCity))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>")}),[t.placeholderCity]),r=g((()=>{var e;return null===(e=ue(a.language,t.labelCity))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>")}),[t.placeholderCity]),s=g((()=>{var e;return null===(e=ue(a.language,t.labelCountry))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>")}),[t.labelCountry]),d=e.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 16px;
    height: ${e=>`${e.boxHeigth}`};
    @media only screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  `,u=e.div`
    border: solid 1px #000;
    height: auto;
    width: 100%;
    display: block;
    position: relative;

    select {
      border: none;
      height: 100%;
      width: 100%;
      background-color: transparent;
      font-size: 14px;
      font-family: "ModerneRegular";
      padding: 27px 10px 15px 10px;
      -webkit-appearance: none;
      -moz-appearance: none;

      outline-color: initial;
      outline-style: none;
      outline-width: initial;

      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' height='9' viewBox='0 0 18 9' width='18'><path d='m4-4 3.67495264 3.67495264 4.32504736 4.32504736-8 8' fill='none' stroke='black' stroke-linecap='square' transform='matrix(0 1 -1 0 12.96 -3.141463)'></path></svg>");
      background-position: calc(100% - 20px) calc(50%);
      background-size: 18px 9px;
      background-repeat: no-repeat;

      &::-webkit-scrollbar {
        width: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background: #333;
        border-radius: 10px;
      }
    }
  `,m=e.div`
    position: absolute;
    top: 8px;
    left: 10px;
    font-family: "ModerneRegular";
    pointer-events: none;
    font-size: 10px;
    color: gray;
  `,h=e.input`
    display: block;
    padding: 27px 10px 15px 10px;
    background: transparent;
    width: 100%;
    border-width: 0;
    height: 100%;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  `;return c.createElement(d,Object.assign({},t),c.createElement(u,Object.assign({},t),c.createElement(m,Object.assign({},t),s),c.createElement(_,{value:o,onChange:e=>{n(e)},defaultOptionLabel:i,valueType:"short"})),c.createElement(u,Object.assign({},t),c.createElement(m,Object.assign({},t),r),c.createElement(h,{name:"rcrs-region",placeholder:l})))},Fe=e.div`
  position: relative;
  display: block;
  width: auto;

  img {
    position: absolute;
    top: 16px;
    right: 16px;
  }

  input:checked ~ img {
    transform: rotate(180deg);
  }
`,Ge=e.div`
  background-color: #dfdfdf;
  padding: 9px 0px 13px 16px;
  font-family: ModerneRegular;
  font-weight: normal;
  font-size: 14px;
  width: auto;
  height: 20px;
`,Pe=e.input.attrs({type:"checkbox"})`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 46px;
  opacity: 0;
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  cursor: pointer;
`,Oe=e.div`
  margin-top: 24px;
  display: none;

  input:checked ~ & {
    display: block;
  }
`,je=e=>{const{children:t}=e;P(e,["children"]);const{config:a}=f(Z),o=g((()=>{var t;return null===(t=ue(a.language,e.label))||void 0===t?void 0:t.replace(/[\n\r]+/gm,"<br/>")}),[e.label]);return c.createElement(Fe,Object.assign({},e,{"data-dynamicclass":e.dynamicClass,onClick:e.onClick}),c.createElement(Ge,Object.assign({},e),o),c.createElement(Pe,{defaultChecked:!0}),c.createElement("img",{alt:"Open",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/1edf5e11-b11b-4b23-82e2-c4fb666f670f/chevron.svg"}),c.createElement(Oe,null,t))},Re=e.iframe`
  display: block;
  border: none;
  width: 100%;
  height: auto;
`,qe=e.div`
  position: relative;
`,He=e.input`
  position: relative;
  background-color: transparent;
  padding: 27px 10px 15px 10px;
  font-family: ModerneRegular;
  font-weight: normal;
  font-size: 14px;
  color: #000000;
  width: 100%;
  border: none;
  box-sizing: border-box;
  outline: none;
  height: 100%;
`,Ue=e.span`
  position: absolute;
  pointer-events: none;
  font-family: ModerneRegular;
  font-weight: normal;
  font-size: 14px;
  color: gray;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.2s ease all;
`,We=e.div`
  position: relative;
  height: ${({height:e})=>e};
  display: flex;
  align-items: center;
  border: 1px solid #000000;

  ${He}:focus + ${Ue}, ${He}:not(:placeholder-shown) + ${Ue} {
    top: 8px;
    bottom: 10px;
    left: 10px;
    font-size: 11px;
    opacity: 1;
    transform: translateY(0);
  }

  &:focus + span {
    display: block;
  }
`,Qe=e.p`
  font-size: 10px;
  color: red;
  font-family: ModerneRegular;
  font-weight: normal;
  position: absolute;
  top: 0;
  right: 10px;
`,Ye=c.forwardRef((({type:e,placeholder:t,height:a},o)=>{const{config:n}=f(Z),[i,l]=p(!0),r=g((()=>{var e;return null===(e=ue(n.language,t))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>")}),[t]);return c.createElement(qe,null,c.createElement(We,{height:a},c.createElement(He,{ref:o,type:e,onChange:e=>(e=>{e.target.value.length>0?e.target.setAttribute("style","border: none"):e.target.setAttribute("style","border: 2px solid red")})(e),onBlur:e=>(e=>{var t;"email"!=e.target.type||(t=e.target.value,/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(t))?"email"==e.target.type&&(e.target.setAttribute("style","border: none"),l(!0)):(e.target.setAttribute("style","border: 2px solid red"),l(!1))})(e),placeholder:" "}),c.createElement(Ue,null,r)),i||"email"!=e?"":c.createElement(Qe,null,"Invalid Email"))})),Ve=e=>(m((()=>{const t=window.location.search,a=new URLSearchParams(t).get(e.parameter);let o=document.querySelectorAll("[data-class='parameter']");for(let e=0;e<o.length;e++)o[e].innerHTML=null!=a?a:""}),[]),c.createElement("span",{"data-class":"parameter"})),Xe=e.img`
  &.dimensions-set {
    // Si tenemos width y height se han de ajustar las imágenes
    width: 100%;
    height: auto;
    display: block;
  }
`,Je=e.source``,Ke=(e,t)=>{if(t)return t.toLowerCase().includes("http")?t:e+t.replace(/\s/m,"%20")},Ze=(e,t)=>`https://cloud.camper.com/is/asset/${t}/${e}`,et=c.forwardRef((({className:e,alt:t,mobile:a,tablet:o,desktop:n,bigScreen:i,onClick:l,lazy:r,imageURLDesktop:s,imageURLTablet:d,imageURLMobile:u,hoxCodeDesktop:p,hoxCodeTablet:m,hoxCodeMobile:h},b)=>{const{config:x}=f(Z),v=g((()=>ue(x.language,t)),[x.language,t]);return a||u?u?c.createElement("picture",{ref:b},c.createElement("source",{srcSet:s&&p?Ze(s,p)+".avif":h&&Ze(u,h)+".avif",type:"image/avif",media:"(min-width: 1200px)"}),c.createElement("source",{srcSet:s&&p?Ze(s,p)+".webp":h&&Ze(u,h)+".webp",type:"image/webp",media:"(min-width: 1200px)"}),c.createElement("source",{srcSet:s&&p?Ze(s,p)+".jpg":h&&Ze(u,h)+".jpg",media:"(min-width: 1200px)"}),c.createElement(Je,{srcSet:d&&m?Ze(d,m)+".avif":h&&Ze(u,h)+".avif",type:"image/avif",width:null==o?void 0:o.width,height:null==o?void 0:o.height,media:"(min-width: 768px)"}),c.createElement(Je,{srcSet:d&&m?Ze(d,m)+".webp":h&&Ze(u,h)+".webp",width:null==o?void 0:o.width,height:null==o?void 0:o.height,type:"image/webp",media:"(min-width: 768px)"}),c.createElement(Je,{width:null==o?void 0:o.width,height:null==o?void 0:o.height,srcSet:d&&m?Ze(d,m)+".jpg":h&&Ze(u,h)+".jpg",media:"(min-width: 768px)"}),c.createElement(Je,{width:null==a?void 0:a.width,height:null==a?void 0:a.height,srcSet:h&&Ze(u,h)+".avif",type:"image/avif",media:"(max-width: 767px)"}),c.createElement(Je,{srcSet:h&&Ze(u,h)+".webp",width:null==a?void 0:a.width,height:null==a?void 0:a.height,type:"image/webp",media:"(max-width: 767px)"}),c.createElement(Xe,{onClick:l,src:h&&Ze(u,h)+".jpg",alt:v,loading:r?"lazy":void 0,className:`dimensions-set ${e}`})):c.createElement("picture",{ref:b},(null==i?void 0:i.avif)&&c.createElement(Je,{srcSet:Ke(x.urlBase,i.avif),width:i.width,height:i.height,type:"image/avif",media:"(min-width: 1600px)"}),(null==i?void 0:i.webp)&&c.createElement(Je,{srcSet:Ke(x.urlBase,i.webp),width:i.width,height:i.height,type:"image/webp",media:"(min-width: 1600px)"}),(null==i?void 0:i.standard)&&c.createElement(Je,{width:i.width,height:i.height,srcSet:Ke(x.urlBase,i.standard),media:"(min-width: 1600px)"}),(null==n?void 0:n.avif)&&c.createElement(Je,{width:n.width,height:n.height,srcSet:Ke(x.urlBase,n.avif),type:"image/avif",media:"(min-width: 1200px)"}),(null==n?void 0:n.webp)&&c.createElement(Je,{width:n.width,height:n.height,srcSet:Ke(x.urlBase,n.webp),type:"image/webp",media:"(min-width: 1200px)"}),(null==n?void 0:n.standard)&&c.createElement(Je,{width:n.width,height:n.height,srcSet:Ke(x.urlBase,n.standard),media:"(min-width: 1200px)"}),(null==o?void 0:o.avif)&&c.createElement(Je,{width:o.width,height:o.height,srcSet:Ke(x.urlBase,o.avif),type:"image/avif",media:"(min-width: 768px)"}),(null==o?void 0:o.webp)&&c.createElement(Je,{width:o.width,height:o.height,srcSet:Ke(x.urlBase,o.webp),type:"image/webp",media:"(min-width: 768px)"}),(null==o?void 0:o.standard)&&c.createElement(Je,{width:o.width,height:o.height,srcSet:Ke(x.urlBase,o.standard),media:"(min-width: 768px)"}),(null==a?void 0:a.avif)&&c.createElement(Je,{width:a.width,height:a.height,srcSet:Ke(x.urlBase,a.avif),type:"image/avif",media:"(max-width: 767px)"}),(null==a?void 0:a.webp)&&c.createElement(Je,{width:a.width,height:a.height,srcSet:Ke(x.urlBase,a.webp),type:"image/webp",media:"(max-width: 767px)"}),c.createElement(Xe,{onClick:l,width:null==a?void 0:a.width,height:null==a?void 0:a.height,src:Ke(x.urlBase,a?a.standard:""),alt:v,loading:r?"lazy":void 0,className:`dimensions-set ${e}`})):null})),tt=e.span`
  height: 16px;
  width: 16px;
  background-color: transparent;
  border: solid 1px;
  border-radius: 50%;
  position: relative;
  margin-right: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.25s;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);

  @media only screen and (max-width: 768px) {
    height: 32px;
    width: 32px;
  }

  /* Create the indicator (the dot/circle - hidden when not checked) */
  &:after {
    content: "";
    display: none;
    width: 50%;
    height: 50%;
    border-radius: 50%;
    background: #000;
  }
`,at=e.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;

  &:checked ~ ${tt} {
    background-color: transparent;
  }
  &:checked ~ ${tt}:after {
    display: block;
  }
`,ot=e.label`
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-family: ModerneRegular;
  font-weight: normal;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding-left: 24px;

  @media only screen and (max-width: 768px) {
    padding-left: 42px;
  }

  &:hover ${at} ~ ${tt} {
    background-color: #e0e0e0;
    transition: background-color 0.25s;
  }
`,nt=c.forwardRef((({groupName:e,label:t,value:a,onClick:o},n)=>{const{config:i}=f(Z),l=g((()=>{var e;return null===(e=ue(i.language,t))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>")}),[t]);return c.createElement(ot,{className:"radio-label"},c.createElement(at,{type:"radio",name:e,className:"radio-input",value:a,onClick:t=>{var a,o;a=t,o=e,R(void 0,void 0,void 0,(function*(){var e,t;if("terms"===o){let e=document.getElementsByClassName("cenable");for(let t=0;t<e.length;t++)"1"==a.target.value?e[t].setAttribute("style",""):"0"==a.target.value&&e[t].setAttribute("style","pointer-events: none;cursor: not-allowed;opacity: 0.5;")}let n="";const i=document.getElementsByName(o);for(let a=0;a<i.length;a++)(null===(e=i[a])||void 0===e?void 0:e.checked)&&(n=null===(t=i[a])||void 0===t?void 0:t.value);n?document.getElementsByName(o).forEach((e=>{var t;null===(t=e.parentNode)||void 0===t||t.removeAttribute("style")})):document.getElementsByName(o).forEach((e=>{var t;null===(t=e.parentNode)||void 0===t||t.setAttribute("style","color:red")}))}))},ref:n,defaultChecked:"sendingCamperShoes"===e&&"1"===a}),c.createElement(tt,{className:"radio-check"}),c.createElement("span",{className:"radio-label"},l))})),it=e.label`
  font-family: ModerneMedium;
  font-weight: normal;
  font-size: 16px;
  margin-bottom: 20px;
  display: inline-block;
`,lt=e.div`
  position: relative;
  width: ${({width:e})=>e+"px"};
  &:after {
    content: "";
    position: absolute;
    right: 16px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(calc(-50% - 3px)) rotate(-45deg);
    width: 8.64px;
    height: 8.64px;
    border-left: 1px solid;
    border-bottom: 1px solid;
    pointer-events: none;
  }
`,rt=e.div`
  border: 1px solid;
  position: relative;
  display: flex;
  align-items: center;
  height: ${({height:e})=>e+"px"};
`,st=e.div`
  position: absolute;
  top: 8px;
  left: 10px;
  font-family: "ModerneRegular";
  pointer-events: none;
  font-size: 10px;
  color: gray;
`,dt=e.select`
  display: block;
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  font-family: ModerneRegular;
  font-weight: normal;
  font-size: 12px;
  width: 100%;
  outline: none;
  border: none;
  height: 45px;

  ${({tagTerm:e})=>e.length>0?"padding: 10px 10px 10px 10px;":"padding: 10px 10px;"};

  option {
    padding: 10px 5px;
  }
`,ct=c.forwardRef((({label:e,selectTag:t,height:a,classToDisplay:o,width:n,children:i},l)=>{const{config:r}=f(Z),s=g((()=>{var t;return null===(t=ue(r.language,e))||void 0===t?void 0:t.replace(/[\n\r]+/gm,"<br/>")}),[e]),d=g((()=>{var e;return null===(e=ue(r.language,t))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>")}),[t]);return c.createElement("div",null,s.length>0&&c.createElement(it,null,s),c.createElement(lt,{width:n},c.createElement(rt,{height:a},c.createElement(st,null,d),c.createElement(dt,{tagTerm:d,ref:l,"data-classname":"change-select",onChange:e=>{((e,t)=>{R(void 0,void 0,void 0,(function*(){if(null!=t&&""!==t){for(var a=e.target.value,o=document.querySelectorAll("[data-dynamicclass='"+t+"']"),n=document.querySelectorAll("[data-dynamicclass='"+t+"']").length,i=0;i<parseInt(a);i++)o[i].style.display="block",o[i].children[0].style.display="block";for(i=parseInt(a);i<n;i++)o[i].style.display="none",o[i].children[0].style.display="none"}}))})(e,o)}},i))))})),ut=e.label`
  font-family: ModerneMedium;
  font-weight: normal;
  font-size: 16px;
`,pt=e.div`
  position: relative;
  width: ${e=>e.width?e.width+"px":"100%"};
  &:after {
    content: "";
    position: absolute;
    right: 16px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(calc(-50% - 3px)) rotate(-45deg);
    width: 8.64px;
    height: 8.64px;
    border-left: 1px solid;
    border-bottom: 1px solid;
    pointer-events: none;
  }
`,mt=e.select`
  display: block;
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  padding: 10px 10px;
  height: 45px;
  font-family: ModerneRegular;
  font-weight: normal;
  font-size: 12px;
  width: 100%;
  border: 1px solid;
  margin-top: 20px;
  option {
    padding: 10px 5px;
  }
`,ft=c.forwardRef((({label:e,classToDisplay:t,from:a,to:o,name:n,width:i,selectOption:l},r)=>{const{config:s}=f(Z),d=g((()=>{var t;return null===(t=ue(s.language,e))||void 0===t?void 0:t.replace(/[\n\r]+/gm,"<br/>")}),[e]);return m((()=>{if(null!=l&&""!=l){let e=new Option(l,"0");e.disabled=!0,e.hidden=!0,e.selected=!0,document.getElementsByName(n)[0].options.add(e)}for(let e=a;e<=o;e++)document.getElementsByName(n)[0].options.add(new Option(e.toString(),e.toString()))}),[]),c.createElement("div",null,c.createElement(ut,null,d),c.createElement(pt,{width:i,label:e,classToDisplay:t,from:a,to:o,name:n,selectOption:l},c.createElement(mt,{ref:r,name:n,"data-classname":"change-select",onChange:e=>{((e,t)=>{R(void 0,void 0,void 0,(function*(){if(null!=t&&""!==t){let a=e.target.value,o=document.querySelectorAll("[data-dynamicclass='"+t+"']"),n=document.querySelectorAll("[data-dynamicclass='"+t+"']").length;for(let e=0;e<parseInt(a);e++)o[e].style.display="block",o[e].children[0].style.display="block";for(let e=parseInt(a);e<n;e++)o[e].style.display="none",o[e].children[0].style.display="none"}}))})(e,t)}})))})),gt=c.forwardRef((({value:e,label:t,first:a},o)=>{const{config:n}=f(Z),i=g((()=>{var e;return null===(e=ue(n.language,t))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>")}),[t]);return"true"==a?c.createElement("option",{ref:o,key:`option_${e}`,value:e,disabled:!0,selected:!0,hidden:!0},i):c.createElement("option",{ref:o,key:`option_${e}`,value:e},i)}));c.createRef();const ht=e.div`
  position: relative;

  .intl-tel-input {
    position: relative;
    display: inline-block;
  }
  .intl-tel-input * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .intl-tel-input .hide {
    display: none;
  }
  .intl-tel-input .v-hide {
    visibility: hidden;
  }
  .intl-tel-input input,
  .intl-tel-input input[type="text"],
  .intl-tel-input input[type="tel"] {
    position: relative;
    z-index: 0;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-right: 36px;
    margin-right: 0;
  }
  .intl-tel-input .flag-container {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    padding: 1px;
  }
  .intl-tel-input .flag-container .arrow {
    font-size: 6px;
    margin-left: 5px;
  }
  .intl-tel-input .flag-container .arrow.up:after {
    content: "▲";
  }
  .intl-tel-input .flag-container .arrow.down:after {
    content: "▼";
  }
  .intl-tel-input .selected-flag {
    z-index: 1;
    position: relative;
    width: 36px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .intl-tel-input .country-list {
    position: absolute;
    z-index: 2;
    list-style: none;
    text-align: left;
    padding: 0;
    margin: 0 0 0 -1px;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
    background-color: white;
    border: 1px solid #ccc;
    white-space: nowrap;
    max-height: 200px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
  .intl-tel-input .country-list .divider {
    padding-bottom: 5px;
    margin-bottom: 5px;
    border-bottom: 1px solid #ccc;
  }
  .intl-tel-input .country-list.dropup {
    bottom: 100%;
    margin-bottom: -1px;
  }
  .intl-tel-input .country-list .flag-box {
    display: inline-block;
    width: 20px;
  }
  @media (max-width: 500px) {
    .intl-tel-input .country-list {
      white-space: normal;
    }
  }
  .intl-tel-input .country-list .country {
    padding: 5px 10px;
  }
  .intl-tel-input .country-list .country .dial-code {
    color: #999;
  }
  .intl-tel-input .country-list .country.highlight {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .intl-tel-input .country-list .flag-box,
  .intl-tel-input .country-list .country-name,
  .intl-tel-input .country-list .dial-code {
    vertical-align: middle;
  }
  .intl-tel-input .country-list .flag-box,
  .intl-tel-input .country-list .country-name {
    margin-right: 6px;
  }
  .intl-tel-input.allow-dropdown input,
  .intl-tel-input.allow-dropdown input[type="text"],
  .intl-tel-input.allow-dropdown input[type="tel"] {
    padding-right: 6px;
    padding-left: 52px;
    margin-left: 0;
  }
  .intl-tel-input.allow-dropdown .flag-container {
    right: auto;
    left: 0;
    width: 100%;
  }
  .intl-tel-input.allow-dropdown .selected-flag {
    width: 46px;
  }
  .intl-tel-input.allow-dropdown .flag-container:hover {
    cursor: pointer;
  }
  .intl-tel-input.allow-dropdown .flag-container:hover .selected-flag {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .intl-tel-input.allow-dropdown input[disabled] + .flag-container:hover,
  .intl-tel-input.allow-dropdown input[readonly] + .flag-container:hover {
    cursor: default;
  }
  .intl-tel-input.allow-dropdown
    input[disabled]
    + .flag-container:hover
    .selected-flag,
  .intl-tel-input.allow-dropdown
    input[readonly]
    + .flag-container:hover
    .selected-flag {
    background-color: transparent;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code .selected-flag {
    background-color: rgba(0, 0, 0, 0.05);
    display: table;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code .selected-dial-code {
    display: table-cell;
    vertical-align: middle;
    padding-left: 28px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-2 input,
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-2
    input[type="text"],
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-2
    input[type="tel"] {
    padding-left: 76px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-2 .selected-flag {
    width: 70px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-3 input,
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-3
    input[type="text"],
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-3
    input[type="tel"] {
    padding-left: 84px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-3 .selected-flag {
    width: 78px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-4 input,
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-4
    input[type="text"],
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-4
    input[type="tel"] {
    padding-left: 92px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-4 .selected-flag {
    width: 86px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-5 input,
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-5
    input[type="text"],
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-5
    input[type="tel"] {
    padding-left: 100px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-5 .selected-flag {
    width: 94px;
  }
  .intl-tel-input.iti-container {
    position: absolute;
    top: -1000px;
    left: -1000px;
    z-index: 1060;
    padding: 1px;
  }
  .intl-tel-input.iti-container:hover {
    cursor: pointer;
  }

  .iti-mobile .intl-tel-input.iti-container {
    top: 30px;
    bottom: 30px;
    left: 30px;
    right: 30px;
    position: fixed;
  }
  .iti-mobile .intl-tel-input .country-list {
    max-height: 100%;
    width: 100%;
    -webkit-overflow-scrolling: touch;
  }
  .iti-mobile .intl-tel-input .country-list .country {
    padding: 10px 10px;
    line-height: 1.5em;
  }

  .iti-flag {
    width: 20px;
  }
  .iti-flag.be {
    width: 18px;
  }
  .iti-flag.ch {
    width: 15px;
  }
  .iti-flag.mc {
    width: 19px;
  }
  .iti-flag.ne {
    width: 18px;
  }
  .iti-flag.np {
    width: 13px;
  }
  .iti-flag.va {
    width: 15px;
  }
  @media only screen and (-webkit-min-device-pixel-ratio: 2),
    only screen and (min--moz-device-pixel-ratio: 2),
    only screen and (-o-min-device-pixel-ratio: 2/1),
    only screen and (min-device-pixel-ratio: 2),
    only screen and (min-resolution: 192dpi),
    only screen and (min-resolution: 2dppx) {
    .iti-flag {
      background-size: 5630px 15px;
    }
  }
  .iti-flag.ac {
    height: 10px;
    background-position: 0px 0px;
  }
  .iti-flag.ad {
    height: 14px;
    background-position: -22px 0px;
  }
  .iti-flag.ae {
    height: 10px;
    background-position: -44px 0px;
  }
  .iti-flag.af {
    height: 14px;
    background-position: -66px 0px;
  }
  .iti-flag.ag {
    height: 14px;
    background-position: -88px 0px;
  }
  .iti-flag.ai {
    height: 10px;
    background-position: -110px 0px;
  }
  .iti-flag.al {
    height: 15px;
    background-position: -132px 0px;
  }
  .iti-flag.am {
    height: 10px;
    background-position: -154px 0px;
  }
  .iti-flag.ao {
    height: 14px;
    background-position: -176px 0px;
  }
  .iti-flag.aq {
    height: 14px;
    background-position: -198px 0px;
  }
  .iti-flag.ar {
    height: 13px;
    background-position: -220px 0px;
  }
  .iti-flag.as {
    height: 10px;
    background-position: -242px 0px;
  }
  .iti-flag.at {
    height: 14px;
    background-position: -264px 0px;
  }
  .iti-flag.au {
    height: 10px;
    background-position: -286px 0px;
  }
  .iti-flag.aw {
    height: 14px;
    background-position: -308px 0px;
  }
  .iti-flag.ax {
    height: 13px;
    background-position: -330px 0px;
  }
  .iti-flag.az {
    height: 10px;
    background-position: -352px 0px;
  }
  .iti-flag.ba {
    height: 10px;
    background-position: -374px 0px;
  }
  .iti-flag.bb {
    height: 14px;
    background-position: -396px 0px;
  }
  .iti-flag.bd {
    height: 12px;
    background-position: -418px 0px;
  }
  .iti-flag.be {
    height: 15px;
    background-position: -440px 0px;
  }
  .iti-flag.bf {
    height: 14px;
    background-position: -460px 0px;
  }
  .iti-flag.bg {
    height: 12px;
    background-position: -482px 0px;
  }
  .iti-flag.bh {
    height: 12px;
    background-position: -504px 0px;
  }
  .iti-flag.bi {
    height: 12px;
    background-position: -526px 0px;
  }
  .iti-flag.bj {
    height: 14px;
    background-position: -548px 0px;
  }
  .iti-flag.bl {
    height: 14px;
    background-position: -570px 0px;
  }
  .iti-flag.bm {
    height: 10px;
    background-position: -592px 0px;
  }
  .iti-flag.bn {
    height: 10px;
    background-position: -614px 0px;
  }
  .iti-flag.bo {
    height: 14px;
    background-position: -636px 0px;
  }
  .iti-flag.bq {
    height: 14px;
    background-position: -658px 0px;
  }
  .iti-flag.br {
    height: 14px;
    background-position: -680px 0px;
  }
  .iti-flag.bs {
    height: 10px;
    background-position: -702px 0px;
  }
  .iti-flag.bt {
    height: 14px;
    background-position: -724px 0px;
  }
  .iti-flag.bv {
    height: 15px;
    background-position: -746px 0px;
  }
  .iti-flag.bw {
    height: 14px;
    background-position: -768px 0px;
  }
  .iti-flag.by {
    height: 10px;
    background-position: -790px 0px;
  }
  .iti-flag.bz {
    height: 14px;
    background-position: -812px 0px;
  }
  .iti-flag.ca {
    height: 10px;
    background-position: -834px 0px;
  }
  .iti-flag.cc {
    height: 10px;
    background-position: -856px 0px;
  }
  .iti-flag.cd {
    height: 15px;
    background-position: -878px 0px;
  }
  .iti-flag.cf {
    height: 14px;
    background-position: -900px 0px;
  }
  .iti-flag.cg {
    height: 14px;
    background-position: -922px 0px;
  }
  .iti-flag.ch {
    height: 15px;
    background-position: -944px 0px;
  }
  .iti-flag.ci {
    height: 14px;
    background-position: -961px 0px;
  }
  .iti-flag.ck {
    height: 10px;
    background-position: -983px 0px;
  }
  .iti-flag.cl {
    height: 14px;
    background-position: -1005px 0px;
  }
  .iti-flag.cm {
    height: 14px;
    background-position: -1027px 0px;
  }
  .iti-flag.cn {
    height: 14px;
    background-position: -1049px 0px;
  }
  .iti-flag.co {
    height: 14px;
    background-position: -1071px 0px;
  }
  .iti-flag.cp {
    height: 14px;
    background-position: -1093px 0px;
  }
  .iti-flag.cr {
    height: 12px;
    background-position: -1115px 0px;
  }
  .iti-flag.cu {
    height: 10px;
    background-position: -1137px 0px;
  }
  .iti-flag.cv {
    height: 12px;
    background-position: -1159px 0px;
  }
  .iti-flag.cw {
    height: 14px;
    background-position: -1181px 0px;
  }
  .iti-flag.cx {
    height: 10px;
    background-position: -1203px 0px;
  }
  .iti-flag.cy {
    height: 14px;
    background-position: -1225px 0px;
  }
  .iti-flag.cz {
    height: 14px;
    background-position: -1247px 0px;
  }
  .iti-flag.de {
    height: 12px;
    background-position: -1269px 0px;
  }
  .iti-flag.dg {
    height: 10px;
    background-position: -1291px 0px;
  }
  .iti-flag.dj {
    height: 14px;
    background-position: -1313px 0px;
  }
  .iti-flag.dk {
    height: 15px;
    background-position: -1335px 0px;
  }
  .iti-flag.dm {
    height: 10px;
    background-position: -1357px 0px;
  }
  .iti-flag.do {
    height: 13px;
    background-position: -1379px 0px;
  }
  .iti-flag.dz {
    height: 14px;
    background-position: -1401px 0px;
  }
  .iti-flag.ea {
    height: 14px;
    background-position: -1423px 0px;
  }
  .iti-flag.ec {
    height: 14px;
    background-position: -1445px 0px;
  }
  .iti-flag.ee {
    height: 13px;
    background-position: -1467px 0px;
  }
  .iti-flag.eg {
    height: 14px;
    background-position: -1489px 0px;
  }
  .iti-flag.eh {
    height: 10px;
    background-position: -1511px 0px;
  }
  .iti-flag.er {
    height: 10px;
    background-position: -1533px 0px;
  }
  .iti-flag.es {
    height: 14px;
    background-position: -1555px 0px;
  }
  .iti-flag.et {
    height: 10px;
    background-position: -1577px 0px;
  }
  .iti-flag.eu {
    height: 14px;
    background-position: -1599px 0px;
  }
  .iti-flag.fi {
    height: 12px;
    background-position: -1621px 0px;
  }
  .iti-flag.fj {
    height: 10px;
    background-position: -1643px 0px;
  }
  .iti-flag.fk {
    height: 10px;
    background-position: -1665px 0px;
  }
  .iti-flag.fm {
    height: 11px;
    background-position: -1687px 0px;
  }
  .iti-flag.fo {
    height: 15px;
    background-position: -1709px 0px;
  }
  .iti-flag.fr {
    height: 14px;
    background-position: -1731px 0px;
  }
  .iti-flag.ga {
    height: 15px;
    background-position: -1753px 0px;
  }
  .iti-flag.gb {
    height: 10px;
    background-position: -1775px 0px;
  }
  .iti-flag.gd {
    height: 12px;
    background-position: -1797px 0px;
  }
  .iti-flag.ge {
    height: 14px;
    background-position: -1819px 0px;
  }
  .iti-flag.gf {
    height: 14px;
    background-position: -1841px 0px;
  }
  .iti-flag.gg {
    height: 14px;
    background-position: -1863px 0px;
  }
  .iti-flag.gh {
    height: 14px;
    background-position: -1885px 0px;
  }
  .iti-flag.gi {
    height: 10px;
    background-position: -1907px 0px;
  }
  .iti-flag.gl {
    height: 14px;
    background-position: -1929px 0px;
  }
  .iti-flag.gm {
    height: 14px;
    background-position: -1951px 0px;
  }
  .iti-flag.gn {
    height: 14px;
    background-position: -1973px 0px;
  }
  .iti-flag.gp {
    height: 14px;
    background-position: -1995px 0px;
  }
  .iti-flag.gq {
    height: 14px;
    background-position: -2017px 0px;
  }
  .iti-flag.gr {
    height: 14px;
    background-position: -2039px 0px;
  }
  .iti-flag.gs {
    height: 10px;
    background-position: -2061px 0px;
  }
  .iti-flag.gt {
    height: 13px;
    background-position: -2083px 0px;
  }
  .iti-flag.gu {
    height: 11px;
    background-position: -2105px 0px;
  }
  .iti-flag.gw {
    height: 10px;
    background-position: -2127px 0px;
  }
  .iti-flag.gy {
    height: 12px;
    background-position: -2149px 0px;
  }
  .iti-flag.hk {
    height: 14px;
    background-position: -2171px 0px;
  }
  .iti-flag.hm {
    height: 10px;
    background-position: -2193px 0px;
  }
  .iti-flag.hn {
    height: 10px;
    background-position: -2215px 0px;
  }
  .iti-flag.hr {
    height: 10px;
    background-position: -2237px 0px;
  }
  .iti-flag.ht {
    height: 12px;
    background-position: -2259px 0px;
  }
  .iti-flag.hu {
    height: 10px;
    background-position: -2281px 0px;
  }
  .iti-flag.ic {
    height: 14px;
    background-position: -2303px 0px;
  }
  .iti-flag.id {
    height: 14px;
    background-position: -2325px 0px;
  }
  .iti-flag.ie {
    height: 10px;
    background-position: -2347px 0px;
  }
  .iti-flag.il {
    height: 15px;
    background-position: -2369px 0px;
  }
  .iti-flag.im {
    height: 10px;
    background-position: -2391px 0px;
  }
  .iti-flag.in {
    height: 14px;
    background-position: -2413px 0px;
  }
  .iti-flag.io {
    height: 10px;
    background-position: -2435px 0px;
  }
  .iti-flag.iq {
    height: 14px;
    background-position: -2457px 0px;
  }
  .iti-flag.ir {
    height: 12px;
    background-position: -2479px 0px;
  }
  .iti-flag.is {
    height: 15px;
    background-position: -2501px 0px;
  }
  .iti-flag.it {
    height: 14px;
    background-position: -2523px 0px;
  }
  .iti-flag.je {
    height: 12px;
    background-position: -2545px 0px;
  }
  .iti-flag.jm {
    height: 10px;
    background-position: -2567px 0px;
  }
  .iti-flag.jo {
    height: 10px;
    background-position: -2589px 0px;
  }
  .iti-flag.jp {
    height: 14px;
    background-position: -2611px 0px;
  }
  .iti-flag.ke {
    height: 14px;
    background-position: -2633px 0px;
  }
  .iti-flag.kg {
    height: 12px;
    background-position: -2655px 0px;
  }
  .iti-flag.kh {
    height: 13px;
    background-position: -2677px 0px;
  }
  .iti-flag.ki {
    height: 10px;
    background-position: -2699px 0px;
  }
  .iti-flag.km {
    height: 12px;
    background-position: -2721px 0px;
  }
  .iti-flag.kn {
    height: 14px;
    background-position: -2743px 0px;
  }
  .iti-flag.kp {
    height: 10px;
    background-position: -2765px 0px;
  }
  .iti-flag.kr {
    height: 14px;
    background-position: -2787px 0px;
  }
  .iti-flag.kw {
    height: 10px;
    background-position: -2809px 0px;
  }
  .iti-flag.ky {
    height: 10px;
    background-position: -2831px 0px;
  }
  .iti-flag.kz {
    height: 10px;
    background-position: -2853px 0px;
  }
  .iti-flag.la {
    height: 14px;
    background-position: -2875px 0px;
  }
  .iti-flag.lb {
    height: 14px;
    background-position: -2897px 0px;
  }
  .iti-flag.lc {
    height: 10px;
    background-position: -2919px 0px;
  }
  .iti-flag.li {
    height: 12px;
    background-position: -2941px 0px;
  }
  .iti-flag.lk {
    height: 10px;
    background-position: -2963px 0px;
  }
  .iti-flag.lr {
    height: 11px;
    background-position: -2985px 0px;
  }
  .iti-flag.ls {
    height: 14px;
    background-position: -3007px 0px;
  }
  .iti-flag.lt {
    height: 12px;
    background-position: -3029px 0px;
  }
  .iti-flag.lu {
    height: 12px;
    background-position: -3051px 0px;
  }
  .iti-flag.lv {
    height: 10px;
    background-position: -3073px 0px;
  }
  .iti-flag.ly {
    height: 10px;
    background-position: -3095px 0px;
  }
  .iti-flag.ma {
    height: 14px;
    background-position: -3117px 0px;
  }
  .iti-flag.mc {
    height: 15px;
    background-position: -3139px 0px;
  }
  .iti-flag.md {
    height: 10px;
    background-position: -3160px 0px;
  }
  .iti-flag.me {
    height: 10px;
    background-position: -3182px 0px;
  }
  .iti-flag.mf {
    height: 14px;
    background-position: -3204px 0px;
  }
  .iti-flag.mg {
    height: 14px;
    background-position: -3226px 0px;
  }
  .iti-flag.mh {
    height: 11px;
    background-position: -3248px 0px;
  }
  .iti-flag.mk {
    height: 10px;
    background-position: -3270px 0px;
  }
  .iti-flag.ml {
    height: 14px;
    background-position: -3292px 0px;
  }
  .iti-flag.mm {
    height: 14px;
    background-position: -3314px 0px;
  }
  .iti-flag.mn {
    height: 10px;
    background-position: -3336px 0px;
  }
  .iti-flag.mo {
    height: 14px;
    background-position: -3358px 0px;
  }
  .iti-flag.mp {
    height: 10px;
    background-position: -3380px 0px;
  }
  .iti-flag.mq {
    height: 14px;
    background-position: -3402px 0px;
  }
  .iti-flag.mr {
    height: 14px;
    background-position: -3424px 0px;
  }
  .iti-flag.ms {
    height: 10px;
    background-position: -3446px 0px;
  }
  .iti-flag.mt {
    height: 14px;
    background-position: -3468px 0px;
  }
  .iti-flag.mu {
    height: 14px;
    background-position: -3490px 0px;
  }
  .iti-flag.mv {
    height: 14px;
    background-position: -3512px 0px;
  }
  .iti-flag.mw {
    height: 14px;
    background-position: -3534px 0px;
  }
  .iti-flag.mx {
    height: 12px;
    background-position: -3556px 0px;
  }
  .iti-flag.my {
    height: 10px;
    background-position: -3578px 0px;
  }
  .iti-flag.mz {
    height: 14px;
    background-position: -3600px 0px;
  }
  .iti-flag.na {
    height: 14px;
    background-position: -3622px 0px;
  }
  .iti-flag.nc {
    height: 10px;
    background-position: -3644px 0px;
  }
  .iti-flag.ne {
    height: 15px;
    background-position: -3666px 0px;
  }
  .iti-flag.nf {
    height: 10px;
    background-position: -3686px 0px;
  }
  .iti-flag.ng {
    height: 10px;
    background-position: -3708px 0px;
  }
  .iti-flag.ni {
    height: 12px;
    background-position: -3730px 0px;
  }
  .iti-flag.nl {
    height: 14px;
    background-position: -3752px 0px;
  }
  .iti-flag.no {
    height: 15px;
    background-position: -3774px 0px;
  }
  .iti-flag.np {
    height: 15px;
    background-position: -3796px 0px;
  }
  .iti-flag.nr {
    height: 10px;
    background-position: -3811px 0px;
  }
  .iti-flag.nu {
    height: 10px;
    background-position: -3833px 0px;
  }
  .iti-flag.nz {
    height: 10px;
    background-position: -3855px 0px;
  }
  .iti-flag.om {
    height: 10px;
    background-position: -3877px 0px;
  }
  .iti-flag.pa {
    height: 14px;
    background-position: -3899px 0px;
  }
  .iti-flag.pe {
    height: 14px;
    background-position: -3921px 0px;
  }
  .iti-flag.pf {
    height: 14px;
    background-position: -3943px 0px;
  }
  .iti-flag.pg {
    height: 15px;
    background-position: -3965px 0px;
  }
  .iti-flag.ph {
    height: 10px;
    background-position: -3987px 0px;
  }
  .iti-flag.pk {
    height: 14px;
    background-position: -4009px 0px;
  }
  .iti-flag.pl {
    height: 13px;
    background-position: -4031px 0px;
  }
  .iti-flag.pm {
    height: 14px;
    background-position: -4053px 0px;
  }
  .iti-flag.pn {
    height: 10px;
    background-position: -4075px 0px;
  }
  .iti-flag.pr {
    height: 14px;
    background-position: -4097px 0px;
  }
  .iti-flag.ps {
    height: 10px;
    background-position: -4119px 0px;
  }
  .iti-flag.pt {
    height: 14px;
    background-position: -4141px 0px;
  }
  .iti-flag.pw {
    height: 13px;
    background-position: -4163px 0px;
  }
  .iti-flag.py {
    height: 11px;
    background-position: -4185px 0px;
  }
  .iti-flag.qa {
    height: 8px;
    background-position: -4207px 0px;
  }
  .iti-flag.re {
    height: 14px;
    background-position: -4229px 0px;
  }
  .iti-flag.ro {
    height: 14px;
    background-position: -4251px 0px;
  }
  .iti-flag.rs {
    height: 14px;
    background-position: -4273px 0px;
  }
  .iti-flag.ru {
    height: 14px;
    background-position: -4295px 0px;
  }
  .iti-flag.rw {
    height: 14px;
    background-position: -4317px 0px;
  }
  .iti-flag.sa {
    height: 14px;
    background-position: -4339px 0px;
  }
  .iti-flag.sb {
    height: 10px;
    background-position: -4361px 0px;
  }
  .iti-flag.sc {
    height: 10px;
    background-position: -4383px 0px;
  }
  .iti-flag.sd {
    height: 10px;
    background-position: -4405px 0px;
  }
  .iti-flag.se {
    height: 13px;
    background-position: -4427px 0px;
  }
  .iti-flag.sg {
    height: 14px;
    background-position: -4449px 0px;
  }
  .iti-flag.sh {
    height: 10px;
    background-position: -4471px 0px;
  }
  .iti-flag.si {
    height: 10px;
    background-position: -4493px 0px;
  }
  .iti-flag.sj {
    height: 15px;
    background-position: -4515px 0px;
  }
  .iti-flag.sk {
    height: 14px;
    background-position: -4537px 0px;
  }
  .iti-flag.sl {
    height: 14px;
    background-position: -4559px 0px;
  }
  .iti-flag.sm {
    height: 15px;
    background-position: -4581px 0px;
  }
  .iti-flag.sn {
    height: 14px;
    background-position: -4603px 0px;
  }
  .iti-flag.so {
    height: 14px;
    background-position: -4625px 0px;
  }
  .iti-flag.sr {
    height: 14px;
    background-position: -4647px 0px;
  }
  .iti-flag.ss {
    height: 10px;
    background-position: -4669px 0px;
  }
  .iti-flag.st {
    height: 10px;
    background-position: -4691px 0px;
  }
  .iti-flag.sv {
    height: 12px;
    background-position: -4713px 0px;
  }
  .iti-flag.sx {
    height: 14px;
    background-position: -4735px 0px;
  }
  .iti-flag.sy {
    height: 14px;
    background-position: -4757px 0px;
  }
  .iti-flag.sz {
    height: 14px;
    background-position: -4779px 0px;
  }
  .iti-flag.ta {
    height: 10px;
    background-position: -4801px 0px;
  }
  .iti-flag.tc {
    height: 10px;
    background-position: -4823px 0px;
  }
  .iti-flag.td {
    height: 14px;
    background-position: -4845px 0px;
  }
  .iti-flag.tf {
    height: 14px;
    background-position: -4867px 0px;
  }
  .iti-flag.tg {
    height: 13px;
    background-position: -4889px 0px;
  }
  .iti-flag.th {
    height: 14px;
    background-position: -4911px 0px;
  }
  .iti-flag.tj {
    height: 10px;
    background-position: -4933px 0px;
  }
  .iti-flag.tk {
    height: 10px;
    background-position: -4955px 0px;
  }
  .iti-flag.tl {
    height: 10px;
    background-position: -4977px 0px;
  }
  .iti-flag.tm {
    height: 14px;
    background-position: -4999px 0px;
  }
  .iti-flag.tn {
    height: 14px;
    background-position: -5021px 0px;
  }
  .iti-flag.to {
    height: 10px;
    background-position: -5043px 0px;
  }
  .iti-flag.tr {
    height: 14px;
    background-position: -5065px 0px;
  }
  .iti-flag.tt {
    height: 12px;
    background-position: -5087px 0px;
  }
  .iti-flag.tv {
    height: 10px;
    background-position: -5109px 0px;
  }
  .iti-flag.tw {
    height: 14px;
    background-position: -5131px 0px;
  }
  .iti-flag.tz {
    height: 14px;
    background-position: -5153px 0px;
  }
  .iti-flag.ua {
    height: 14px;
    background-position: -5175px 0px;
  }
  .iti-flag.ug {
    height: 14px;
    background-position: -5197px 0px;
  }
  .iti-flag.um {
    height: 11px;
    background-position: -5219px 0px;
  }
  .iti-flag.us {
    height: 11px;
    background-position: -5241px 0px;
  }
  .iti-flag.uy {
    height: 14px;
    background-position: -5263px 0px;
  }
  .iti-flag.uz {
    height: 10px;
    background-position: -5285px 0px;
  }
  .iti-flag.va {
    height: 15px;
    background-position: -5307px 0px;
  }
  .iti-flag.vc {
    height: 14px;
    background-position: -5324px 0px;
  }
  .iti-flag.ve {
    height: 14px;
    background-position: -5346px 0px;
  }
  .iti-flag.vg {
    height: 10px;
    background-position: -5368px 0px;
  }
  .iti-flag.vi {
    height: 14px;
    background-position: -5390px 0px;
  }
  .iti-flag.vn {
    height: 14px;
    background-position: -5412px 0px;
  }
  .iti-flag.vu {
    height: 12px;
    background-position: -5434px 0px;
  }
  .iti-flag.wf {
    height: 14px;
    background-position: -5456px 0px;
  }
  .iti-flag.ws {
    height: 10px;
    background-position: -5478px 0px;
  }
  .iti-flag.xk {
    height: 15px;
    background-position: -5500px 0px;
  }
  .iti-flag.ye {
    height: 14px;
    background-position: -5522px 0px;
  }
  .iti-flag.yt {
    height: 14px;
    background-position: -5544px 0px;
  }
  .iti-flag.za {
    height: 14px;
    background-position: -5566px 0px;
  }
  .iti-flag.zm {
    height: 14px;
    background-position: -5588px 0px;
  }
  .iti-flag.zw {
    height: 10px;
    background-position: -5610px 0px;
  }

  .iti-flag {
    width: 20px;
    height: 15px;
    box-shadow: 0px 0px 1px 0px #888;
    background-image: url("https://static.camper.com/mkt/clab16/new/assets/flags/flags.png");
    background-repeat: no-repeat;
    background-color: #dbdbdb;
    background-position: 20px 0;
  }

  .intl-tel-input {
    border: solid 1px ${e=>e.borderColor};
    width: ${e=>`${e.boxWidth}`};
    input {
      background-color: transparent;
      border: none;
      padding: 10px;
      box-sizing: border-box;
      font-family: ${e=>e.fontName};
      font-size: 12px;
      width: ${e=>`${e.boxWidth}`};
      height: ${e=>`${e.boxHeigth}`};
      -webkit-appearance: none;
      -moz-appearance: none;
      outline: none;
    }
  }

  /*# sourceMappingURL=main.css.map */

  .selected-flag {
    display: flex;
    font-family: ModerneRegular;
    font-weight: normal;
    font-size: 14px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code .selected-dial-code {
    padding-left: 5px;
  }

  .intl-tel-input .flag-container .arrow.down::after {
    content: "";
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(calc(-50% - 3px)) rotate(-45deg);
    width: 8.64px;
    height: 8.64px;
    border-left: 1px solid;
    border-bottom: 1px solid;
    pointer-events: none;
  }

  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-3 .selected-flag {
    width: 110px;
  }

  .intl-tel-input.allow-dropdown.separate-dial-code.iti-sdc-3
    input[type="tel"] {
    padding-left: 120px;
    font-size: 14px;
    font-family: "ModerneRegular";
    font-weight: normal;
  }

  .intl-tel-input .country-list {
    font-size: 14px;
    font-family: "ModerneRegular";
    font-weight: normal;
  }

  .intl-tel-input.allow-dropdown.separate-dial-code .selected-flag {
    display: flex;
  }

  .intl-tel-input .flag-container .arrow.up::after {
    content: "";
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(calc(-50% - -3px)) rotate(135deg);
    width: 8.64px;
    height: 8.64px;
    border-left: 1px solid;
    border-bottom: 1px solid;
    pointer-events: none;
  }

  .form-control {
    position: relative;
  }

  .PhoneInputInput {
    outline: none;
    border: none;
    flex-grow: 20;
    font-family: ${e=>e.fontName};
    background-color: transparent;
  }

  .PhoneInput {
    height: ${e=>`${e.boxHeigth}`};
    width: ${e=>`${e.boxWidth}`};

    border: 1px solid ${e=>e.borderColor};
  }

  .PhoneInputCountry {
    flex-grow: 1;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.05);
  }
`,bt=e.p`
  font-size: 10px;
  color: red;
  font-family: ModerneRegular;
  font-weight: normal;
  position: absolute;
  top: 10px;
  right: 20px;
`,xt=e=>{const{config:t}=f(Z),[a,o]=p(!0),n=g((()=>{var a;return null===(a=ue(t.language,e.placeholder))||void 0===a?void 0:a.replace(/[\n\r]+/gm,"<br/>")}),[e.placeholder]);return c.createElement(c.Fragment,null,c.createElement(ht,Object.assign({},e),c.createElement(z,{id:"selectPhoneNumber",onBlur:()=>{var e;let t=document.getElementsByClassName("PhoneInput");if(function(e){let t=e.substring(e.indexOf(" ")+1);return/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im.test(t.replace(/\s/g,""))}(null===(e=document.getElementById("selectPhoneNumber"))||void 0===e?void 0:e.value)){for(let e=0;e<t.length;e++){t[e].style.border="1px solid black"}o(!0)}else{for(let e=0;e<t.length;e++){t[e].style.border="2px solid red"}o(!1)}},defaultCountry:"ES",international:!0,placeholder:n,onChange:e=>{void 0!==e&&(e=>{var t;let a=e.substring(e.toString().indexOf(" ")+1),o=e.replace(/\s/g,"");e&&e.length>0?document.getElementById("userPhoneNumber").value=o:document.getElementById("userPhoneNumber").value=a;let n=document.getElementsByClassName("PhoneInput");if((null===(t=document.getElementById("selectPhoneNumber"))||void 0===t?void 0:t.value.length)>0)for(let e=0;e<n.length;e++)n[e].style.border="1px solid black";else for(let e=0;e<n.length;e++)n[e].style.border="2px solid red"})(e)}}),c.createElement("input",{type:"hidden",name:"userPhoneNumber",id:"userPhoneNumber"}),a?"":c.createElement(bt,null,"Invalid Phone")))},vt=e.input.withConfig({shouldForwardProp:e=>!["language"].includes(e)})`
  font-family: ${({language:e})=>Y(e)?"Arial":"ModerneBook"};
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #979797;
  font-size: 1rem;
  padding: 10px;
  width: 100%;

  ::-webkit-input-placeholder,
  ::-moz-:placeholder-shown,
  ::placeholder {
    color: black;
  }

  :focus::-webkit-input-placeholder,
  :focus::-moz-placeholder :focus::placeholder {
    color: gray;
  }

  @media (min-width: 768px) {
    font-size: 0.75em;
  }
`,yt=e.a.withConfig({shouldForwardProp:e=>!["underline","fontColor"].includes(e)})`
  text-decoration: ${e=>e.underline?"underline":"none"};
  &:hover {
    color: ${e=>{var t;return null!==(t=e.fontColor)&&void 0!==t?t:"#000000"}};
  }
`,kt=e.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`,wt=e.li`
  margin-top: 5px;
`,Ct=e.p.withConfig({shouldForwardProp:e=>!["as","bold","cursor","fontColor","fontColorMobile","fontColorTablet","fontName","fontSizeDesktop","fontSizeTablet","fontSizeMobile","fontWeight","lineHeight","lowerCase","marginTop","marginTopMobile","nowrap","script","text","textAlign","textDecoration","textShadowDesktop","textShadowTablet","textShadowMobile","tracking","trackingGA4","upperCase","storyLink","url"].includes(e)})`
  margin: 0;
  padding: 0;
  ${({textDecoration:e})=>e&&`text-decoration: ${e};`}
  ${({textAlign:e})=>e&&`text-align: ${e};`};
  white-space: ${e=>(e.nowrap?"nowrap":"normal")+";"};
  font-weight: ${e=>{var t;return(null!==(t=e.fontWeight)&&void 0!==t?t:e.bold?"bold":"normal")+";"}};
  font-family: ${e=>{var t;return(Y(e.language)?"Arial":null!==(t=e.fontName)&&void 0!==t?t:"ModeloRegular")+";"}};
  color: ${e=>{var t;return(null!==(t=e.fontColor)&&void 0!==t?t:"#000")+";"}};
  ${e=>""+(null!=e.fontName&&"ModeloBlack"==e.fontName&&Y(e.language)?"font-weight: bold":"")};
  ${e=>""+(e.upperCase?"text-transform: uppercase;":"")};
  ${e=>""+(e.lowerCase?"text-transform: lowercase;":"")};
  @media (min-width: 1440px) {
    color: ${e=>{var t;return null!==(t=e.fontColor)&&void 0!==t?t:"#000;"}};
    font-size: ${e=>re(e.fontSizeDesktop)+";"};
  }
  @media (min-width: 768px) and (max-width: 1439px) {
    color: ${e=>{var t,a;return null!==(a=null!==(t=e.fontColorTablet)&&void 0!==t?t:e.fontColor)&&void 0!==a?a:"#000;"}};
    font-size: ${e=>re(e.fontSizeTablet)+";"};
  }
  color: ${e=>{var t,a;return null!==(a=null!==(t=e.fontColorMobile)&&void 0!==t?t:e.fontColor)&&void 0!==a?a:"#000;"}};
  font-size: ${e=>re(e.fontSizeMobile)+";"};

  ${e=>""+(e.textShadowMobile?`text-shadow: ${e.textShadowMobile} 2px 2px 10px;`:"text-shadow: unset;")};
  @media (min-width: 1440px) {
    ${e=>""+(e.textShadowDesktop?`text-shadow: ${e.textShadowDesktop} 2px 2px 10px;`:"text-shadow: unset;")};
  }
  @media (min-width: 768px) and (max-width: 1439px) {
    ${e=>""+(e.textShadowTablet?`text-shadow: ${e.textShadowTablet} 2px 2px 10px;`:"text-shadow: unset;")};
  }

  ${e=>""+(e.cursor?`cursor: ${e.cursor};`:"")};
  ${e=>""+(e.lineHeight?`line-height: ${e.lineHeight};`:"")};
  ${e=>(e.marginTop?`margin-top: ${e.marginTop}px;`:"0px;")+"}"}
  ${e=>(e.storyLink?"display: inline-block;":"")+"}"}  
  @media (max-width: 768px) {
    ${e=>""+(e.marginTopMobile?`margin-top: ${e.marginTopMobile}px;`:"0px")}
  }
`,Dt=e=>{const{children:t,text:a}=e,o=P(e,["children","text"]),{config:n}=f(Z),i=g((()=>a?ue(n.language,a):t),[a,t]);return c.createElement(Ct,Object.assign({language:n.language},o),c.createElement((({children:e})=>{const t=c.Children.map(e,(e=>"string"==typeof e?c.createElement("span",{dangerouslySetInnerHTML:{__html:e}}):e));return c.createElement(c.Fragment,null,t)}),null,i))},St=e.a.withConfig({shouldForwardProp:e=>!["text","fontColor","fontColorTablet","fontColorMobile","fontWeight","selectedFontColor","backgroundColor","backgroundColorTablet","backgroundColorMobile","boxShadowDesktop","boxShadowTablet","boxShadowMobile","selectedBackgroundColor","fontSizeDesktop","fontSizeTablet","fontSizeMobile","fontName","marginTop","marginLeft","marginRight","cursor","upperCase","lowerCase","width","whiteSpace","showCountriesModal","underline","borderColor"].includes(e)})`
  pointer-events: initial;
  color: ${e=>{var t,a;return null!==(a=null!==(t=e.fontColorMobile)&&void 0!==t?t:e.fontColor)&&void 0!==a?a:"#000"}};
  font-family: ${e=>{var t;return Y(e.language)?"Arial":null!==(t=e.fontName)&&void 0!==t?t:"ModerneRegular"}};
  background-color: ${e=>{var t,a;return null!==(a=null!==(t=e.backgroundColorMobile)&&void 0!==t?t:e.backgroundColor)&&void 0!==a?a:"transparent"}};
  font-size: ${e=>re(e.fontSizeDesktop)};
  font-weight: ${e=>{var t;return null!==(t=e.fontWeight)&&void 0!==t?t:"normal"}};
  width: ${e=>{var t;return null!==(t=e.width)&&void 0!==t?t:"auto"}};
  text-decoration: ${e=>e.underline?"underline":"none"};
  white-space: ${e=>{var t;return null!==(t=e.whiteSpace)&&void 0!==t?t:"normal"}};

  @media (min-width: 1440px) {
    color: ${e=>{var t;return null!==(t=e.fontColor)&&void 0!==t?t:"#000;"}};
    background-color: ${e=>{var t;return null!==(t=e.backgroundColor)&&void 0!==t?t:"transparent"}};
    font-size: ${e=>re(e.fontSizeDesktop)};
  }
  @media (min-width: 768px) and (max-width: 1439px) {
    color: ${e=>{var t,a;return null!==(a=null!==(t=e.fontColorTablet)&&void 0!==t?t:e.fontColor)&&void 0!==a?a:"#000;"}};
    background-color: ${e=>{var t,a;return null!==(a=null!==(t=e.backgroundColorTablet)&&void 0!==t?t:e.backgroundColor)&&void 0!==a?a:"transparent"}};
    font-size: ${e=>re(e.fontSizeTablet)};
  }

  ${e=>""+(e.boxShadowMobile?`box-shadow: ${e.boxShadowMobile} 0px 4px 8px 0px, ${e.boxShadowMobile} 0px 6px 20px 0px;`:"box-shadow: unset;")};
  @media (min-width: 1440px) {
    ${e=>""+(e.boxShadowDesktop?`box-shadow: ${e.boxShadowDesktop} 0px 4px 8px 0px, ${e.boxShadowDesktop} 0px 6px 20px 0px;`:"box-shadow: unset;")};
  }
  @media (min-width: 768px) and (max-width: 1439px) {
    ${e=>""+(e.boxShadowTablet?`box-shadow: ${e.boxShadowTablet} 0px 4px 8px 0px, ${e.boxShadowTablet} 0px 6px 20px 0px;`:"box-shadow: unset;")};
  }

  ${e=>void 0!==e.marginTop?0===e.marginTop?"margin-top:15px":`margin-top:${e.marginTop}px`:""};
  ${e=>void 0!==e.marginLeft?`margin-left:${e.marginLeft}px`:"margin-left:4px"};
  ${e=>void 0!==e.marginRight?`margin-right:${e.marginRight}px`:"margin-right:4px"};
  margin-bottom: 4px;
  ${e=>void 0!==e.cursor?`cursor:${e.cursor}`:""};
  appearance: none;
  border: none;
  display: inline-block;
  padding: 10px 20px;
  text-align: center;
  ${e=>""+(e.upperCase?"text-transform: uppercase":"")};
  ${e=>""+(e.lowerCase?"text-transform: lowercase":"")};
  ${e=>!e.backgroundColor&&e.fontColor?`border:1px solid ${e.fontColor}`:""};
  ${e=>e.selectedFontColor||e.selectedBackgroundColor?`&:hover{ ${e.selectedFontColor?"color:"+e.selectedFontColor+";":e.fontColor?"color:"+e.fontColor+";":"color: #000;"} ${e.selectedBackgroundColor?"background-color:"+e.selectedBackgroundColor+";":e.backgroundColor?"background-color:"+e.backgroundColor+";":"background-color: transparent;"} }`:""};
  ${e=>""+(e.borderColor?`border: 1px solid ${e.borderColor}`:"border: none")};
`,Tt=e=>{const{config:t}=f(Z),{children:a,text:o}=e,n=P(e,["children","text"]),i=g((()=>o?ue(t.language,o):a),[o,a]);return c.createElement(St,Object.assign({language:t.language},n,{onClick:t=>{e.showCountriesModal&&(t.preventDefault(),e.showI18nModal&&e.showI18nModal())}}),i)},_t=e.a`
  color: ${e=>{var t;return null!==(t=e.fontColor)&&void 0!==t?t:"#000"}};
  font-family: ${e=>{var t;return null!==(t=e.fontName)&&void 0!==t?t:"ModerneRegular"}};
  background-color: ${e=>{var t;return null!==(t=e.backgroundColor)&&void 0!==t?t:""}};
  font-size: ${e=>{var t;return`${null!==(t=e.fontSizeDesktop)&&void 0!==t?t:.75}rem`}};
  ${e=>0!==e.marginTop?`margin-top:${e.marginTop}px`:""};
  ${e=>0===e.marginTop?"margin:10px 4px":""};
  text-decoration: none;
  appearance: none;
  border: none;
  display: inline-block;
  padding: 10px 20px;
  text-align: center;
`,zt=u({market:"T000"}),Et=c.forwardRef((({className:e,text:t,onClick:a,component:o},n)=>{const{config:i}=f(Z),{vars:l}=f(zt),r=g((()=>{var e;let a=null===(e=ue(i.language,t))||void 0===e?void 0:e.replace(/[\n\r]+/gm,"<br/>");if(l)for(const e of Object.keys(l)){const t=l[e]+"";a=null==a?void 0:a.replace(new RegExp(`{{${e}}}`,"gmi"),t)}return a}),[t,l]);return c.createElement(Nt,{as:o,ref:n,className:e,onClick:a,dangerouslySetInnerHTML:{__html:r}})})),Nt=e.p`
  margin: 0;
  padding: 0;
  //font-family: Arial;
  //font-size: 14px;
  //font-weight: normal;
`,Mt=c.forwardRef((({className:e,alt:t,mobile:a,tablet:o,desktop:n,bigScreen:i,onClick:l,controls:r,autoPlay:s,loop:d,muted:u,playsInline:p,poster:m,lazy:h},b)=>{const{config:x}=f(Z),v=g((()=>ue(x.language,t)),[x.language,t]);return a?c.createElement("video",{ref:b,controls:r,autoPlay:s,loop:d,onClick:l,className:`${e}${h&&!x.isPreview?" lazy":""}`,title:v,muted:u,playsInline:p,poster:m},h&&!x.isPreview?c.createElement(c.Fragment,null,(null==i?void 0:i.webm)&&c.createElement("source",{"data-src":i.webm.startsWith("http")?i.webm:x.urlBase+i.webm,type:"video/webm",media:"(min-width: 1600px)"}),(null==i?void 0:i.mp4)&&c.createElement("source",{"data-src":i.mp4.startsWith("http")?i.mp4:x.urlBase+i.mp4,media:"(min-width: 1600px)",type:"video/mp4"}),(null==n?void 0:n.webm)&&c.createElement("source",{"data-src":n.webm.startsWith("http")?n.webm:x.urlBase+n.webm,type:"video/webm",media:"(min-width: 1200px)"}),(null==n?void 0:n.mp4)&&c.createElement("source",{"data-src":n.mp4.startsWith("http")?n.mp4:x.urlBase+n.mp4,media:"(min-width: 1200px)",type:"video/mp4"}),(null==o?void 0:o.webm)&&c.createElement("source",{"data-src":o.webm.startsWith("http")?o.webm:x.urlBase+o.webm,type:"video/webm",media:"(min-width: 768px)"}),(null==o?void 0:o.mp4)&&c.createElement("source",{"data-src":o.mp4.startsWith("http")?o.mp4:x.urlBase+o.mp4,media:"(min-width: 768px)",type:"video/mp4"}),a.webm&&c.createElement("source",{"data-src":a.webm.startsWith("http")?a.webm:x.urlBase+a.webm,type:"video/webm"}),c.createElement("source",{"data-src":a.mp4.startsWith("http")?a.mp4:x.urlBase+a.mp4,type:"video/mp4"})):c.createElement(c.Fragment,null,(null==i?void 0:i.webm)&&c.createElement("source",{src:i.webm.startsWith("http")?i.webm:x.urlBase+i.webm,type:"video/webm",media:"(min-width: 1600px)"}),(null==i?void 0:i.mp4)&&c.createElement("source",{src:i.mp4.startsWith("http")?i.mp4:x.urlBase+i.mp4,media:"(min-width: 1600px)",type:"video/mp4"}),(null==n?void 0:n.webm)&&c.createElement("source",{src:n.webm.startsWith("http")?n.webm:x.urlBase+n.webm,type:"video/webm",media:"(min-width: 1200px)"}),(null==n?void 0:n.mp4)&&c.createElement("source",{src:n.mp4.startsWith("http")?n.mp4:x.urlBase+n.mp4,media:"(min-width: 1200px)",type:"video/mp4"}),(null==o?void 0:o.webm)&&c.createElement("source",{src:o.webm.startsWith("http")?o.webm:x.urlBase+o.webm,type:"video/webm",media:"(min-width: 768px)"}),(null==o?void 0:o.mp4)&&c.createElement("source",{src:o.mp4.startsWith("http")?o.mp4:x.urlBase+o.mp4,media:"(min-width: 768px)",type:"video/mp4"}),a.webm&&c.createElement("source",{src:a.webm.startsWith("http")?a.webm:x.urlBase+a.webm,type:"video/webm"}),c.createElement("source",{src:a.mp4.startsWith("http")?a.mp4:x.urlBase+a.mp4,type:"video/mp4"}))):null}));function $t(e,t,a){if("undefined"==typeof window)return Promise.reject("Load asset can be called only from browser side");let o=document.getElementById(e);if(o)return Promise.resolve();switch(t){case"script":o=function(e,t){const a=document.createElement("script");return a.id=e,a.src=t,a.type="text/javascript",document.body.appendChild(a),a}(e,a);break;case"style":o=function(e,t){const a=document.createElement("link");return a.id=e,a.href=t,a.rel="stylesheet",document.head.appendChild(a),a}(e,a);break;case"scriptHome":o=function(e,t){const a=document.createElement("script");a.type="application/ld+json",a.id=e;const o={"@context":"https://schema.org","@type":"Organization",url:t,name:"NNormal",logo:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/1bc02c82-b9b7-4feb-a8af-88ab7b304dcc/nnormal-logo.svg",alternateName:["normal","Nnormal","nnormal","n normal","N Normal"]};return a.textContent=JSON.stringify(o),document.head.appendChild(a),a}(e,a);break;default:throw new Error(`Unexpected type asset ${t}`)}return new Promise(((e,t)=>{o?(o.addEventListener("load",(function(t){e()})),o.addEventListener("error",(function(e){t(e)}))):t("Expected node")}))}let Bt=!1;const At=c.forwardRef((({videoId:e,autoplay:t},a)=>{const o=h(null),[n,i]=p(!1),[l,r]=p(null);return m((()=>{a&&("function"==typeof a?a(o.current):a.current=o.current)}),[o,a]),m((()=>{"undefined"!=typeof window&&$t("youtube_iframe_api","script","https://www.youtube.com/iframe_api").then((()=>{Bt?i(!0):window.onYouTubeIframeAPIReady=()=>{Bt=!0,i(!0)}}))}),[]),m((()=>{if("undefined"==typeof window)return;if(!n)return;if(!o.current)return;if(!e)return;const a={videoId:e,playerVars:{autoplay:!0===t?1:0}},i=new YT.Player(o.current,a);return r(i),()=>{i.destroy()}}),[o,n,t,e]),c.createElement("div",{ref:o})}));function Lt(e){const t=h(null);return m((function(){const a=document.querySelector(`#${e}`),o=a||function(e){const t=document.createElement("div");return t.setAttribute("id",e),t}(e);var n;if(a||(n=o,document.body.appendChild(n)),t.current)return o.appendChild(t.current),function(){var e;null===(e=t.current)||void 0===e||e.remove(),o.childElementCount||o.remove()}}),[e]),"undefined"==typeof document?null:(t.current||(t.current=document.createElement("div")),t.current)}const It=({visible:e,onClick:t})=>{const a=Lt("modal-backdrop");return m((()=>{if("undefined"==typeof document)return;if(!a)return;const e=()=>{a.querySelectorAll(".visible").length>0?document.body.style.overflow="hidden":document.body.style.overflow="auto"};return e(),()=>{e()}}),[a,e]),a?N(c.createElement(Ft,{onClick:t,className:E(e&&"visible")}),a):c.createElement(c.Fragment,null)},Ft=e.div`
  pointer-events: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  opacity: 0;
  transition: opacity 0.3s;
  &.visible {
    pointer-events: all;
    opacity: 1;
  }
`,Gt=({html:e,className:t})=>(m((()=>{M(e,{replace:e=>{if("script"===e.type){let t=!!(e instanceof $&&e.attribs.src);const a=document.createElement("script");t?a.src=e instanceof $?e.attribs.src:"":a.innerHTML=e instanceof $&&e.children[0]?e.children[0].data:"",document.head.append(a)}}})}),[]),c.createElement("div",{className:t,dangerouslySetInnerHTML:{__html:e}}));let Pt=class{constructor(e){this.fetchPopUpById=e=>this.fetchService.cmsFetchGraphQL("getPopUpId","query getPopUpId($id: String!) { findPopUpContent(id: $id) { flatData { title behaviour campaign { id flatData { name } } color background dataEnrichment showVoucher allowedUsers popUps { flatData { images{ assets { metadata mimeType fileName fileType tags url } } type { flatData { name } } buttons { fontColor className fontSize slug { flatData { slug action } } fontFamily { flatData { name } } literal { flatData { text } } } texts { fontColor className fontSize slug { flatData { slug action } } fontFamily { flatData { name } } textType { flatData{ name } } literal { flatData { text } } } images { assets { fileName url tags } } } } } }}",{id:e}),this.fetchPopUpDetail=e=>this.fetchService.cmsFetchGraphQL("GetPopUp",`query GetPopUp{queryPopUpContents(filter:"status eq 'Published' and data/countries/iv eq '${e}'",orderby:"created desc"){ flatData { title behaviour campaign { id flatData { name } } color background dataEnrichment showVoucher allowedUsers popUps { flatData { images{ assets { metadata mimeType fileName fileType tags url } } type { flatData { name } } buttons { fontColor className fontSize slug { flatData { slug action } } fontFamily { flatData { name } } literal { flatData { text } } } texts { fontColor className fontSize slug { flatData { slug action } } fontFamily { flatData { name } } textType { flatData{ name } } literal { flatData { text } } } images { assets { fileName url tags } } } } } }}`),this.fetchService=e}};Pt=O([D(),j("design:paramtypes",[te])],Pt);let Ot=class{constructor(e){this.getConfig=()=>this.fetchService.cmsFetchGraphQL("GetConfig","query GetConfig { queryConfigurationContents(top: 1) { id flatData { name configuration { startDate endDate countries { flatData { name } } } } } }"),this.fetchCampaignById=e=>this.fetchService.cmsFetchGraphQL("getCampaignById","query getCampaignById($id: String!) { findCampaignsContent(id: $id) { id flatData { name configuration { startDate endDate countries { flatData { name code } } } } } }",{id:e}),this.fetchService=e}};function jt(e,t){return null!=e?e:[{flatData:{[t]:""}}]}function Rt(e,t,a,o){var n,i,l,r,s,d,c,u,p,m,f,g,h,b,x,v,y,k,w,C,D,S,T,_,z,E,N,M,$,B,A,L,I,F,G,P,O,j,R,q,H,U,W,Q,Y,V,X,J,K,Z,ee,te,ae,oe,ne,ie,le,re,se,de,ce,ue,pe,me,fe,ge,he,be,xe,ve,ye,ke,we,Ce,De,Se,Te,_e,ze,Ee,Ne,Me,$e,Be,Ae,Le,Ie,Fe,Ge,Pe,Oe,je,Re,qe,He,Ue,We,Qe,Ye,Ve,Xe,Je,Ke,Ze,et,tt,at,ot,nt,it,lt,rt,st,dt,ct,ut,pt,mt,ft,gt,ht,bt,xt,vt,yt,kt,wt,Ct,Dt,St,Tt,_t,zt,Et,Nt,Mt,$t,Bt,At,Lt,It,Ft,Gt,Pt,Ot,Rt,qt,Ht,Ut,Wt,Qt,Yt,Vt,Xt,Jt,Kt,Zt,ea,ta,aa,oa,na,ia,la,ra,sa,da,ca,ua,pa,ma,fa,ga,ha,ba,xa,va,ya,ka,wa,Ca,Da;const Sa=function(e){var t,a;return e?{id:null!==(t=e.id)&&void 0!==t?t:"",name:e.flatData.name,configuration:null===(a=e.flatData.configuration)||void 0===a?void 0:a.map((e=>({startDate:e.startDate,endDate:e.endDate,countries:e.countries.map((e=>({flatData:{name:e.flatData.name,code:e.flatData.code}})))})))}:null}(null!=t?t:null),Ta=null===(n=null==Sa?void 0:Sa.configuration)||void 0===n?void 0:n.find((e=>e.countries.some((e=>e.flatData.code===a)))),_a={startDate:null!==(i=null==Ta?void 0:Ta.startDate)&&void 0!==i?i:"",endDate:null!==(l=null==Ta?void 0:Ta.endDate)&&void 0!==l?l:""},za=e.flatData.popUps.find((e=>"emailStep"===e.flatData.type[0].flatData.name)),Ea=e.flatData.popUps.find((e=>"extraStep"===e.flatData.type[0].flatData.name)),Na=e.flatData.popUps.find((e=>"thanksStep"===e.flatData.type[0].flatData.name)),Ma=e=>e?function(e,t,a){const o=e.replace(/{{([^,}]+),([^}]+)}}/g,((e,o,n)=>{const i="fecha_inicio"===o.trim()?t.startDate:"fecha_fin"===o.trim()?t.endDate:null;if(!i)return e;const l=new Date(i);return isNaN(l.getTime())?e:function(e,t,a){const o=e.getDate().toString().padStart(2,"0"),n=(e.getMonth()+1).toString().padStart(2,"0"),i=e.getFullYear().toString(),l=i.slice(-2);let r=e.toLocaleString(a,{month:"short"});return r=r.charAt(0).toUpperCase()+r.slice(1),t.replace("DD",o).replace("MMM",r).replace("MM",n).replace("yyyy",i).replace("yy",l)}(l,n.trim(),a)}));return o}(e,_a,o):"";return{behaviour:e.flatData.behaviour,dataEnrichment:null!==(r=e.flatData.dataEnrichment)&&void 0!==r&&r,showVoucher:null!==(s=e.flatData.showVoucher)&&void 0!==s&&s,allowedUsers:null!==(d=e.flatData.allowedUsers)&&void 0!==d?d:"all",subscribeUsers:null!==(c=e.flatData.subscribeUsers)&&void 0!==c?c:"all",campaign:{id:null!==(u=null==Sa?void 0:Sa.id)&&void 0!==u?u:"",name:null!==(p=null==Sa?void 0:Sa.name)&&void 0!==p?p:""},style:{color:e.flatData.color,background:e.flatData.background},emailStep:{image:{url:null!==(m=null==za?void 0:za.flatData.images[0].assets[0].url)&&void 0!==m?m:"",mimeType:null==za?void 0:za.flatData.images[0].assets[0].mimeType,fileName:null!==(f=null==za?void 0:za.flatData.images[0].assets[0].fileName)&&void 0!==f?f:"",tags:null!==(g=null==za?void 0:za.flatData.images[0].assets[0].tags)&&void 0!==g?g:[""],metadata:null==za?void 0:za.flatData.images[0].assets[0].metadata},title:{text:Ma(null!==(b=null===(h=null==za?void 0:za.flatData.texts.find((e=>"Claim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===h?void 0:h.literal[0].flatData.text)&&void 0!==b?b:""),href:null!==(y=null===(v=jt(null===(x=null==za?void 0:za.flatData.texts.find((e=>"Claim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===x?void 0:x.slug,"slug")[0])||void 0===v?void 0:v.flatData.slug)&&void 0!==y?y:"",style:{color:null!==(w=null===(k=null==za?void 0:za.flatData.texts.find((e=>"Claim"===jt(e.textType,"name")[0].flatData.name)))||void 0===k?void 0:k.fontColor)&&void 0!==w?w:"",fontSize:null!==(D=null===(C=null==za?void 0:za.flatData.texts.find((e=>"Claim"===jt(e.textType,"name")[0].flatData.name)))||void 0===C?void 0:C.fontSize)&&void 0!==D?D:"",fontFamily:null!==(_=null===(T=jt(null===(S=null==za?void 0:za.flatData.texts.find((e=>"Claim"===jt(e.textType,"name")[0].flatData.name)))||void 0===S?void 0:S.fontFamily,"name")[0])||void 0===T?void 0:T.flatData.name)&&void 0!==_?_:""},className:null!==(E=null===(z=null==za?void 0:za.flatData.texts.find((e=>"Claim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===z?void 0:z.className)&&void 0!==E?E:""},subtitle:{text:Ma(null!==(M=null===(N=null==za?void 0:za.flatData.texts.find((e=>"Subclaim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===N?void 0:N.literal[0].flatData.text)&&void 0!==M?M:""),href:null!==(A=null===(B=jt(null===($=null==za?void 0:za.flatData.texts.find((e=>"Subclaim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===$?void 0:$.slug,"slug")[0])||void 0===B?void 0:B.flatData.slug)&&void 0!==A?A:"",style:{color:null!==(I=null===(L=null==za?void 0:za.flatData.texts.find((e=>"Subclaim"===jt(e.textType,"name")[0].flatData.name)))||void 0===L?void 0:L.fontColor)&&void 0!==I?I:"",fontSize:null!==(G=null===(F=null==za?void 0:za.flatData.texts.find((e=>"Subclaim"===jt(e.textType,"name")[0].flatData.name)))||void 0===F?void 0:F.fontSize)&&void 0!==G?G:"",fontFamily:null!==(j=null===(O=jt(null===(P=null==za?void 0:za.flatData.texts.find((e=>"Subclaim"===jt(e.textType,"name")[0].flatData.name)))||void 0===P?void 0:P.fontFamily,"name")[0])||void 0===O?void 0:O.flatData.name)&&void 0!==j?j:""},className:null!==(q=null===(R=null==za?void 0:za.flatData.texts.find((e=>"Subclaim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===R?void 0:R.className)&&void 0!==q?q:""},submit:{text:Ma(null!==(U=null===(H=null==za?void 0:za.flatData.texts.find((e=>"CTA"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===H?void 0:H.literal[0].flatData.text)&&void 0!==U?U:""),href:null!==(Y=null===(Q=jt(null===(W=null==za?void 0:za.flatData.texts.find((e=>"CTA"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===W?void 0:W.slug,"slug")[0])||void 0===Q?void 0:Q.flatData.slug)&&void 0!==Y?Y:"",style:{color:null!==(X=null===(V=null==za?void 0:za.flatData.texts.find((e=>"CTA"===jt(e.textType,"name")[0].flatData.name)))||void 0===V?void 0:V.fontColor)&&void 0!==X?X:"",fontSize:null!==(K=null===(J=null==za?void 0:za.flatData.texts.find((e=>"CTA"===jt(e.textType,"name")[0].flatData.name)))||void 0===J?void 0:J.fontSize)&&void 0!==K?K:"",fontFamily:null!==(te=null===(ee=jt(null===(Z=null==za?void 0:za.flatData.texts.find((e=>"CTA"===jt(e.textType,"name")[0].flatData.name)))||void 0===Z?void 0:Z.fontFamily,"name")[0])||void 0===ee?void 0:ee.flatData.name)&&void 0!==te?te:""},className:null!==(oe=null===(ae=null==za?void 0:za.flatData.texts.find((e=>"CTA"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===ae?void 0:ae.className)&&void 0!==oe?oe:""}},extraStep:{title:{text:Ma(null!==(ie=null===(ne=null==Ea?void 0:Ea.flatData.texts.find((e=>"Claim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===ne?void 0:ne.literal[0].flatData.text)&&void 0!==ie?ie:""),href:null!==(se=null===(re=jt(null===(le=null==Ea?void 0:Ea.flatData.texts.find((e=>"Claim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===le?void 0:le.slug,"slug")[0])||void 0===re?void 0:re.flatData.slug)&&void 0!==se?se:"",style:{color:null!==(ce=null===(de=null==Ea?void 0:Ea.flatData.texts.find((e=>"Claim"===jt(e.textType,"name")[0].flatData.name)))||void 0===de?void 0:de.fontColor)&&void 0!==ce?ce:"",fontSize:null!==(pe=null===(ue=null==Ea?void 0:Ea.flatData.texts.find((e=>"Claim"===jt(e.textType,"name")[0].flatData.name)))||void 0===ue?void 0:ue.fontSize)&&void 0!==pe?pe:"",fontFamily:null!==(ge=null===(fe=jt(null===(me=null==Ea?void 0:Ea.flatData.texts.find((e=>"Claim"===jt(e.textType,"name")[0].flatData.name)))||void 0===me?void 0:me.fontFamily,"name")[0])||void 0===fe?void 0:fe.flatData.name)&&void 0!==ge?ge:""},className:null!==(be=null===(he=null==Ea?void 0:Ea.flatData.texts.find((e=>"Claim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===he?void 0:he.className)&&void 0!==be?be:""},subtitle:{text:Ma(null!==(ve=null===(xe=null==Ea?void 0:Ea.flatData.texts.find((e=>"Subclaim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===xe?void 0:xe.literal[0].flatData.text)&&void 0!==ve?ve:""),href:null!==(we=null===(ke=jt(null===(ye=null==Ea?void 0:Ea.flatData.texts.find((e=>"Subclaim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===ye?void 0:ye.slug,"slug")[0])||void 0===ke?void 0:ke.flatData.slug)&&void 0!==we?we:"",style:{color:null!==(De=null===(Ce=null==Ea?void 0:Ea.flatData.texts.find((e=>"Subclaim"===jt(e.textType,"name")[0].flatData.name)))||void 0===Ce?void 0:Ce.fontColor)&&void 0!==De?De:"",fontSize:null!==(Te=null===(Se=null==Ea?void 0:Ea.flatData.texts.find((e=>"Subclaim"===jt(e.textType,"name")[0].flatData.name)))||void 0===Se?void 0:Se.fontSize)&&void 0!==Te?Te:"",fontFamily:null!==(Ee=null===(ze=jt(null===(_e=null==Ea?void 0:Ea.flatData.texts.find((e=>"Subclaim"===jt(e.textType,"name")[0].flatData.name)))||void 0===_e?void 0:_e.fontFamily,"name")[0])||void 0===ze?void 0:ze.flatData.name)&&void 0!==Ee?Ee:""},className:null!==(Me=null===(Ne=null==Ea?void 0:Ea.flatData.texts.find((e=>"Subclaim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===Ne?void 0:Ne.className)&&void 0!==Me?Me:""},submit:{text:Ma(null!==(Be=null===($e=null==Ea?void 0:Ea.flatData.texts.find((e=>"CTA"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===$e?void 0:$e.literal[0].flatData.text)&&void 0!==Be?Be:""),href:null!==(Ie=null===(Le=jt(null===(Ae=null==Ea?void 0:Ea.flatData.texts.find((e=>"CTA"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===Ae?void 0:Ae.slug,"slug")[0])||void 0===Le?void 0:Le.flatData.slug)&&void 0!==Ie?Ie:"",style:{color:null!==(Ge=null===(Fe=null==Ea?void 0:Ea.flatData.texts.find((e=>"CTA"===jt(e.textType,"name")[0].flatData.name)))||void 0===Fe?void 0:Fe.fontColor)&&void 0!==Ge?Ge:"",fontSize:null!==(Oe=null===(Pe=null==Ea?void 0:Ea.flatData.texts.find((e=>"CTA"===jt(e.textType,"name")[0].flatData.name)))||void 0===Pe?void 0:Pe.fontSize)&&void 0!==Oe?Oe:"",fontFamily:null!==(qe=null===(Re=jt(null===(je=null==Ea?void 0:Ea.flatData.texts.find((e=>"CTA"===jt(e.textType,"name")[0].flatData.name)))||void 0===je?void 0:je.fontFamily,"name")[0])||void 0===Re?void 0:Re.flatData.name)&&void 0!==qe?qe:""},className:null!==(Ue=null===(He=null==Ea?void 0:Ea.flatData.texts.find((e=>"CTA"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===He?void 0:He.className)&&void 0!==Ue?Ue:""},next:{text:Ma(null!==(Qe=null===(We=null==Ea?void 0:Ea.flatData.texts.find((e=>"NEXT"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===We?void 0:We.literal[0].flatData.text)&&void 0!==Qe?Qe:""),href:null!==(Xe=null===(Ve=jt(null===(Ye=null==Ea?void 0:Ea.flatData.texts.find((e=>"NEXT"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===Ye?void 0:Ye.slug,"slug")[0])||void 0===Ve?void 0:Ve.flatData.slug)&&void 0!==Xe?Xe:"",style:{color:null!==(Ke=null===(Je=null==Ea?void 0:Ea.flatData.texts.find((e=>"NEXT"===jt(e.textType,"name")[0].flatData.name)))||void 0===Je?void 0:Je.fontColor)&&void 0!==Ke?Ke:"",fontSize:null!==(et=null===(Ze=null==Ea?void 0:Ea.flatData.texts.find((e=>"NEXT"===jt(e.textType,"name")[0].flatData.name)))||void 0===Ze?void 0:Ze.fontSize)&&void 0!==et?et:"",fontFamily:null!==(ot=null===(at=jt(null===(tt=null==Ea?void 0:Ea.flatData.texts.find((e=>"NEXT"===jt(e.textType,"name")[0].flatData.name)))||void 0===tt?void 0:tt.fontFamily,"name")[0])||void 0===at?void 0:at.flatData.name)&&void 0!==ot?ot:""},className:null!==(it=null===(nt=null==Ea?void 0:Ea.flatData.texts.find((e=>"NEXT"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===nt?void 0:nt.className)&&void 0!==it?it:""}},thanksStep:{title:{text:Ma(null!==(rt=null===(lt=null==Na?void 0:Na.flatData.texts.find((e=>"Claim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===lt?void 0:lt.literal[0].flatData.text)&&void 0!==rt?rt:""),href:null!==(ct=null===(dt=jt(null===(st=null==Na?void 0:Na.flatData.texts.find((e=>"Claim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===st?void 0:st.slug,"slug")[0])||void 0===dt?void 0:dt.flatData.slug)&&void 0!==ct?ct:"",style:{color:null!==(pt=null===(ut=null==Na?void 0:Na.flatData.texts.find((e=>"Claim"===jt(e.textType,"name")[0].flatData.name)))||void 0===ut?void 0:ut.fontColor)&&void 0!==pt?pt:"",fontSize:null!==(ft=null===(mt=null==Na?void 0:Na.flatData.texts.find((e=>"Claim"===jt(e.textType,"name")[0].flatData.name)))||void 0===mt?void 0:mt.fontSize)&&void 0!==ft?ft:"",fontFamily:null!==(bt=null===(ht=jt(null===(gt=null==Na?void 0:Na.flatData.texts.find((e=>"Claim"===jt(e.textType,"name")[0].flatData.name)))||void 0===gt?void 0:gt.fontFamily,"name")[0])||void 0===ht?void 0:ht.flatData.name)&&void 0!==bt?bt:""},className:null!==(vt=null===(xt=null==Na?void 0:Na.flatData.texts.find((e=>"Claim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===xt?void 0:xt.className)&&void 0!==vt?vt:""},subtitle:{text:Ma(null!==(kt=null===(yt=null==Na?void 0:Na.flatData.texts.find((e=>"Subclaim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===yt?void 0:yt.literal[0].flatData.text)&&void 0!==kt?kt:""),href:null!==(Dt=null===(Ct=jt(null===(wt=null==Na?void 0:Na.flatData.texts.find((e=>"Subclaim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===wt?void 0:wt.slug,"slug")[0])||void 0===Ct?void 0:Ct.flatData.slug)&&void 0!==Dt?Dt:"",style:{color:null!==(Tt=null===(St=null==Na?void 0:Na.flatData.texts.find((e=>"Subclaim"===jt(e.textType,"name")[0].flatData.name)))||void 0===St?void 0:St.fontColor)&&void 0!==Tt?Tt:"",fontSize:null!==(zt=null===(_t=null==Na?void 0:Na.flatData.texts.find((e=>"Subclaim"===jt(e.textType,"name")[0].flatData.name)))||void 0===_t?void 0:_t.fontSize)&&void 0!==zt?zt:"",fontFamily:null!==(Mt=null===(Nt=jt(null===(Et=null==Na?void 0:Na.flatData.texts.find((e=>"Subclaim"===jt(e.textType,"name")[0].flatData.name)))||void 0===Et?void 0:Et.fontFamily,"name")[0])||void 0===Nt?void 0:Nt.flatData.name)&&void 0!==Mt?Mt:""},className:null!==(Bt=null===($t=null==Na?void 0:Na.flatData.texts.find((e=>"Subclaim"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===$t?void 0:$t.className)&&void 0!==Bt?Bt:""},voucher:{text:Ma(null!==(Lt=null===(At=null==Na?void 0:Na.flatData.texts.find((e=>"VOUCHER"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===At?void 0:At.literal[0].flatData.text)&&void 0!==Lt?Lt:""),href:null!==(Gt=null===(Ft=jt(null===(It=null==Na?void 0:Na.flatData.texts.find((e=>"VOUCHER"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===It?void 0:It.slug,"slug")[0])||void 0===Ft?void 0:Ft.flatData.slug)&&void 0!==Gt?Gt:"",style:{color:null!==(Ot=null===(Pt=null==Na?void 0:Na.flatData.texts.find((e=>"VOUCHER"===jt(e.textType,"name")[0].flatData.name)))||void 0===Pt?void 0:Pt.fontColor)&&void 0!==Ot?Ot:"",fontSize:null!==(qt=null===(Rt=null==Na?void 0:Na.flatData.texts.find((e=>"VOUCHER"===jt(e.textType,"name")[0].flatData.name)))||void 0===Rt?void 0:Rt.fontSize)&&void 0!==qt?qt:"",fontFamily:null!==(Wt=null===(Ut=jt(null===(Ht=null==Na?void 0:Na.flatData.texts.find((e=>"VOUCHER"===jt(e.textType,"name")[0].flatData.name)))||void 0===Ht?void 0:Ht.fontFamily,"name")[0])||void 0===Ut?void 0:Ut.flatData.name)&&void 0!==Wt?Wt:""},className:null!==(Yt=null===(Qt=null==Na?void 0:Na.flatData.texts.find((e=>"VOUCHER"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===Qt?void 0:Qt.className)&&void 0!==Yt?Yt:""},ctaTitle:{text:Ma(null!==(Xt=null===(Vt=null==Na?void 0:Na.flatData.texts.find((e=>"CTATITLE"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===Vt?void 0:Vt.literal[0].flatData.text)&&void 0!==Xt?Xt:""),href:null!==(Zt=null===(Kt=jt(null===(Jt=null==Na?void 0:Na.flatData.texts.find((e=>"CTATITLE"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===Jt?void 0:Jt.slug,"slug")[0])||void 0===Kt?void 0:Kt.flatData.slug)&&void 0!==Zt?Zt:"",style:{color:null!==(ta=null===(ea=null==Na?void 0:Na.flatData.texts.find((e=>"CTATITLE"===jt(e.textType,"name")[0].flatData.name)))||void 0===ea?void 0:ea.fontColor)&&void 0!==ta?ta:"",fontSize:null!==(oa=null===(aa=null==Na?void 0:Na.flatData.texts.find((e=>"CTATITLE"===jt(e.textType,"name")[0].flatData.name)))||void 0===aa?void 0:aa.fontSize)&&void 0!==oa?oa:"",fontFamily:null!==(la=null===(ia=jt(null===(na=null==Na?void 0:Na.flatData.texts.find((e=>"CTATITLE"===jt(e.textType,"name")[0].flatData.name)))||void 0===na?void 0:na.fontFamily,"name")[0])||void 0===ia?void 0:ia.flatData.name)&&void 0!==la?la:""},className:null!==(sa=null===(ra=null==Na?void 0:Na.flatData.texts.find((e=>"CTATITLE"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===ra?void 0:ra.className)&&void 0!==sa?sa:""},ctas:null===(ca=null===(da=null==Na?void 0:Na.flatData)||void 0===da?void 0:da.buttons)||void 0===ca?void 0:ca.map((e=>{var t,a,o,n,i,l,r,s,d;return{text:Ma(null!==(t=null==e?void 0:e.literal[0].flatData.text)&&void 0!==t?t:""),href:null!==(a=jt(null==e?void 0:e.slug,"slug")[0].flatData.slug)&&void 0!==a?a:"",style:{color:null!==(o=null==e?void 0:e.fontColor)&&void 0!==o?o:"",fontSize:null!==(n=null==e?void 0:e.fontSize)&&void 0!==n?n:"",fontFamily:null!==(l=null===(i=jt(null==e?void 0:e.fontFamily,"name")[0].flatData)||void 0===i?void 0:i.name)&&void 0!==l?l:""},className:null!==(r=null==e?void 0:e.className)&&void 0!==r?r:"",name:null!==(d=null===(s=null==e?void 0:e.name)||void 0===s?void 0:s.toLowerCase())&&void 0!==d?d:""}})),subscribed:{text:Ma(null!==(pa=null===(ua=null==Na?void 0:Na.flatData.texts.find((e=>"SUBSCRIBED"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===ua?void 0:ua.literal[0].flatData.text)&&void 0!==pa?pa:""),href:null!==(ga=null===(fa=jt(null===(ma=null==Na?void 0:Na.flatData.texts.find((e=>"SUBSCRIBED"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===ma?void 0:ma.slug,"slug")[0])||void 0===fa?void 0:fa.flatData.slug)&&void 0!==ga?ga:"",style:{color:null!==(ba=null===(ha=null==Na?void 0:Na.flatData.texts.find((e=>"SUBSCRIBED"===jt(e.textType,"name")[0].flatData.name)))||void 0===ha?void 0:ha.fontColor)&&void 0!==ba?ba:"",fontSize:null!==(va=null===(xa=null==Na?void 0:Na.flatData.texts.find((e=>"SUBSCRIBED"===jt(e.textType,"name")[0].flatData.name)))||void 0===xa?void 0:xa.fontSize)&&void 0!==va?va:"",fontFamily:null!==(wa=null===(ka=jt(null===(ya=null==Na?void 0:Na.flatData.texts.find((e=>"SUBSCRIBED"===jt(e.textType,"name")[0].flatData.name)))||void 0===ya?void 0:ya.fontFamily,"name")[0])||void 0===ka?void 0:ka.flatData.name)&&void 0!==wa?wa:""},className:null!==(Da=null===(Ca=null==Na?void 0:Na.flatData.texts.find((e=>"SUBSCRIBED"===(null==e?void 0:e.textType[0].flatData.name))))||void 0===Ca?void 0:Ca.className)&&void 0!==Da?Da:""}}}}Ot=O([k(w.ContainerScoped),j("design:paramtypes",[te])],Ot);let qt=class{constructor(e,t,a,o){this.getProps=e=>R(this,void 0,void 0,(function*(){var t,a,o;const n=yield this.countryService.fetchCountryByCode(this.config.country),i=e?yield this.popupService.fetchPopUpById(e):(yield this.popupService.fetchPopUpDetail(null!==(a=null===(t=n[0])||void 0===t?void 0:t.id)&&void 0!==a?a:""))[0];let l=null;i.flatData.campaign&&(null===(o=i.flatData.campaign[0])||void 0===o?void 0:o.id)&&(l=yield this.campaignService.fetchCampaignById(i.flatData.campaign[0].id));const r=`${this.config.language}-${this.config.country}`;return Rt(i,l,this.config.country,r)})),this.config=a,this.countryService=t,this.popupService=e,this.campaignService=o}};qt=O([k(w.ContainerScoped),j("design:paramtypes",[Pt,oe,Q,Ot])],qt);var Ht=Object.freeze({__proto__:null,ActionButton:fe,Anchor:De,Backdrop:It,Background:({children:e,style:t,className:a,backgroundColor:o,url:n})=>{const i=g((()=>Object.assign(Object.assign({},t),{background:`url(${n})`,backgroundColor:o,backgroundRepeat:"no-repeat",backgroundSize:"cover"})),[]);return c.createElement("div",{style:i,className:a},e)},BannerButton:e=>{const{children:t}=e,a=P(e,["children"]);return c.createElement(_t,Object.assign({},a),t)},BirthdayInputV3:ze,Button:({label:e,slug:t,tracking:a})=>c.createElement("a",{href:t,"data-tracking":a},e),CheckBox:Be,Container:Le,CountryInput:Ie,DirtyHtml:Gt,DropdownContainer:je,IFrame:Re,Input:vt,InputForm:Ye,Link:yt,LoadParameter:Ve,Loader:()=>c.createElement("div",null,"Cargando..."),Menu:kt,MenuItem:wt,Picture:et,get PopupPropsService(){return qt},RadioOption:nt,Select:ct,SelectNum:ft,SelectOption:gt,StyledButton:Tt,TelephoneInput:xt,Text:Et,Typography:Dt,Video:Mt,Youtube:At});const Ut=({open:e,children:t,onClose:a})=>{const{height:o}=le();console.log("args",{open:e});const n=g((()=>({onClose:a})),[a]),i=c.Children.map(t,(e=>c.isValidElement(e)?c.cloneElement(e,n):e));return c.createElement(c.Fragment,null,c.createElement(Wt,{className:E(e&&"open")},c.createElement("div",{className:"dialog",style:{transform:!e&&o?"translateY("+o+"px)":"translateY(0)"}},i)),c.createElement(It,{visible:e,onClick:a}))},Wt=e.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  max-height:950px;
  overflow: auto;
  z-index: 1001;
  pointer-events: none;

  .dialog {
    background-color: #fff;
    opacity: 0;
    transition: transform 0.4s ease-in-out, opacity 0.3s linear;
    pointer-events: all;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    max-height: 100%;
  }

  &.open {
    .dialog {
      opacity: 1;
    }
  }

  @media (min-width: 45em) {
    .dialog {
      width: auto;
      height: auto;
    }
  }
`,Qt=u({}),Yt=e=>{const t={};for(const a of e.sources)void 0!==a.type?t[a.type]={hover:Vt(a.hover,"_MM.","_LF."),main:Vt(a.main,"_MM.","_LF.")}:t.sources=[Object.assign({},a)];return t},Vt=(e,t,a)=>e&&""!==e?e.replace(t,a):e,Xt=c.forwardRef((({title:e,withHover:t,slider:a,slidesToShow:o,targetId:n,productsId:i,familyId:l,squareImg:r},s)=>{const d=f(Qt),{config:u,container:h}=f(Z),[b,x]=p([]),[v,y]=p(!0),[k,w]=p(!1),C=g((()=>h.resolve(se)),[h]),D=g((()=>ue(u.language,e)),[u.language,e]),S=g((()=>`${u.language}_${u.country}`),[u.language,u.country]),T=g((()=>d.products),[d]);return m((()=>{R(void 0,void 0,void 0,(function*(){y(!0);const e=yield C.getProducts(n,i,l,r);x(e.products.map((e=>Object.assign(Object.assign({},e),{images:Yt(e.images)})))),w(!0===e.camperlab),y(!1)}))}),[n,i,C]),v?null:T?c.createElement("div",{ref:s},c.createElement(T,{title:D,withHover:t,slider:a,slidesToShow:o,camperlab:k,locale:S,source:b,squareImg:r})):c.createElement(Jt,{ref:s},c.createElement("p",null,"Products slots not configured"),c.createElement("pre",null,JSON.stringify(b,null,2)))})),Jt=e.div`
  padding: 0.5rem;
  margin: 0.5rem;
  p {
    font-family: ModerneRegular;
    font-size: 26px;
    color: red;
    text-align: center;
    margin-bottom: 0.5rem;
  }

  pre {
    border: 1px solid #000;
    border-radius: 5px;
    padding: 0.5rem;
    background-color: #e0e0e0;
    max-height: 400px;
    overflow: auto;
  }
`,Kt=u({}),Zt={draggable:!0,dots:!1,arrows:!0,speed:300,slidesToShow:1,slidesToScroll:1,autoplay:!1,autoplaySpeed:3e3,infinite:!0,pauseOnFocus:!0,pauseOnHover:!0,pauseOnDotsHover:!1,initialSlide:0,rtl:!1},ea=c.forwardRef((({className:e,asNavForId:t,children:a,mobile:o,tablet:n,desktop:i,bigScreen:l},r)=>{var s,d;const u=h(null),[b,x]=p(!1);p(!1);const{width:v}=le(),y=f(Kt),k=g((()=>{var e;return t?null===(e=y[t])||void 0===e?void 0:e.current:void 0}),[y,t]),w=g((()=>Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({},Zt),o),n),i),l),{responsive:[...i?[{breakpoint:1599,settings:Object.assign(Object.assign(Object.assign(Object.assign({},Zt),o),n),i)}]:[],...n?[{breakpoint:1199,settings:Object.assign(Object.assign(Object.assign({},Zt),o),n)}]:[],...o?[{breakpoint:767,settings:Object.assign(Object.assign({},Zt),o)}]:[]]})),[o,n,i,l]),C=g((()=>!v||v<768?Object.assign(Object.assign({},Zt),o):v<1200?Object.assign(Object.assign(Object.assign({},Zt),o),n):v<1600?Object.assign(Object.assign(Object.assign(Object.assign({},Zt),o),n),i):Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({},Zt),o),n),i),l)),[v,w]);return m((()=>{r&&("function"==typeof r?r(u.current):r.current=u.current)}),[u,r]),m((()=>{var e;u.current&&!b&&C.initialSlide&&(null===(e=u.current)||void 0===e||e.slickGoTo(C.initialSlide),x(!0))}),[C.initialSlide,b,u.current]),c.createElement(c.Fragment,null,c.createElement(aa,{dotsStyle:null!==(s=C.dotsStyle)&&void 0!==s?s:"dots",autoplay:!0===C.autoplay,animationSpeed:null!==(d=C.autoplaySpeed)&&void 0!==d?d:0,pauseOnFocus:!0===C.pauseOnFocus,pauseOnHover:!0===C.pauseOnHover},c.createElement(B,Object.assign({ref:u,className:e,children:a,asNavFor:k,cssEase:"linear"},w))))})),ta=a`
  0% { width: 0; }
  100% { width: 100%; }
`,aa=e.div`
  .slick-arrow {
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: transparent;
    background-color: rgba(255, 255, 255, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 1px 2px;
    width: 37px;
    height: 37px;
    border-radius: 50%;
    border-width: 0;
    z-index: 2;

    &::before {
      content: "";
      position: absolute;
      border-top: 3px solid;
      border-right: 3px solid black;
      width: 10px;
      height: 10px;
      display: block;
      border-color: black;
    }

    &.slick-prev {
      left: 40px;

      &::before {
        transform: rotate(225deg);
        top: 34%;
        left: 39%;
      }
    }

    &.slick-next {
      right: 40px;

      &::before {
        transform: rotate(45deg);
        top: 34%;
        left: 30%;
      }
    }
  }

  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    background-color: rgba(255, 255, 255, 1) !important;
  }

  ${({dotsStyle:e,autoplay:t,animationSpeed:a,pauseOnFocus:n,pauseOnHover:i})=>"bars"===e&&o`
      .slick-dots {
        position: absolute;
        width: 100%;
        bottom: 8px;
        list-style: none;
        margin: 0;
        padding: 0;

        /* override inline-style */
        display: flex !important;

        li {
          width: auto;
          flex-basis: 100%;
          background: rgba(255, 255, 255, 0.5);
          margin: 0 4px;
          height: 5px;

          &:first-child {
            margin-left: 0;
          }

          &:last-child {
            margin-right: 0;
          }

          button {
            display: block;
            width: 100%;
            height: 100%;
            background: none;
            color: transparent;
            border-width: 0;
            position: relative;
            padding: 0;
            border-width: 0;

            &:before {
              content: "";
              width: 100%;
            }
          }
        }
      }
    `}

  ${({dotsStyle:e})=>"dots"===e&&o`
      .slick-dots {
        bottom: 8px;
      }
    `}

  ${({autoplay:e,animationSpeed:t,dotsStyle:a})=>"bars"===a&&o`
      .slick-slider:not(:hover) .slick-active button:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background: rgba(255, 255, 255, 0.75);
        ${e&&!!t&&o`
          animation: ${ta} ${t}ms 1;
        `}
      }
    `}

  ${({pauseOnHover:e})=>e&&o`
      .slick-slider:hover .slick-dots li.slick-active button:before {
        width: 0%;
      }
    `}

  ${({pauseOnFocus:e})=>e&&o`
      .slick-slider:focus .slick-dots li.slick-active button:before {
        width: 0%;
      }
    `}
`,oa=(e,t)=>na(e,t.find((e=>e.endsWith(".avif"))),t.find((e=>e.endsWith(".webp"))),t.find((e=>!e.endsWith(".avif")&&!e.endsWith(".webp")))),na=(e,t,a,o)=>e.support.avif&&t&&""!=t?t:e.support.webp&&a&&""!=a?a:o,ia=e=>{var t,a,o,n;const i=e.filter((e=>!!e))[0];return{width:null!==(a=null===(t=null==i?void 0:i.metadata)||void 0===t?void 0:t.pixelWidth)&&void 0!==a?a:0,height:null!==(n=null===(o=null==i?void 0:i.metadata)||void 0===o?void 0:o.pixelHeight)&&void 0!==n?n:0}},la=(e,t,a,o,n,i,l,r)=>{var s,d,c,u,p,m;const f=null==e?void 0:e.filter((e=>e.tags.includes("desktop"))),g=null==f?void 0:f.find((e=>e.tags.includes("type/avif"))),h=null==f?void 0:f.find((e=>e.tags.includes("type/webp"))),b=null==f?void 0:f.find((e=>!(e.tags.includes("type/avif")||e.tags.includes("type/webp")||e.tags.includes("type/webm")||e.tags.includes("type/mp4")))),x=null==e?void 0:e.filter((e=>e.tags.includes("tablet"))),v=x&&null!==(s=x.find((e=>e.tags.includes("type/avif"))))&&void 0!==s?s:g,y=x&&null!==(d=x.find((e=>e.tags.includes("type/webp"))))&&void 0!==d?d:h,k=x&&null!==(c=x.find((e=>!(e.tags.includes("type/avif")||e.tags.includes("type/webp")||e.tags.includes("type/webm")||e.tags.includes("type/mp4")))))&&void 0!==c?c:b,w=null==e?void 0:e.filter((e=>e.tags.includes("mobile"))),C=w&&null!==(u=w.find((e=>e.tags.includes("type/avif"))))&&void 0!==u?u:g,D=w&&null!==(p=w.find((e=>e.tags.includes("type/webp"))))&&void 0!==p?p:h,S=w&&null!==(m=w.find((e=>!(e.tags.includes("type/avif")||e.tags.includes("type/webp")||e.tags.includes("type/webm")||e.tags.includes("type/mp4")))))&&void 0!==m?m:b;return{mobile:null!=f?Object.assign({standard:be(t.config.country,t.config.language,t.config.urlBase,Ce(S)),avif:C?be(t.config.country,t.config.language,t.config.urlBase,Ce(C)):void 0,webp:D?be(t.config.country,t.config.language,t.config.urlBase,Ce(D)):void 0},ia([S,C,D])):null,tablet:null!=f?Object.assign({standard:be(t.config.country,t.config.language,t.config.urlBase,Ce(k)),avif:v?be(t.config.country,t.config.language,t.config.urlBase,Ce(v)):void 0,webp:y?be(t.config.country,t.config.language,t.config.urlBase,Ce(y)):void 0},ia([k,v,y])):null,desktop:null!=f?Object.assign({standard:be(t.config.country,t.config.language,t.config.urlBase,Ce(b)),avif:g?be(t.config.country,t.config.language,t.config.urlBase,Ce(g)):void 0,webp:h?be(t.config.country,t.config.language,t.config.urlBase,Ce(h)):void 0},ia([b,g,h])):null,imageURLDesktop:a,imageURLTablet:o,imageURLMobile:n,hoxCodeDesktop:i,hoxCodeTablet:l,hoxCodeMobile:r}},ra=e=>{var t,a,o,n;if(!e)return null;const i=null==e?void 0:e.filter((e=>e.tags.includes("desktop"))),l=i.find((e=>e.tags.includes("type/webm"))),r=i.find((e=>e.tags.includes("type/mp4")));if(!r)return null;const s=null==e?void 0:e.filter((e=>e.tags.includes("tablet"))),d=s&&null!==(t=s.find((e=>e.tags.includes("type/webm"))))&&void 0!==t?t:l,c=s&&null!==(a=s.find((e=>e.tags.includes("type/mp4"))))&&void 0!==a?a:r,u=null==e?void 0:e.filter((e=>e.tags.includes("mobile"))),p=u&&null!==(o=u.find((e=>e.tags.includes("type/webm"))))&&void 0!==o?o:l,m=u&&null!==(n=u.find((e=>e.tags.includes("type/mp4"))))&&void 0!==n?n:r;return{mobile:{mp4:Ce(m),webm:p?Ce(p):void 0},tablet:{mp4:Ce(c),webm:d?Ce(d):void 0},desktop:{mp4:Ce(r),webm:l?Ce(l):void 0}}},sa=e(B)`
	display: flex;
	align-items: flex-start;
	justify-content: center;
	gap: 30px;
	max-width: 90vw;
	margin: 0 auto;
	.slick-track {
		display: flex;
		gap: 20px;
		@media (max-width: 500px) {
			display: block;
		}
		@media (min-width: 500px) and (max-width: 1023px) {
			gap: 10px;
		}
	}
	@media (max-width: 768px) {
		align-items: center;
	}
	.slick-slider {
        width: 100%;
        overflow: hidden;
        position: relative;

        .slick-list {
            width: 100%;

            .slick-track {
                display: flex;
				gap: 30px;
                .slick-slide {
                    max-width: 100vw;
                }
            }
        }

        .slick-dots {
            position: absolute;
            width: 100%;
            bottom: 8px;
            list-style: none;
            margin: 0;
            padding: 0;

            /* override inline-style */
            display: flex !important;

            li {
                width: auto;
                flex-basis: 100%;
                margin: 0 4px;
                height: 5px;

                &:first-child {
                    margin-left: 0;
                }

                &:last-child {
                    margin-right: 0;
                }

                button {
                    display: block;
                    width: 100%;
                    height: 100%;
                    background: none;
                    color: transparent;
                    border-width: none;
                    position: relative;
                    padding: 0;
                    border-width: 0;

                    &:before {
                        content: "";
                        width: 100%;
                    }
                }
            }
        }
    }
`,da=e.a`
	text-decoration: none;
	color: blue;
	margin: 5px 0;
	display: flex!important;
	flex-direction: column;
	flex: 1;
	gap: 10px;
	color: inherit;
	text-align: left;
	width: 100%;
	max-width: 473px;
	font-family: 'RyhmesTextBold';
	&:hover {
		color: inherit;
	}
	img {
		max-width: 100%;
		height: 66.9vw !important;
		object-fit: cover;
		@media (min-width: 500px) {
			height: 355px !important;
		}
		@media (min-width: 768px) {
				height: 22.75vw !important;
		}
		@media (min-width: 1640px) {
				height: 355px !important;
		}
	}
`,ca=({items:e,preview:t})=>{const a=f(Z),o={dots:!1,infinite:!0,speed:500,slidesToShow:(null==e?void 0:e.length)<3?null==e?void 0:e.length:3,slidesToScroll:1,autoplay:!1,responsive:[{breakpoint:992,settings:{slidesToShow:3}},{breakpoint:768,settings:{slidesToShow:2}},{breakpoint:500,settings:{slidesToShow:1,arrows:!1}}]};return c.createElement(c.Fragment,null,t&&c.createElement("p",null,"Este componente se cargara dinamicamente - Latest Posts"),!t&&e.length>0?c.createElement(sa,Object.assign({},o),e.map(((t,o)=>{var n;const i=null===(n=t.label)||void 0===n?void 0:n.replace(" - NNormal",""),l=la(t.image,a);return c.createElement(da,{key:o,href:t.slug,className:`num-items-${e.length<3?e.length:3}`},c.createElement(et,Object.assign({},l)),c.createElement("span",{style:{paddingTop:"10px"}},i))}))):c.createElement(c.Fragment,null))},ua=n.div`
    width: 100%;
    display: block;
    border-bottom: 1px solid rgb(189, 189, 189);
    padding-bottom: 15px;
    margin: 50px 0 0
`,pa=n(et)`
    width: 60px!important;
    height: 60px!important;
    border-radius: 500px;
    border: 1px solid rgb(170, 170, 170);
    padding: 2px;`,ma=n.div`
    justify-content: start;
    align-items: flex-end;
    gap: 20px;
    grid-template-columns: 66px auto;
    display: grid;`,fa=n.span`
    font-family: RyhmesTextLight;
    font-size: 14px;
    line-height: 1;
    margin: 0px 0px 5px;`,ga={atom:{ActionButton:fe,Anchor:De,BirthdayInputV3:ze,CheckBox:Be,Container:Le,CountryInput:Ie,DropdownContainer:je,IFrame:Re,InputForm:Ye,LoadParameter:Ve,Picture:et,RadioOption:nt,SelectNum:ft,SelectOption:gt,Select:ct,TelephoneInput:xt,Text:Et,Video:Mt,Youtube:At,DirtyHtml:Gt},molecule:{LatestPosts:ca,Author:({name:e,images:t,url:a,instagram:o,headline:n,datePublished:i,articleBody:l,imageArticle:r,text:s,preview:d})=>{const u=f(Z),p=g((()=>{var e,t;return null===(t=null!==(e=s[u.config.language])&&void 0!==e?e:"")||void 0===t?void 0:t.replace(" - NNormal","")}),[s]),m=g((()=>({"@context":"http://schema.org","@type":"Article",author:{"@type":"Person",name:e,url:a,sameAs:[o]},headline:n,datePublished:i,image:r,articleBody:l})),[e,a,o,n,i,l,r]),h=g((()=>la(t,u)),[t,u]);return c.createElement(c.Fragment,null,d?c.createElement("p",null,"Este componente se cargara dinamicamente - Autor"):c.createElement(ua,null,c.createElement("script",{type:"application/ld+json"},`${JSON.stringify(m)}`),c.createElement(ma,null,c.createElement(pa,Object.assign({},h,{alt:`avatar-${e}`})),c.createElement(fa,null,p," ",c.createElement("a",{style:{textDecoration:"underline",color:"rgb(0, 0, 0)"},href:a,target:"_blank"},e)))))}},organism:{Dialog:Ut,Products:Xt,Slider:ea}},ha=u(null);function ba(e,t){if(!t||!e||"string"!=typeof e)return e;const a=/^\$STATE\((.+?)\)$/gim.exec(e);if(a)return t[a[1]];return e.replace(/\$STATE\((.+?)\)/gim,((e,a)=>a in t?t[a]:""))}const xa=u({sticked:!1}),va=c.forwardRef(((e,t)=>{const{type:a,name:o,args:n,className:i,onRef:l,onDestroyRef:r}=e,s=b(((e,t)=>{l&&l(e,t)}),[l]),d=b((e=>{r&&r(e)}),[r]),u=g((()=>{let e=ga[a];return e||(console.error(`Collection ${a} not found`),null)}),[a]),p=g((()=>{if(!u)return null;let e=u[o];return e?null!==e&&"object"==typeof e&&"default"in e?e.default:e:(console.error(`Component ${o} not found inside ${a}`),null)}),[a,u,o]),m=g((()=>{if(!n)return{};const{children:e}=n,t=P(n,["children"]),a=Object.assign({},t);return e&&e instanceof Array&&(a.children=e.map(((e,t)=>"string"==typeof e?c.createElement(x,{key:`dc_nested_${t}`},e):c.createElement(Ca,Object.assign({key:`dc_nested_${t}`},e,{onRef:s,onDestroyRef:d}))))),Object.assign({},a)}),[n]);return p?c.createElement(p,Object.assign({ref:t,className:i},m,{onRef:s,onDestroyRef:d})):c.createElement(x,null)})),ya=e=>null!=e&&("string"==typeof e&&e.length>0||"number"==typeof e),ka=(e,t)=>{var a;const o=[];return ya(e.justifyContent)&&o.push(`justify-content: ${e.justifyContent};`),ya(e.flex)&&o.push(`flex: ${e.flex};`),ya(e.alignItems)&&o.push(`align-items: ${e.alignItems};`),ya(e.alignSelf)&&o.push(`align-self: ${e.alignSelf};`),ya(e.backgroundColor)&&o.push(`background-color: ${e.backgroundColor};`),ya(e.border)&&o.push(`border: ${e.border};`),ya(e.bottom)&&o.push(`bottom: ${e.bottom};`),ya(e.top)&&o.push(`top: ${e.top};`),ya(e.left)&&o.push(`left: ${e.left};`),ya(e.right)&&o.push(`right: ${e.right};`),ya(e.color)&&o.push(`color: ${e.color};`),ya(e.fontFamily)&&o.push(`font-family: ${e.fontFamily};`),ya(e.fontSize)&&o.push(`font-size: ${e.fontSize};`),ya(e.fontWeight)&&o.push(`font-weight: ${e.fontWeight};`),ya(e.gap)&&o.push(`gap: ${e.gap};`),ya(e.gridArea)&&o.push(`grid-area: ${e.gridArea};`),ya(e.gridColumn)&&o.push(`grid-column: ${e.gridColumn};`),ya(e.gridRow)&&o.push(`grid-row: ${e.gridRow};`),ya(e.gridTemplateAreas)&&o.push(`grid-template-areas: ${null===(a=e.gridTemplateAreas)||void 0===a?void 0:a.split("\n").map((e=>`"${e}"`)).join("\n")};`),ya(e.gridTemplateColumns)&&o.push(`grid-template-columns: ${e.gridTemplateColumns};`),ya(e.gridTemplateRows)&&o.push(`grid-template-rows: ${e.gridTemplateRows};`),ya(e.height)&&o.push(`height: ${e.height};`),ya(e.width)&&o.push(`width: ${e.width};`),ya(e.flexWrap)&&o.push(`flex-wrap: ${e.flexWrap};`),ya(e.flexGrow)&&o.push(`flex-grow: ${e.flexGrow};`),ya(e.flexDirection)&&o.push(`flex-direction: ${e.flexDirection};`),ya(e.flexBasis)&&o.push(`flex-basis: ${e.flexBasis};`),ya(e.display)&&(o.push(`display: ${e.display};`),"grid"===e.display&&o.push("> * { min-height: 0; min-width: 0; }")),ya(e.textAlign)&&o.push(`text-align: ${e.textAlign};`),ya(e.lineHeight)&&o.push(`line-height: ${e.lineHeight};`),ya(e.margin)&&o.push(`margin: ${e.margin};`),ya(e.padding)&&o.push(`padding: ${e.padding};`),ya(e.objectFit)&&o.push(`object-fit: ${e.objectFit};`),ya(e.position)&&o.push(`position: ${e.position};`),ya(e.overflow)&&o.push(`overflow: ${e.overflow};`),ya(e.transition)&&o.push(`transition: ${e.transition};`),e.raw&&e.raw.length>0&&o.push(e.raw),o.join("\n")},wa=e(va)`
  ${e=>{var t,a,o,n,{styles:i,isSticked:l}=e;return P(e,["styles","isSticked"]),`\n    ${(null==i?void 0:i.mobile)?ka(i.mobile):""}\n    ${(null==i?void 0:i.tablet)?(e=>`\n    @media (min-width: 768px) {\n      ${e}\n    }\n  `)(ka(i.tablet)):""}\n    ${(null==i?void 0:i.desktop)?(e=>`\n    @media (min-width: 1200px) {\n      ${e}\n    }\n  `)(ka(i.desktop)):""}\n    ${(null==i?void 0:i.bigScreen)?(e=>`\n    @media (min-width: 1600px) {\n      ${e}\n    }\n  `)(ka(i.bigScreen)):""}\n    ${l&&(null===(t=null==i?void 0:i.mobile)||void 0===t?void 0:t.sticky)?ka(i.mobile.sticky):""}\n    ${l&&(null===(a=null==i?void 0:i.tablet)||void 0===a?void 0:a.sticky)?ka(i.tablet.sticky):""}\n    ${l&&(null===(o=null==i?void 0:i.desktop)||void 0===o?void 0:o.sticky)?ka(i.desktop.sticky):""}\n    ${l&&(null===(n=null==i?void 0:i.bigScreen)||void 0===n?void 0:n.sticky)?ka(i.bigScreen.sticky):""}\n  `}}
`,Ca=e=>{var t,a;const o=h(null),[n,i]=p(!1),l=f(xa),[r,s]=p(null!==(t=e.styles)&&void 0!==t?t:{}),[d,u]=p(null!==(a=e.args)&&void 0!==a?a:{}),{config:b}=f(Z),x=f(zt),[v,y]=f(ha),k=g((()=>{if(void 0===e.mount)return!0;if("boolean"==typeof e.mount)return e.mount;if("number"==typeof e.mount)return 1===e.mount;if("string"==typeof e.mount){return 1==ba(e.mount,v)}return!1}),[v,e.mount]),w=g((()=>n||l.sticked),[n,l.sticked]),C=g((()=>{var t,a,o,n,i,l,r,s;return"sticky"===(null===(a=null===(t=e.styles)||void 0===t?void 0:t.mobile)||void 0===a?void 0:a.position)||"sticky"===(null===(n=null===(o=e.styles)||void 0===o?void 0:o.tablet)||void 0===n?void 0:n.position)||"sticky"===(null===(l=null===(i=e.styles)||void 0===i?void 0:i.desktop)||void 0===l?void 0:l.position)||"sticky"===(null===(s=null===(r=e.styles)||void 0===r?void 0:r.bigScreen)||void 0===s?void 0:s.position)}),[e.styles]);m((()=>{if(!e.styles)return;const t=JSON.parse(JSON.stringify(e.styles));for(const a in e.styles){const e=t[a];for(const t in e){const a=e[t];e[t]=ba(a,v)}}s(t)}),[v,e.styles]),m((()=>{if(!e.args)return;const t=JSON.parse(JSON.stringify(e.args));for(const a in e.args){const e=t[a];"string"==typeof e&&(t[a]=ba(e,v))}u(t)}),[v,e.args]),m((()=>{if(o.current)return o.current.id=e.id,e.onRef&&e.onRef(e.id,o),()=>{e.onDestroyRef&&e.onDestroyRef(e.id)}}),[o,e.id,e.onRef,e.onDestroyRef]),m((()=>{var t,a,n,l;if(!C)return;let d=Object.assign({},r);if("sticky"===(null===(t=d.mobile)||void 0===t?void 0:t.position)&&(d.mobile.position="relative",d.mobile.raw="z-index: 1000;"+(d.mobile.raw||""),d.mobile.transition=null!==(l=null===(n=null===(a=e.styles)||void 0===a?void 0:a.mobile)||void 0===n?void 0:n.transition)&&void 0!==l?l:"top 0.3s"),o.current&&"undefined"!=typeof window)return c(),window.addEventListener("scroll",c),()=>{window.removeEventListener("scroll",c)};function c(){var t,a,n,l,r,c,u,p,m,f;if(o.current)if("fixed"===(null===(t=d.mobile)||void 0===t?void 0:t.position)){const t=null!==(a=o.current.getAttribute("rposy"))&&void 0!==a?a:"0";window.scrollY<=parseInt(t,10)&&(d.mobile.position="relative",(null===(l=null===(n=e.styles)||void 0===n?void 0:n.mobile)||void 0===l?void 0:l.width)?d.mobile.width=null===(c=null===(r=e.styles)||void 0===r?void 0:r.mobile)||void 0===c?void 0:c.width:delete d.mobile.width,s(d),i(!1))}else if("relative"===(null===(u=d.mobile)||void 0===u?void 0:u.position)){(e.stickyPosition?Number(e.stickyPosition):o.current.offsetTop)-window.scrollY<0&&d.mobile&&(o.current.setAttribute("rposy",o.current.offsetTop.toString()),d.mobile.position="fixed",d.mobile.width=null!==(f=null===(m=null===(p=e.styles)||void 0===p?void 0:p.mobile)||void 0===m?void 0:m.width)&&void 0!==f?f:o.current.offsetWidth+"px",s(d),i(!0))}}}),[C,e.styles,o.current,r]),m((()=>{if(!e.tracking||!o.current)return;const t=Object.assign({country:b.country,language:b.language},x),a=function(e,t){if(!e)return e;const a=Object.keys(t).map((e=>({original:e,normalized:e.toLowerCase()})));return e.replace(/\{\s*(.+?)\s*\}/gim,((e,o)=>{const n=o.toLowerCase(),i=a.find((e=>e.normalized===n));return i&&i.original in t?t[i.original]+"":""}))}(e.tracking,t);return o.current.setAttribute("data-tracking",a),o.current.classList.add("trackable"),()=>{var e,t;null===(e=o.current)||void 0===e||e.removeAttribute("data-tracking"),null===(t=o.current)||void 0===t||t.classList.remove("trackable")}}),[e.tracking,o,b,x]);const D=g((()=>t=>{var a,o,n;(null===(a=e.trigger)||void 0===a?void 0:a.stopPrevent)||t.preventDefault();for(const t of null!==(n=null===(o=e.trigger)||void 0===o?void 0:o.actions)&&void 0!==n?n:[])switch(t.type){case"setState":y((e=>Object.assign(Object.assign({},e),{[t.args.property]:t.args.value})));break;case"setMove":y((e=>Object.assign(Object.assign({},e),{idToMove:t.args.value})))}}),[]);return m((()=>{if(o.current&&e.trigger&&"click"===e.trigger.on)return o.current.addEventListener("click",D),()=>{var e,t;null!=v.idToMove&&(null===(e=document.getElementById(v.idToMove))||void 0===e||e.scrollIntoView({block:"center",behavior:"smooth"})),null===(t=o.current)||void 0===t||t.removeEventListener("click",D)}}),[o.current,y,e.trigger]),k?c.createElement(xa.Provider,{value:{sticked:n}},c.createElement(wa,Object.assign({},e,{ref:o,isSticked:w,args:d,styles:r,className:n?"sticky-class":""}))):null};var Da=Object.freeze({__proto__:null,DynamicComponent:Ca,DynamicComponentRefContext:Kt,SlotsContext:Qt,typeComponents:ga});const Sa=({rootComponent:e,slots:t,market:a,vars:o})=>{const[n,i]=p({}),[l,r]=p(""),s=c.createRef(),d=g((()=>null!=t?t:{}),[t]),u=g((()=>({market:a,vars:o})),[a,o]),f=b(((e,t)=>{i((a=>Object.assign(Object.assign({},a),{[e]:t})))}),[]),h=p({}),x=b((e=>{i((t=>{const a=Object.assign({},t);return delete a[e],a}))}),[]);return m((()=>{const t={};if(e.state)for(const a in e.state)if(Object.hasOwnProperty.call(e.state,a)){const o=e.state[a];t[a]=o.initialValue}h[1](t)}),[e.state]),m((()=>{const e=location.hash;if(!e)return;const t=null===document||void 0===document?void 0:document.querySelector(e),a=e&&document&&t;e&&s&&s.current&&a&&"done"!==l&&document&&(a&&""===l?r("preReady1"):a&&"preReady1"===l?(t.scrollIntoView({behavior:"smooth"}),r("preReady2")):a&&"preReady2"===l?(t.scrollIntoView({behavior:"smooth"}),r("ready")):a&&"ready"===l&&(t.scrollIntoView({behavior:"smooth"}),e&&document&&t&&setTimeout((()=>{t.scrollIntoView({behavior:"smooth"}),r("done")}),667)))}),[l,s]),c.createElement(zt.Provider,{value:u},c.createElement(Qt.Provider,{value:d},c.createElement(Kt.Provider,{value:n},c.createElement(ha.Provider,{value:h},c.createElement(Ta,null,c.createElement(Ca,Object.assign({},e,{onRef:f,onDestroyRef:x,vars:o})),c.createElement("div",{ref:s,style:{display:"none"}}))))))},Ta=e.div``,_a=({className:e,children:t})=>{const[a,o]=A((()=>({opacity:0,config:{duration:600}}))),n=h(null),[i,l]=p(!1),{isVisible:r}=I(n,{intervalCheck:!0,scrollCheck:!0,resizeCheck:!0,partialVisibility:!0});return m((()=>{!i&&r&&(o.start({opacity:1}),l(!0))}),[r,i]),c.createElement(L.div,{ref:n,style:a,className:e},t)},za=({daysLiteral:e,hoursLiteral:t,minutesLiteral:a,font:o,color:n,fontSizeTextDesktop:i,fontSizeTextMobile:l,fontSizeTextTablet:r,fontSizeNumbersDesktop:s,fontSizeNumbersMobile:d,fontSizeNumbersTablet:u,finalDate:p})=>c.createElement(F,{date:new Date(p.replace("Z","")),renderer:p=>c.createElement("div",{className:"bannerCountdown",style:{display:"flex",lineHeight:"1"}},c.createElement("div",{style:{textAlign:"center"}},c.createElement(Dt,{fontName:o,fontColor:n,fontSizeDesktop:s,fontSizeMobile:d,fontSizeTablet:u},p.formatted.days),c.createElement(Dt,{fontName:o,fontColor:n,fontSizeDesktop:i,fontSizeMobile:l,fontSizeTablet:r},e)),c.createElement("div",{style:{textAlign:"center",paddingLeft:"25px"}},c.createElement(Dt,{fontName:o,fontColor:n,fontSizeDesktop:s,fontSizeMobile:d,fontSizeTablet:u},p.formatted.hours),c.createElement(Dt,{fontName:o,fontColor:n,fontSizeDesktop:i,fontSizeMobile:l,fontSizeTablet:r},t)),c.createElement("div",{style:{textAlign:"center",paddingLeft:"25px"}},c.createElement(Dt,{fontName:o,fontColor:n,fontSizeDesktop:s,fontSizeMobile:d,fontSizeTablet:u},p.formatted.minutes),c.createElement(Dt,{fontName:o,fontColor:n,fontSizeDesktop:i,fontSizeMobile:l,fontSizeTablet:r},a)))}),Ea=e.div.withConfig({shouldForwardProp:e=>!["mobileLayout"].includes(e)})`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  ${e=>void 0!==e.mobileLayout&&""!==e.mobileLayout?" @media (max-width: 767px) {\n            grid-column-start: span 2;\n            grid-column-end: auto;\n          }":""};

  position: relative;
  width: 100%;
  height: 100%;

  .bottom-center {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 5%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .content-center {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .bannerCountdown {
    margin-bottom: 50px;
    @media (min-width: 1024px) {
      margin-bottom: 30px;
    }
  }
`,Na=e.div`
  .firstButtons {
    margin-top: 70px;
  }
  .buttonMinWidth {
    min-width: 140px;
    &,
    &:before,
    &:after {
      box-sizing: border-box;
    }
  }
`,Ma=e.div`
  text-align: center;
  .marginNote {
    margin-bottom: 10px;
  }

  h1,
  h2,
  h3 {
    line-height: 1;
    @media (max-width: 1023px) {
      max-width: 90%;
    }
  }

  h3 {
    @media (min-width: 768px) and (max-width: 1023px) {
      max-width: 60%;
    }
  }
`,$a=e.div`
  text-align: center;

  > a {
    height: 100%;
    display: block;
  }

  .background {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
    object-fit: cover;
  }

  .backgroundvideo {
    display: block;
    max-width: 100%;
    @media (max-width: 767px) {
      width: 100vw;
      height: 177.77vw;
    }
    @media (min-width: 768px) and (max-width: 1024px) {
      width: 100vw;
      height: 100vw;
    }
    z-index: 0;
    object-fit: cover;
  }
`,Ba=e(et)`
  width: 100%;
  display: block;
`;function Aa({data:e,market:t,position:a,type:o,blur:n,lazy:i,mobileLayout:l}){const r=f(Z),[s]=e.images;let d=g((()=>{var e,t;return be(r.config.country,r.config.language,r.config.urlBase,null===(e=s.slug[0])||void 0===e?void 0:e.flatData.slug,null!==(t=s.script)&&void 0!==t&&t)}),[s.slug,s.script]);const u=g((()=>ye(s.tracking,t,a.toString())),[s.tracking,t,a]),p=g((()=>ke(s.trackingGA4,t,a.toString(),o)),[s.tracking,t,a,o]),m=g((()=>ra(s.assets)),[s.assets]),h=g((()=>la(s.assets,r)),[s.assets,r]),b=g((()=>{var n;return null===(n=e.texts)||void 0===n?void 0:n.map((e=>{var n,i;return{fontName:e.font[0].flatData.name,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,textType:e.textType[0].flatData.name,literal:e.literal[0].flatData.text,cta:e.cta,tracking:e.tracking?ye(e.tracking,t,a):"",trackingGA4:e.trackingGA4?ke(e.trackingGA4,t,a,o):"",slug:e.slug?be(r.config.country,r.config.language,r.config.urlBase,e.slug[0].flatData.slug,null!==(n=e.script)&&void 0!==n&&n):"",upperCase:e.upperCase,lowerCase:e.lowerCase,script:null!==(i=e.script)&&void 0!==i&&i,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile}}))}),[e.texts]),x=g((()=>e.buttons&&e.buttons.length>1&&"Inline"!==e.buttonsLayout?+e.buttonsLayout[0]:0),[e.buttonsLayout]),v=g((()=>{var n;return null===(n=e.buttons)||void 0===n?void 0:n.map((e=>{var n,i,l;return{label:e.literal[0].flatData.text,url:be(r.config.country,r.config.language,r.config.urlBase,null===(n=e.slug[0])||void 0===n?void 0:n.flatData.slug,null!==(i=e.script)&&void 0!==i&&i),tracking:ye(e.tracking,t,a),trackingGA4:ke(e.trackingGA4,t,a,o),search:e.search,searchTracking:e.searchTracking,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,borderColor:e.borderColor,selectedFontColor:e.selectedFontColor,selectedBackgroundColor:e.selectedBackgroundColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.font[0].flatData.name,upperCase:e.upperCase,lowerCase:e.lowerCase,script:null!==(l=e.script)&&void 0!==l&&l}}))}),[e.buttons]),y=g((()=>{if(0===x)return v;let e=[];for(let t=0;t<x;t++)e.push(v[t]);return e}),[x,v]),k=g((()=>{if(0===x)return;let e=[];for(let t=x;t<v.length;t++)e.push(v[t]);return e}),[x,v]),w=g((()=>null==b?void 0:b.find((e=>"Claim"===e.textType))),[null==b?void 0:b.find]),C=g((()=>null==b?void 0:b.find((e=>"Subclaim"===e.textType))),[null==b?void 0:b.find]),D=g((()=>w?w.literal:v&&v.length>0?v[0].label:""),[w,v]),S=g((()=>null==b?void 0:b.find((e=>"Bottom"===e.textType))),[null==b?void 0:b.find]),T=g((()=>{var e,t;return m?c.createElement(c.Fragment,null,m.desktop&&c.createElement(Mt,{mobile:m.desktop,alt:{en:D},autoPlay:!0,muted:!0,loop:!0,poster:h&&h.desktop?oa(r,[h.desktop.standard,null!==(e=h.desktop.webp)&&void 0!==e?e:"",null!==(t=h.desktop.avif)&&void 0!==t?t:""]):"",playsInline:!0,className:"backgroundvideo",lazy:i})):h&&c.createElement(Ba,Object.assign({},h,{alt:D,lazy:i}))}),[r,h,m,D]),_=g((()=>e.countdown&&e.countdown.length>0?{daysLiteral:e.countdown[0].daysLiteral[0].flatData.text,hoursLiteral:e.countdown[0].hoursLiteral[0].flatData.text,minutesLiteral:e.countdown[0].minutesLiteral[0].flatData.text,finalDate:e.countdown[0].finalDate,font:e.countdown[0].font[0].flatData.name,fontSizeTextDesktop:e.countdown[0].fontSizeTextDesktop,fontSizeTextTablet:e.countdown[0].fontSizeTextTablet,fontSizeTextMobile:e.countdown[0].fontSizeTextMobile,fontSizeNumbersDesktop:e.countdown[0].fontSizeNumbersDesktop,fontSizeNumbersTablet:e.countdown[0].fontSizeNumbersTablet,fontSizeNumbersMobile:e.countdown[0].fontSizeNumbersMobile,fontColor:e.countdown[0].fontColor}:null),[e.countdown]);return c.createElement(Ea,{mobileLayout:l},c.createElement($a,null,c.createElement("a",{className:"trackable "+(s.script?"slugwithparameters":""),href:d,"data-tracking":s.search&&null!=s.searchTracking?we(s.searchTracking,!0):u,"data-trackingga4":p},!n||m?T:c.createElement(_a,{className:"fadein-animation"},T))),c.createElement(Ma,{className:"content-center"},_&&c.createElement(za,{daysLiteral:_.daysLiteral,hoursLiteral:_.hoursLiteral,minutesLiteral:_.minutesLiteral,finalDate:_.finalDate,font:_.font,fontSizeTextDesktop:_.fontSizeTextDesktop,fontSizeTextTablet:_.fontSizeTextTablet,fontSizeTextMobile:_.fontSizeTextMobile,fontSizeNumbersDesktop:_.fontSizeNumbersDesktop,fontSizeNumbersTablet:_.fontSizeNumbersTablet,fontSizeNumbersMobile:_.fontSizeNumbersMobile,color:_.fontColor}),null==b?void 0:b.map(((e,t)=>e.cta&&"Bottom"!=e.textType?c.createElement(Dt,{key:`typo_${t}`,as:yt,fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,"data-tracking":e.tracking,"data-trackingga4":e.trackingGA4,href:e.slug,underline:!0,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable "+(e.script?"slugwithparameters":""),marginTop:e.marginTop,marginTopMobile:e.marginTopMobile},e.literal):"Bottom"!=e.textType&&c.createElement(Dt,{key:`typo_${t}`,as:"Claim"===e.textType?"1"===a||"1A"===a?"h1":"h2":"h3",className:"Note"===e.textType&&y&&(null==y?void 0:y.length)>0?"marginNote":"",fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,upperCase:e.upperCase,lowerCase:e.lowerCase,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile},e.literal))),y&&c.createElement(Na,null,y.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:C||!w&&!C?0:15,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable firstButtons buttonMinWidth "+(e.script?"slugwithparameters":"")},e.label)))),k&&c.createElement(Na,null,k.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:4,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable buttonMinWidth "+(e.script?"slugwithparameters":"")},e.label))))),S&&c.createElement(Ma,{className:"bottom-center"},c.createElement(Dt,{key:`typo_${b.length}`,as:"h3",className:"",fontName:S.fontName,fontColor:S.fontColor,fontColorMobile:S.fontColorMobile,fontColorTablet:S.fontColorTablet,fontSizeDesktop:S.fontSizeDesktop,fontSizeTablet:S.fontSizeTablet,fontSizeMobile:S.fontSizeMobile,upperCase:S.upperCase,lowerCase:S.lowerCase,marginTop:S.marginTop,marginTopMobile:S.marginTopMobile,textShadowDesktop:S.textShadowDesktop,textShadowTablet:S.textShadowTablet,textShadowMobile:S.textShadowMobile},S.literal)))}const La=e.div.withConfig({shouldForwardProp:e=>!["mobileLayout"].includes(e)})`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  ${e=>void 0!==e.mobileLayout&&""!==e.mobileLayout?" @media (max-width: 767px) {\n            grid-column-start: span 2;\n            grid-column-end: auto;\n          }":""};

  position: relative;
  width: 100%;
  height: 100%;

  .bottom-center {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 5%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .content-left {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    top: 70%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;

    @media (min-width: 767px) {
      top: 65%;
    }

    @media (min-width: 1024px) {
      width: 50%;
      left: 25%;
      top: 50%;
    }
  }

  .bannerCountdown {
    margin-bottom: 50px;
    @media (min-width: 1024px) {
      margin-bottom: 30px;
    }
  }
`,Ia=e.div`
  .firstButtons {
    margin-top: 30px;
    @media (min-width: 767px) {
      margin-top: 60px;
    }
    @media (min-width: 1024px) {
      margin-top: 70px;
    }
  }
  .buttonMinWidth {
    min-width: 140px;
    &,
    &:before,
    &:after {
      box-sizing: border-box;
    }
  }
`,Fa=e.div`
  text-align: center;
  .marginNote {
    margin-bottom: 10px;
  }

  h1,
  h2,
  h3 {
    line-height: 1;
    @media (max-width: 1023px) {
      max-width: 90%;
    }
  }

  h3 {
    @media (min-width: 768px) and (max-width: 1023px) {
      max-width: 60%;
    }
  }
`,Ga=e.div`
  text-align: center;

  > a {
    height: 100%;
    display: block;
  }

  .background {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
    object-fit: cover;
  }
`,Pa=e(et)`
  width: 100%;
  display: block;
`;function Oa({data:e,market:t,position:a,type:o,blur:n,mobileLayout:i}){const s=f(Z),[d]=e.images;let u=g((()=>{var e;return be(s.config.country,s.config.language,s.config.urlBase,d.slug[0].flatData.slug,null!==(e=d.script)&&void 0!==e&&e)}),[d.slug,d.script]);const p=g((()=>ye(d.tracking,t,a.toString())),[d.tracking,t,a]),m=g((()=>ke(d.trackingGA4,t,a.toString(),o)),[d.tracking,t,a,o]),h=g((()=>{var e,t,a;const o=null===(e=d.assets)||void 0===e?void 0:e.filter((e=>e.tags.includes("desktop"))),n=o.find((e=>e.tags.includes("type/webm"))),i=o.find((e=>e.tags.includes("type/mp4")));if(!i)return null;const l=null===(t=d.assets)||void 0===t?void 0:t.filter((e=>e.tags.includes("tablet"))),r=l?l.find((e=>e.tags.includes("type/webm"))):n,s=l?l.find((e=>e.tags.includes("type/mp4"))):i,c=null===(a=d.assets)||void 0===a?void 0:a.filter((e=>e.tags.includes("mobile"))),u=c?c.find((e=>e.tags.includes("type/webm"))):n,p=c?c.find((e=>e.tags.includes("type/mp4"))):i;return{mobile:{mp4:Ce(p),webm:u?Ce(u):void 0},tablet:{mp4:Ce(s),webm:r?Ce(r):void 0},desktop:{mp4:Ce(i),webm:n?Ce(n):void 0}}}),[d.assets]),b=g((()=>{var e,t,a,o,n,i,l,r,c;const u=null===(e=d.assets)||void 0===e?void 0:e.filter((e=>e.tags.includes("desktop"))),p=u.find((e=>e.tags.includes("type/avif"))),m=u.find((e=>e.tags.includes("type/webp"))),f=u.find((e=>!(e.tags.includes("type/avif")||e.tags.includes("type/webp")||e.tags.includes("type/webm")||e.tags.includes("type/mp4")))),g=null===(t=d.assets)||void 0===t?void 0:t.filter((e=>e.tags.includes("tablet"))),h=g?g.find((e=>e.tags.includes("type/avif"))):p,b=g?g.find((e=>e.tags.includes("type/webp"))):m,x=g?g.find((e=>!(e.tags.includes("type/avif")||e.tags.includes("type/webp")||e.tags.includes("type/webm")||e.tags.includes("type/mp4")))):f,v=null===(a=d.assets)||void 0===a?void 0:a.filter((e=>e.tags.includes("mobile"))),y=v?v.find((e=>e.tags.includes("type/avif"))):p,k=v?v.find((e=>e.tags.includes("type/webp"))):m,w=v?v.find((e=>!(e.tags.includes("type/avif")||e.tags.includes("type/webp")||e.tags.includes("type/webm")||e.tags.includes("type/mp4")))):f;return{mobile:{standard:be(s.config.country,s.config.language,s.config.urlBase,Ce(w)),avif:y?be(s.config.country,s.config.language,s.config.urlBase,Ce(y)):void 0,webp:k?be(s.config.country,s.config.language,s.config.urlBase,Ce(k)):void 0,width:(null===(o=null==w?void 0:w.metadata)||void 0===o?void 0:o.pixelWidth)||0,height:(null===(n=null==w?void 0:w.metadata)||void 0===n?void 0:n.pixelHeight)||0},tablet:{standard:be(s.config.country,s.config.language,s.config.urlBase,Ce(x)),avif:h?be(s.config.country,s.config.language,s.config.urlBase,Ce(h)):void 0,webp:b?be(s.config.country,s.config.language,s.config.urlBase,Ce(b)):void 0,width:(null===(i=null==x?void 0:x.metadata)||void 0===i?void 0:i.pixelWidth)||0,height:(null===(l=null==x?void 0:x.metadata)||void 0===l?void 0:l.pixelHeight)||0},desktop:{standard:be(s.config.country,s.config.language,s.config.urlBase,Ce(f)),avif:p?be(s.config.country,s.config.language,s.config.urlBase,Ce(p)):void 0,webp:m?be(s.config.country,s.config.language,s.config.urlBase,Ce(m)):void 0,width:(null===(r=null==f?void 0:f.metadata)||void 0===r?void 0:r.pixelWidth)||0,height:(null===(c=null==f?void 0:f.metadata)||void 0===c?void 0:c.pixelHeight)||0}}}),[d.assets]),x=g((()=>{var n;return null===(n=e.texts)||void 0===n?void 0:n.map((e=>{var n,i;return{fontName:e.font[0].flatData.name,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,textType:e.textType[0].flatData.name,literal:e.literal[0].flatData.text,cta:e.cta,tracking:e.tracking?ye(e.tracking,t,a):"",trackingGA4:e.trackingGA4?ke(e.trackingGA4,t,a,o):"",slug:e.slug?be(s.config.country,s.config.language,s.config.urlBase,e.slug[0].flatData.slug,null!==(n=e.script)&&void 0!==n&&n):"",upperCase:e.upperCase,lowerCase:e.lowerCase,script:null!==(i=e.script)&&void 0!==i&&i,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile}}))}),[e.texts]),v=g((()=>e.buttons&&e.buttons.length>1&&"Inline"!==e.buttonsLayout?+e.buttonsLayout[0]:0),[e.buttonsLayout]),y=g((()=>{var n;return null===(n=e.buttons)||void 0===n?void 0:n.map((e=>{var n,i;return{label:e.literal[0].flatData.text,url:be(s.config.country,s.config.language,s.config.urlBase,e.slug[0].flatData.slug,null!==(n=e.script)&&void 0!==n&&n),tracking:ye(e.tracking,t,a),trackingGA4:ke(e.trackingGA4,t,a,o),search:e.search,searchTracking:e.searchTracking,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,borderColor:e.borderColor,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedFontColor:e.selectedFontColor,selectedBackgroundColor:e.selectedBackgroundColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.font[0].flatData.name,upperCase:e.upperCase,lowerCase:e.lowerCase,script:null!==(i=e.script)&&void 0!==i&&i}}))}),[e.buttons]),k=g((()=>{if(0===v)return y;let e=[];for(let t=0;t<v;t++)e.push(y[t]);return e}),[v,y]),w=g((()=>{if(0===v)return;let e=[];for(let t=v;t<y.length;t++)e.push(y[t]);return e}),[v,y]),C=g((()=>null==x?void 0:x.find((e=>"Claim"===e.textType))),[null==x?void 0:x.find]),D=g((()=>null==x?void 0:x.find((e=>"Subclaim"===e.textType))),[null==x?void 0:x.find]),S=g((()=>C?C.literal:y&&y.length>0?y[0].label:""),[C,y]),T=g((()=>null==x?void 0:x.find((e=>"Bottom"===e.textType))),[null==x?void 0:x.find]),_=g((()=>{var e,t;return h?c.createElement(c.Fragment,null,c.createElement(l,{xs:!0,sm:!0,md:!0},h.desktop&&c.createElement(Mt,{mobile:h.desktop,alt:{en:S},autoPlay:!0,muted:!0,loop:!0,playsInline:!0,className:"background lazy"})),c.createElement(r,{md:!0},h.desktop&&c.createElement(Mt,{mobile:null!==(e=h.tablet)&&void 0!==e?e:h.desktop,alt:{en:S},autoPlay:!0,muted:!0,loop:!0,playsInline:!0,className:"background lazy"})),c.createElement(r,{xs:!0,sm:!0},h.desktop&&c.createElement(Mt,{mobile:null!==(t=h.mobile)&&void 0!==t?t:h.desktop,alt:{en:S},autoPlay:!0,muted:!0,loop:!0,playsInline:!0,className:"background lazy"}))):b&&c.createElement(Pa,Object.assign({},b,{alt:S}))}),[b,h,S]),z=g((()=>e.countdown&&e.countdown.length>0?{daysLiteral:e.countdown[0].daysLiteral[0].flatData.text,hoursLiteral:e.countdown[0].hoursLiteral[0].flatData.text,minutesLiteral:e.countdown[0].minutesLiteral[0].flatData.text,finalDate:e.countdown[0].finalDate,font:e.countdown[0].font[0].flatData.name,fontSizeTextDesktop:e.countdown[0].fontSizeTextDesktop,fontSizeTextTablet:e.countdown[0].fontSizeTextTablet,fontSizeTextMobile:e.countdown[0].fontSizeTextMobile,fontSizeNumbersDesktop:e.countdown[0].fontSizeNumbersDesktop,fontSizeNumbersTablet:e.countdown[0].fontSizeNumbersTablet,fontSizeNumbersMobile:e.countdown[0].fontSizeNumbersMobile,fontColor:e.countdown[0].fontColor}:null),[e.countdown]);return c.createElement(La,{mobileLayout:i},c.createElement(Ga,null,c.createElement("a",{className:"trackable "+(d.script?"slugwithparameters":""),href:u,"data-tracking":d.search&&null!=d.searchTracking?we(d.searchTracking,!0):p,"data-trackingga4":m},!n||h?_:c.createElement(_a,{className:"fadein-animation"},_))),c.createElement(Fa,{className:"content-left"},z&&c.createElement(za,{daysLiteral:z.daysLiteral,hoursLiteral:z.hoursLiteral,minutesLiteral:z.minutesLiteral,finalDate:z.finalDate,font:z.font,fontSizeTextDesktop:z.fontSizeTextDesktop,fontSizeTextTablet:z.fontSizeTextTablet,fontSizeTextMobile:z.fontSizeTextMobile,fontSizeNumbersDesktop:z.fontSizeNumbersDesktop,fontSizeNumbersTablet:z.fontSizeNumbersTablet,fontSizeNumbersMobile:z.fontSizeNumbersMobile,color:z.fontColor}),null==x?void 0:x.map(((e,t)=>e.cta&&"Bottom"!=e.textType?c.createElement(Dt,{key:`typo_${t}`,as:yt,fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,"data-tracking":e.tracking,"data-trackingga4":e.trackingGA4,href:e.slug,underline:!0,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable "+(e.script?"slugwithparameters":""),marginTop:e.marginTop,marginTopMobile:e.marginTopMobile},e.literal):"Bottom"!=e.textType&&c.createElement(Dt,{key:`typo_${t}`,as:"Claim"===e.textType?"1"===a||"1A"===a?"h1":"h2":"h3",className:"Note"===e.textType&&k&&(null==k?void 0:k.length)>0?"marginNote":"",fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,upperCase:e.upperCase,lowerCase:e.lowerCase,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile},e.literal))),k&&c.createElement(Ia,null,k.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:D||!C&&!D?0:15,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable firstButtons buttonMinWidth "+(e.script?"slugwithparameters":"")},e.label)))),w&&c.createElement(Ia,null,w.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:4,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable buttonMinWidth "+(e.script?"slugwithparameters":"")},e.label))))),T&&c.createElement(Fa,{className:"bottom-center"},c.createElement(Dt,{key:`typo_${x.length}`,as:"h3",className:"",fontName:T.fontName,fontColor:T.fontColor,fontColorMobile:T.fontColorMobile,fontColorTablet:T.fontColorTablet,fontSizeDesktop:T.fontSizeDesktop,fontSizeTablet:T.fontSizeTablet,fontSizeMobile:T.fontSizeMobile,upperCase:T.upperCase,lowerCase:T.lowerCase,marginTop:T.marginTop,marginTopMobile:T.marginTopMobile,textShadowDesktop:T.textShadowDesktop,textShadowTablet:T.textShadowTablet,textShadowMobile:T.textShadowMobile},T.literal)))}const ja=e.div.withConfig({shouldForwardProp:e=>!["mobileLayout"].includes(e)})`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  ${e=>void 0!==e.mobileLayout&&""!==e.mobileLayout?" @media (max-width: 767px) {\n            grid-column-start: span 2;\n            grid-column-end: auto;\n          }":""};

  position: relative;
  width: 100%;
  height: 100%;

  .bottom-center {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 5%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .content-left {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;

    @media (min-width: 1024px) {
      width: 50%;
      left: 25%;
      top: 50%;
    }
  }

  .bannerCountdown {
    margin-bottom: 25px;
    @media (min-width: 1024px) {
      margin-bottom: 30px;
    }
  }
`,Ra=e.div`
  .firstButtons {
    margin-top: 200px;
    @media (min-width: 767px) {
      margin-top: 500px;
    }
    @media (min-width: 1024px) {
      margin-top: 70px;
    }
  }
  .buttonMinWidth {
    min-width: 140px;
    &,
    &:before,
    &:after {
      box-sizing: border-box;
    }
  }
`,qa=e.div`
  text-align: center;
  .marginNote {
    margin-bottom: 10px;
  }

  h1,
  h2,
  h3 {
    line-height: 1;
    @media (max-width: 1023px) {
      max-width: 90%;
    }
  }

  h3 {
    @media (min-width: 768px) and (max-width: 1023px) {
      max-width: 60%;
    }
  }
`,Ha=e.div`
  text-align: center;

  > a {
    height: 100%;
    display: block;
  }

  .background {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
    object-fit: cover;
  }
`,Ua=e(et)`
  width: 100%;
  display: block;
`;function Wa({data:e,market:t,position:a,type:o,blur:n,mobileLayout:i}){const s=f(Z),[d]=e.images;let u=g((()=>{var e;return be(s.config.country,s.config.language,s.config.urlBase,d.slug[0].flatData.slug,null!==(e=d.script)&&void 0!==e&&e)}),[d.slug,d.script]);const p=g((()=>ye(d.tracking,t,a.toString())),[d.tracking,t,a]),m=g((()=>ke(d.trackingGA4,t,a.toString(),o)),[d.tracking,t,a,o]),h=g((()=>{var e,t,a;const o=null===(e=d.assets)||void 0===e?void 0:e.filter((e=>e.tags.includes("desktop"))),n=o.find((e=>e.tags.includes("type/webm"))),i=o.find((e=>e.tags.includes("type/mp4")));if(!i)return null;const l=null===(t=d.assets)||void 0===t?void 0:t.filter((e=>e.tags.includes("tablet"))),r=l?l.find((e=>e.tags.includes("type/webm"))):n,s=l?l.find((e=>e.tags.includes("type/mp4"))):i,c=null===(a=d.assets)||void 0===a?void 0:a.filter((e=>e.tags.includes("mobile"))),u=c?c.find((e=>e.tags.includes("type/webm"))):n,p=c?c.find((e=>e.tags.includes("type/mp4"))):i;return{mobile:{mp4:Ce(p),webm:u?Ce(u):void 0},tablet:{mp4:Ce(s),webm:r?Ce(r):void 0},desktop:{mp4:Ce(i),webm:n?Ce(n):void 0}}}),[d.assets]),b=g((()=>{var e,t,a,o,n,i,l,r,c;const u=null===(e=d.assets)||void 0===e?void 0:e.filter((e=>e.tags.includes("desktop"))),p=u.find((e=>e.tags.includes("type/avif"))),m=u.find((e=>e.tags.includes("type/webp"))),f=u.find((e=>!(e.tags.includes("type/avif")||e.tags.includes("type/webp")||e.tags.includes("type/webm")||e.tags.includes("type/mp4")))),g=null===(t=d.assets)||void 0===t?void 0:t.filter((e=>e.tags.includes("tablet"))),h=g?g.find((e=>e.tags.includes("type/avif"))):p,b=g?g.find((e=>e.tags.includes("type/webp"))):m,x=g?g.find((e=>!(e.tags.includes("type/avif")||e.tags.includes("type/webp")||e.tags.includes("type/webm")||e.tags.includes("type/mp4")))):f,v=null===(a=d.assets)||void 0===a?void 0:a.filter((e=>e.tags.includes("mobile"))),y=v?v.find((e=>e.tags.includes("type/avif"))):p,k=v?v.find((e=>e.tags.includes("type/webp"))):m,w=v?v.find((e=>!(e.tags.includes("type/avif")||e.tags.includes("type/webp")||e.tags.includes("type/webm")||e.tags.includes("type/mp4")))):f;return{mobile:{standard:be(s.config.country,s.config.language,s.config.urlBase,Ce(w)),avif:y?be(s.config.country,s.config.language,s.config.urlBase,Ce(y)):void 0,webp:k?be(s.config.country,s.config.language,s.config.urlBase,Ce(k)):void 0,width:(null===(o=null==w?void 0:w.metadata)||void 0===o?void 0:o.pixelWidth)||0,height:(null===(n=null==w?void 0:w.metadata)||void 0===n?void 0:n.pixelHeight)||0},tablet:{standard:be(s.config.country,s.config.language,s.config.urlBase,Ce(x)),avif:h?be(s.config.country,s.config.language,s.config.urlBase,Ce(h)):void 0,webp:b?be(s.config.country,s.config.language,s.config.urlBase,Ce(b)):void 0,width:(null===(i=null==x?void 0:x.metadata)||void 0===i?void 0:i.pixelWidth)||0,height:(null===(l=null==x?void 0:x.metadata)||void 0===l?void 0:l.pixelHeight)||0},desktop:{standard:be(s.config.country,s.config.language,s.config.urlBase,Ce(f)),avif:p?be(s.config.country,s.config.language,s.config.urlBase,Ce(p)):void 0,webp:m?be(s.config.country,s.config.language,s.config.urlBase,Ce(m)):void 0,width:(null===(r=null==f?void 0:f.metadata)||void 0===r?void 0:r.pixelWidth)||0,height:(null===(c=null==f?void 0:f.metadata)||void 0===c?void 0:c.pixelHeight)||0}}}),[d.assets]),x=g((()=>{var n;return null===(n=e.texts)||void 0===n?void 0:n.map((e=>{var n,i;return{fontName:e.font[0].flatData.name,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,textType:e.textType[0].flatData.name,literal:e.literal[0].flatData.text,cta:e.cta,tracking:e.tracking?ye(e.tracking,t,a):"",trackingGA4:e.trackingGA4?ke(e.trackingGA4,t,a,o):"",slug:e.slug?be(s.config.country,s.config.language,s.config.urlBase,e.slug[0].flatData.slug,null!==(n=e.script)&&void 0!==n&&n):"",upperCase:e.upperCase,lowerCase:e.lowerCase,script:null!==(i=e.script)&&void 0!==i&&i,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile}}))}),[e.texts]),v=g((()=>e.buttons&&e.buttons.length>1&&"Inline"!==e.buttonsLayout?+e.buttonsLayout[0]:0),[e.buttonsLayout]),y=g((()=>{var n;return null===(n=e.buttons)||void 0===n?void 0:n.map((e=>{var n,i;return{label:e.literal[0].flatData.text,url:be(s.config.country,s.config.language,s.config.urlBase,e.slug[0].flatData.slug,null!==(n=e.script)&&void 0!==n&&n),tracking:ye(e.tracking,t,a),trackingGA4:ke(e.trackingGA4,t,a,o),search:e.search,searchTracking:e.searchTracking,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,borderColor:e.borderColor,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedFontColor:e.selectedFontColor,selectedBackgroundColor:e.selectedBackgroundColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.font[0].flatData.name,upperCase:e.upperCase,lowerCase:e.lowerCase,script:null!==(i=e.script)&&void 0!==i&&i}}))}),[e.buttons]),k=g((()=>{if(0===v)return y;let e=[];for(let t=0;t<v;t++)e.push(y[t]);return e}),[v,y]),w=g((()=>{if(0===v)return;let e=[];for(let t=v;t<y.length;t++)e.push(y[t]);return e}),[v,y]),C=g((()=>null==x?void 0:x.find((e=>"Claim"===e.textType))),[null==x?void 0:x.find]),D=g((()=>null==x?void 0:x.find((e=>"Subclaim"===e.textType))),[null==x?void 0:x.find]),S=g((()=>C?C.literal:y&&y.length>0?y[0].label:""),[C,y]),T=g((()=>null==x?void 0:x.find((e=>"Bottom"===e.textType))),[null==x?void 0:x.find]),_=g((()=>{var e,t;return h?c.createElement(c.Fragment,null,c.createElement(l,{xs:!0,sm:!0,md:!0},h.desktop&&c.createElement(Mt,{mobile:h.desktop,alt:{en:S},autoPlay:!0,muted:!0,loop:!0,playsInline:!0,className:"background lazy"})),c.createElement(r,{md:!0},h.desktop&&c.createElement(Mt,{mobile:null!==(e=h.tablet)&&void 0!==e?e:h.desktop,alt:{en:S},autoPlay:!0,muted:!0,loop:!0,playsInline:!0,className:"background lazy"})),c.createElement(r,{xs:!0,sm:!0},h.desktop&&c.createElement(Mt,{mobile:null!==(t=h.mobile)&&void 0!==t?t:h.desktop,alt:{en:S},autoPlay:!0,muted:!0,loop:!0,playsInline:!0,className:"background lazy"}))):b&&c.createElement(Ua,Object.assign({},b,{alt:S}))}),[b,h,S]),z=g((()=>e.countdown&&e.countdown.length>0?{daysLiteral:e.countdown[0].daysLiteral[0].flatData.text,hoursLiteral:e.countdown[0].hoursLiteral[0].flatData.text,minutesLiteral:e.countdown[0].minutesLiteral[0].flatData.text,finalDate:e.countdown[0].finalDate,font:e.countdown[0].font[0].flatData.name,fontSizeTextDesktop:e.countdown[0].fontSizeTextDesktop,fontSizeTextTablet:e.countdown[0].fontSizeTextTablet,fontSizeTextMobile:e.countdown[0].fontSizeTextMobile,fontSizeNumbersDesktop:e.countdown[0].fontSizeNumbersDesktop,fontSizeNumbersTablet:e.countdown[0].fontSizeNumbersTablet,fontSizeNumbersMobile:e.countdown[0].fontSizeNumbersMobile,fontColor:e.countdown[0].fontColor}:null),[e.countdown]);return c.createElement(ja,{mobileLayout:i},c.createElement(Ha,null,c.createElement("a",{className:"trackable "+(d.script?"slugwithparameters":""),href:u,"data-tracking":d.search&&null!=d.searchTracking?we(d.searchTracking,!0):p,"data-trackingga4":m},!n||h?_:c.createElement(_a,{className:"fadein-animation"},_))),c.createElement(qa,{className:"content-left"},z&&c.createElement(za,{daysLiteral:z.daysLiteral,hoursLiteral:z.hoursLiteral,minutesLiteral:z.minutesLiteral,finalDate:z.finalDate,font:z.font,fontSizeTextDesktop:z.fontSizeTextDesktop,fontSizeTextTablet:z.fontSizeTextTablet,fontSizeTextMobile:z.fontSizeTextMobile,fontSizeNumbersDesktop:z.fontSizeNumbersDesktop,fontSizeNumbersTablet:z.fontSizeNumbersTablet,fontSizeNumbersMobile:z.fontSizeNumbersMobile,color:z.fontColor}),null==x?void 0:x.map(((e,t)=>e.cta&&"Bottom"!=e.textType?c.createElement(Dt,{key:`typo_${t}`,as:yt,fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,"data-tracking":e.tracking,"data-trackingga4":e.trackingGA4,href:e.slug,underline:!0,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable "+(e.script?"slugwithparameters":""),marginTop:e.marginTop,marginTopMobile:e.marginTopMobile},e.literal):"Bottom"!=e.textType&&c.createElement(Dt,{key:`typo_${t}`,as:"Claim"===e.textType?"1"===a||"1A"===a?"h1":"h2":"h3",className:"Note"===e.textType&&k&&(null==k?void 0:k.length)>0?"marginNote":"",fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,upperCase:e.upperCase,lowerCase:e.lowerCase,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile},e.literal))),k&&c.createElement(Ra,null,k.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:D||!C&&!D?0:15,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable firstButtons buttonMinWidth "+(e.script?"slugwithparameters":"")},e.label)))),w&&c.createElement(Ra,null,w.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:4,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable buttonMinWidth "+(e.script?"slugwithparameters":"")},e.label))))),T&&c.createElement(qa,{className:"bottom-center"},c.createElement(Dt,{key:`typo_${x.length}`,as:"h3",className:"",fontName:T.fontName,fontColor:T.fontColor,fontColorMobile:T.fontColorMobile,fontColorTablet:T.fontColorTablet,fontSizeDesktop:T.fontSizeDesktop,fontSizeTablet:T.fontSizeTablet,fontSizeMobile:T.fontSizeMobile,upperCase:T.upperCase,lowerCase:T.lowerCase,marginTop:T.marginTop,marginTopMobile:T.marginTopMobile,textShadowDesktop:T.textShadowDesktop,textShadowTablet:T.textShadowTablet,textShadowMobile:T.textShadowMobile},T.literal)))}const Qa=e.div.withConfig({shouldForwardProp:e=>!["mobileLayout"].includes(e)})`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  ${e=>void 0!==e.mobileLayout&&""!==e.mobileLayout?" @media (max-width: 767px) {\n            grid-column-start: span 2;\n            grid-column-end: auto;\n          }":""};

  position: relative;
  width: 100%;
  height: 100%;

  .bottom-center {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 5%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .content-center {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    top: 15%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .content-center-countdown {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    top: 20%;
    @media (min-width: 1024px) {
      top: 18%;
    }
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .bannerCountdown {
    margin-bottom: 10px;
  }
`,Ya=e.div`
  .buttonMinWidth {
    min-width: 140px;
    &,
    &:before,
    &:after {
      box-sizing: border-box;
    }
  }
`,Va=e.div`
  text-align: center;
  .marginNote {
    margin-bottom: 10px;
  }

  h1,
  h2,
  h3 {
    line-height: 1;
    @media (max-width: 1023px) {
      max-width: 90%;
    }
  }

  h3 {
    @media (min-width: 768px) and (max-width: 1023px) {
      max-width: 60%;
    }
  }
`,Xa=e.div`
  text-align: center;
  z-index: 10;
  position: absolute;
  left: 0;
  bottom: 10%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`,Ja=e.div`
  text-align: center;

  > a {
    height: 100%;
    display: block;
  }

  .background {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
    object-fit: cover;
  }

  .backgroundvideo {
    display: block;
    max-width: 100%;
    @media (max-width: 767px) {
      width: 100vw;
      height: 177.77vw;
    }
    @media (min-width: 768px) and (max-width: 1024px) {
      width: 100vw;
      height: 100vw;
    }
    z-index: 0;
    object-fit: cover;
  }
`,Ka=e(et)`
  width: 100%;
  display: block;
`;function Za({data:e,market:t,position:a,type:o,blur:n,lazy:i,mobileLayout:l}){const r=f(Z),[s]=e.images;let d=g((()=>{var e;return be(r.config.country,r.config.language,r.config.urlBase,s.slug[0].flatData.slug,null!==(e=s.script)&&void 0!==e&&e)}),[s.slug,s.script]);const u=g((()=>ye(s.tracking,t,a.toString())),[s.tracking,t,a]),p=g((()=>ke(s.trackingGA4,t,a.toString(),o)),[s.tracking,t,a,o]),m=g((()=>ra(s.assets)),[s.assets]),h=g((()=>la(s.assets,r)),[s.assets,r]),b=g((()=>{var n;return null===(n=e.texts)||void 0===n?void 0:n.map((e=>{var n,i;return{fontName:e.font[0].flatData.name,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,textType:e.textType[0].flatData.name,literal:e.literal[0].flatData.text,cta:e.cta,tracking:e.tracking?ye(e.tracking,t,a):"",trackingGA4:e.trackingGA4?ke(e.trackingGA4,t,a,o):"",slug:e.slug?be(r.config.country,r.config.language,r.config.urlBase,e.slug[0].flatData.slug,null!==(n=e.script)&&void 0!==n&&n):"",upperCase:e.upperCase,lowerCase:e.lowerCase,script:null!==(i=e.script)&&void 0!==i&&i,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile}}))}),[e.texts]),x=g((()=>e.buttons&&e.buttons.length>1&&"Inline"!==e.buttonsLayout?+e.buttonsLayout[0]:0),[e.buttonsLayout]),v=g((()=>{var n;return null===(n=e.buttons)||void 0===n?void 0:n.map((e=>{var n,i;return{label:e.literal[0].flatData.text,url:be(r.config.country,r.config.language,r.config.urlBase,e.slug[0].flatData.slug,null!==(n=e.script)&&void 0!==n&&n),tracking:ye(e.tracking,t,a),trackingGA4:ke(e.trackingGA4,t,a,o),search:e.search,searchTracking:e.searchTracking,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,borderColor:e.borderColor,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedFontColor:e.selectedFontColor,selectedBackgroundColor:e.selectedBackgroundColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.font[0].flatData.name,upperCase:e.upperCase,lowerCase:e.lowerCase,script:null!==(i=e.script)&&void 0!==i&&i}}))}),[e.buttons]),y=g((()=>{if(0===x)return v;let e=[];for(let t=0;t<x;t++)e.push(v[t]);return e}),[x,v]),k=g((()=>{if(0===x)return;let e=[];for(let t=x;t<v.length;t++)e.push(v[t]);return e}),[x,v]),w=g((()=>null==b?void 0:b.find((e=>"Claim"===e.textType))),[null==b?void 0:b.find]),C=g((()=>null==b?void 0:b.find((e=>"Subclaim"===e.textType))),[null==b?void 0:b.find]),D=g((()=>w?w.literal:v&&v.length>0?v[0].label:""),[w,v]),S=g((()=>null==b?void 0:b.find((e=>"Bottom"===e.textType))),[null==b?void 0:b.find]),T=g((()=>{var e,t;return m?c.createElement(c.Fragment,null,m.desktop&&c.createElement(Mt,{mobile:m.desktop,alt:{en:D},autoPlay:!0,muted:!0,loop:!0,poster:h&&h.desktop?oa(r,[h.desktop.standard,null!==(e=h.desktop.webp)&&void 0!==e?e:"",null!==(t=h.desktop.avif)&&void 0!==t?t:""]):"",playsInline:!0,className:"backgroundvideo",lazy:i})):h&&c.createElement(Ka,Object.assign({},h,{alt:D,lazy:i}))}),[r,h,m,D]),_=g((()=>e.countdown&&e.countdown.length>0?{daysLiteral:e.countdown[0].daysLiteral[0].flatData.text,hoursLiteral:e.countdown[0].hoursLiteral[0].flatData.text,minutesLiteral:e.countdown[0].minutesLiteral[0].flatData.text,finalDate:e.countdown[0].finalDate,font:e.countdown[0].font[0].flatData.name,fontSizeTextDesktop:e.countdown[0].fontSizeTextDesktop,fontSizeTextTablet:e.countdown[0].fontSizeTextTablet,fontSizeTextMobile:e.countdown[0].fontSizeTextMobile,fontSizeNumbersDesktop:e.countdown[0].fontSizeNumbersDesktop,fontSizeNumbersTablet:e.countdown[0].fontSizeNumbersTablet,fontSizeNumbersMobile:e.countdown[0].fontSizeNumbersMobile,fontColor:e.countdown[0].fontColor}:null),[e.countdown]);return c.createElement(Qa,{mobileLayout:l},c.createElement(Ja,null,c.createElement("a",{className:"trackable "+(s.script?"slugwithparameters":""),href:d,"data-tracking":s.search&&null!=s.searchTracking?we(s.searchTracking,!0):u,"data-trackingga4":p},!n||m?T:c.createElement(_a,{className:"fadein-animation"},T))),c.createElement(Va,{className:_?"content-center-countdown":"content-center"},_&&c.createElement(za,{daysLiteral:_.daysLiteral,hoursLiteral:_.hoursLiteral,minutesLiteral:_.minutesLiteral,finalDate:_.finalDate,font:_.font,fontSizeTextDesktop:_.fontSizeTextDesktop,fontSizeTextTablet:_.fontSizeTextTablet,fontSizeTextMobile:_.fontSizeTextMobile,fontSizeNumbersDesktop:_.fontSizeNumbersDesktop,fontSizeNumbersTablet:_.fontSizeNumbersTablet,fontSizeNumbersMobile:_.fontSizeNumbersMobile,color:_.fontColor}),null==b?void 0:b.map(((e,t)=>e.cta&&"Bottom"!=e.textType?c.createElement(Dt,{key:`typo_${t}`,as:yt,fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,"data-tracking":e.tracking,"data-trackingga4":e.trackingGA4,href:e.slug,underline:!0,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable "+(e.script?"slugwithparameters":""),marginTop:e.marginTop,marginTopMobile:e.marginTopMobile},e.literal):"Bottom"!=e.textType&&c.createElement(Dt,{key:`typo_${t}`,as:"Claim"===e.textType?"1"===a||"1A"===a?"h1":"h2":"h3",className:"Note"===e.textType&&y&&(null==y?void 0:y.length)>0?"marginNote":"",fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,upperCase:e.upperCase,lowerCase:e.lowerCase,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile},e.literal)))),c.createElement(Xa,null,y&&c.createElement(Ya,null,y.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:C||!w&&!C?0:15,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable buttonMinWidth "+(e.script?"slugwithparameters":"")},e.label)))),k&&c.createElement(Ya,null,k.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:4,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable buttonMinWidth "+(e.script?"slugwithparameters":"")},e.label))))),S&&c.createElement(Va,{className:"bottom-center"},c.createElement(Dt,{key:`typo_${b.length}`,as:"h3",className:"",fontName:S.fontName,fontColor:S.fontColor,fontColorMobile:S.fontColorMobile,fontColorTablet:S.fontColorTablet,fontSizeDesktop:S.fontSizeDesktop,fontSizeTablet:S.fontSizeTablet,fontSizeMobile:S.fontSizeMobile,upperCase:S.upperCase,lowerCase:S.lowerCase,marginTop:S.marginTop,marginTopMobile:S.marginTopMobile,textShadowDesktop:S.textShadowDesktop,textShadowTablet:S.textShadowTablet,textShadowMobile:S.textShadowMobile},S.literal)))}const eo=e.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  position: relative;
  width: 100%;
  height: 100%;

  .bottom-center {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 5%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .content-center {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .content-bottom {
    z-index: 10;
    position: absolute;
    left: 0;
    bottom: 50px;
    @media (max-width: 767px) {
      bottom: 30px;
    }
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .content-buttononly {
    z-index: 10;
    position: absolute;
    left: 0;
    bottom: 20px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .content-search {
    z-index: 10;
    position: absolute;
    width: 100%;
    left: 50%;
    height: 100%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    pointer-events: none;
  }
`,to=e.div`
  .buttonMinWidth {
    min-width: 140px;
    &,
    &:before,
    &:after {
      box-sizing: border-box;
    }
  }

  .firstButtons {
    position: absolute;
    bottom: 10%;
    left: 49%;
    transform: translate(-50%, -50%);
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
  }
`,ao=e.div`
  text-align: center;
  .marginNote {
    margin-bottom: 10px;
  }

  h1,
  h2,
  h3 {
    line-height: 1;
    @media (max-width: 1023px) {
      max-width: 90%;
    }
  }

  h3 {
    @media (min-width: 768px) and (max-width: 1023px) {
      max-width: 60%;
    }
  }
`,oo=e.div`
  text-align: center;

  > a {
    height: 100%;
    display: block;
  }

  .background {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
    object-fit: cover;
  }

  .backgroundvideo {
    display: block;
    max-width: 100%;
    width: 100vw;
    @media (max-width: 767px) {
      width: 100vw;
      height: 177.77vw;
    }
    @media (min-width: 768px) and (max-width: 1024px) {
      width: 100vw;
      height: 100vw;
    }
    z-index: 0;
    object-fit: cover;
  }
`,no=e(et)`
  width: 100%;
  display: block;
`;function io({data:e,market:t,position:a,type:o,blur:n,lazy:i,mobileLayout:l,showI18nModal:r}){const s=f(Z),[d]=e.images;let u=g((()=>{var e;return d.slug?be(s.config.country,s.config.language,s.config.urlBase,d.slug[0].flatData.slug,null!==(e=d.script)&&void 0!==e&&e):""}),[d.slug,d.script]);const p=g((()=>ye(d.tracking,t,a.toString())),[d.tracking,t,a]),m=g((()=>ke(d.trackingGA4,t,a.toString(),o)),[d.tracking,t,a,o]),h=g((()=>ra(d.assets)),[d.assets]),b=g((()=>la(d.assets,s)),[d.assets,s]),x=g((()=>{var n;return null===(n=e.texts)||void 0===n?void 0:n.map((e=>{var n,i;return{fontName:e.font[0].flatData.name,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,textType:e.textType[0].flatData.name,literal:e.literal[0].flatData.text,cta:e.cta,tracking:e.tracking?ye(e.tracking,t,a):"",trackingGA4:e.trackingGA4?ke(e.trackingGA4,t,a,o):"",slug:e.slug?be(s.config.country,s.config.language,s.config.urlBase,e.slug[0].flatData.slug,null!==(n=e.script)&&void 0!==n&&n):"",upperCase:e.upperCase,lowerCase:e.lowerCase,script:null!==(i=e.script)&&void 0!==i&&i,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile}}))}),[e.texts]),v=g((()=>e.buttons&&e.buttons.length>1&&"Inline"!==e.buttonsLayout?+e.buttonsLayout[0]:0),[e.buttonsLayout]),y=g((()=>{var n;return null===(n=e.buttons)||void 0===n?void 0:n.map((e=>{var n,i;return{label:e.literal[0].flatData.text,url:be(s.config.country,s.config.language,s.config.urlBase,e.slug[0].flatData.slug,null!==(n=e.script)&&void 0!==n&&n),tracking:ye(e.tracking,t,a),trackingGA4:ke(e.trackingGA4,t,a,o),search:e.search,searchTracking:e.searchTracking,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,borderColor:e.borderColor,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedFontColor:e.selectedFontColor,selectedBackgroundColor:e.selectedBackgroundColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.font[0].flatData.name,upperCase:e.upperCase,lowerCase:e.lowerCase,showCountriesModal:e.showCountriesModal,underline:e.underline,script:null!==(i=e.script)&&void 0!==i&&i}}))}),[e.buttons]),k=g((()=>{if(0===v)return y;let e=[];for(let t=0;t<v;t++)e.push(y[t]);return e}),[v,y]),w=g((()=>{if(0===v)return;let e=[];for(let t=v;t<y.length;t++)e.push(y[t]);return e}),[v,y]),C=g((()=>null==x?void 0:x.find((e=>"Claim"===e.textType))),[null==x?void 0:x.find]),D=g((()=>null==x?void 0:x.find((e=>"Subclaim"===e.textType))),[null==x?void 0:x.find]),S=g((()=>C?C.literal:y&&y.length>0?y[0].label:""),[C,y]),T=g((()=>e.componentType[0].flatData.name.toLocaleLowerCase()),[e.componentType]),_=g((()=>null==x?void 0:x.find((e=>"Bottom"===e.textType))),[null==x?void 0:x.find]),z=g((()=>{switch(T){case"standard center":case"standard spaced":return"content-center";case"standard bottom":return C||D?"content-bottom":"content-buttononly";case"standard search":return"content-search";default:return""}}),[e.componentType,C,D]),E=g((()=>{var e,t;return h?c.createElement(c.Fragment,null,h.desktop&&c.createElement(Mt,{mobile:h.desktop,alt:{en:S},autoPlay:!0,muted:!0,loop:!0,poster:b&&b.desktop?oa(s,[b.desktop.standard,null!==(e=b.desktop.webp)&&void 0!==e?e:"",null!==(t=b.desktop.avif)&&void 0!==t?t:""]):"",playsInline:!0,className:"backgroundvideo",lazy:i})):b&&c.createElement(no,Object.assign({},b,{alt:S,lazy:i}))}),[s,b,h,S]),N=g((()=>e.countdown&&e.countdown.length>0?{daysLiteral:e.countdown[0].daysLiteral[0].flatData.text,hoursLiteral:e.countdown[0].hoursLiteral[0].flatData.text,minutesLiteral:e.countdown[0].minutesLiteral[0].flatData.text,finalDate:e.countdown[0].finalDate,font:e.countdown[0].font[0].flatData.name,fontSizeTextDesktop:e.countdown[0].fontSizeTextDesktop,fontSizeTextTablet:e.countdown[0].fontSizeTextTablet,fontSizeTextMobile:e.countdown[0].fontSizeTextMobile,fontSizeNumbersDesktop:e.countdown[0].fontSizeNumbersDesktop,fontSizeNumbersTablet:e.countdown[0].fontSizeNumbersTablet,fontSizeNumbersMobile:e.countdown[0].fontSizeNumbersMobile,fontColor:e.countdown[0].fontColor}:null),[e.countdown]);return c.createElement(eo,{mobileLayout:l},c.createElement(oo,null,c.createElement("a",{className:"trackable "+(d.script?"slugwithparameters":""),href:u,"data-tracking":d.search&&null!=d.searchTracking?we(d.searchTracking,!0):p,"data-trackingga4":m},!n||h?E:c.createElement(_a,{className:"fadein-animation"},E))),c.createElement(ao,{className:z},N&&c.createElement(za,{daysLiteral:N.daysLiteral,hoursLiteral:N.hoursLiteral,minutesLiteral:N.minutesLiteral,finalDate:N.finalDate,font:N.font,fontSizeTextDesktop:N.fontSizeTextDesktop,fontSizeTextTablet:N.fontSizeTextTablet,fontSizeTextMobile:N.fontSizeTextMobile,fontSizeNumbersDesktop:N.fontSizeNumbersDesktop,fontSizeNumbersTablet:N.fontSizeNumbersTablet,fontSizeNumbersMobile:N.fontSizeNumbersMobile,color:N.fontColor}),null==x?void 0:x.map(((e,t)=>e.cta&&"Bottom"!=e.textType?c.createElement(Dt,{key:`typo_${t}`,as:yt,fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,"data-tracking":e.tracking,"data-trackingga4":e.trackingGA4,href:e.slug,underline:!0,upperCase:e.upperCase,lowerCase:e.lowerCase,className:"trackable "+(e.script?"slugwithparameters":""),marginTop:e.marginTop,marginTopMobile:e.marginTopMobile},e.literal):"Bottom"!=e.textType&&c.createElement(Dt,{key:`typo_${t}`,as:"Claim"===e.textType?"1"===a||"1A"===a?"h1":"h2":"h3",className:"Note"===e.textType&&k&&(null==k?void 0:k.length)>0?"marginNote":"",fontName:e.fontName,fontColor:e.fontColor,fontColorMobile:e.fontColorMobile,fontColorTablet:e.fontColorTablet,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,upperCase:e.upperCase,lowerCase:e.lowerCase,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile,textShadowDesktop:e.textShadowDesktop,textShadowTablet:e.textShadowTablet,textShadowMobile:e.textShadowMobile},e.literal))),k&&c.createElement(to,null,k.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:D||!C&&!D?0:15,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,showCountriesModal:e.showCountriesModal,underline:e.underline,showI18nModal:r,className:`trackable buttonMinWidth ${e.script?"slugwithparameters":""} ${"standard search"===T?"firstButtons":""}`},e.label)))),w&&c.createElement(to,null,w.map(((e,t)=>c.createElement(Tt,{key:`banner_button_${t}`,backgroundColor:e.backgroundColor,backgroundColorTablet:e.backgroundColorTablet,backgroundColorMobile:e.backgroundColorMobile,boxShadowDesktop:e.boxShadowDesktop,boxShadowTablet:e.boxShadowTablet,boxShadowMobile:e.boxShadowMobile,selectedBackgroundColor:e.selectedBackgroundColor,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,selectedFontColor:e.selectedFontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,fontName:e.fontName,borderColor:e.borderColor,marginTop:4,marginLeft:4,href:e.url,"data-tracking":e.search&&null!=e.searchTracking?we(e.searchTracking,!0):e.tracking,"data-trackingga4":e.trackingGA4,upperCase:e.upperCase,lowerCase:e.lowerCase,showCountriesModal:e.showCountriesModal,underline:e.underline,className:"trackable buttonMinWidth "+(e.script?"slugwithparameters":""),showI18nModal:r},e.label))))),_&&c.createElement(ao,{className:"bottom-center"},c.createElement(Dt,{key:`typo_${x.length}`,as:"h3",className:"",fontName:_.fontName,fontColor:_.fontColor,fontColorMobile:_.fontColorMobile,fontColorTablet:_.fontColorTablet,fontSizeDesktop:_.fontSizeDesktop,fontSizeTablet:_.fontSizeTablet,fontSizeMobile:_.fontSizeMobile,upperCase:_.upperCase,lowerCase:_.lowerCase,marginTop:_.marginTop,marginTopMobile:_.marginTopMobile,textShadowDesktop:_.textShadowDesktop,textShadowTablet:_.textShadowTablet,textShadowMobile:_.textShadowMobile},_.literal)))}const lo=a`
  0% { left: 0; }
  100% { left: -100%; }
`,ro=e.div.withConfig({shouldForwardProp:e=>!["fontColor","textType","fontColorMobile","fontColorTablet","backgroundColor","fontSizeDesktop","fontSizeTablet","fontSizeMobile","marginTopMobile","marginTop","upperCase","lowerCase","textShadowDesktop","textShadowTablet","textShadowMobile","fontName"].includes(e)})`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  height: 2.5em; /* TODO - TONI - pendiente cuando lo agreguen a la maqueta */
  color: ${e=>{var t;return null!==(t=e.fontColor)&&void 0!==t?t:"#000"}};
  font-family: ${e=>{var t;return Y(e.language)?"Arial":null!==(t=e.fontName)&&void 0!==t?t:"ModerneBlack"}};
  background-color: ${e=>{var t;return null!==(t=e.backgroundColor)&&void 0!==t?t:"transparent"}};
  font-size: ${e=>{var t;return`${null!==(t=e.fontSizeDesktop)&&void 0!==t?t:.75}rem`}};

  > div {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 200%;
    display: flex;
    justify-content: space-evenly;
    animation: ${lo} 5s linear infinite;

    @media (min-width: 768px) {
      animation: ${lo} 10s linear infinite;
    }

    span {
      width: ${100/6}%;
      padding: 0 14px;

      @media (max-width: 1280px) {
        width: 50%;

        &:nth-child(8) ~ span {
          display: none;
        }
      }

      @media (max-width: 1024px) {
        width: ${100/6}%;

        &:nth-child(6) ~ span {
          display: none;
        }
      }

      @media (max-width: 768px) {
        width: 25%;
        padding: 0 8px;

        &:nth-child(4) ~ span {
          display: none;
        }
      }
    }
  }

  @media (min-width: 768px) {
    font-size: ${e=>{var t;return`${null!==(t=e.fontSizeTablet)&&void 0!==t?t:.75}em`}};
  }

  @media (min-width: 1440px) {
    font-size: ${e=>{var t;return`${null!==(t=e.fontSizeDesktop)&&void 0!==t?t:.75}em`}};
  }

  ${e=>""+(e.upperCase?"text-transform: uppercase":"")};
  ${e=>""+(e.lowerCase?"text-transform: lowercase":"")};
`,so=e=>{const{config:t}=f(Z),{children:a}=e,o=P(e,["children"]);return c.createElement(ro,Object.assign({language:t.language},o),c.createElement("div",null,Array.from({length:12},((e,t)=>c.createElement("span",{key:`ribbon_children_${t}`},a)))))},co=e.div`
  position: relative;
  margin-right: 20px;

  .background {
    width: 100%;
    display: block;
  }
`,uo=e.div`
  position: relative;
  flex: 0 0 262px;
`,po=e.a`
  text-decoration: none;
  display: block;
  position: relative;
  margin-bottom: 12px;

  .fadein-animation {
    width: 100%;
    display: block;
  }
`,mo=e(et)`
  width: 100%;
  display: block;
`;function fo({data:e,market:t,position:a,type:o,blur:n,lazy:i}){var l,r,s;const d=f(Z),[u]=e.images,p=g((()=>{var e;return be(d.config.country,d.config.language,d.config.urlBase,u.slug[0].flatData.slug,null!==(e=u.script)&&void 0!==e&&e)}),[u.slug,u.script]),m=g((()=>(null==u?void 0:u.tracking)?ye(u.tracking,t,a.toString()):""),[u,t,a]),h=g((()=>(null==u?void 0:u.trackingGA4)?ke(u.trackingGA4,t,a.toString(),o):""),[u,t,a,o]),b=g((()=>{var t;return null===(t=e.texts)||void 0===t?void 0:t.find((e=>"Claim"===e.textType[0].flatData.name))}),[null===(l=e.texts)||void 0===l?void 0:l.find]),x=g((()=>null==b?void 0:b.literal[0].flatData.text),[b]),v=g((()=>{var e;return(null==b?void 0:b.slug)?be(d.config.country,d.config.language,d.config.urlBase,null==b?void 0:b.slug[0].flatData.slug,null!==(e=null==b?void 0:b.script)&&void 0!==e&&e):"#"}),[b]),y=g((()=>(null==b?void 0:b.tracking)?ye(b.tracking,t,a.toString()):""),[b,t,a]),k=g((()=>(null==b?void 0:b.trackingGA4)?ke(b.trackingGA4,t,a.toString(),o):""),[b,t,a,o]),w=g((()=>{var t;return null===(t=e.texts)||void 0===t?void 0:t.find((e=>"Subclaim"===e.textType[0].flatData.name))}),[null===(r=e.texts)||void 0===r?void 0:r.find]),C=g((()=>null==w?void 0:w.literal[0].flatData.text),[w]),D=g((()=>{var e;return(null==w?void 0:w.slug)?be(d.config.country,d.config.language,d.config.urlBase,null==w?void 0:w.slug[0].flatData.slug,null!==(e=null==w?void 0:w.script)&&void 0!==e&&e):"#"}),[w]),S=g((()=>(null==w?void 0:w.tracking)?ye(w.tracking,t,a.toString()):""),[w,t,a]),T=g((()=>(null==w?void 0:w.trackingGA4)?ke(w.trackingGA4,t,a.toString(),o):""),[w,t,a,o]),_=g((()=>{var t;return null===(t=e.texts)||void 0===t?void 0:t.find((e=>"Ribbon"===e.textType[0].flatData.name))}),[null===(s=e.texts)||void 0===s?void 0:s.find]),z=g((()=>null==_?void 0:_.literal[0].flatData.text),[_]),E=g((()=>ra(u.assets)),[u.assets]),N=g((()=>la(u.assets,d)),[u.assets,d]),M=g((()=>{var e,t;return E?c.createElement(c.Fragment,null,E.desktop&&c.createElement(Mt,{mobile:E.desktop,alt:{en:null!=x?x:""},autoPlay:!0,muted:!0,loop:!0,poster:N&&N.desktop?oa(d,[N.desktop.standard,null!==(e=N.desktop.webp)&&void 0!==e?e:"",null!==(t=N.desktop.avif)&&void 0!==t?t:""]):"",playsInline:!0,className:"background",lazy:i})):N&&c.createElement(mo,Object.assign({},N,{alt:x,lazy:i}))}),[d,N,E,x]);return c.createElement(co,null,c.createElement(po,{className:"trackable "+(u.script?"slugwithparameters":""),"data-tracking":m,"data-trackingga4":h,href:p},!n||E?M:c.createElement(_a,{className:"fadein-animation"},N&&M),_?c.createElement(so,{fontName:null==_?void 0:_.font[0].flatData.name,fontColor:null==_?void 0:_.fontColor,fontSizeDesktop:null==_?void 0:_.fontSizeDesktop,fontSizeTablet:null==_?void 0:_.fontSizeTablet,fontSizeMobile:null==_?void 0:_.fontSizeMobile,backgroundColor:null==_?void 0:_.backgroundColor,upperCase:null==_?void 0:_.upperCase,lowerCase:null==_?void 0:_.lowerCase},z):""),c.createElement(uo,null,c.createElement(Dt,{as:yt,href:v,className:"trackable "+((null==b?void 0:b.script)?"slugwithparameters":""),"data-tracking":y,"data-trackingga4":k,fontName:null==b?void 0:b.font[0].flatData.name,fontColor:null==b?void 0:b.fontColor,fontSizeDesktop:null==b?void 0:b.fontSizeDesktop,fontSizeTablet:null==b?void 0:b.fontSizeTablet,fontSizeMobile:null==b?void 0:b.fontSizeMobile,upperCase:null==b?void 0:b.upperCase,lowerCase:null==b?void 0:b.lowerCase,marginTop:null==b?void 0:b.marginTop,marginTopMobile:null==b?void 0:b.marginTopMobile,storyLink:!0},x),c.createElement("br",null),c.createElement(Dt,{as:yt,href:D,"data-tracking":S,"data-trackingga4":T,className:"trackable "+((null==w?void 0:w.script)?"slugwithparameters":""),fontName:null==w?void 0:w.font[0].flatData.name,fontColor:null==w?void 0:w.fontColor,fontSizeDesktop:null==w?void 0:w.fontSizeDesktop,fontSizeTablet:null==w?void 0:w.fontSizeTablet,fontSizeMobile:null==w?void 0:w.fontSizeMobile,upperCase:null==w?void 0:w.upperCase,lowerCase:null==w?void 0:w.lowerCase,marginTop:null==w?void 0:w.marginTop,marginTopMobile:null==w?void 0:w.marginTopMobile,storyLink:!0},C)))}function go({data:e,market:t,position:a,type:o,blur:n,lazy:i,mobileLayout:s,showI18nModal:d,slots:u}){const{width:p}=le(),[m]=e.componentType,f=g((()=>m.flatData.name.toLocaleLowerCase()),[m.flatData.name]);switch(f){case"standard search":case"standard spaced":case"standard center":case"standard bottom":return c.createElement(ho,{viewPortWidth:p},c.createElement(io,{data:e,market:t,position:a,type:o,lazy:i,blur:n}));case"promo":return c.createElement(ho,{viewPortWidth:p},c.createElement(Aa,{data:e,market:t,position:a,type:o,blur:n,lazy:i,mobileLayout:s}));case"promo left":return c.createElement(ho,{viewPortWidth:p},c.createElement(Wa,{data:e,market:t,position:a,type:o,blur:n,mobileLayout:s,lazy:i}));case"promo left bottom":return c.createElement(ho,{viewPortWidth:p},c.createElement(Oa,{data:e,market:t,position:a,type:o,blur:n,mobileLayout:s,lazy:i}));case"standard spaced":return c.createElement(ho,{viewPortWidth:p,mobileLayout:s},c.createElement(r,{xs:!0,sm:!0,md:!0},c.createElement(Za,{data:e,market:t,position:a,type:o,blur:n,lazy:i,mobileLayout:s})),c.createElement(l,{xs:!0,sm:!0,md:!0},c.createElement(io,{data:e,market:t,position:a,type:o,blur:n,lazy:i,mobileLayout:s,showI18nModal:d})));case"promo product":return c.createElement(ho,{viewPortWidth:p},c.createElement(Za,{data:e,market:t,position:a,type:o,blur:n,lazy:i,mobileLayout:s}));case"story":return c.createElement(ho,{viewPortWidth:p},c.createElement(fo,{data:e,market:t,position:a,type:o,lazy:i,blur:n}));case"dynamic":return e.dynamic?c.createElement(Sa,{market:t,rootComponent:e.dynamic,slots:u}):c.createElement(c.Fragment,null);default:return console.error(`Unknown banner component variant: ${f}`),null}}const ho=e.div.withConfig({shouldForwardProp:e=>!["viewPortWidth","mobileLayout"].includes(e)})`
  ${({viewPortWidth:e})=>void 0!==e?`max-width: ${e}px;`:""}

  ${e=>void 0!==e.mobileLayout&&""!==e.mobileLayout?" @media (max-width: 767px) {\n            grid-column-start: span 2;\n            grid-column-end: auto;\n          }":""};
`,bo=a`
  0% { width: 0; }
  100% { width: 100%; }
`,xo=e.div.withConfig({shouldForwardProp:e=>!["growWidth","sliderDuration"].includes(e)})`
  display: flex;
  position: relative;
  display: grid;
  @media (min-width: 1024px) {
    max-width: 50%;
  }

  > .background {
    display: block;
    width: 100%;
    height: auto;
    z-index: 0;
  }

  .fadein-animation {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .slick-slider {
    width: 100%;
    overflow: hidden;
    position: relative;

    .slick-list {
      width: 100%;

      .slick-track {
        display: flex;

        .slick-slide {
          max-width: 100vw;
        }
      }
    }

    .slick-dots {
      position: absolute;
      width: 100%;
      bottom: 8px;
      list-style: none;
      margin: 0;
      padding: 0;

      /* override inline-style */
      display: flex !important;

      li {
        width: auto;
        flex-basis: 100%;
        background: rgba(255, 255, 255, 0.5);
        margin: 0 4px;
        height: 5px;

        &:first-child {
          margin-left: 0;
        }

        &:last-child {
          margin-right: 0;
        }

        button {
          display: block;
          width: 100%;
          height: 100%;
          background: none;
          color: transparent;
          border-width: none;
          position: relative;
          padding: 0;
          border-width: 0;

          &:before {
            content: "";
            width: 100%;
          }
        }

        &.slick-active {
          button {
            &:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              height: 100%;
              background: rgba(255, 255, 255, 0.75);
              animation: ${bo} ${4}s 1;
            }
          }
        }
      }
    }
  }
`,vo=e=>{const{children:t}=e,a=P(e,["children"]);return c.createElement(xo,Object.assign({},a),t)},yo={dots:!0,arrows:!1,infinite:!0,speed:500,slidesToShow:1,slidesToScroll:1,autoplay:!0,autoplaySpeed:4e3};function ko({data:e,market:t,position:a,type:o,slots:n}){var i;const l=g((()=>{const t=[10..toString(36).toLocaleUpperCase()];if(1===e.components.length)return[""];for(let a=1;a<e.components.length;a++)t.push((a+10).toString(36).toLocaleUpperCase());return t}),[e.components.length]),r=g((()=>{var t;return null===(t=e.texts)||void 0===t?void 0:t.find((e=>{var t;return"Ribbon"===(null===(t=e.textType[0])||void 0===t?void 0:t.flatData.name)}))}),[null===(i=e.texts)||void 0===i?void 0:i.find]),s=g((()=>null==r?void 0:r.literal[0].flatData.text),[r]);return c.createElement(vo,{numComponents:e.components.length},c.createElement(B,Object.assign({},yo),e.components.map(((e,i)=>c.createElement(go,{key:`bannerregularcarousel_${i}`,data:e.flatData,market:t,position:a+l[i],type:o,blur:!0,lazy:1!==a,slots:n})))),r&&c.createElement(so,{fontName:null==r?void 0:r.font[0].flatData.name,fontColor:null==r?void 0:r.fontColor,fontSizeDesktop:null==r?void 0:r.fontSizeDesktop,fontSizeTablet:null==r?void 0:r.fontSizeTablet,fontSizeMobile:null==r?void 0:r.fontSizeMobile,backgroundColor:null==r?void 0:r.backgroundColor,upperCase:null==r?void 0:r.upperCase,lowerCase:null==r?void 0:r.lowerCase},s))}const wo=e.div.withConfig({shouldForwardProp:e=>!["numComponents"].includes(e)})`
  display: flex;
  position: relative;
  display: grid;

  @media (min-width: 1024px) {
    max-width: 50%;
  }

  ${e=>void 0!==e.numComponents&&e.numComponents>1?"grid-template-columns: 1fr 1fr;":""};

  > .background {
    display: block;
    width: 100%;
    height: auto;
    z-index: 0;
  }

  .fadein-animation {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
`,Co=e=>{const{children:t}=e,a=P(e,["children"]);return c.createElement(wo,Object.assign({},a),t)};function Do({data:e,market:t,position:a,type:o,slots:n}){var i;const l=g((()=>{const t=[10..toString(36).toLocaleUpperCase()];if(1===e.components.length)return[""];for(let a=1;a<e.components.length;a++)t.push((a+10).toString(36).toLocaleUpperCase());return t}),[e.components.length]),r=g((()=>{var t;return null===(t=e.texts)||void 0===t?void 0:t.find((e=>{var t;return"Ribbon"===(null===(t=e.textType[0])||void 0===t?void 0:t.flatData.name)}))}),[null===(i=e.texts)||void 0===i?void 0:i.find]),s=g((()=>null==r?void 0:r.literal[0].flatData.text),[r]);return c.createElement(Co,{numComponents:e.components.length},e.components.map(((e,i)=>c.createElement(go,{key:`bannerregular_${i}`,data:e.flatData,market:t,position:a+l[i],type:o,blur:!0,lazy:1!==a,slots:n}))),r&&c.createElement(so,{fontName:null==r?void 0:r.font[0].flatData.name,fontColor:null==r?void 0:r.fontColor,fontSizeDesktop:null==r?void 0:r.fontSizeDesktop,fontSizeTablet:null==r?void 0:r.fontSizeTablet,fontSizeMobile:null==r?void 0:r.fontSizeMobile,backgroundColor:null==r?void 0:r.backgroundColor,upperCase:null==r?void 0:r.upperCase,lowerCase:null==r?void 0:r.lowerCase},s))}const So=e.div`
  position: relative;
  margin: 50px auto 50px;
  padding-left: 24px;

  @media (min-width: 768px) {
    margin-top: 50px;
    padding-left: 50px;
  }

  @media (min-width: 1440px) {
    padding: 0 0 0 100px;
  }

  > .background {
    width: 100%;
    height: auto;
    z-index: 0;
  }

  .slick-dots {
    /* just in case */
    display: none !important;
  }

  .slick-slider {
    width: 100%;
    overflow: hidden;

    .slick-list {
      width: 100%;

      .slick-track {
        display: flex;

        .slick-slide {
          max-width: 100vw;
        }
      }
    }

    .slick-arrow {
      cursor: pointer;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      color: transparent;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 4px rgb(0 0 0 / 50%);
      width: 48px;
      height: 48px;
      border-radius: 50%;
      border-width: 0;
      z-index: 2;

      &::before {
        content: "";
        position: absolute;
        border-top: 1px solid;
        border-right: 1px solid;
        width: 10px;
        height: 10px;
        display: block;
        border-color: black;
      }

      &.slick-prev {
        left: 40px;

        &::before {
          transform: rotate(225deg);
          top: 39%;
          left: 42%;
        }
      }

      &.slick-next {
        right: 40px;

        &::before {
          transform: rotate(45deg);
          top: 38%;
          left: 37%;
        }
      }

      &.slick-disabled {
        cursor: default;
        opacity: 0;
      }
    }
  }

  .carousel-stories {
    width: 100vw;
    overflow: hidden;

    > div {
      display: block;

      > div {
        display: inline-flex;
      }
    }
  }
`,To=e.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding-right: 24px;

  h2 {
    font-weight: 600;
  }

  .trackable {
    margin: auto 0;
    border: 1px solid black;
    padding: 10px 20px;
    transition: color 0.3s, background-color 0.3s;
    background-color: #fff;
    color: #000;

    &:hover {
      color: #fff;
      background-color: #000;
    }
  }

  @media (min-width: 1440px) {
    padding-right: 100px;
  }
`,_o=e.div`
  position: relative;
  display: flex;
  margin-top: 30px;
  overflow-x: auto;
  overflow-y: hidden;
`;function zo({data:e,market:t,position:a,type:o,slots:n}){var i,l;const{config:r}=f(Z),s=g((()=>{var t;return null===(t=e.texts)||void 0===t?void 0:t.find((e=>"Banner Title"===e.textType[0].flatData.name))}),[null===(i=e.texts)||void 0===i?void 0:i.find]),d=g((()=>null==s?void 0:s.literal[0].flatData.text),[s]),u=g((()=>{var t;return null===(t=e.texts)||void 0===t?void 0:t.find((e=>"See All"===e.textType[0].flatData.name))}),[null===(l=e.texts)||void 0===l?void 0:l.find]),p=g((()=>null==u?void 0:u.literal[0].flatData.text),[u]),m=g((()=>(null==u?void 0:u.slug)?be(r.country,r.language,r.urlBase,null==u?void 0:u.slug[0].flatData.slug):"#"),[u,r.country,r.language,r.urlBase]),h=g((()=>(null==u?void 0:u.tracking)?ye(u.tracking,t,a.toString()):""),[u,t,a]),b=g((()=>{const t=[10..toString(36).toLocaleUpperCase()];if(1===e.components.length)return[""];for(let a=1;a<e.components.length;a++)t.push((a+10).toString(36).toLocaleUpperCase());return t}),[e.components.length]),x={dots:!1,infinite:!1,speed:500,slidesToShow:e.components.length<=4?e.components.length:4.2,slidesToScroll:1,autoplay:!1,responsive:[{breakpoint:992,settings:{slidesToShow:3.2}},{breakpoint:768,settings:{slidesToShow:2.2}}]};return c.createElement(So,null,c.createElement(To,null,c.createElement(Dt,{as:"h2",fontName:null==s?void 0:s.font[0].flatData.name,fontColor:null==s?void 0:s.fontColor,fontSizeDesktop:null==s?void 0:s.fontSizeDesktop,fontSizeTablet:null==s?void 0:s.fontSizeTablet,fontSizeMobile:null==s?void 0:s.fontSizeMobile,upperCase:null==s?void 0:s.upperCase,lowerCase:null==s?void 0:s.lowerCase},d),c.createElement(Dt,{as:yt,href:m,className:"trackable","data-tracking":h,fontName:null==u?void 0:u.font[0].flatData.name,fontColor:null==u?void 0:u.fontColor,fontSizeDesktop:null==u?void 0:u.fontSizeDesktop,fontSizeTablet:null==u?void 0:u.fontSizeTablet,fontSizeMobile:null==u?void 0:u.fontSizeMobile,upperCase:null==u?void 0:u.upperCase,lowerCase:null==u?void 0:u.lowerCase},p)),c.createElement(_o,null,c.createElement("div",{className:"carousel-stories"},c.createElement(B,Object.assign({},x),e.components.map(((e,i)=>c.createElement(go,{key:`banner_${i}`,data:e.flatData,market:t,position:a+b[i],type:o,blur:!0,lazy:1!==a,slots:n})))))))}const Eo=a`
  0% { width: 0; }
  100% { width: 100%; }
`,No=4,Mo=e.div.withConfig({shouldForwardProp:e=>!["growWidth","sliderDuration","nogrid"].includes(e)})`

${e=>!e.nogrid&&o`
    display: flex;
    position: relative;
    display: grid;

    ${void 0!==e.numComponents&&e.numComponents>=4?"\n        grid-template-columns: 1fr 1fr;\n        @media (min-width: 768px) {\n          grid-template-columns: 1fr 1fr 1fr 1fr;\n        }":""};
  `}

  > .background {
    display: block;
    width: 100%;
    height: auto;
    z-index: 0;
  }
  
  .fadein-animation {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
  }

  .slick-slider {
    position: relative;
    width: 100%;
    overflow: hidden;

    .slick-list {
      width: 100%;

      .slick-track {
        display: flex;

        .slick-slide {
          max-width: 100vw;
        }
      }
    }

    .slick-dots {
      position: absolute;
      width: 100%;
      bottom: 8px;
      list-style: none;
      margin: 0;
      padding: 0;

      /* override inline-style */
      display: flex !important; 

      li {
        width: auto;
        flex-basis: 100%;
        background: rgba(255, 255, 255, 0.5);
        margin: 0 4px;
        height: 5px;

        &:first-child {
          margin-left: 0;
        }

        &:last-child {
          margin-right: 0;
        }

        button {
          display: block;
          width: 100%;
          height: 100%;
          background: none;
          color: transparent;
          border-width: none;
          position: relative;
          padding: 0;
          border-width: 0;

          &:before {
						content: "";
            width: 100%;				
          }
        }

        &.slick-active {
          button {
            &:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              height: 100%;
              background: rgba(255, 255, 255, 0.75);
              animation: ${Eo} ${No}s 1;
            }
          }
        }
      }
    }
  }
}
`,$o=e=>{const{children:t}=e,a=P(e,["children"]);return c.createElement(Mo,Object.assign({},a),t)};function Bo({data:e,market:t,position:a,type:o,slots:n}){var i;const l=g((()=>{const t=[10..toString(36).toLocaleUpperCase()];if(1===e.components.length)return[""];for(let a=1;a<e.components.length;a++)t.push((a+10).toString(36).toLocaleUpperCase());return t}),[e.components.length]),r=g((()=>{var t;return null===(t=e.texts)||void 0===t?void 0:t.find((e=>{var t;return"Ribbon"===(null===(t=e.textType[0])||void 0===t?void 0:t.flatData.name)}))}),[null===(i=e.texts)||void 0===i?void 0:i.find]),s=g((()=>null==r?void 0:r.literal[0].flatData.text),[r]),d={dots:!0,arrows:!1,infinite:!0,speed:500,slidesToShow:1,slidesToScroll:1,autoplay:!0,autoplaySpeed:1e3*No};return c.createElement($o,{nogrid:!0,numComponents:e.components.length},c.createElement(B,Object.assign({},d),e.components.map(((e,i)=>c.createElement(go,{key:`bannerwidecarousel_${i}`,data:e.flatData,market:t,position:a+l[i],type:o,blur:!0,lazy:1!==a,slots:n})))),r&&c.createElement(so,{fontName:null==r?void 0:r.font[0].flatData.name,fontColor:null==r?void 0:r.fontColor,fontSizeDesktop:null==r?void 0:r.fontSizeDesktop,fontSizeTablet:null==r?void 0:r.fontSizeTablet,fontSizeMobile:null==r?void 0:r.fontSizeMobile,backgroundColor:null==r?void 0:r.backgroundColor,upperCase:null==r?void 0:r.upperCase,lowerCase:null==r?void 0:r.lowerCase},s))}const Ao=e.div.withConfig({shouldForwardProp:e=>!["numComponents","mobileLayout"].includes(e)})`
  display: flex;
  position: relative;
  display: grid;

  ${e=>void 0!==e.numComponents&&e.numComponents>=4?"grid-template-columns: 1fr 1fr;\n          @media (min-width: 768px) {\n            grid-template-columns: 1fr 1fr 1fr 1fr;\n          }":3===e.numComponents?`grid-template-columns: ${"1+1+1"===e.mobileLayout?"1fr":"1fr 1fr"};\n        @media (min-width: 768px) {\n          grid-template-columns: 1fr 1fr 1fr;\n        }`:2===e.numComponents?"grid-template-columns: 1fr 1fr;":""};

  > .background {
    display: block;
    width: 100%;
    height: auto;
    z-index: 0;
  }

  .fadein-animation {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
`,Lo=e=>{const{children:t}=e,a=P(e,["children"]);return c.createElement(Ao,Object.assign({},a),t)};function Io({onlyFirst:e,data:t,market:a,position:o,type:n,showI18nModal:i,slots:l}){var r;const s=g((()=>{const e=[10..toString(36).toLocaleUpperCase()];if(1===t.components.length)return[""];for(let a=1;a<t.components.length;a++)e.push((a+10).toString(36).toLocaleUpperCase());return e}),[t.components.length]),d=g((()=>{var e;return null===(e=t.texts)||void 0===e?void 0:e.find((e=>{var t;return"Ribbon"===(null===(t=e.textType[0])||void 0===t?void 0:t.flatData.name)}))}),[null===(r=t.texts)||void 0===r?void 0:r.find]),u=null==d?void 0:d.literal[0].flatData.text;return c.createElement(Lo,{numComponents:e?1:t.components.length,mobileLayout:t.layoutMobile},t.components.map(((r,d)=>0==d&&e||!e?c.createElement(go,{key:`bannerwide_${d}`,data:r.flatData,market:a,position:o+s[d],type:n,blur:!0,mobileLayout:3===t.components.length&&"1+1+1"!==t.layoutMobile&&"2+1"===t.layoutMobile&&2===d?t.layoutMobile:"",lazy:1!==o,showI18nModal:i,slots:l}):c.createElement(c.Fragment,null))),d&&c.createElement(so,{fontName:null==d?void 0:d.font[0].flatData.name,fontColor:null==d?void 0:d.fontColor,fontSizeDesktop:null==d?void 0:d.fontSizeDesktop,fontSizeTablet:null==d?void 0:d.fontSizeTablet,fontSizeMobile:null==d?void 0:d.fontSizeMobile,backgroundColor:null==d?void 0:d.backgroundColor,upperCase:null==d?void 0:d.upperCase,lowerCase:null==d?void 0:d.lowerCase},u))}function Fo({data:e,market:t,position:a,type:o,showI18nModal:n,slots:i}){if("string"==typeof e.bannerType)return console.error(`Unknown banner variant: ${e.bannerType}`),null;const[s]=e.bannerType,d=g((()=>s.flatData.name.toLocaleLowerCase()),[s.flatData.name]);switch(d){case"wide":case"search":return e.onlyDesktop?c.createElement(l,{xs:!0,sm:!0,md:!0},c.createElement(Io,{data:e,market:t,position:a,type:o,showI18nModal:n,slots:i})):c.createElement(Io,{data:e,market:t,position:a,type:o,showI18nModal:n,slots:i});case"wide carousel":return e.onlyDesktop?c.createElement(l,{xs:!0,sm:!0,md:!0},c.createElement(Bo,{data:e,market:t,position:a,slots:i,type:o})):c.createElement(Bo,{data:e,market:t,position:a,slots:i,type:o});case"wide carousel mobile":return e.onlyDesktop?c.createElement(l,{xs:!0,sm:!0,md:!0},c.createElement(r,{xs:!0,sm:!0,md:!0},c.createElement(Bo,{data:e,market:t,position:a,slots:i,type:o})),c.createElement(l,{xs:!0,sm:!0,md:!0},c.createElement(Io,{onlyFirst:!0,data:e,market:t,position:a,type:o,showI18nModal:n,slots:i}))):c.createElement(c.Fragment,null,c.createElement(r,{xs:!0,sm:!0,md:!0},c.createElement(Bo,{data:e,market:t,position:a,type:o,slots:i})),c.createElement(l,{xs:!0,sm:!0,md:!0},c.createElement(Io,{onlyFirst:!0,data:e,market:t,position:a,type:o,showI18nModal:n,slots:i})));case"stories":case"store locator":return e.onlyDesktop?c.createElement(l,{xs:!0,sm:!0,md:!0},c.createElement(zo,{data:e,market:t,position:a,type:o,slots:i})):c.createElement(zo,{data:e,market:t,position:a,type:o,slots:i});case"regular":return e.onlyDesktop?c.createElement(l,{xs:!0,sm:!0,md:!0},c.createElement(Do,{data:e,market:t,position:a,type:o,slots:i})):c.createElement(Do,{data:e,market:t,position:a,type:o,slots:i});case"regular carousel":return e.onlyDesktop?c.createElement(l,{xs:!0,sm:!0,md:!0},c.createElement(ko,{data:e,market:t,position:a,type:o,slots:i})):c.createElement(ko,{data:e,market:t,position:a,type:o,slots:i});default:return console.error(`Unknown banner variant: ${d}`),null}}let Go=class{constructor(e){this.fetchNewsletterDetail=(e,t)=>this.fetchService.cmsFetchGraphQL("GetNewsletter",`query GetNewsletter{queryNewsletterContents(filter:"status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}'",orderby:"created desc") {\n        flatData {\n          icon {\n            fileName\n            url\n            tags\n          }\n          name\n          texts {\n            literal {\n              flatData {\n                code\n                text\n              }\n            }\n            textType {\n              flatData {\n                code\n                name\n              }\n            }\n          }\n          images {\n            assets {\n              fileName\n              url\n              tags\n              metadata\n            }\n          }\n        }\n      }\n      }`),this.fetchNewsletterDefault=(e,t,a)=>this.fetchService.cmsFetchGraphQL("GetNewsletter",`query GetNewsletter { queryNewsletterContents(filter:"status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}' and data/type/iv eq '${a}'",orderby:"created desc") { flatData { icon { fileName url tags } name texts { literal { flatData { code text } } textType { flatData { code name } } } images { assets { fileName url tags metadata } } } }}`),this.fetchDefaultStep=()=>this.fetchService.cmsFetchGraphQL("GetStep","query GetStep { queryStepPopupContents( filter: \"data/name/iv eq 'default'\" ) { id }}"),this.fetchNewsletterById=e=>this.fetchService.cmsFetchGraphQL("GetNewsletter","query GetNewsletter($id: String!) {\n        findNewsletterContent(id: $id) {\n          flatData {\n            icon {\n              fileName\n              url\n              tags\n            }\n            name\n            texts {\n              literal {\n                flatData {\n                  code\n                  text\n                }\n              }\n              textType {\n                flatData {\n                  code\n                  name\n                }\n              }\n            }\n            images {\n              assets {\n                fileName\n                url\n                tags\n                metadata\n              }\n            }\n          }\n        }\n      }\n      ",{id:e}),this.fetchService=e}};Go=O([k(w.ContainerScoped),j("design:paramtypes",[te])],Go);let Po=class{constructor(e,t,a,o){this.getProps=e=>R(this,void 0,void 0,(function*(){var t,a,o,n;const i=yield this.languageService.fetchLanguageByCode(this.config.language),l=yield this.countryService.fetchCountryByCode(this.config.country),r=e?yield this.newsletterService.fetchNewsletterById(e):(yield this.newsletterService.fetchNewsletterDetail(null!==(a=null===(t=l[0])||void 0===t?void 0:t.id)&&void 0!==a?a:"",null!==(n=null===(o=i[0])||void 0===o?void 0:o.id)&&void 0!==n?n:""))[0];return r?{data:null==r?void 0:r.flatData}:null})),this.config=t,this.newsletterService=e,this.languageService=o,this.countryService=a}};Po=O([k(w.ContainerScoped),j("design:paramtypes",[Go,Q,oe,ne])],Po);const Oo=({data:t})=>{const a=e(et)`
    width: 100%;
    display: block;
  `,o=f(Z),n=g((()=>t.texts.map((e=>({textType:e.textType[0].flatData.name,literal:e.literal[0].flatData.text})))),[t.texts]),i=g((()=>null==n?void 0:n.find((e=>"Claim"===e.textType))),[null==n?void 0:n.find]),l=g((()=>null==n?void 0:n.find((e=>"Subclaim"===e.textType))),[null==n?void 0:n.find]),r=g((()=>la(t.images[0].assets,o)),[t.images[0].assets,o]);return c.createElement(c.Fragment,null,c.createElement(a,Object.assign({},r)),c.createElement("div",null,null==i?void 0:i.literal),c.createElement("div",null,null==l?void 0:l.literal))};let jo=class{constructor(e){this.fetchPdpDynamicComponentById=e=>this.fetchService.cmsFetchGraphQL("GetPdpDynamicComponentById","query GetPdpDynamicComponentById($id: String!){findPdpDynamicComponentContent(id: $id){flatData{sku,rootComponent,geography,countries{flatData{code,translatedName{flatData{code,text}},marketCode}},languages{flatData{code,translatedName}},gender{flatData{code,name}},position{flatData{name}}}}}",{id:e}),this.fetchPdpDynamicComponentBySku=(e,t,a,o)=>this.fetchService.cmsFetchGraphQL("GetPdpDynamicComponentBySku",`query GetPdpDynamicComponentBySku {queryPdpDynamicComponentContents(filter: "status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}' and data/sku/iv eq '${a}' and data/gender/iv eq '${o}'",   orderby: "created desc") {flatData {sku,rootComponent,geography,countries{flatData{code,translatedName{flatData{code,text}},marketCode}},languages{flatData{code,translatedName}},gender{flatData{code,name}},position{flatData{name}}}}}`),this.fetchService=e}};jo=O([k(w.ContainerScoped),j("design:paramtypes",[te])],jo);const Ro=(e,t)=>{const a=e.filter((e=>e.flatData.geography===t));return 0===a.length?null:a};let qo=class{constructor(e){this.fetchService=e}fetchGenderByCode(e){return this.fetchService.cmsFetchGraphQL("GetGender",`query GetGender{queryGendersContents(filter:"data/code/iv eq '${e}'"){id}}`)}};qo=O([k(w.ContainerScoped),j("design:paramtypes",[te])],qo);let Ho=class{constructor(e,t,a,o,n){this.config=o,this.languageService=a,this.countryService=t,this.pdpDynamicComponentService=e,this.genderService=n}getProps(e,t,a){var o,n,i,l,r,s,d,c,u,p;return R(this,void 0,void 0,(function*(){const m=yield this.languageService.fetchLanguageByCode(this.config.language),f=yield this.countryService.fetchCountryByCode(this.config.country),g=yield this.genderService.fetchGenderByCode(null!=t?t:""),h=a?yield this.pdpDynamicComponentService.fetchPdpDynamicComponentById(a):(e=>{var t;return null!==(t=Ro(e,"Countries"))&&void 0!==t?t:Ro(e,"Markets")})(yield this.pdpDynamicComponentService.fetchPdpDynamicComponentBySku(null!==(n=null===(o=f[0])||void 0===o?void 0:o.id)&&void 0!==n?n:"",null!==(l=null===(i=m[0])||void 0===i?void 0:i.id)&&void 0!==l?l:"",e||"",null!==(s=null===(r=g[0])||void 0===r?void 0:r.id)&&void 0!==s?s:""));return{top:null!==(c=null===(d=null==h?void 0:h.find((e=>"top"===e.flatData.position[0].flatData.name)))||void 0===d?void 0:d.flatData)&&void 0!==c?c:null,bottom:null!==(p=null===(u=null==h?void 0:h.find((e=>"bottom"===e.flatData.position[0].flatData.name)))||void 0===u?void 0:u.flatData)&&void 0!==p?p:null,market:f[0].flatData.marketCode}}))}};Ho=O([k(w.ContainerScoped),j("design:paramtypes",[jo,oe,ne,Q,qo])],Ho);const Uo=({market:e,data:t,slots:a})=>c.createElement(Sa,{market:e,rootComponent:t.rootComponent,slots:a});let Wo=class{constructor(e){this.fetchKboixTipById=e=>this.fetchService.cmsFetchGraphQL("GetKboixTipById","query GetKboixTipById($id: String!){findKboixTipContent(id: $id){flatData{idTip,rootComponent,geography,countries{flatData{code,translatedName{flatData{code,text}},marketCode}},languages{flatData{code,translatedName}}}}}",{id:e}),this.fetchKboixTipByIdTip=(e,t,a)=>this.fetchService.cmsFetchGraphQL("GetKboixTipByIdTip",`query GetKboixTipByIdTip {queryKboixTipContents(filter: "status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}' and data/idTip/iv eq '${a}'",   orderby: "created desc") {flatData {idTip,rootComponent,geography,countries{flatData{code,translatedName{flatData{code,text}},marketCode}},languages{flatData{code,translatedName}}}}}`),this.fetchService=e}};Wo=O([k(w.ContainerScoped),j("design:paramtypes",[te])],Wo);const Qo=(e,t)=>{const a=e.filter((e=>e.flatData.geography===t));return 0===a.length?null:a};let Yo=class{constructor(e,t,a,o){this.config=o,this.languageService=a,this.countryService=t,this.kboixDynamicComponentService=e}getProps(e,t){var a,o,n,i;return R(this,void 0,void 0,(function*(){const l=yield this.languageService.fetchLanguageByCode(this.config.language),r=yield this.countryService.fetchCountryByCode(this.config.country);return{data:(t?yield this.kboixDynamicComponentService.fetchKboixTipById(t):((e=>{var t;return null!==(t=Qo(e,"Countries"))&&void 0!==t?t:Qo(e,"Markets")})(yield this.kboixDynamicComponentService.fetchKboixTipByIdTip(null!==(o=null===(a=r[0])||void 0===a?void 0:a.id)&&void 0!==o?o:"",null!==(i=null===(n=l[0])||void 0===n?void 0:n.id)&&void 0!==i?i:"",e||""))||[])[0]).flatData,market:r[0].flatData.marketCode}}))}};Yo=O([k(w.ContainerScoped),j("design:paramtypes",[Wo,oe,ne,Q])],Yo);var Vo=Object.freeze({__proto__:null,Banner:Fo,get BannerPropsService(){return ie},KboixDynamicComponent:({market:e,data:t,slots:a,vars:o})=>c.createElement(Sa,{market:e,rootComponent:t.rootComponent,slots:a,vars:o}),get KboixDynamicComponentPropsService(){return Yo},LatestPosts:ca,NewsletterPopup:({data:e})=>c.createElement(Oo,{data:e}),get NewsletterPropsService(){return Po},PdpDynamicComponent:Uo,get PdpDynamicComponentPropsService(){return Ho}});const Xo=e.div`
  display: flex;
`,Jo=e.div`
  margin-right: 1em;
`,Ko=e.div`
  display: flex;
`,Zo=e.div`
  margin-right: 1em;

  img {
    max-width: 100%;
  }
`,en=`(min-width: ${"768px"})`,tn=e.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;

  .column:first-child {
    @media (min-width: 1180px) {
      order: 1;
    }
  }

  .column:last-child {
    order: -1;

    @media (min-width: 992px) {
      justify-content: center;
      order: initial;
    }

    @media (min-width: 1180px) {
      order: 2;
    }
  }

  .column:nth-child(2) {
    justify-content: flex-end;

    @media (max-width: 767px) {
      display: none;
    }

    @media (min-width: 768px) {
      text-align: right;
    }

    @media (min-width: 768px) {
      order: 3;
    }
  }

  @media (min-width: 768px) {
    border-top: 1px solid white;
  }
`,an=e.div`
  text-align: center;
  padding: 14px 24px;
`,on=e.div`
  flex: 1;
  height: 100%;
  padding: 14px 24px 32px;

  u {
    text-decoration: none;
    color: #a9a9a9;
  }

  @media (min-width: 768px) {
    padding: 14px 24px;
  }
`,nn=e(on)`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    padding-top: 40px;
  }
`,ln=e((({type:e,link:t,className:a})=>{const o=g((()=>"twitter"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/194feef9-9354-4498-bcbb-745bfd991a40/twitter.svg":"facebook"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/9719c3b2-3349-48d3-9857-6aa431776006/facebook.svg":"pinterest"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/c7cf92ea-e533-414e-8297-60d3532bc855/pinterest.svg":"linkedin"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/e1d2d92a-5e4d-4bd4-9a60-9e9bcec1ef3c/linkedin.svg":"instagram"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/876b5bc0-2594-4909-937f-5b0993e2dbf3/instagram.svg":"youtube"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/78c97a56-ec4b-4b24-b234-e01bde6c0552/youtube.svg":"strava"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/c7675bd3-da78-4f7a-af7e-bbf53785cbf3/strava.svg":"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/61c68490-7c4f-429c-8422-9e1b873d4eb4/facebook.svg"),[e]);return c.createElement(Ko,{className:a},c.createElement(Zo,null,c.createElement("a",{href:t.url,target:"_blank",rel:"noopener noreferrer"},c.createElement(l,{xs:!0,sm:!0},c.createElement("img",{alt:e,src:o,width:"24px",height:"24px"})),c.createElement(r,{xs:!0,sm:!0},c.createElement("img",{alt:e,src:o,width:"32px",height:"32px"})))))}))`
  img {
    width: 32px;
    height: 32px;

    @media ${en} {
      width: 24px;
      height: 24px;
    }
  }
`,rn=e.div`
  display: inline;
  img {
    max-height: 23px;
    vertical-align: middle;
    padding-right: 8px;
  }
`,sn=({copyright:e,shippingTo:t,countryName:a,coinSymbol:o,socialMedias:n,showI18nModal:i,className:l,footerBottom:r,flag:d})=>(f(Z),c.createElement(c.Fragment,null,c.createElement(tn,{className:l},c.createElement(s,{md:6,lg:3.5,className:"column"},c.createElement(on,null,c.createElement(Dt,{fontSizeMobile:.75,fontSizeDesktop:.75,fontColor:"#FFFFFF",fontName:"RyhmesTextRegular"},e))),c.createElement(s,{md:6,lg:3.5,className:"column"},c.createElement(on,null,c.createElement(Dt,{fontSizeDesktop:.75,fontSizeMobile:1,onClick:i,cursor:"pointer",fontColor:"#FFFFFF",fontName:"RyhmesTextRegular",textDecoration:"none"},d&&""!==d&&c.createElement(rn,null,c.createElement("img",{src:d,alt:a,loading:"lazy",width:"30px",height:"23px"})),t," ",c.createElement("u",null,a," / ",o)))),c.createElement(s,{md:12,lg:5,className:"column"},c.createElement(nn,null,null==n?void 0:n.map(((e,t)=>e.show&&c.createElement(ln,{key:`social_media_${t}`,type:e.icon,link:{text:e.title,url:e.url}})))))),r&&""!==r&&c.createElement(an,null,c.createElement(Dt,{fontSizeMobile:.75,fontSizeDesktop:.75},r)))),dn=e.div`
  display: flex;
`;e.form`
  margin-top: 20px;
`;const cn=e.div`
  flex: 1;
  height: 100%;
  padding: 40px 50px;

  @media (max-width: 768px) {
    padding: 40px 24px;
  }
`,un=e.div`
  margin-top: 10px;
`,pn=e.div`
  display: inline-block;
  margin-top: 20px;
`,mn=e(Tt)`
  margin-top: 0;
  border: solid 1px #ffffff;
`,fn=({title:e,description:t,placeholder:a,showNewsletterModal:o,className:n})=>c.createElement(dn,{className:n},c.createElement(cn,null,c.createElement(Dt,{as:"h2",fontSizeDesktop:1,fontSizeTablet:1.25,fontSizeMobile:1.25,fontColor:"#FFFFFF"},e),c.createElement(un,null,c.createElement(Dt,{fontSizeDesktop:1.25,fontSizeTablet:1,fontSizeMobile:1,fontColor:"#FFFFFF",fontName:"RyhmesTextRegular"},t)),c.createElement(pn,{onClick:o},c.createElement(mn,{selectedBackgroundColor:"#000000",backgroundColor:"#FFFFFF",fontColor:"#000000",selectedFontColor:"#ffffff",fontSizeDesktop:1,fontSizeTablet:1,fontSizeMobile:1,fontName:"RyhmesTextRegular",marginLeft:0,marginTop:20,cursor:"pointer"},a)))),gn=e.div`
  display: flex;

  img {
    position: absolute;
    top: 24px;
    right: 24px;

    @media (min-width: 767px) {
      display: none;
    }
  }

  input:checked ~ img {
    transform: rotate(180deg);
  }
`,hn=e.div`
  flex: 1;
  height: 100%;
  padding: 0 15px;

  @media (min-width: 767px) {
    padding: 40px 50px;
  }

  @media (max-width: 1199px) and (min-width: 767px) {
    border-top: 1px solid white;
  }
`,bn=e.input.attrs({type:"checkbox"})`
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 45px;
  opacity: 0;
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  cursor: pointer;

  @media (min-width: 767px) {
    display: none;
  }
`,xn=e(kt)`
  @media (max-width: 767px) {
    a {
      font-size: 1em;
    }
    margin-top: 15px;

    input:checked ~ & {
      display: block;
    }
  }
`,vn=e(wt)`
  line-height: 1.15;
`,yn=({children:e})=>c.createElement("div",null,c.createElement(r,{xs:!0,sm:!0},c.createElement(Dt,{fontName:"ModeloBold",fontSizeDesktop:.875,fontSizeTablet:.875,fontSizeMobile:1,fontColor:"#FFFFFF",nowrap:!0},e)),c.createElement(l,{xs:!0,sm:!0},c.createElement(Dt,{fontName:"ModeloBold",fontSizeDesktop:.875,fontSizeTablet:.875,fontSizeMobile:1,fontColor:"#FFFFFF",lineHeight:"1.5",marginTop:5,nowrap:!0},e))),kn=e(s)`
  @media (max-width: 767px) {
    padding: 20px 24px !important;

    border-top: 1px solid black;

    &:last-child {
      border-bottom: 1px solid black;
    }
  }
`,wn=({menus:e,orderTrackingModal:t,className:a})=>c.createElement(gn,{className:a},c.createElement(hn,null,c.createElement(d,null,null==e?void 0:e.map(((e,a)=>0===a?c.createElement(kn,{md:3,xl:6,key:`footer_col_${a}`},c.createElement(xn,null,e.submenus.map(((e,a)=>e.show&&c.createElement(vn,{key:`footer_col_menu_${a}`},e.functionality&&"orderTracking"===e.functionality&&t?c.createElement(Dt,{fontSizeMobile:"16px",fontSizeTablet:"14px",as:"p",fontSizeDesktop:.875,cursor:"pointer",onClick:t,fontColor:"#FFFFFF",fontName:"RyhmesTextRegular"},e.title):c.createElement(Dt,{fontSizeMobile:"16px",fontSizeTablet:"14px",fontName:"ModeloBold",cursor:"pointer",as:yt,href:e.onClick?void 0:e.slug,fontSizeDesktop:.875,fontColor:"#FFFFFF",marginTop:0==a?0:10,marginTopMobile:0==a?0:10,storyLink:!0,onClick:()=>{e.onClick&&Function(e.onClick)()}},e.title)))))):c.createElement(kn,{md:3,xl:6,key:`footer_col_${a}`},c.createElement(yn,null,e.title),c.createElement(bn,null),c.createElement("img",{alt:"Open",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/1edf5e11-b11b-4b23-82e2-c4fb666f670f/chevron.svg"}),c.createElement(xn,null,e.submenus.map(((e,a)=>e.show&&c.createElement(vn,{key:`footer_col_menu_${a}`},e.functionality&&"orderTracking"===e.functionality&&t?c.createElement(Dt,{as:"p",fontSizeMobile:"16px",fontSizeTablet:"14px",fontSizeDesktop:.875,cursor:"pointer",onClick:t,fontColor:"#FFFFFF",fontName:"RyhmesTextLight",marginTop:15},e.title):c.createElement(Dt,{fontName:"RyhmesTextLight",as:yt,cursor:"pointer",href:e.onClick?void 0:e.slug,target:e.tag&&["terms-and-conditions","legal-notice","privacy-policy-and-cookies"].includes(e.tag)?"_blank":void 0,fontSizeMobile:"16px",fontSizeTablet:"14px",fontSizeDesktop:.875,fontColor:"#FFFFFF",marginTop:10,marginTopMobile:10,storyLink:!0,onClick:()=>{e.onClick&&Function(e.onClick)()}},e.title))))))))))),Cn=e.footer`
  background-color: #000000;
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;

  .logos {
    padding: 0;
    text-align: center;

    img {
      padding: 0 14px 28px;

      @media (max-width: 767px) {
        padding: 20px 14px 0;
      }
    }

    .logo-planet {
      height: 75px;
    }

    .logo-b-corp {
      height: 100px;
    }
  }
`,Dn=e(s)`
  &:last-child {
    border-bottom: none;
  }

  @media (min-width: 768px) {
    /*&:first-child {
      border-right: 1px solid #fff;
    }*/
  }

  @media (min-width: 1440px) {
    & {
      //border-right: 1px solid #fff;
      border-bottom: none;
    }
  }
`,Sn=e.div`
  flex: 1;
  height: 100%;
  padding: 40px 50px;
`;function Tn({copyright:e,shippingTo:t,countryName:a,coinSymbol:o,socialMedias:n,newsletterContent:i,menus:l,highlightMenus:r,showI18nModal:u,showNewsletterModal:p,showOrderTrackingModal:m,newsletterTitle:g,newsletterDescription:h,footerBottom:b,flag:x,newsletterPopup:v,newsletterPopupImages:y}){var k,w,C,D,S,T;const _=f(Z);let z=null;null!=y&&null!=y&&(z=la(null==y?void 0:y.newsletterImages,_));const E=be(_.config.country,_.config.language,_.config.urlBase,Ce(null==y?void 0:y.newsletterIcon));return null!=v&&null!=v&&(v.newsletterPopupImageAvif=null!==(w=null===(k=null==z?void 0:z.desktop)||void 0===k?void 0:k.avif)&&void 0!==w?w:"",v.newsletterPopupImageJpg=null!==(D=null===(C=null==z?void 0:z.desktop)||void 0===C?void 0:C.standard)&&void 0!==D?D:"",v.newsletterPopupImageWebp=null!==(T=null===(S=null==z?void 0:z.desktop)||void 0===S?void 0:S.webp)&&void 0!==T?T:"",v.newsletterPopupIcon=E),c.createElement(Cn,null,c.createElement(d,null,c.createElement(Dn,{md:6,xl:6},c.createElement(fn,{title:null!=g?g:i.title,description:null!=h?h:i.description,placeholder:i.placeholder,showNewsletterModal:p})),c.createElement(Dn,{md:12,xl:6},c.createElement(wn,{menus:l,orderTrackingModal:m}))),c.createElement(d,null,c.createElement(s,{xs:12},c.createElement(Sn,{className:"logos"},c.createElement("img",{src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/41add229-8714-4cc8-bdda-87fa2e9933dc/b-corp-logo-white.svg?version=0",alt:"b-corp",className:"logo-b-corp"}),c.createElement("img",{src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/d9d25b35-2756-4d25-a7dd-7f480d0a0b14/100-for-the-planet-white.svg?version=0",alt:"100-for-the-planet",className:"logo-planet"})))),c.createElement(sn,{copyright:e,shippingTo:t,countryName:a,coinSymbol:o,socialMedias:n,showI18nModal:u,footerBottom:b,flag:x}))}e((({icon:e,title:t,text:a,link:o,link2:n,link3:i,className:l})=>{const r=g((()=>"phone"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/20768a97-5e2f-4998-8983-cbe4b129960c/phone.svg":"store-search"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/8ccbb1dc-2c03-40ef-b99f-f3726112974a/store-search.svg":"e-gift"===e?"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/18bb2026-bbd4-4fde-a35a-b7c3d3e2371a/e-gift.svg":"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/20768a97-5e2f-4998-8983-cbe4b129960c/phone.svg"),[e]);let s="30px",d="30px";return"store-search"===e?d="34px":"e-gift"===e&&(d="29px",s="34px"),c.createElement(Xo,{className:l},c.createElement(Jo,null,c.createElement("img",{alt:e,src:r,width:s,height:d})),c.createElement("div",null,c.createElement(Dt,{fontSizeDesktop:1.25,fontSizeTablet:1.25,fontSizeMobile:1.25},t),c.createElement(Dt,{fontSizeDesktop:.75},a),o&&"phone"===e?c.createElement(Dt,{className:"trackable","data-tracking":`eventGA|customer-service|call|${o.url.replace("tel:","")}`,fontSizeDesktop:.75,as:yt,underline:!0,href:o.url},o.text):o&&c.createElement(Dt,{fontSizeDesktop:.75,as:yt,underline:!0,href:o.url},o.text),i&&c.createElement(c.Fragment,null,c.createElement("br",null),c.createElement(Dt,{fontSizeDesktop:.75,as:yt,underline:!0,href:i.url},i.text))),c.createElement("div",null))}))`
  margin-bottom: 30px;

  &:last-child {
    margin-bottom: 0;

    @media (max-width: 768px) {
      align-items: center;
    }
  }
`,e(sn)`
  border-top: 1px solid white;
  border-bottom: 1px solid white;

  .column {
    &:nth-child(2) {
      display: block;

      > div {
        padding: 20px 24px;
      }
    }

    &:last-child,
    &:first-child {
      display: none;
    }
  }

  img {
    max-height: 16px;
  }
`;let _n=class{constructor(e){this.fetchFooterDetail=(e,t)=>this.fetchService.cmsFetchGraphQL("GetFooter",`query GetFooter{queryFootersContents(filter:"status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}'",orderby:"created desc"){flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,whatsapp,workingHours{flatData{text}},flag{url, fileName}}},languages{flatData{code,translatedName}},menus{title{flatData{code,text}},submenus{flatData{title{flatData{code,text}},slug{flatData{slug,paisIdioma,action}},functionality,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}},newsletter{title{flatData{code,text}},description{flatData{code,text}},placeholder{flatData{code,text}}},contact{title{flatData{code,text}},callUs{flatData{code,text}},submenu{flatData{title{flatData{code,text}},slug{flatData{slug,paisIdioma,action}},functionality,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}}highlightedSubmenus{title{flatData{code,text}},submenus{flatData{title{flatData{code,text}},slug{flatData{slug,paisIdioma,action}},functionality,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}},icon},socialMedia{flatData{title,url,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}},copyright{flatData{code,text}},footerBottom{flatData{title{flatData{code,text}},slug{flatData{slug,paisIdioma,action}},functionality,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}}}}`),this.fetchFooterById=e=>this.fetchService.cmsFetchGraphQL("GetFooter","query GetFooter($id:String!){findFootersContent(id:$id){flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,whatsapp,workingHours{flatData{text}},flag{url, fileName}}},languages{flatData{code,translatedName}},menus{title{flatData{code,text}},submenus{flatData{title{flatData{code,text}},slug{flatData{slug,paisIdioma,action}},functionality,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}},newsletter{title{flatData{code,text}},description{flatData{code,text}},placeholder{flatData{code,text}}},contact{title{flatData{code,text}},callUs{flatData{code,text}},submenu{flatData{title{flatData{code,text}},slug{flatData{slug,paisIdioma,action}},functionality,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}}highlightedSubmenus{title{flatData{code,text}},submenus{flatData{title{flatData{code,text}},slug{flatData{slug,paisIdioma,action}},functionality,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}},icon},socialMedia{flatData{title,url,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}},copyright{flatData{code,text}},footerBottom{flatData{title{flatData{code,text}},slug{flatData{slug,paisIdioma,action}},functionality,rules{countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}}}}",{id:e}),this.fetchService=e}};_n=O([k(w.ContainerScoped),j("design:paramtypes",[te])],_n);const zn=(e,t)=>{if(e&&e.length>0){const a=e[0];switch(a.countryRules){case"Hide for Country":return En(a.country,t,!1);case"Show only for Country":return En(a.country,t,!0);case"Hide for Country Groups":return Nn(a.countryGroups,t,!1);case"Show only for Country Groups":return Nn(a.countryGroups,t,!0);default:return!0}}return!0},En=(e,t,a)=>{if(e.length>0){var o=void 0!==e.find((e=>e.flatData.code===t));return a?o:!o}return!0},Nn=(e,t,a)=>{if(e.length>0){var o=void 0!==e.find((e=>e.flatData.countries.find((e=>e.flatData.code.toString()===t.toString()))));return a?o:!o}return!0};let Mn=class{constructor(e,t,a,o,n){this.getProps=e=>R(this,void 0,void 0,(function*(){var t,a,o,n,i,l,r,s,d,c,u,p,m,f,g,h,b,x,v,y,k,w,C,D,S,T,_,z,E,N,M;try{const $=yield this.languageService.fetchLanguageByCode(this.config.language),B=yield this.countryService.fetchCountryByCode(this.config.country),A=yield this.newsletterService.fetchDefaultStep(),L=(yield this.newsletterService.fetchNewsletterDefault(null!==(a=null===(t=B[0])||void 0===t?void 0:t.id)&&void 0!==a?a:"",null!==(n=null===(o=$[0])||void 0===o?void 0:o.id)&&void 0!==n?n:"",null!==(l=null===(i=A[0])||void 0===i?void 0:i.id)&&void 0!==l?l:""))[0],I=null==L?void 0:L.flatData.texts.map((e=>({textType:e.textType[0].flatData.name,literal:e.literal[0].flatData.text}))),F=null==I?void 0:I.find((e=>"Claim"===e.textType)),G=null==I?void 0:I.find((e=>"Subclaim"===e.textType)),P=e?yield this.footerService.fetchFooterById(e):(yield this.footerService.fetchFooterDetail(null!==(s=null===(r=B[0])||void 0===r?void 0:r.id)&&void 0!==s?s:"",null!==(c=null===(d=$[0])||void 0===d?void 0:d.id)&&void 0!==c?c:""))[0];try{const e=null==P?void 0:P.flatData.languages.find((e=>e.flatData.code.toLowerCase()===this.config.language.toLowerCase())),t=null!==(u=null==e?void 0:e.flatData.translatedName)&&void 0!==u?u:"",a=null==P?void 0:P.flatData.countries.find((e=>e.flatData.code.toLowerCase()===this.config.country.toLowerCase())),o=(null==a?void 0:a.flatData.translatedName)?null===(p=null==a?void 0:a.flatData.translatedName[0])||void 0===p?void 0:p.flatData.text:"",n=(null==a?void 0:a.flatData.workingHours)?null===(m=null==a?void 0:a.flatData.workingHours[0])||void 0===m?void 0:m.flatData.text:"",i=null!==(f=null==a?void 0:a.flatData.telephone)&&void 0!==f?f:"",l=(null==P?void 0:P.flatData.contact)?null===(g=P.flatData.contact[0])||void 0===g?void 0:g.callUs[0].flatData.text.replace("#TELEPHONE#",i):"",r=null!==(h=null==a?void 0:a.flatData.whatsapp)&&void 0!==h?h:"",s=""!==r?`WhatsApp: ${r}`:"",d=(null==a?void 0:a.flatData.flag)?Ce(null==a?void 0:a.flatData.flag[0]):"",c=P?[{icon:"phone",title:null===(b=null==P?void 0:P.flatData.contact[0])||void 0===b?void 0:b.title[0].flatData.text,text:n,link:{text:l,url:""!==i&&"-"!==i?"tel:"+i:be(this.config.country,this.config.language,this.config.urlBase,"/contacto")},link2:{text:s,url:r?`https://api.whatsapp.com/send?phone=${r.replace("(","").replace(")","").replace("+","").replace(" ","")}`:""},link3:(null===(x=null==P?void 0:P.flatData.contact[0])||void 0===x?void 0:x.submenu)&&(null===(v=null==P?void 0:P.flatData.contact[0])||void 0===v?void 0:v.submenu.length)>0&&zn(null===(y=null==P?void 0:P.flatData.contact[0])||void 0===y?void 0:y.submenu[0].flatData.rules,this.config.country)?{url:(null===(k=null==P?void 0:P.flatData.contact[0])||void 0===k?void 0:k.submenu[0].flatData.slug)?be(this.config.country,this.config.language,this.config.urlBase,null===(w=null==P?void 0:P.flatData.contact[0])||void 0===w?void 0:w.submenu[0].flatData.slug[0].flatData.slug):"",text:null===(C=null==P?void 0:P.flatData.contact[0])||void 0===C?void 0:C.submenu[0].flatData.title[0].flatData.text}:void 0,show:!0},...P.flatData.highlightedSubmenus.map((e=>({icon:e.icon,title:e.title[0].flatData.text,link:e.submenus&&e.submenus.length>0?{url:e.submenus[0].flatData.slug?be(this.config.country,this.config.language,this.config.urlBase,e.submenus[0].flatData.slug[0].flatData.slug):"",text:e.submenus[0].flatData.title[0].flatData.text}:void 0,link2:e.submenus&&e.submenus.length>1&&zn(e.submenus[1].flatData.rules,this.config.country)?{url:e.submenus[1].flatData.slug?be(this.config.country,this.config.language,this.config.urlBase,e.submenus[1].flatData.slug[0].flatData.slug):"",text:e.submenus[1].flatData.title[0].flatData.text}:void 0,show:!!(e.submenus&&e.submenus.length>0&&zn(e.submenus[0].flatData.rules,this.config.country))})))]:[],$=null===(D=null==P?void 0:P.flatData.footerBottom)||void 0===D?void 0:D.find((e=>!0===zn(e.flatData.rules,this.config.country)));return{copyright:null==P?void 0:P.flatData.copyright[0].flatData.text,countryName:o,coinSymbol:t,highlightMenus:c,menus:null==P?void 0:P.flatData.menus.map((e=>({title:e.title[0].flatData.text,icon:e.title[0].flatData.text.toLowerCase(),submenus:e.submenus.map((e=>{return{tag:e.flatData.title[0].flatData.code,title:e.flatData.title[0].flatData.text,onClick:e.flatData.slug&&e.flatData.slug[0].flatData.action,slug:e.flatData.slug?be(this.config.country,this.config.language,this.config.urlBase,(t=this.config.country,a=e.flatData.slug[0].flatData.slug,a?a.replace(/#COUNTRY#/g,t):a),void 0,e.flatData.slug[0].flatData.paisIdioma):null,functionality:e.flatData.functionality,show:zn(e.flatData.rules,this.config.country)};var t,a}))}))),newsletterContent:{description:null===(S=null==P?void 0:P.flatData.newsletter[0])||void 0===S?void 0:S.description[0].flatData.text,placeholder:null===(T=null==P?void 0:P.flatData.newsletter[0])||void 0===T?void 0:T.placeholder[0].flatData.text,title:null===(_=null==P?void 0:P.flatData.newsletter[0])||void 0===_?void 0:_.title[0].flatData.text},socialMedias:null===(z=null==P?void 0:P.flatData.socialMedia)||void 0===z?void 0:z.map((e=>({title:e.flatData.title,url:e.flatData.url,icon:e.flatData.title.toLowerCase(),show:zn(e.flatData.rules,this.config.country)}))),footerBottom:$?$.flatData.title[0].flatData.text:"",flag:d,newsletterPopup:{newsletterPopupClaim:null==F?void 0:F.literal,newsletterPopupSubclaim:null==G?void 0:G.literal},newsletterPopupImages:{newsletterImages:null===(E=null==L?void 0:L.flatData)||void 0===E?void 0:E.images[0].assets,newsletterIcon:null!=(null===(N=null==L?void 0:L.flatData)||void 0===N?void 0:N.icon)?null===(M=null==L?void 0:L.flatData)||void 0===M?void 0:M.icon[0]:""}}}catch(e){throw console.error("Error parsing footer props! cms data: "+JSON.stringify(P)+", error: "+e.toString()),e}}catch(t){throw console.error("Error getting cms response: "+JSON.stringify({id:e})+", config: "+JSON.stringify(this.config)+", error: "+t.toString()),t}})),this.config=n,this.languageService=a,this.countryService=t,this.footerService=e,this.newsletterService=o}};Mn=O([k(w.ContainerScoped),j("design:paramtypes",[_n,oe,ne,Go,Q])],Mn);const $n=e.div.withConfig({shouldForwardProp:e=>!["numComponents"].includes(e)})`
  position: relative;
  display: grid;
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;

  ${e=>void 0!==e.numComponents&&e.numComponents>1?`\n        grid-template-columns: 1fr 1fr;\n        @media (min-width: 768px) {\n          grid-template-columns: ${Array(e.numComponents+1).join("1fr ")};\n        }`:""};

  > .background {
    width: 100%;
    height: auto;
    z-index: 0;
  }

  .firstBottomButton {
    @media (max-width: 767px) {
      grid-column: 1 / span 2;
    }
  }
  .otherBottomButton {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
  }

  .tier_button_center {
    top: 50%;
    bottom: 50%;
  }

  .tier_button_bottom {
    bottom: 30px;
  }
`,Bn=e.div`
  display: grid;
  position: relative;
  width: 100%;
  height: 100%;
`,An=e.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  width: 100%;
  z-index: 10;
  position: absolute;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`,Ln=e.div.withConfig({shouldForwardProp:e=>!["urlMobile","urlDesktop"].includes(e)})`
  text-align: center;

  .background {
    width: 100%;
    height: 100%;
    z-index: 0;
    @media (max-width: 767px) {
      content: url("${e=>`${e.urlMobile}`}");
    }
    content: url("${e=>`${e.urlDesktop}`}");
  }
`,In=e(et)`
  width: 100%;
  height: 100%;
  z-index: 0;
`,Fn=({id:e,buttons:t,tierbuttonstyles:a})=>{const o=f(Z);return m((()=>{let e=ve("usrhash");if(""!==e){let t=document.getElementsByClassName("slugwithparameters");for(const a of t){let t=a.getAttribute("href");-1===(null==t?void 0:t.indexOf("&usrhash="))&&a.setAttribute("href",`${t}&usrhash=${e}`)}}}),[]),c.createElement($n,{id:`tier_${e}`,numComponents:t.length},t.map(((e,n)=>c.createElement(Bn,{key:`tierbottom_${n}`,className:0===n&&t.length%2!=0?"firstBottomButton":"otherBottomButton"},c.createElement(Ln,{key:`tierbottom_button_image_${n}`,urlMobile:e.imageMobile,urlDesktop:e.image},c.createElement("a",{href:e.url,"data-tracking":e.tracking,className:"trackable "+(e.script?"slugwithparameters":"")},c.createElement(In,Object.assign({},la(e.images,o),{alt:e.text,lazy:!0})))),c.createElement(An,{className:"Center"===e.alignment?"tier_button_center":"tier_button_bottom"},c.createElement(Tt,{key:`tierbottom_button_${n}`,backgroundColor:a.backgroundColor,selectedBackgroundColor:a.selectedBackgroundColor,selectedFontColor:a.selectedFontColor,fontColor:a.fontColor,fontSizeDesktop:a.fontSizeDesktop,fontSizeTablet:a.fontSizeTablet,fontSizeMobile:a.fontSizeMobile,fontName:a.fontName,href:e.url,"data-tracking":e.tracking,className:"trackable "+(e.script?"slugwithparameters":""),upperCase:a.upperCase,lowerCase:a.lowerCase},e.text))))))},Gn=e.div`
  text-align: center;
`,Pn=e.div`
  margin-bottom: 20px;
`,On=e.div`
  margin-top: 40px;
  margin-bottom: 20px;
`,jn=e.div`
  ${e=>e.has2Levels?"margin-bottom: 30px;":""};

  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
  }

  .selectedbutton {
    pointer-events: none;
  }
`,Rn=e.div``,qn=({id:e,text:t,subclaimText:a,textProps:o,subclaimTextProps:n,buttons:i,tierbuttonstyles:l})=>{m((()=>{let e=ve("usrhash");if(""!==e){let t=document.getElementsByClassName("slugwithparameters");for(const a of t){let t=a.getAttribute("href");-1===(null==t?void 0:t.indexOf("&usrhash="))&&a.setAttribute("href",`${t}&usrhash=${e}`)}}}),[]);const r=g((()=>null==i?void 0:i.filter((e=>1===e.level))),[null==i?void 0:i.filter]),s=g((()=>null==i?void 0:i.filter((e=>2===e.level))),[null==i?void 0:i.filter]);return c.createElement(Gn,{id:`tier_${e}`},t&&""!==t&&c.createElement(Pn,null,c.createElement(Dt,{as:"h3",fontName:o.fontName,fontColor:o.fontColor,fontSizeDesktop:o.fontSizeDesktop,fontSizeTablet:o.fontSizeTablet,fontSizeMobile:o.fontSizeMobile,upperCase:o.upperCase,lowerCase:o.lowerCase},t)),r&&r.length>0&&c.createElement(jn,{has2Levels:s&&s.length>0},r.map(((e,t)=>c.createElement(Tt,{key:`bottom_level1_button_${t}`,backgroundColor:e.selected?l.selectedBackgroundColor:l.backgroundColor,selectedBackgroundColor:l.selectedBackgroundColor,fontColor:e.selected?l.selectedFontColor:l.fontColor,selectedFontColor:l.selectedFontColor,fontSizeDesktop:l.fontSizeDesktop,fontSizeTablet:l.fontSizeTablet,fontSizeMobile:l.fontSizeMobile,fontName:l.fontName,href:e.url,"data-tracking":e.tracking,className:`trackable ${e.selected?"selectedbutton":""} ${e.script?"slugwithparameters":""}`},e.text)))),a&&""!==a&&c.createElement(On,null,c.createElement(Dt,{as:"h3",fontName:n.fontName,fontColor:n.fontColor,fontSizeDesktop:n.fontSizeDesktop,fontSizeTablet:n.fontSizeTablet,fontSizeMobile:n.fontSizeMobile,upperCase:n.upperCase,lowerCase:n.lowerCase},a)),s&&s.length>0&&c.createElement(Rn,null,s.map(((e,t)=>c.createElement(Tt,{key:`bottom_level2_button_${t}`,backgroundColor:l.backgroundColor,selectedBackgroundColor:l.selectedBackgroundColor,fontColor:l.fontColor,selectedFontColor:l.selectedFontColor,fontSizeDesktop:l.fontSizeDesktop,fontSizeTablet:l.fontSizeTablet,fontSizeMobile:l.fontSizeMobile,fontName:l.fontName,href:e.url,"data-tracking":e.tracking,className:"trackable "+(e.script?"slugwithparameters":"")},e.text)))))},Hn=e.div`
  .seobottomtitle {
    padding: 0px 20px 20px 20px;
  }

  .seobottomsubtitle {
    padding: 0px 20px;
  }

  .seobottomtext {
    padding: 0px 20px 15px 20px;
  }

  width: 50%;

  @media (max-width: 1024px) {
    width: 100%;
  }
`,Un=({id:e,textProps:t,text:a,seoTexts:o})=>c.createElement(Hn,{id:`tier_${e}`},a&&c.createElement(Dt,Object.assign({as:"p"},t,{className:"seobottomtitle"}),a),o&&o.map(((e,t)=>c.createElement(Dt,{key:`${e.literal[0].flatData.text}_${t}`,as:"p",lineHeight:"1.25",upperCase:e.upperCase,lowerCase:e.lowerCase,fontName:e.font[0].flatData.name,fontColor:e.fontColor,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,className:"Subclaim"===e.textType[0].flatData.name?"seobottomsubtitle":"seobottomtext"},e.literal[0].flatData.text)))),Wn=c.createRef(),Qn=c.createRef(),Yn=e.div`
  display: block;
  background-color: ${e=>{var t;return null!==(t=e.backgroundColor)&&void 0!==t?t:""}};
  text-decoration: none;
  position: relative;
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;
  overflow: hidden;

  .tier {
    &__media {
      display: block;
      max-width: 100%;

      &--video {
        width: 100%;
        margin: auto;
        position: absolute;
        left: 50%;
        top: 50%;
      }
    }

    &__media-holder {
      max-width: 100%;
      display: block;
    }

    &__content--align-center-center {
      justify-content: center;
      align-content: center;
      text-align: center;
    }

    &__content--align-top-left {
      justify-content: flex-start;
      align-content: flex-start;
    }

    &__content--align-center-bottom {
      -webkit-box-pack: center;
      place-content: end;
      text-align: center;

      .tier__ctas {
        margin-top: 50%;
        @media (min-width: 767px) {
          margin-top: 65%;
        }
      }
    }

    &__icon,
    &__title,
    &__claim,
    &__ctas,
    &__note {
      width: 100%;
      z-index: 3;
    }

    &__icon_image {
      max-width: 48px;
      @media (min-width: 1440px) {
        max-width: 64px;
      }
    }

    &__title {
      margin-top: 10px;

      @media (min-width: 767px) {
        margin-top: 24px;
      }
    }

    &__claim {
      margin-top: 10px;

      @media (min-width: 767px) {
        margin-top: 16px;
      }
    }

    &__ctas {
      margin-top: 30px;
      position: relative;

      @media (min-width: 767px) {
        margin-top: 50px;
      }
    }

    &__cta {
      position: relative;
    }
  }
`,Vn=e.a`
  display: block;
  position: relative;
  width: 100%;
  z-index: 2;
`,Xn=e.div`
  background-color: ${e=>{var t;return null!==(t=e.backgroundColor)&&void 0!==t?t:""}};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  padding: 24px;

  @media (min-width: 767px) {
    padding: 60px;
  }

  .tier__button {
    z-index: 3;
    margin: auto 0 20px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 1024px) {
      margin-bottom: 50px;
    }
  }
`,Jn=e(et)``,Kn=({id:e,backgroundColor:t,tracking:a,url:o,script:n,textProps:i,text:l,subclaimTextProps:r,subclaimText:s,noteTextProps:d,noteText:u,ctaText:p,ctaTextProps:h,image:b,video:x,images:v,icon:y,buttons:k,tierbuttonstyles:w,alignment:C})=>{var D,S,T,_,z,E;const N=f(Z);m((()=>{let e=1;const t=()=>{if(Wn.current&&Qn.current){const t=402/640,a=Wn.current.clientWidth/Wn.current.clientHeight;e=Math.max(a,t)/Math.min(a,t),Qn.current.style.transform=`scale(${e}) translate(-50%, -50%)`}};t(),document.addEventListener("DOMContentLoaded",(()=>{t()})),window.onresize=t})),m((()=>{let e=ve("usrhash");if(""!==e){let t=document.getElementsByClassName("slugwithparameters");for(const a of t){let t=a.getAttribute("href");-1===(null==t?void 0:t.indexOf("&usrhash="))&&a.setAttribute("href",`${t}&usrhash=${e}`)}}}),[]);const M=g((()=>ra(v)),[v]),$=g((()=>la(v,N)),[v,N]);return c.createElement(Yn,{id:`tier_${e}`,backgroundColor:t,ref:Wn},o&&""!==o&&a&&""!==a?c.createElement(Vn,{href:o,"data-tracking":a,className:"trackable "+(n?"slugwithparameters":"")},M?c.createElement(c.Fragment,null,(null==M?void 0:M.desktop)&&c.createElement(Mt,{mobile:M.desktop,alt:{en:l},autoPlay:!0,muted:!0,loop:!0,poster:$&&$.desktop?oa(N,[$.desktop.standard,null!==(D=$.desktop.webp)&&void 0!==D?D:"",null!==(S=$.desktop.avif)&&void 0!==S?S:""]):"",playsInline:!0,className:"tier__media tier__media--video",lazy:!1,controls:!1,ref:Qn}),c.createElement(Jn,Object.assign({},$,{alt:l,lazy:!0,className:"tier__media-holder"}))):c.createElement(Jn,Object.assign({},$,{alt:l,lazy:!0,className:"tier__media tier__media--image"}))):M?c.createElement(c.Fragment,null,(null==M?void 0:M.desktop)&&c.createElement(Mt,{mobile:M.desktop,alt:{en:l},autoPlay:!0,muted:!0,loop:!0,poster:$&&$.desktop?oa(N,[$.desktop.standard,null!==(T=$.desktop.webp)&&void 0!==T?T:"",null!==(_=$.desktop.avif)&&void 0!==_?_:""]):"",playsInline:!0,className:"tier__media tier__media--video",lazy:!1,controls:!1,ref:Qn}),c.createElement(Jn,Object.assign({},$,{alt:l,lazy:!0,className:"tier__media-holder"}))):c.createElement(Jn,Object.assign({},$,{alt:l,lazy:!0,className:"tier__media tier__media--image"})),c.createElement(Xn,{backgroundColor:t,className:`tier__content tier__content--align-${null!==(z=C.toLowerCase())&&void 0!==z?z:"center-center"}`},y&&c.createElement(Dt,{as:"h3",className:"tier__icon"},c.createElement("img",{className:"tier__icon_image",src:y,alt:l})),l&&c.createElement(Dt,Object.assign({as:"h3"},i,{className:"tier__title"}),l),s&&c.createElement(Dt,Object.assign({as:"h3"},r,{className:"tier__claim"}),s),u&&c.createElement(Dt,Object.assign({as:"p"},d,{className:"tier__note"}),u),p&&c.createElement("div",{className:"tier__ctas"},c.createElement(Dt,{as:yt,underline:!0,href:null!==(E=h.url)&&void 0!==E?E:"","data-tracking":h.tracking,className:"trackable tier__cta "+(h.script?"slugwithparameters":""),fontName:h.fontName,fontColor:h.fontColor,fontSizeDesktop:h.fontSizeDesktop,fontSizeTablet:h.fontSizeTablet,fontSizeMobile:h.fontSizeMobile,upperCase:h.upperCase,lowerCase:h.lowerCase},p)),(null==k?void 0:k.length)>0&&c.createElement(Tt,{className:"tier__button trackable "+(k[0].script?"slugwithparameters":""),backgroundColor:w.backgroundColor,selectedBackgroundColor:w.selectedBackgroundColor,fontColor:w.fontColor,fontSizeDesktop:w.fontSizeDesktop,fontSizeTablet:w.fontSizeTablet,fontSizeMobile:w.fontSizeMobile,fontName:w.fontName,selectedFontColor:w.selectedFontColor,href:k[0].url,"data-tracking":k[0].tracking,upperCase:w.upperCase,lowerCase:w.lowerCase},k[0].text)))},Zn=e.div`
  position: relative;
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;

  @media (min-width: 768px) {
    background-color: ${e=>{var t;return null!==(t=e.backgroundColor)&&void 0!==t?t:""}};
  }
`,ei=e.img`
  display: block;
  width: 100%;
  margin-bottom: 30px;

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`,ti=e.div`
  text-align: center;
  padding-left: 8px;
  padding-right: 8px;

  @media (min-width: 768px) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .title {
    margin: 0 0 16px;
  }

  .claim {
    max-width: 350px;
    margin: 0 auto 20px;

    @media (min-width: 768px) {
      margin: 0 auto 60px;
    }
  }

  nav {
    overflow: auto;
    margin-bottom: 16px;

    a {
      margin-right: 20px;
    }
  }
`,ai=({id:e,backgroundColor:t,text:a,textProps:o,subclaimText:n,subclaimTextProps:i,image:s,imageMobile:d,buttons:u,tierbuttonstyles:p})=>(m((()=>{let e=ve("usrhash");if(""!==e){let t=document.getElementsByClassName("slugwithparameters");for(const a of t){let t=a.getAttribute("href");-1===(null==t?void 0:t.indexOf("&usrhash="))&&a.setAttribute("href",`${t}&usrhash=${e}`)}}}),[]),c.createElement(Zn,{id:`tier_${e}`,backgroundColor:t},d&&c.createElement(r,{xs:!0,sm:!0},c.createElement(ei,{src:d})),c.createElement(l,{xs:!0,sm:!0},c.createElement(ei,{src:s})),c.createElement(ti,null,c.createElement(Dt,Object.assign({className:"title",as:"h1"},o),a),n&&c.createElement(Dt,Object.assign({className:"claim",as:"h2"},i),n),u&&c.createElement("nav",null,u.map(((e,t)=>c.createElement(Dt,{key:`tier_regular_button_${t}`,as:yt,underline:e.selected,href:e.url,"data-tracking":e.tracking,className:"trackable "+(e.script?"slugwithparameters":""),fontName:p.fontName,fontColor:p.fontColor,fontSizeDesktop:p.fontSizeDesktop,fontSizeTablet:p.fontSizeTablet,fontSizeMobile:p.fontSizeMobile,upperCase:p.upperCase,lowerCase:p.lowerCase},e.text))))))),oi=e.div`
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;
  .claim {
    padding: 0 30px;
    text-align: center;
    margin-top: 30px;
  }
  text-align: center;

  .icon {
    max-width: 70px;
    margin-top: 30px;
  }

  .subclaim {
    padding: 0 30px;
    text-align: center;
    margin: 16px auto 0;
    max-width: 650px;
    line-height: 1.45;
  }

  .note {
    padding: 0 30px;
    text-align: center;
    margin: 16px auto 0;
    max-width: 650px;
    line-height: 1.45;
  }

  .subclaimcta {
    padding: 0 30px;
    text-align: center;
    margin: 16px auto 0;
    max-width: 650px;
    line-height: 1.45;
  }

  .buttons {
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-top: 6px;
  }

  .buttons-list {
    display: flex;
    padding: 10px 24px;
    overflow: auto;
    margin-top: 0;
  }

  .buttons-list-element {
    list-style: none;
    margin-right: 20px;
  }

  .buttons-list-element:last-child {
    margin-right: 0px;
  }
`,ni=({id:e,text:t,textProps:a,subclaimText:o,subclaimTextProps:n,ctaText:i,ctaTextProps:l,noteText:r,noteTextProps:s,buttons:d,tierbuttonstyles:u,icon:p,iconUrl:f,iconTracking:g})=>(m((()=>{let e=ve("usrhash");if(""!==e){let t=document.getElementsByClassName("slugwithparameters");for(const a of t){let t=a.getAttribute("href");-1===(null==t?void 0:t.indexOf("&usrhash="))&&a.setAttribute("href",`${t}&usrhash=${e}`)}}}),[]),c.createElement(oi,{id:`tier_${e}`},p&&""!==f&&c.createElement("a",{className:"trackable",href:f,"data-tracking":g},c.createElement("img",{className:"icon",src:p,alt:t})),p&&""===f&&c.createElement("img",{src:p,alt:t}),c.createElement(Dt,Object.assign({as:"h1"},a,{className:"claim"}),t),o&&c.createElement(Dt,Object.assign({as:"h2"},n,{className:"subclaim"}),o),r&&c.createElement(Dt,Object.assign({as:"p"},s,{className:"note"}),r),i&&c.createElement(Dt,{as:yt,underline:!0,href:l.url,"data-tracking":l.tracking,className:"subclaimcta trackable "+(l.script?"slugwithparameters":""),fontName:l.fontName,fontColor:l.fontColor,fontSizeDesktop:l.fontSizeDesktop,fontSizeTablet:l.fontSizeTablet,fontSizeMobile:l.fontSizeMobile,upperCase:l.upperCase,lowerCase:l.lowerCase},i),d&&d.length>0&&c.createElement("nav",{className:"buttons"},c.createElement("ul",{className:"buttons-list"},d.map(((e,t)=>c.createElement("li",{key:`tier_standard_button_${t}`,className:"buttons-list-element"},c.createElement(Dt,{key:`tier_standard_a_${t}`,as:yt,underline:e.selected,href:e.url,"data-tracking":e.tracking,className:"trackable "+(e.script?"slugwithparameters":""),fontName:u.fontName,fontColor:u.fontColor,fontSizeDesktop:u.fontSizeDesktop,fontSizeTablet:u.fontSizeTablet,fontSizeMobile:u.fontSizeMobile,upperCase:u.upperCase,lowerCase:u.lowerCase,nowrap:!0},e.text)))))))),ii=e.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  background-color: ${e=>{var t;return null!==(t=e.backgroundColor)&&void 0!==t?t:""}};
  text-decoration: none;
  position: relative;
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;

  .tier__image {
    max-width: 100%;
  }

  .title {
  }

  .claim {
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;

    @media (min-width: 767px) {
      margin-top: 16px;
    }
  }
`,li=e.div`
  background-color: ${e=>{var t;return null!==(t=e.backgroundColor)&&void 0!==t?t:""}};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  grid-column: 1;
  grid-row: 1;
  padding: 24px;

  @media (min-width: 767px) {
    padding: 60px;
  }

  .tier__button {
    margin: auto 0 20px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);

    @media (min-width: 768px) {
      margin-bottom: 50px;
    }

    @media (min-width: 1024px) {
      margin-bottom: 87px;
    }
  }
`,ri=({id:e,backgroundColor:t,textProps:a,text:o,subclaimTextProps:n,subclaimText:i,image:l,buttons:r,tierbuttonstyles:s,tracking:d,url:u})=>{m((()=>{let e=ve("usrhash");if(""!==e){let t=document.getElementsByClassName("slugwithparameters");for(const a of t){let t=a.getAttribute("href");-1===(null==t?void 0:t.indexOf("&usrhash="))&&a.setAttribute("href",`${t}&usrhash=${e}`)}}}),[]);let p=c.createElement(c.Fragment,null,c.createElement("img",{className:"tier__image",src:l}),c.createElement(li,{backgroundColor:t},c.createElement("div",null,c.createElement(Dt,Object.assign({as:"h3",className:"title"},a),o),i&&c.createElement(Dt,Object.assign({as:"div",className:"claim"},n),i)),r.map(((e,t)=>c.createElement(Tt,{key:`subtier_button_${t}`,className:"tier__button trackable "+(e.script?"slugwithparameters":""),backgroundColor:s.backgroundColor,selectedBackgroundColor:s.selectedBackgroundColor,fontColor:s.fontColor,fontSizeDesktop:s.fontSizeDesktop,fontSizeTablet:s.fontSizeTablet,fontSizeMobile:s.fontSizeMobile,fontName:s.fontName,selectedFontColor:s.selectedFontColor,href:e.url,"data-tracking":e.tracking,upperCase:s.upperCase,lowerCase:s.lowerCase},e.text)))));return c.createElement(ii,{id:`tier_${e}`,backgroundColor:t},d&&""!==d&&u&&""!==u?c.createElement("a",{className:"trackable",href:u,"data-tracking":d},p):p)},si=e.div`
  display: flex;
  flex-wrap: wrap;
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;
`,di=e.div`
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    width: 50%;
  }

  .tier__image {
    display: none;

    @media (min-width: 768px) {
      display: block;
      width: 100%;
    }
  }

  .icon {
    display: flex;
    justify-content: center;
    padding: 30px 30px 16px;

    @media (min-width: 1440px) {
      img {
        height: auto;
        min-width: 240px;
      }
    }

    @media (min-width: 768px) {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 0;
    }
  }

  .icon__text {
    display: flex;
    justify-content: center;
    padding: 30px 30px 16px;

    @media (min-width: 768px) {
      position: absolute;
      top: 50%;
      left: 50%;
      padding: 0;
    }
  }
`,ci=e.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (min-width: 768px) {
    background-color: ${e=>{var t;return null!==(t=e.backgroundColor)&&void 0!==t?t:""}};
    width: 50%;
  }

  .wrapper {
    max-width: 90%;

    .title {
      margin-bottom: 16px;
    }

    .claim,
    .title {
      @media (max-width: 767px) {
        color: black;
        padding: 0 30px;
      }

      @media (min-width: 768px) and (max-width: 1439px) {
        max-width: 265px;
      }

      @media (min-width: 1440px) {
        max-width: 400px;
      }
    }
  }
`,ui=e.div`
  width: 100%;

  .buttons {
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin-top: 10px;
  }

  .buttons-list {
    display: flex;
    overflow: auto;
    padding: 0 24px;
    margin: 0;
  }

  .buttons-list-element {
    list-style: none;

    a {
      display: block;
      padding: 10px;
    }
  }

  .buttons-list-element:last-child {
    margin-right: 0px;
  }
`,pi=({id:e,image:t,backgroundColor:a,text:o,textProps:n,icon:i,subclaimText:l,subclaimTextProps:r,noteText:s,noteTextProps:d,buttons:u,tierbuttonstyles:p})=>(m((()=>{let e=ve("usrhash");if(""!==e){let t=document.getElementsByClassName("slugwithparameters");for(const a of t){let t=a.getAttribute("href");-1===(null==t?void 0:t.indexOf("&usrhash="))&&a.setAttribute("href",`${t}&usrhash=${e}`)}}}),[]),c.createElement(si,{id:`tier_${e}`},c.createElement(di,null,c.createElement("img",{className:"tier__image",src:t}),i?c.createElement(Dt,{as:"h1",className:"icon"},c.createElement("img",{src:i,alt:o})):c.createElement(Dt,Object.assign({as:"h1",className:"icon__text"},n),o)),c.createElement(ci,{backgroundColor:a},c.createElement("div",{className:"wrapper"},c.createElement(Dt,Object.assign({as:"h2",className:"title"},r),l),s&&c.createElement(Dt,Object.assign({as:"h3",className:"claim"},d),s))),u&&c.createElement(ui,null,c.createElement("nav",{className:"buttons"},c.createElement("ul",{className:"buttons-list"},u.map(((e,t)=>c.createElement("li",{key:`tier_wide_button_${t}`,className:"buttons-list-element"},c.createElement(Dt,{key:`tier_wide_a_${t}`,as:yt,underline:e.selected,href:e.url,"data-tracking":e.tracking,className:"trackable "+(e.script?"slugwithparameters":""),fontName:p.fontName,fontColor:p.fontColor,fontSizeDesktop:p.fontSizeDesktop,fontSizeTablet:p.fontSizeTablet,fontSizeMobile:p.fontSizeMobile,upperCase:p.upperCase,lowerCase:p.lowerCase},e.text))))))))),mi=e=>{switch(e.variant){case"Grid":return c.createElement(Kn,Object.assign({},e));case"Regular":return c.createElement(ai,Object.assign({},e));case"Standard":return c.createElement(ni,Object.assign({},e));case"Subtier":return c.createElement(ri,Object.assign({},e));case"Wide":return c.createElement(pi,Object.assign({},e));case"Bottom":return c.createElement(Fn,Object.assign({},e));case"Bottom-CTAs":return c.createElement(qn,Object.assign({},e));case"Bottom-SEO":return c.createElement(Un,Object.assign({},e));default:throw new Error(`Not implemented Tier ${e.variant}`)}};let fi=class{constructor(e){this.fetchTierDetail=e=>this.fetchService.cmsFetchGraphQL("GetTier",`query GetTier{queryTiersContents(filter:"status eq 'Published' and data/countries/iv eq '${e.country}' and data/languages/iv eq '${e.language}' and data/tierTags/iv eq 'tierType-${e.tierType}' ${this.getPositionQuery(e.tierPosition)} ${this.getCodeQuery(e)} and data/tierTags/iv eq 'tierProductType-${e.productType}' and data/tierTags/iv eq 'tierGender-${e.gender}'", orderby: "created desc") {id,flatData{geography,countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},languages{flatData{code,translatedName}},layout{flatData{code,name}},tierType{flatData{code,name}},tierPosition{flatData{code,name}},positionGrid,gridId,camperCampaignCode{flatData{code,name}},camperCollectionCode{flatData{code,name}},camperLineCode{flatData{code,name}},camperConceptCode{flatData{code,name}},camperTypologyCode{flatData{code,name}},camperSustainabilityCode{flatData{code,name}},gender{flatData{code,name}},productyType{flatData{code,name}},contentAlignment,images{url,fileName,tags},backgroundColor,tracking,slug{flatData{slug}},script,texts{textType{flatData{code,name}},literal{flatData{code,text}},upperCase,lowerCase,icon{url,fileName,tags},font{flatData{name}}fontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,cta,tracking,slug{flatData{slug}},script},buttons{selected,alignment,level,literal{flatData{code,text}},tracking,slug{flatData{slug}},script,images{url,fileName,tags}},buttonStyles{font{flatData{name}},fontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,backgroundColor,selectedFontColor,selectedBackgroundColor,upperCase,lowerCase},tierTags}}}`),this.fetchTierById=e=>this.fetchService.cmsFetchGraphQL("GetTier","query GetTier($id:String!){findTiersContent(id:$id){id,flatData{geography,countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},languages{flatData{code,translatedName}},layout{flatData{code,name}},tierType{flatData{code,name}},tierPosition{flatData{code,name}},positionGrid,gridId,camperCampaignCode{flatData{code,name}},camperCollectionCode{flatData{code,name}},camperLineCode{flatData{code,name}},camperConceptCode{flatData{code,name}},camperTypologyCode{flatData{code,name}},camperSustainabilityCode{flatData{code,name}},gender{flatData{code,name}},productyType{flatData{code,name}},contentAlignment,images{url,fileName,tags},backgroundColor,tracking,slug{flatData{slug}},script,texts{textType{flatData{code,name}},literal{flatData{code,text}},upperCase,lowerCase,icon{url,fileName,tags},font{flatData{name}},fontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,cta,tracking,slug{flatData{slug}},script},buttons{selected,alignment,level,literal{flatData{code,text}},tracking,slug{flatData{slug}},script,images{url,fileName,tags}},buttonStyles{font{flatData{name}},fontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,backgroundColor,selectedFontColor,selectedBackgroundColor,upperCase,lowerCase,},tierTags}}}",{id:e}),this.getCodeQuery=e=>"grid"===e.tierType?`and data/gridId/iv eq '${e.gridId}'`:`and data/tierTags/iv eq 'tierCamperCode-${e.camperCode}'`,this.getPositionQuery=e=>""!==e?`and data/tierTags/iv eq 'tierPosition-${e}'`:"",this.fetchService=e}};fi=O([k(w.ContainerScoped),j("design:paramtypes",[te])],fi);const gi=e=>{const t=[],a=hi(e);if(a)if(a.includes("grid"))for(const o of a)if("grid"!==o){let a=bi(e,o);a&&t.push(a)}else{let a=bi(e,"grid");Array.isArray(a)&&a.length>0?a.forEach((e=>t.push(e))):Array.isArray(a)||t.push(a)}else for(const o of a){let a=bi(e,o);a&&t.push(a)}return t},hi=e=>null==e?void 0:e.map((e=>e.flatData.tierPosition[0].flatData.code)).filter(((e,t,a)=>a.indexOf(e)===t)),bi=(e,t)=>{var a;return null!==(a=xi(e,t,"Countries"))&&void 0!==a?a:xi(e,t,"Markets")},xi=(e,t,a)=>e.find((e=>e.flatData.tierPosition[0].flatData.code===t&&e.flatData.geography===a)),vi=e=>{if(e){let t=e.tierTags.find((e=>e.startsWith("tierCamperCode-")));return t?t.substring(15):""}return""},yi=(e,t,a,o,n)=>{var i,l,r,s,d,c,u,p,m,f,g,h,b,x;const v=n.layout[0].flatData.name,y=null===(i=n.texts)||void 0===i?void 0:i.find((e=>"Claim"===e.textType[0].flatData.name)),k=null==y?void 0:y.literal[0].flatData.text,w=null===(l=n.texts)||void 0===l?void 0:l.filter((e=>"Claim"!==e.textType[0].flatData.name)),C=(null==y?void 0:y.icon)?Ce(null==y?void 0:y.icon[0]):"",D=(null==y?void 0:y.slug)?be(e,t,a,y.slug[0].flatData.slug):"",S=null!==(r=null==y?void 0:y.tracking)&&void 0!==r?r:"",T=null===(s=n.texts)||void 0===s?void 0:s.find((e=>"Subclaim"===e.textType[0].flatData.name)),_=null==T?void 0:T.literal[0].flatData.text,z=null===(d=n.texts)||void 0===d?void 0:d.find((e=>"CTA"===e.textType[0].flatData.name)),E=null==z?void 0:z.literal[0].flatData.text,N=null===(c=n.texts)||void 0===c?void 0:c.find((e=>"Note"===e.textType[0].flatData.name)),M=null==N?void 0:N.literal[0].flatData.text,$=n.slug?be(e,t,a,n.slug[0].flatData.slug,null!==(u=n.script)&&void 0!==u&&u):"",B=null===(p=n.images)||void 0===p?void 0:p.find((e=>e.tags.includes("desktop"))),A=Ce(B),L=null===(m=n.images)||void 0===m?void 0:m.find((e=>e.tags.includes("mobile"))),I=Ce(L),F=null===(f=n.images)||void 0===f?void 0:f.find((e=>e.tags.includes("video"))),G=Ce(F),P=n.tracking?we(n.tracking,!1):"",O=null!==(g=n.script)&&void 0!==g&&g,j=null===(h=n.buttons)||void 0===h?void 0:h.map((o=>{var n,i,l,r,s,d;return{selected:o.selected,alignment:null!==(n=o.alignment)&&void 0!==n?n:"Bottom",level:null!==(i=o.level)&&void 0!==i?i:0,text:o.literal[0].flatData.text,tracking:we(o.tracking,"Bottom"===v||"Bottom-CTAs"===v),url:o.slug?be(e,t,a,o.slug[0].flatData.slug,null!==(l=o.script)&&void 0!==l&&l):"",script:null!==(r=o.script)&&void 0!==r&&r,image:Ce(null===(s=o.images)||void 0===s?void 0:s.find((e=>e.tags.includes("desktop")))),imageMobile:Ce(null===(d=o.images)||void 0===d?void 0:d.find((e=>e.tags.includes("mobile")))),images:o.images}})),R=n.buttonStyles?n.buttonStyles[0]:null,q=R?{fontName:null==R?void 0:R.font[0].flatData.name,fontColor:null==R?void 0:R.fontColor,fontSizeDesktop:null==R?void 0:R.fontSizeDesktop,fontSizeTablet:null==R?void 0:R.fontSizeTablet,fontSizeMobile:null==R?void 0:R.fontSizeMobile,backgroundColor:null==R?void 0:R.backgroundColor,selectedBackgroundColor:null==R?void 0:R.selectedBackgroundColor,selectedFontColor:null==R?void 0:R.selectedFontColor,upperCase:null==R?void 0:R.upperCase,lowerCase:null==R?void 0:R.lowerCase}:null,H=null!==(b=n.contentAlignment)&&void 0!==b?b:"Center-Center";return{id:o,camperCode:vi(n),gridId:n.gridId,tierPosition:n.tierPosition[0].flatData.code,positionInGrid:"grid"===n.tierPosition[0].flatData.code?n.positionGrid.split(",").map(Number):[],backgroundColor:n.backgroundColor,text:k,textProps:{fontName:null==y?void 0:y.font[0].flatData.name,fontColor:null==y?void 0:y.fontColor,fontSizeDesktop:null==y?void 0:y.fontSizeDesktop,fontSizeTablet:null==y?void 0:y.fontSizeTablet,fontSizeMobile:null==y?void 0:y.fontSizeMobile,upperCase:null==y?void 0:y.upperCase,lowerCase:null==y?void 0:y.lowerCase},seoTexts:null!=w?w:[],icon:C,iconUrl:D,iconTracking:S,alignment:H,subclaimText:_,subclaimTextProps:{fontName:null==T?void 0:T.font[0].flatData.name,fontColor:null==T?void 0:T.fontColor,fontSizeDesktop:null==T?void 0:T.fontSizeDesktop,fontSizeTablet:null==T?void 0:T.fontSizeTablet,fontSizeMobile:null==T?void 0:T.fontSizeMobile,upperCase:null==T?void 0:T.upperCase,lowerCase:null==T?void 0:T.lowerCase},ctaText:E,ctaTextProps:{fontName:null==z?void 0:z.font[0].flatData.name,fontColor:null==z?void 0:z.fontColor,fontSizeDesktop:null==z?void 0:z.fontSizeDesktop,fontSizeTablet:null==z?void 0:z.fontSizeTablet,fontSizeMobile:null==z?void 0:z.fontSizeMobile,upperCase:null==z?void 0:z.upperCase,lowerCase:null==z?void 0:z.lowerCase,url:(null==z?void 0:z.slug)?be(e,t,a,z.slug[0].flatData.slug,null!==(x=z.script)&&void 0!==x&&x):"",script:null==z?void 0:z.script,tracking:(null==z?void 0:z.tracking)?we(null==z?void 0:z.tracking,!1):null==z?void 0:z.tracking},noteText:M,noteTextProps:{fontName:null==N?void 0:N.font[0].flatData.name,fontColor:null==N?void 0:N.fontColor,fontSizeDesktop:null==N?void 0:N.fontSizeDesktop,fontSizeTablet:null==N?void 0:N.fontSizeTablet,fontSizeMobile:null==N?void 0:N.fontSizeMobile,upperCase:null==N?void 0:N.upperCase,lowerCase:null==N?void 0:N.lowerCase},tracking:P,url:$,script:O,image:A,imageMobile:I,video:G,images:n.images,buttons:j,tierbuttonstyles:q,variant:v}};let ki=class{constructor(e,t,a,o){this.getProps=(e,t,a,o,n,i,l)=>R(this,void 0,void 0,(function*(){var r,s,d;const c=yield this.languageService.fetchLanguageByCode(this.config.language),u=yield this.countryService.fetchCountryByCode(this.config.country),p={language:c[0]&&null!==(r=c[0].id)&&void 0!==r?r:"",country:u[0]&&null!==(s=u[0].id)&&void 0!==s?s:"",tierType:e,tierPosition:t,camperCode:a,gender:o,productType:n,gridId:i},m=l?yield this.tierService.fetchTierById(l):gi(yield this.tierService.fetchTierDetail(p))[0];return m?yi(this.config.country,this.config.language,this.config.urlBase,null!==(d=m.id)&&void 0!==d?d:"",m.flatData):null})),this.getPageProps=(e,t,a,o)=>R(this,void 0,void 0,(function*(){var n,i,l;const r=yield this.languageService.fetchLanguageByCode(this.config.language),s=yield this.countryService.fetchCountryByCode(this.config.country);let d=[];for(const c of t){let t={language:r[0]&&null!==(n=r[0].id)&&void 0!==n?n:"",country:s[0]&&null!==(i=s[0].id)&&void 0!==i?i:"",tierType:e,tierPosition:"",camperCode:c,gender:a,productType:o,gridId:""},u=gi(yield this.tierService.fetchTierDetail(t));if(u&&u.length>0)for(const e of u)d.push(yi(this.config.country,this.config.language,this.config.urlBase,null!==(l=e.id)&&void 0!==l?l:"",e.flatData))}return d.length>0?d:null})),this.config=o,this.languageService=a,this.countryService=t,this.tierService=e}};ki=O([k(w.ContainerScoped),j("design:paramtypes",[fi,oe,ne,Q])],ki);let wi=class{constructor(e){this.fetchTierBannerDetail=e=>{const t=`\n      query GetTierBanner {\n        queryTierBannerContents(\n          filter: ${`"${["status eq 'Published'",`data/countries/iv eq '${e.country}'`,`data/languages/iv eq '${e.language}'`,`contains(data/tierTags/iv, 'tierType-${e.tierType}')`,this.getPositionQuery(e.tierPosition),this.getCodeQuery(e),`contains(data/tierTags/iv, 'tierProductType-${e.productType}')`,`contains(data/tierTags/iv, 'tierGender-${e.gender}')`].filter(Boolean).join(" and ")}"`},\n          orderby: "created desc"\n        ) {\n          id\n          flatData {\n            name\n            geography\n            countries { flatData { code translatedName { flatData { code text } } marketCode telephone workingHours { flatData { code text } } } }\n            languages { flatData { code translatedName } }\n            tierType { flatData { code name } }\n            tierPosition { flatData { code name } }\n            positionGrid\n            gridId\n            numColumns\n            numColumnsTablet\n            numColumnsMobile\n            camperCampaignCode { flatData { code name } }\n            camperCollectionCode { flatData { code name } }\n            camperLineCode { flatData { code name } }\n            camperConceptCode { flatData { code name } }\n            camperTypologyCode { flatData { code name } }\n            camperSustainabilityCode { flatData { code name } }\n            gender { flatData { code name } }\n            productyType { flatData { code name } }  \n            tierTags\n            bannerType { flatData { code name } }\n            layoutMobile\n            components {\n              flatData {\n                dynamic\n                componentType { flatData { code name } }\n                countdown {\n                  daysLiteral { flatData { code text } }\n                  hoursLiteral { flatData { code text } }\n                  minutesLiteral { flatData { code text } }\n                  font { flatData { name } }\n                  fontColor\n                  fontSizeTextDesktop\n                  fontSizeTextTablet\n                  fontSizeTextMobile\n                  fontSizeNumbersDesktop\n                  fontSizeNumbersTablet\n                  fontSizeNumbersMobile\n                  finalDate\n                }\n                images {\n                  tracking\n                  search\n                  searchTracking\n                  slug { flatData { slug } }\n                  assets { url fileName tags metadata }\n                }\n                buttons {\n                  selectedBackgroundColor\n                  selectedFontColor\n                  borderColor\n                  underline\n                  showCountriesModal\n                  backgroundColor\n                  backgroundColorTablet\n                  backgroundColorMobile\n                  font { flatData { name } }\n                  fontColor\n                  fontColorTablet\n                  fontColorMobile\n                  fontSizeDesktop\n                  fontSizeTablet\n                  fontSizeMobile\n                  literal { flatData { code text } }\n                  search\n                  searchTracking\n                  slug { flatData { slug } }\n                  tracking\n                }\n                texts {\n                  backgroundColor\n                  cta\n                  tracking\n                  slug { flatData { slug } }\n                  font { flatData { name } }\n                  fontColor\n                  fontColorMobile\n                  fontColorTablet\n                  fontSizeDesktop\n                  fontSizeTablet\n                  fontSizeMobile\n                  marginTop\n                  marginTopMobile\n                  literal { flatData { code text } }\n                  textType { flatData { code name } }\n                }\n              }\n            }\n          }\n        }\n      }`;return this.fetchService.cmsFetchGraphQL("GetTierBanner",t)},this.fetchTierById=e=>this.fetchService.cmsFetchGraphQL("GetTierBanner","query GetTierBanner($id:String!){findTierBannerContent(id:$id){\n        id\n    flatData {\n      name\n      geography\n      gridId\n      countries {\n        flatData {\n          code\n          translatedName {\n            flatData {\n              code\n              text\n            }\n          }\n          marketCode\n          telephone\n          workingHours {\n            flatData {\n              code\n              text\n            }\n          }\n        }\n      }\n      languages {\n        flatData {\n          code\n          translatedName\n        }\n      }\n      tierType {\n        flatData {\n          code\n          name\n        }\n      }\n      tierPosition {\n        flatData {\n          code\n          name\n        }\n      }\n      positionGrid\n      numColumns\n      numColumnsTablet\n      numColumnsMobile\n      camperCampaignCode {\n        flatData {\n          code\n          name\n        }\n      }\n      camperCollectionCode {\n        flatData {\n          code\n          name\n        }\n      }\n      camperLineCode {\n        flatData {\n          code\n          name\n        }\n      }\n      camperConceptCode {\n        flatData {\n          code\n          name\n        }\n      }\n      camperTypologyCode {\n        flatData {\n          code\n          name\n        }\n      }\n      camperSustainabilityCode {\n        flatData {\n          code\n          name\n        }\n      }\n      gender {\n        flatData {\n          code\n          name\n        }\n      }\n      productyType {\n        flatData {\n          code\n          name\n        }\n      }\n      tierTags\n      bannerType {\n        flatData {\n          code\n          name\n        }\n      }\n      layoutMobile\n      components {\n        flatData {\n          dynamic\n          componentType {\n            flatData {\n              code\n              name\n            }\n          }\n          countdown {\n            daysLiteral {\n              flatData {\n                code\n                text\n              }\n            }\n            hoursLiteral {\n              flatData {\n                code\n                text\n              }\n            }\n            minutesLiteral {\n              flatData {\n                code\n                text\n              }\n            }\n            font {\n              flatData {\n                name\n              }\n            }\n            fontColor\n            fontSizeTextDesktop\n            fontSizeTextTablet\n            fontSizeTextMobile\n            fontSizeNumbersDesktop\n            fontSizeNumbersTablet\n            fontSizeNumbersMobile\n            finalDate\n          }\n          images {\n            tracking\n            search\n            searchTracking\n            slug {\n              flatData {\n                slug\n              }\n            }\n            assets {\n              url\n              fileName\n              tags\n              metadata\n            }\n          }\n          buttons {\n            selectedBackgroundColor\n            selectedFontColor\n            borderColor\n            underline\n            showCountriesModal\n            backgroundColor\n            backgroundColorTablet\n            backgroundColorMobile\n            font {\n              flatData {\n                name\n              }\n            }\n            fontColor\n            fontColorTablet\n            fontColorMobile\n            fontSizeDesktop\n            fontSizeTablet\n            fontSizeMobile\n            literal {\n              flatData {\n                code\n                text\n              }\n            }\n            search\n            searchTracking\n            slug {\n              flatData {\n                slug\n              }\n            }\n            tracking\n          }\n          texts {\n            backgroundColor\n            cta\n            tracking\n            slug {\n              flatData {\n                slug\n              }\n            }\n            font {\n              flatData {\n                name\n              }\n            }\n            fontColor\n            fontColorMobile\n            fontColorTablet\n            fontSizeDesktop\n            fontSizeTablet\n            fontSizeMobile\n            marginTop\n            marginTopMobile\n            literal {\n              flatData {\n                code\n                text\n              }\n            }\n            textType {\n              flatData {\n                code\n                name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}",{id:e}),this.getPositionQuery=e=>e&&""!==e?`contains(data/tierTags/iv, 'tierPosition-${e}')`:"",this.getCodeQuery=e=>"grid"===e.tierType?e.gridId?`data/gridId/iv eq '${e.gridId}'`:"":e.camperCode?`contains(data/tierTags/iv, 'tierCamperCode-${e.camperCode}')`:"",this.fetchService=e}};wi=O([k(w.ContainerScoped),j("design:paramtypes",[te])],wi);const Ci=e=>{const t=[],a=Di(e);if(a)if(a.includes("grid"))for(const o of a)if("grid"!==o){let a=Si(e,o);a&&t.push(a)}else{let a=Si(e,"grid");Array.isArray(a)&&a.length>0?a.forEach((e=>t.push(e))):Array.isArray(a)||t.push(a)}else for(const o of a){let a=Si(e,o);a&&t.push(a)}return t},Di=e=>null==e?void 0:e.map((e=>e.flatData.tierPosition[0].flatData.code)).filter(((e,t,a)=>a.indexOf(e)===t)),Si=(e,t)=>{var a;if("grid"===t){let t=_i(e,"Countries");return t.length>0?t:_i(e,"Markets")}return null!==(a=Ti(e,t,"Countries"))&&void 0!==a?a:Ti(e,t,"Markets")},Ti=(e,t,a)=>e.find((e=>e.flatData.tierPosition[0].flatData.code===t&&e.flatData.geography===a)),_i=(e,t)=>e.filter((e=>e.flatData.geography===t)),zi=e=>{if(e){const t=e.tierTags.find((e=>e.startsWith("tierCamperCode-")));return t?t.substring(15):""}return""},Ei=(e,t)=>({id:t,camperCode:zi(e),tierPosition:e.tierPosition[0].flatData.code,positionInGrid:"grid"===e.tierPosition[0].flatData.code?e.positionGrid.split(",").map(Number):[],numColumns:"grid"===e.tierPosition[0].flatData.code?e.numColumns:1,numColumnsTablet:"grid"===e.tierPosition[0].flatData.code?e.numColumnsTablet:1,numColumnsMobile:"grid"===e.tierPosition[0].flatData.code?e.numColumnsMobile:1,variant:e.bannerType,components:e.components,market:e.countries[0].flatData.marketCode,name:e.name});let Ni=class{constructor(e,t,a,o){this.getProps=(e,t,a,o,n,i,l)=>R(this,void 0,void 0,(function*(){var r,s,d;const c=yield this.languageService.fetchLanguageByCode(this.config.language),u=yield this.countryService.fetchCountryByCode(this.config.country),p={language:c[0]&&null!==(r=c[0].id)&&void 0!==r?r:"",country:u[0]&&null!==(s=u[0].id)&&void 0!==s?s:"",tierType:e,tierPosition:t,camperCode:a,gender:o,productType:n,gridId:i},m=l?yield this.tierBannerService.fetchTierById(l):Ci(yield this.tierBannerService.fetchTierBannerDetail(p))[0];return m?Ei(m.flatData,null!==(d=m.id)&&void 0!==d?d:""):null})),this.getPageProps=(e,t,a,o,n)=>R(this,void 0,void 0,(function*(){var i,l,r,s,d,c;const u=yield this.languageService.fetchLanguageByCode(this.config.language),p=yield this.countryService.fetchCountryByCode(this.config.country);let m=[];if(t.length>0&&""!==t[0])for(const n of t){let t={language:u[0]&&null!==(i=u[0].id)&&void 0!==i?i:"",country:p[0]&&null!==(l=p[0].id)&&void 0!==l?l:"",tierType:e,tierPosition:"",camperCode:n,gender:a,productType:o,gridId:""},s=Ci(yield this.tierBannerService.fetchTierBannerDetail(t));if(s&&s.length>0)for(const e of s)m.push(Ei(e.flatData,null!==(r=e.id)&&void 0!==r?r:""))}else if(n&&""!==n){let t={language:u[0]&&null!==(s=u[0].id)&&void 0!==s?s:"",country:p[0]&&null!==(d=p[0].id)&&void 0!==d?d:"",tierType:e,tierPosition:"",camperCode:"",gender:a,productType:o,gridId:n},i=Ci(yield this.tierBannerService.fetchTierBannerDetail(t));if(i)return[Ei(i[0].flatData,null!==(c=i[0].id)&&void 0!==c?c:"")]}return m.length>0?m:null})),this.config=o,this.languageService=a,this.countryService=t,this.tierBannerService=e}};Ni=O([k(w.ContainerScoped),j("design:paramtypes",[wi,oe,ne,Q])],Ni);const Mi=e.footer`
  // border-top: 1px solid #919191;
  width: 100%;
  // margin-top: 0px !important;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @media (max-width: 768px) {
    padding-bottom: 0px;
  }

  // @media (min-width: 768px) and (max-width: 1439px) {
  //  display: grid;
  //  grid-template-columns: 2fr 1fr;
  // }

  .tnm-footer {
    padding-bottom: 32px;

    &__list {
      list-style: none;
      margin: 0;
      padding-inline-start: 0px;

      li:first-child {
        border-top: 1px solid black;
      }
    }

    &__item {
      color: black;
      list-style: none;
      padding: 0 20px;
      border-bottom: 1px solid black;

      div {
        padding-bottom: 20px;
        margin-top: 20px;
      }
    }

    &__link {
      color: black;
      display: flex;
      align-items: center;
      text-decoration: none;
      font-size: 1em;
      padding-bottom: 20px;
      font-family: "RyhmesTextRegular";
      margin-top: 20px;
    }

    &__icon {
      &--small {
        width: 16px;
        margin-right: 14px;
        stroke: black;
      }

      &--medium {
        width: 20px;
        margin-right: 10px;
        stroke: black;
      }
    }

    &__shipping {
      margin-top: 20px;
      padding: 0 20px;
      padding-bottom: 20px;
    }

    &__shipping-link {
      color: inherit;
      font-size: 1em;
      font-family: "RyhmesTextRegular";
    }

    &__account-literal {
      margin-left: 10px;
    }
  }
`,$i=e.div`
  display: flex;
`,Bi=({languageName:e,countryName:t,accountLiteral:a,accountWidget:o,stores:n,yourOrdersLiteral:i,newsletterLiteral:r,showI18nModal:s,showNewsletterModal:d,showOrderTrackingModal:u,hideStores:p})=>c.createElement(Mi,{className:"menu-mobile__footer"},c.createElement("ul",{className:"tnm-footer__list"},o&&c.createElement(l,{md:!0},c.createElement("li",{className:"tnm-footer__item"},c.createElement($i,null,o))),!p&&c.createElement("li",{className:"tnm-footer__item"},c.createElement(Dt,{className:"tnm-footer__link",as:yt,href:n.url,cursor:"pointer"},c.createElement("span",{className:"tnm-footer__icon"},c.createElement("img",{alt:"Stores",className:"tnm-footer__icon--small",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/baa64494-4706-47e6-b7a7-0f57b8ab7104/marker.svg"})),n.text)),c.createElement("li",{className:"tnm-footer__item"},c.createElement(Dt,{className:"tnm-footer__link",onClick:d,cursor:"pointer"},c.createElement("span",{className:"tnm-footer__icon"},c.createElement("img",{className:"tnm-footer__icon--medium",alt:"Newsletter",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/bd8af0e3-3803-44ba-9723-3f260e8f6523/newsletter.svg"})),r)),c.createElement("li",{className:"tnm-footer__item"},c.createElement(Dt,{className:"tnm-footer__link",as:"p",onClick:u,cursor:"pointer"},c.createElement("span",{className:"tnm-footer__icon"},c.createElement("img",{className:"tnm-footer__icon--medium",alt:"Your Orders",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/e5a43c6f-31e4-4f6d-8ec0-860228d306db/orders.svg"})),i))),c.createElement("div",{className:"tnm-footer__shipping"},c.createElement(Dt,{as:"p",onClick:s,className:"tnm-footer__shipping-link",cursor:"pointer"},t," / ",e))),Ai=e.a`
  min-width: 200px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;

  img {
    width: 120px;
  }
`,Li=e.a`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`,Ii=e.div`
  display: flex;
  z-index: 1;
  background-color: #fff;
  justify-content: space-between;
  align-items: center;
  position: relative;
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;
  padding: 0 24px;
  height: 80px;
  // it's &
  .rhymes {
    font-family: "RyhmesTextRegular";
  }
  .tnm {
    &__sub-title,
    &__list,
    &__item,
    &__link {
      font-size: 1rem;
      margin-bottom: 15px;
    }

    &__title {
      display: block;
      padding: 0 2em;

      > a {
        position: relative;
        padding: 2em 0;
        display: block;

        &:after {
          position: absolute;
          bottom: 25px;
          left: 0;
          content: "";
          border-top: 1px solid #000000;
          transition: 0.2s;
          width: 0;
        }
      }

      &:hover > a:after,
      &.selectedmenu > a:after {
        width: 100%;
      }
    }

    &__title-field {
      position: absolute;
      top: 0;
      background: red;
      height: 2.9em;
      width: 3em;
      z-index: 999;
      cursor: pointer;
    }

    &__list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    &__listtitle {
      padding-left: 20px;
    }

    &__item,
    &__sub-title {
      text-align: center;
    }

    &__sub-title {
      &--sizes-title {
        text-transform: uppercase;
        font-size: 0.625rem;
        margin-bottom: 32px;
        margin-top: 0px;
      }
    }

    &__link {
      &:hover {
        color: #000000;
      }
    }

    &__row {
      width: ${100/7}%;
      z-index: 0 !important;
    }

    &__row + div {
      display: flex;
      justify-content: flex-end;
    }

    &__column {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 2em;
      z-index: 2;
      flex-direction: column;

      &--double {
        width: ${100/3.5}%;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;

        > a {
          width: 100%;
        }

        > div {
          width: 50%;
          margin-left: auto;
        }
      }
    }

    &__row .tnm__column {
      width: 100%;
      border: none;
    }

    &__image {
      display: block;
      height: 100%;
      width: auto;
    }
  }

  /* TODO - delete */
  .agrupamelos {
    outline: 2px dashed orange;
  }

  @media screen and (max-width: 1199px) {
    display: none;
  }
`,Fi=e.div`
  min-width: 200px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  order: 100;
`;e.a`
  .searcherspan {
    width: 128px;
    padding: 3px;

    img {
      width: 20px;
    }
  }

  .searcher {
    padding: 0;
    border: none;
    outline: none;
    font-size: 0.75em;
    font-family: "ModeloRegular";
    cursor: pointer;
    ::placeholder {
      color: #dfdfdf;
    }
  }
`,e.div`
  margin-right: 1.3em;

  span {
    position: relative;
    padding: 0.8em 0;

    &:after {
      position: absolute;
      bottom: 0;
      left: 0;
      content: "";
      border-top: 4px solid #000000;
      transition: 0.2s;
      width: 0;
    }

    :hover {
      color: #000000;

      &:after {
        width: 100%;
      }
    }
  }
`;const Gi=e.div``;e.a`
  display: flex;
  align-items: center;
  gap: 5px;
  text-decoration: none;
`,e.a`
  font-family: Ryhmes;
  color: #000000;
  text-decoration: none;
  font-size: 1em;
  margin-right: 1.3em;
  text-transform: capitalize;
  position: relative;
  padding: 1em 0;
  display: flex;

  &:after {
    position: absolute;
    bottom: 0;
    left: 0;
    content: "";
    border-top: 1px solid #000000;
    transition: 0.2s;
    width: 0;
  }

  :hover {
    color: #000000;

    &:after {
      width: 100%;
    }
  }
  img {
    margin-right: 5px;
  }
`;const Pi=e.div`
  @media (max-width: 1199px) {
    display: block;
  }
  display: none;
  position: relative;
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;
  top: 0px;
  padding: 0 24px;
  padding-bottom: 1em;
  padding-top: 1em !important;
  border-bottom: 1px solid #dfdfdf;
  .rhymes {
      font-family: "RyhmesTextRegular";
    }
  }
  .tnmhighlightgoods {
    @media (min-width: 768px) {
      width: 30% !important;
    }
  }
  .tnmgoods {
    padding-left: 0px !important;
    @media (max-width: 767px) {
      border-top: 1px solid #919191;
    }
    @media (min-width: 768px) and (max-width: 1023px) {
      width: 65% !important;
    }
    @media (min-width: 1024px) {
      width: 70% !important;
    }
  }

  .tnm__menu {
  }

  .tnm__open-field {
    border: none;
  }

  .tnm {
    &__sub-title,
    &__list,
    &__item,
    &__link {
      font-size: 1rem;
    }

    &__open {
      position: relative;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        stroke: black;
      }
    }

    &__close {
      padding-top: 2px;
      padding-left: 5px;
      z-index: 2;
    }

    &__wrapper {
      position: relative;
    }

    &__open-field {
      // todo - toni
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 4em;
      z-index: 101;
      cursor: pointer;
      opacity: 0;

      &:checked {
        top: -1.4em;
        left: -0.8em;
        height: 4em;
      }
    }

    &__modal {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      max-height:950px;

      background: white;
      overflow-y: auto;
      overflow-x: hidden;
      z-index: 101;
      // display: flex;
      // flex-direction: column;
    }

    &__modal-header {
      align-items: center;
      display: grid;
      grid-gap: 20px;
      grid-template-columns: 24px auto 24px;
      padding: 16px 20px 8px;
      @media (max-width: 767px) {
        grid-template-columns: 24px 24px auto;
      }
    }

    &__close {
      img {
        @media (max-width: 768px) {
          // margin-left: -8px;
        }
      }
    }

    &__search {
      fieldset {
        border: none;
        padding: 0;
        display: flex;
        align-items: center;

        input {
          margin-left: 8px; // todo
          border-width: 0 0 1px 0;
          border-bottom: 1px solid #979797;
          padding: 12px 16px;
        }
      }
    }

    &__modal-image {
      img {
        margin-left: -44px;

        @media (min-width: 767px) {
          margin-left: 0;
        }
      }
    }

    &__menu {
      position: relative;
      display: flex;
      border-top: 1px solid #dfdfdf;
      margin-top: 10px;
      //overflow-x: auto;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        width: 100%;
        border-bottom: 1px solid #dfdfdf;
        height: 100%;
      }
    }

    &__menu-item {
    }

    &__title {
      display: block;
      @media (max-width: 1199px) {
        border-right: 1px solid #dfdfdf;
      }

      > a {
        position: relative;
        padding: 12px 18px;
        display: block;
        white-space: nowrap;

        &:first-child {
          z-index: 2;
        }

        @media (max-width: 376px) {
          padding: 12px 15px;
          font-size: 0.72em;
        }

        @media (max-width: 321px) {
          padding: 12px 10px;
          font-size: 0.72em;
        }
      }

      > img {
        // todo
        width: 10px;
        height: 18px;
        margin: auto 12px;
      }

      &:hover > a:after {
        width: 100%;
      }
    }

    &__menu-item:first-child .tnm__title {
      display: flex;
      align-items: center;
      height: 100%;
    }

    &__title-field:checked ~ a,
    &__menu-item--active a {
      background: #000000;
      color: white;
    }

    &__title-field {
      position: absolute;
      z-index: 2;
      width: 4.5em;
      height: 3em;
      z-index: 999;
      cursor: pointer;
      appearance: none;
      margin: 0;
      opacity: 0;
      cursor: pointer;
      margin-bottom: -2em;
    }

    &__highlights {
      padding: 0;
      // test
      max: 100vh;
      overflow: auto;
      // end test
    }

    &__list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    &__item,
    &__sub-title {
      margin-top: 8px;
    }

    &__sub-title {
      &--sizes-title {
        width: 100%;
        text-transform: uppercase;
        font-size: 0.625rem;
        margin-bottom: 32px;
      }
    }

    &__link {
      &:hover {
        color: #000000;
      }
    }

    &__sub-title--line-title + .tnm__list {
      padding-left: 20px;
    }

    &__link-toggle {
      cursor: pointer;
      position: absolute;
      opacity: 0;
      right: 0;
      width: 100%;
      min-height: 4.5em;
      appearance: none;
      margin: 0;
      z-index: 2;
    }

    &__line {
      &:first-child {
        padding-top: 20px;
      }

      &:last-child {
        padding-bottom: 20px;
      }

      &:only-child,
      &:nth-child(2):last-child {
        padding: 20px 0;
      }

      @media (max-width: 767px) {
        padding-bottom: 20px;
      }
    }

    &__link-toggle ~ .tnm__line {
      display: none;
    }

    &__link-toggle:checked ~ .tnm__line {
      display: block;
    }

    &__link-toggle:checked ~ a img {
      transform: rotate(180deg) translateY(50%);
    }

    &__column {
      padding: 0 20px;
      box-sizing: border-box;

      &--double {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: flex-end;
        width: 100%;

        > div {
          width: 50%;

          &:not(:fist-child) {
            margin-left: auto;
          }
        }
      }

      @media (max-width: 1199px) {
        &--simple {
          display: flex;
          flex-wrap: wrap;
          width: 100%;
        }
      }
    }

    &__column-title {
      position: relative;
      display: flex;
      width: 100vw;
      border-top: 1px solid #919191;
      font-size: 1rem;
      padding: 20px;
      margin: 0 -20px;
      justify-content: space-between;
      align-items: center;

      img {
        position: absolute;
        right: 16px;
        top: 50%;
        width: 16px;
        height: 16px;
        transform: translateY(-50%);
      }
    }

    &__image {
      display: block;
      max-width: 100%;
    }
  }

  @media screen and (min-width: 1200px) {
    display: none;
  } 
`,Oi=e.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 24px 24px 1fr 24px 24px;
  @media (max-width: 767px) {
    grid-template-columns: 24px 24px 1fr 68px;
  }
  align-items: center;
  justify-content: center;
`;e.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;

  img {
    width: 24px;
    height: 24px;
  }
`,e.a`
  .searcherspan {
    width: 128px;
    margin-right: 10px;
    padding-left: 0;
    padding-right: 0;
    border: none;
    border-bottom: 1px solid #cac6c6;
    padding: 3px 11px;
  }

  .searcher {
    padding: 0;
    border: none;
    outline: none;
    font-size: 0.75em;
    font-family: "ModeloRegular";

    ::placeholder {
      color: #dfdfdf;
    }
  }

  padding: 12px;
`;const ji=e.div`
  @media screen and (max-width: 768px) {
    display: none;
  }
`,Ri=e.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: right;
  margin-left: auto;
`,qi=e.div`
  &.special_campaign {
    order: 50;
  }
`,Hi=e.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
  box-sizing: border-box;
  font-size: 0.875em;
  @media (min-width: 1199px) {
  }
  padding: 32px 0 22px;

  // todo - toni
  .tnm--mobile & {
    border-top: none;
  }

  /* 
  TODO - decide if is best grid or flex
  grid-gap: 24px;
  grid-template-columns: repeat(7, 1fr);
  */

  .tnm--desktop .tnm__title:hover & {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    min-height: 70px;
    /* height: 500px; */
    /* display: grid; */
  }

  .tnm--mobile .tnm__title-field:checked ~ & {
    display: block;

    @media (min-width: 767px) {
      display: flex;
      flex-wrap: wrap;
    }
  }
`;e.div`
  display: flex;
  margin: 0 0 0px auto;
  min-width: ${100/7}%;

  .tnm--mobile & {
    display: none;
  }
`,e.div`
  position: relative;

  img {
    display: block;
  }
`;const Ui=e.div`
  display: flex;
  padding-top: 5px;
`,Wi=e.div``,Qi=e.div``,Yi=e.li`
  margin-bottom: 10px;
`;e(Tt)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 32px;
`;const Vi=e.div`
  .tnm__highlights {
    &--visible {
      display: flex;
      flex-wrap: wrap;
    }
  }

  .tnm__highlights--reversed .tnm__column:nth-child(2) {
    order: -1;
    border-bottom: 1px solid #dfdfdf;
  }

  .tnm__menu {
    overflow-x: auto;
    border-bottom: 1px solid #dfdfdf;

    &::after {
      display: none;
    }

    /*
    &::-webkit-scrollbar {
      display: none;
    }
    */

    background-image: linear-gradient(to right, white, white),
      linear-gradient(to right, white, white),
      linear-gradient(to right, rgba(0, 0, 0, 0.25), rgba(255, 255, 255, 0)),
      linear-gradient(to left, rgba(0, 0, 0, 0.25), rgba(255, 255, 255, 0));
    background-position: left center, right center, left center, right center;
    background-repeat: no-repeat;
    background-color: white;
    background-size: 20px 100%, 20px 100%, 25px 100%, 25px 100%;
    background-attachment: local, local, scroll, scroll;
    -webkit-appearance: none;
  }
`,Xi=e.ul.withConfig({shouldForwardProp:e=>!["numIcons"].includes(e)})`
  ${e=>e.numIcons>0?`\n      display: grid;\n      grid-template-columns: repeat(${e.numIcons}, 1fr);\n      grid-column-gap:50px;\n      @media (max-width: 1024px) {\n        grid-column-gap:45px;\n      }\n      @media (max-width: 767px) {\n        grid-template-columns: repeat(2, 1fr);\n        grid-row-gap:30px; \n        grid-column-gap:15px;\n      }\n      li{\n        text-align: center;\n      }\n      a {\n        font-size:0.8rem!important;\n      }\n      img{\n        max-height:55px;\n      }\n      `:""};
`,Ji=({group:e})=>{var t;return e.submenus&&e.submenus.some((e=>""!==e.title))&&c.createElement("div",null,e.submenus&&(null===(t=e.submenus.filter((e=>""!==e.title)))||void 0===t?void 0:t.map(((t,a)=>{var o,n;return c.createElement(Qi,{key:`tnm_line_${a}`},t.title&&""!==t.title&&"string"==typeof t.title&&t.submenus.some((e=>e.show))&&c.createElement(Dt,{key:`tnm_line_title_${a}`,className:"tnm__sub-title tnm__sub-title--line-title",as:"p"},t.title,":"),c.createElement(Xi,{className:"tnm__list"+(""!==t.title?" tnm__listtitle":""),numIcons:e.iconSection?null===(o=t.submenus)||void 0===o?void 0:o.length:0},null===(n=t.submenus)||void 0===n?void 0:n.map(((t,a)=>t.show&&c.createElement(Yi,{key:`tnm_submenu_${a}`,className:"tnm__item"},c.createElement(Dt,{key:`tnm_submenu_title_${a}`,as:yt,href:t.slug,fontColor:t.textColor,"data-tracking":t.tracking,className:"tnm__link trackable "+(t.script?"slugwithparameters":""),title:t.seotitle,bold:t.textBold},e.iconSection&&t.icon&&c.createElement("img",{src:t.icon,alt:t.title}),t.title))))))}))))},Ki=({menu:e,indexmenu:t,group:a,indexgroup:o})=>{var n;return c.createElement(Wi,{key:`tnm_group_${o}`,className:`tnm__column ${e.groups.length-1===o?"tnm__column--last":""} ${a.submenus.some((e=>""!=e.title&&e.submenus.some((e=>e.show))))?"tnm__column--double":"tnm__column--simple"}\n                ${a.showUnder||o<=e.groups.length-2&&e.groups[o+1].showUnder?"tnm__column--double-under-3":""}\n                  `},""!==a.title&&c.createElement(Dt,{key:`tnm_group_title_${t}_${o}`,as:yt,href:a.slug,fontColor:a.textColor,"data-tracking":a.tracking,className:"tnm__link trackable "+(a.script?"slugwithparameters":""),title:a.seotitle,bold:a.textBold},a.title),""!==a.subtitle&&c.createElement(Dt,{key:`tnm_group_subtitle_${o}`,as:"p",className:"tnm__sub-title tnm__sub-title--sizes-title"},a.subtitle),a.submenus&&(null===(n=a.submenus.filter((e=>""===e.title)))||void 0===n?void 0:n.map(((e,t)=>{var o,n;return c.createElement(Qi,{className:"tnm__line-root",key:`tnm_line_${t}`},e.title&&""!==e.title&&"string"==typeof e.title&&e.submenus.some((e=>e.show))&&c.createElement(Dt,{key:`tnm_line_title_${t}`,className:"tnm__sub-title tnm__sub-title--line-title",as:"p"},e.title,":"),c.createElement(Xi,{className:"tnm__list"+(""!==e.title?" tnm__listtitle":""),numIcons:a.iconSection?null===(o=e.submenus)||void 0===o?void 0:o.length:0},null===(n=e.submenus)||void 0===n?void 0:n.map(((e,t)=>e.show&&c.createElement(Yi,{key:`tnm_submenu_${t}`,className:"tnm__item"},c.createElement(Dt,{key:`tnm_submenu_title_${t}`,as:yt,href:e.slug,fontColor:e.textColor,"data-tracking":e.tracking,className:`tnm__link trackable ${e.script?"slugwithparameters":""} ${a.title?"rhymes":""}`,title:e.seotitle,bold:e.textBold},a.iconSection&&e.icon&&c.createElement("img",{src:e.icon,alt:e.title}),e.title))))))}))),c.createElement(Ji,{group:a}))},Zi=({menu:e,indexmenu:t})=>{var a,o;let n=-1;return null===(a=e.groups)||void 0===a||a.map(((e,t)=>{e.showUnder&&(n=t)})),c.createElement(c.Fragment,null,null===(o=e.groups)||void 0===o?void 0:o.slice(0,n>=0?n-1:e.groups.length).map(((a,o)=>{var n,i;return!1!==(null===(i=null===(n=a.submenus)||void 0===n?void 0:n[0])||void 0===i?void 0:i.submenus[0].show)?c.createElement(Ki,{menu:e,indexmenu:t,group:a,indexgroup:o,key:`tnm__group_${o}`}):null})))},el=({searcher:e,homeUrl:t,bagWidget:a,menus:o,stores:n,onTnmHide:i,onTnmShow:l,showSearch:r})=>{const s=b((()=>l&&l()),[l]),d=b((()=>i&&i()),[i]);return c.createElement(c.Fragment,null,c.createElement(Ai,{href:t},c.createElement("img",{alt:"NNormal",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/1bc02c82-b9b7-4feb-a8af-88ab7b304dcc/nnormal-logo.svg?version=0"})),c.createElement(Ui,null,null==o?void 0:o.map(((e,t)=>e.show&&c.createElement(qi,{key:`tnm_menu_${t}`,className:""+(e.specialCampaign?"special_campaign":"")},c.createElement("span",{className:"tnm__title "+(e.selected?"selectedmenu":""),onMouseOver:e.groups.length>0?s:()=>{},onMouseLeave:e.groups.length>0?d:()=>{}},c.createElement(Dt,{key:`tnm_menu_title_${t}`,as:yt,href:e.slug,"data-tracking":e.tracking,fontColor:e.textColor,title:e.seotitle,className:"trackable "+(e.script?"slugwithparameters":""),upperCase:!1,fontSizeDesktop:1,fontSizeTablet:1},e.title),e.groups.length>0&&c.createElement(Hi,{className:`tnm__highlights tnm__highlights--${e.groups.length}`},c.createElement(Zi,{menu:e,indexmenu:t}))))))),c.createElement(Fi,null,r&&e,a&&c.createElement(Gi,null,a)))},tl=({searcher:e,homeUrl:t,accountWidget:a,bagWidget:o,menus:n,showShoesFirstInMobile:i,stores:l,languageName:r,countryName:s,accountLiteral:d,yourOrdersLiteral:u,newsletterLiteral:f,showI18nModal:g,showNewsletterModal:h,showOrderTrackingModal:b,showSearch:x})=>{const[v,y]=p(!1),[k,w]=p(0);m((()=>{let e=n.findIndex((e=>e.selected));if(e<0){const t="M";e=n.findIndex((e=>e.menuType===t))}e<0&&(e=0),w(e)}),[]);return m((()=>{document&&document.body&&(document.body.style.overflow=v?"hidden":"unset")}),[v]),c.createElement(Oi,null,c.createElement("span",{className:"tnm__open",onClick:e=>y(!0)},c.createElement("img",{alt:"Menu",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/2279f931-88ec-47db-b606-12fd90025bf3/hamb-menu.svg"})),x&&e,c.createElement(Li,{href:t},c.createElement("img",{alt:"NNormal",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/f50346e4-6d5c-4793-b1ec-5c1b36a9173d/logo-nnormal-black-primary.svg"})),a&&c.createElement(ji,null,a),o&&c.createElement(Ri,null,o),v&&c.createElement(Vi,{className:"tnm__modal"},c.createElement("div",{className:"tnm__modal-header"},c.createElement("span",{className:"tnm__close",onClick:()=>y(!1)},c.createElement("img",{alt:"Close",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/7abee8ba-6e1b-40fb-a432-d65316126515/cross.svg"})),x&&e,c.createElement(Li,{className:"tnm__modal-image",href:t},c.createElement("img",{alt:"NNormal",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/f50346e4-6d5c-4793-b1ec-5c1b36a9173d/logo-nnormal-black-primary.svg"}))),c.createElement("div",{className:"tnm__menu"},null==n?void 0:n.map(((e,t)=>e.show&&c.createElement(qi,{className:"tnm__menu-item "+(t===k?"tnm__menu-item--active":""),key:`tnm_menu_${t}`},c.createElement("span",{className:"tnm__title"},c.createElement(Dt,{key:`tnm_menu_title_${t}`,as:yt,href:e.slug,"data-tracking":e.tracking,fontColor:e.textColor,title:e.seotitle,className:"trackable "+(e.script?"slugwithparameters":""),upperCase:!1,bold:e.textBold,onClick:a=>{e.groups.length&&(a.preventDefault(),w(t),((e,t,a)=>{const o=Math.trunc(t/2);document.getElementsByClassName("tnm__menu")[0].style.scrollBehavior="smooth",a<o?document.getElementsByClassName("tnm__menu")[0].scrollLeft-=60*a:document.getElementsByClassName("tnm__menu")[0].scrollLeft+=60*a})(0,n.length,t))}},e.title)))))),c.createElement("div",{style:{position:"relative",flex:1,display:"flex",flexDirection:"column"}},null==n?void 0:n.map(((e,t)=>{var a;return e.show&&e.groups.length>0&&c.createElement(Hi,{key:`tnm__hightlights_${t}`,className:`tnm__highlights tnm__highlights--${e.groups.length} ${t===k?"tnm__highlights--visible":""} ${!i||"W"!==e.menuType&&"M"!==e.menuType?"":"tnm__highlights--reversed"}`,style:{position:"relative",top:"unset",left:"unset",width:"auto"}},null===(a=e.groups)||void 0===a?void 0:a.map(((a,o)=>{var n,i,l,r,s;return(null===(l=null===(i=null===(n=a.submenus)||void 0===n?void 0:n[0])||void 0===i?void 0:i.submenus)||void 0===l?void 0:l.some((e=>null!==e.title&&""!==e.title)))?c.createElement(Wi,{key:`tnm_group_${o}`,className:`tnm__column ${e.groups.length-1===o?"tnm__column--last":""} ${a.submenus.some((e=>""!=e.title&&e.submenus.some((e=>e.show))))||a.separateColumn>0?"tnm__column--double":"tnm__column--simple"} ${0===o&&"G"===e.menuType?"tnmhighlightgoods":""}\n                                ${1===o&&"G"===e.menuType?"tnmgoods":""}\n                                `},""!==a.title&&c.createElement(c.Fragment,null,c.createElement("input",{type:"checkbox",defaultChecked:0===o,className:"tnm__link-toggle"}),c.createElement(Dt,{key:`tnm_group_title_${t}_${o}`,as:yt,href:a.slug,fontColor:a.textColor,"data-tracking":a.tracking,className:"tnm__column-title trackable "+(a.script?"slugwithparameters":""),title:a.seotitle,bold:a.textBold},a.title,c.createElement("img",{alt:"Open",src:"https://www.nnormal.com/cms/api/assets/tiers-banners-homes/1edf5e11-b11b-4b23-82e2-c4fb666f670f/chevron.svg"}))),""!==a.subtitle&&c.createElement(Dt,{key:`tnm_group_subtitle_${o}`,as:"p",className:"tnm__sub-title tnm__sub-title--sizes-title"},a.subtitle),a.submenus&&(null===(r=a.submenus.filter((e=>""===e.title)))||void 0===r?void 0:r.map(((e,t)=>{var o,n,i,l;return c.createElement(c.Fragment,{key:`tnm__lines${t}`},c.createElement(Qi,{key:`tnm_line_${t}`,className:"tnm__line"},e.title&&""!==e.title&&"string"==typeof e.title&&e.submenus.some((e=>e.show))&&c.createElement(Dt,{key:`tnm_line_title_${t}`,className:"tnm__sub-title tnm__sub-title--line-title",as:"p"},e.title,":"),c.createElement(Xi,{className:"tnm__list",numIcons:a.iconSection?null===(o=e.submenus)||void 0===o?void 0:o.length:0},null===(n=e.submenus)||void 0===n?void 0:n.map(((t,o)=>{var n;let i=0;for(let t=0;t<(null===(n=e.submenus)||void 0===n?void 0:n.length);t++)e.submenus[t].show&&i++;return i=i%2==0?Math.floor(i/2):Math.floor(i/2)+1,t.show&&(0===a.separateColumn||a.separateColumn>0&&o<i)&&c.createElement(Yi,{key:`tnm_submenu_${o}`,className:"tnm__item"},c.createElement(Dt,{key:`tnm_submenu_title_${o}`,as:yt,href:t.slug,fontColor:t.textColor,"data-tracking":t.tracking,className:`tnm__link trackable ${t.script?"slugwithparameters":""} ${a.title?"rhymes":""}`,title:t.seotitle,bold:t.textBold},a.iconSection&&t.icon&&c.createElement(c.Fragment,null,c.createElement("img",{src:t.icon,alt:t.title}),c.createElement("br",null)),t.title))})))),a.separateColumn>0&&c.createElement(Qi,{key:`tnm_line_${t}_tris_bis`,className:"tnm__line"},e.title&&""!==e.title&&"string"==typeof e.title&&e.submenus.some((e=>e.show))&&c.createElement(Dt,{key:`tnm_line_title_${t}`,className:"tnm__sub-title tnm__sub-title--line-title",as:"p"},e.title,":"),c.createElement(Xi,{className:"tnm__list",numIcons:a.iconSection?null===(i=e.submenus)||void 0===i?void 0:i.length:0},null===(l=e.submenus)||void 0===l?void 0:l.map(((t,o)=>{var n;let i=0;for(let t=0;t<(null===(n=e.submenus)||void 0===n?void 0:n.length);t++)e.submenus[t].show&&i++;return i=i%2==0?Math.floor(i/2):Math.floor(i/2)+1,t.show&&a.separateColumn>0&&o>=i&&c.createElement(Yi,{key:`tnm_submenu_${o}`,className:"tnm__item"},c.createElement(Dt,{key:`tnm_submenu_title_${o}`,as:yt,href:t.slug,fontColor:t.textColor,"data-tracking":t.tracking,className:"tnm__link trackable "+(t.script?"slugwithparameters":""),title:t.seotitle,bold:t.textBold},a.iconSection&&t.icon&&c.createElement(c.Fragment,null,c.createElement("img",{src:t.icon,alt:t.title}),c.createElement("br",null)),t.title))})))))}))),a.submenus&&a.submenus.some((e=>""!==e.title))?c.createElement("div",{className:"tnm__line"},a.submenus&&(null===(s=a.submenus.filter((e=>""!==e.title)))||void 0===s?void 0:s.map(((e,t)=>{var o,n;return c.createElement(Qi,{key:`tnm_line_${t}_tris`},e.title&&""!==e.title&&"string"==typeof e.title&&e.submenus.some((e=>e.show))&&c.createElement(Dt,{key:`tnm_line_title_${t}`,className:"tnm__sub-title tnm__sub-title--line-title",as:"p"},e.title,":"),c.createElement(Xi,{className:"tnm__list",numIcons:a.iconSection?null===(o=e.submenus)||void 0===o?void 0:o.length:0},null===(n=e.submenus)||void 0===n?void 0:n.map(((e,t)=>e.show&&c.createElement(Yi,{key:`tnm_submenu_${t}`,className:"tnm__item"},c.createElement(Dt,{key:`tnm_submenu_title_${t}`,as:yt,href:e.slug,fontColor:e.textColor,"data-tracking":e.tracking,className:"tnm__link trackable "+(e.script?"slugwithparameters":""),title:e.seotitle,bold:e.textBold},a.iconSection&&e.icon&&c.createElement("img",{src:e.icon,alt:e.title}),e.title))))))})))):""):null})))})),c.createElement(Bi,{stores:l,accountWidget:a,languageName:r,countryName:s,accountLiteral:d,yourOrdersLiteral:u,newsletterLiteral:f,showI18nModal:g,showNewsletterModal:h,showOrderTrackingModal:b}))))};function al({menus:e,showShoesFirstInMobile:t,languageName:a,countryName:o,homeUrl:n,searcher:i,stores:l,accountLiteral:r,accountWidget:s,bagWidget:d,yourOrdersLiteral:u,newsletterLiteral:p,onTnmHide:f,onTnmShow:g,showI18nModal:h,showNewsletterModal:b,showOrderTrackingModal:x,showSearch:v}){return m((()=>{let e=ve("usrhash");if(""!==e){let t=document.getElementsByClassName("slugwithparameters");for(let a of t){let t=a.getAttribute("href");-1===(null==t?void 0:t.indexOf("&usrhash="))&&a.setAttribute("href",`${t}&usrhash=${e}`)}}}),[]),c.createElement(c.Fragment,null,c.createElement(Ii,{className:"tnm tnm--desktop"},c.createElement(el,{searcher:i,homeUrl:n,bagWidget:d,menus:e,stores:l,onTnmHide:f,onTnmShow:g,showSearch:v})),c.createElement(Pi,{className:"tnm tnm--mobile"},c.createElement(tl,{searcher:i,homeUrl:n,accountWidget:s,bagWidget:d,menus:e,showShoesFirstInMobile:t,stores:l,languageName:a,countryName:o,accountLiteral:r,yourOrdersLiteral:u,newsletterLiteral:p,showI18nModal:h,showNewsletterModal:b,showOrderTrackingModal:x,showSearch:v})))}let ol=class{constructor(e){this.fetchTnmDetail=e=>this.fetchService.cmsFetchGraphQL("GetTnm",`query GetTnm{queryTnmsContents(filter:"status eq 'Published' and data/countries/iv eq '${e}'",orderby:"created desc"){flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},showShoesFirstInMobile,menus{flatData{menuType,title{flatData{code,text}},specialCampaign,tracking,slug{flatData{slug}},textColor,textBold,script,submenus{iconSection,separateColumn,showUnder,title{flatData{code,text}},subtitle{flatData{code,text}},tracking,slug{flatData{slug}},script,textColor,textBold,submenus{flatData{title{flatData{code,text}},line{flatData{title{flatData{code,text}}}},tracking,slug{flatData{slug}},textColor,textBold,script,icon{url, fileName},rules{checkExistance,checkType,camperCode,family,gender,countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}},images{flatData{images{slug{flatData{slug}},tracking,assets{url,fileName,tags,metadata}},buttons{literal{flatData{code,text}},slug{flatData{slug}},tracking,font{\tflatData{name}},fontColor,selectedFontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,backgroundColor,selectedBackgroundColor,}}},rules{checkExistance,checkType,camperCode,family,gender,countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}}}}`),this.fetchTnmById=e=>this.fetchService.cmsFetchGraphQL("GetTnm","query GetTnm($id:String!){findTnmsContent(id:$id){flatData{countries{flatData{code,marketCode}},showShoesFirstInMobile,menus{flatData{menuType,title{flatData{code,text}},specialCampaign,tracking,slug{flatData{slug}},textColor,textBold,script,submenus{iconSection,separateColumn,showUnder,title{flatData{code,text}},subtitle{flatData{code,text}},tracking,slug{flatData{slug}},textColor,textBold,script,submenus{flatData{title{flatData{code,text}},line{flatData{title{flatData{code,text}}}},tracking,slug{flatData{slug}},textColor,textBold,script,icon{url, fileName},rules{checkExistance,checkType,camperCode,family,gender,countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}},images{flatData{images{slug{flatData{slug}},tracking,assets{url,fileName,tags,metadata}},buttons{literal{flatData{code,text}},slug{flatData{slug}},tracking,font{flatData{name}},fontColor,selectedFontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,backgroundColor,selectedBackgroundColor,}}},rules{checkExistance,checkType,camperCode,family,gender,countryRules,country{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}},countryGroups{flatData{countries{flatData{code,translatedName{flatData{code,text}},marketCode,telephone,workingHours{flatData{code,text}}}}}}}}}}}}",{id:e}),this.fetchTnmLiterals=()=>this.fetchService.cmsFetchGraphQL("GetTnmLiterals","query GetTnmLiterals{queryLiteralsContents(filter:\"data/code/iv eq 'stores' or data/code/iv eq 'search' or data/code/iv eq 'my-account' or data/code/iv eq 'your-orders' or data/code/iv eq 'newsletter'\"){flatData {code,text}}}"),this.fetchTnmSlugs=()=>this.fetchService.cmsFetchGraphQL("GetTnmSlugs","query GetTnmSlugs{querySlugsContents(filter:\"data/code/iv eq '/search' or data/code/iv eq '/shops'\"){flatData {code,slug}}}"),this.fetchService=e}};ol=O([k(w.ContainerScoped),j("design:paramtypes",[te])],ol);const nl=e=>{var t;const a=[],o=null!==(t=il(e,(e=>e.flatData.line&&e.flatData.line.length>0?e.flatData.line[0].flatData.title[0].flatData.text:"")))&&void 0!==t?t:[],n=Object.keys(o);for(const e of n)a.push({title:e,submenus:o[e]});return a},il=(e,t)=>e.reduce(((e,a)=>{const o=t(a);return e[o]||(e[o]=[]),e[o].push(a),e}),{}),ll=(e,t,a)=>{let o=!0;if(t&&e.length>0){const n=e[0];if(n.checkExistance&&(o=rl(t,n.checkExistance,!n.checkType||"Exists"===n.checkType,n.camperCode,n.family,n.gender)),o)switch(n.countryRules){case"Hide for Country":return dl(n.country,a,!1);case"Show only for Country":return dl(n.country,a,!0);case"Hide for Country Groups":return cl(n.countryGroups,a,!1);case"Show only for Country Groups":return cl(n.countryGroups,a,!0);default:return!0}}return o},rl=(e,t,a,o,n,i)=>{const l={camperCode:o.toLocaleUpperCase(),family:n.toLocaleString(),gender:i.toLocaleUpperCase()};let r=a;switch(t){case"Collection":r=sl(e.collections,l);break;case"Typology":r=sl(e.typologies,l);break;case"Line":r=sl(e.lines,l)}return a&&r||!a&&!r},sl=(e,t)=>null==e?void 0:e.some((e=>e.id.toLocaleUpperCase()===t.camperCode&&e.targets.find((e=>e.family.toLocaleString()===t.family&&e.gender.toLocaleUpperCase()===t.gender)))),dl=(e,t,a)=>{if(e.length>0){const o=void 0!==e.find((e=>e.flatData.code===t));return a?o:!o}return!0},cl=(e,t,a)=>{if(e.length>0){const o=void 0!==e.find((e=>e.flatData.countries.find((e=>e.flatData.code.toString()===t.toString()))));return a?o:!o}return!0},ul=(e,t,a,o,n,i,l,r,s,d)=>{var c,u,p,m,f,g,h,b,x,v;let y=null==a?void 0:a.menus.map((a=>{var i,l;return{title:a.flatData.title[0].flatData.text,menuType:a.flatData.menuType[0],selected:""!==d&&d===a.flatData.menuType[0],seotitle:"CAMPERLAB"===a.flatData.title[0].flatData.text.toUpperCase()?a.flatData.title[0].flatData.text:`NNormal ${a.flatData.title[0].flatData.text}`,tracking:`eventGA|main-menu|${a.flatData.tracking}|`,specialCampaign:a.flatData.specialCampaign,slug:be(n,e,t,a.flatData.slug[0].flatData.slug,a.flatData.script),textColor:a.flatData.textColor,textBold:null!==(i=a.flatData.textBold)&&void 0!==i&&i,script:a.flatData.script,groups:a.flatData.submenus.map((i=>{var l,r,s;return{title:i.title?i.title[0].flatData.text:"",seotitle:`NNormal ${a.flatData.title[0].flatData.text} ${i.title?i.title[0].flatData.text:""}`,subtitle:i.subtitle?i.subtitle[0].flatData.text:"",tracking:`eventGA|main-menu|${a.flatData.tracking}|${i.tracking}|`,slug:i.slug?be(n,e,t,i.slug[0].flatData.slug,i.script):"",textColor:i.textColor,textBold:null!==(l=i.textBold)&&void 0!==l&&l,script:i.script,iconSection:null!==(r=i.iconSection)&&void 0!==r&&r,separateColumn:i.separateColumn&&0!==i.separateColumn?i.separateColumn:0,showUnder:null!==(s=i.showUnder)&&void 0!==s&&s,submenus:nl(i.submenus).map((l=>({title:l.title,submenus:l.submenus.map((l=>{var r;return{title:l.flatData.title[0].flatData.text,seotitle:i.title?`NNormal ${a.flatData.title[0].flatData.text} ${i.title[0].flatData.text} ${l.flatData.title[0].flatData.text}`:`NNormal ${a.flatData.title[0].flatData.text} ${l.flatData.title[0].flatData.text}`,tracking:`eventGA|main-menu|${a.flatData.tracking}|${l.flatData.line?"":i.tracking+"-"}${l.flatData.tracking}|`,slug:be(n,e,t,l.flatData.slug[0].flatData.slug,l.flatData.script),textColor:l.flatData.textColor,textBold:null!==(r=l.flatData.textBold)&&void 0!==r&&r,script:l.flatData.script,icon:l.flatData.icon?Ce(l.flatData.icon[0]):"",show:ll(l.flatData.rules,o,n)}}))})))}})),images:null===(l=a.flatData.images)||void 0===l?void 0:l.map((o=>{var i;return{assets:o.flatData.images[0].assets,slug:be(n,e,t,o.flatData.images[0].slug[0].flatData.slug),alt:o.flatData.buttons?o.flatData.buttons[0]?o.flatData.buttons[0].literal[0].flatData.text:"":a.flatData.title[0].flatData.text,tracking:`eventGA|main-menu|${a.flatData.tracking}|${o.flatData.images[0].tracking}|`,buttons:null===(i=o.flatData.buttons)||void 0===i?void 0:i.map((o=>({backgroundColor:o.backgroundColor,selectedBackgroundColor:o.selectedBackgroundColor,font:o.font[0].flatData.name,fontColor:o.fontColor,selectedFontColor:o.selectedFontColor,fontSizeDesktop:o.fontSizeDesktop,fontSizeTablet:o.fontSizeTablet,fontSizeMobile:o.fontSizeMobile,literal:"Camperlab"===a.flatData.menuType?o.literal[0].flatData.text.toLocaleUpperCase():o.literal[0].flatData.text,slug:be(n,e,t,o.slug[0].flatData.slug),tracking:`eventGA|main-menu|${a.flatData.tracking}|${o.tracking}|`})))}})),show:ll(a.flatData.rules,o,n)}}));const k=null===(c=l.find((e=>"/shops"===e.flatData.code)))||void 0===c?void 0:c.flatData.slug;let w={text:null!==(p=null===(u=i.find((e=>"stores"===e.flatData.code)))||void 0===u?void 0:u.flatData.text)&&void 0!==p?p:"",url:k?be(n,e,t,k):""},C=null!==(f=null===(m=i.find((e=>"my-account"===e.flatData.code)))||void 0===m?void 0:m.flatData.text)&&void 0!==f?f:"",D=null!==(h=null===(g=i.find((e=>"your-orders"===e.flatData.code)))||void 0===g?void 0:g.flatData.text)&&void 0!==h?h:"",S=null!==(x=null===(b=i.find((e=>"newsletter"===e.flatData.code)))||void 0===b?void 0:b.flatData.text)&&void 0!==x?x:"";return{menus:y,showShoesFirstInMobile:null!==(v=a.showShoesFirstInMobile)&&void 0!==v&&v,homeUrl:xe(n,e,t),stores:w,countryName:s,languageName:r,accountLiteral:C,yourOrdersLiteral:D,newsletterLiteral:S}};let pl=class{constructor(e,t,a,o,n){this.eshopService=e,this.config=n,this.languageService=o,this.countryService=a,this.tnmService=t}getProps(e,t){var a,o,n,i,l,r;return R(this,void 0,void 0,(function*(){try{const s=yield this.languageService.fetchLanguageByCode(this.config.language);if(!s||0===s.length)throw new Error("Language contents empty: "+this.config.language);const d=yield this.countryService.fetchCountryByCode(this.config.country);if(!d||0===d.length)throw new Error("Country contents empty: "+this.config.country);const c=yield this.eshopService.fetchEshopByCountryCode(this.config.country),u=yield this.tnmService.fetchTnmLiterals(),p=yield this.tnmService.fetchTnmSlugs(),m=t?yield this.tnmService.fetchTnmById(t):(yield this.tnmService.fetchTnmDetail(null!==(o=null===(a=d[0])||void 0===a?void 0:a.id)&&void 0!==o?o:""))[0];try{return Object.assign({},ul(this.config.language,this.config.urlBase,null==m?void 0:m.flatData,c,this.config.country,u,p,null!==(i=null===(n=s[0])||void 0===n?void 0:n.flatData.translatedName)&&void 0!==i?i:"",null!==(r=null===(l=d[0])||void 0===l?void 0:l.flatData.translatedName[0].flatData.text)&&void 0!==r?r:"",null!=e?e:""))}catch(e){throw console.error("Error parsing tnm props! cms data: "+JSON.stringify(m)+", error: "+e.toString()),e}}catch(a){throw console.error("Cant load tnm props with this args: "+JSON.stringify({id:t,selectedmenu:e})+", config: "+JSON.stringify(this.config)+", error: "+a.toString()),a}}))}};pl=O([k(w.ContainerScoped),j("design:paramtypes",[se,ol,oe,ne,Q])],pl);let ml=class{constructor(e){this.fetchHomeDetail=(e,t,a)=>this.fetchService.cmsFetchGraphQL("GetHome",`query GetHome{queryHomesContents(filter:"status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}' and data/camperLab/iv eq ${a}",orderby:"created desc") {flatData{geography,countries{flatData{code,marketCode}},languages{flatData{code}},groups{banners{flatData{name,onlyDesktop,bannerType{flatData{code,name}},layoutMobile,texts{textType{flatData{code,name}},literal{flatData{code,text}},upperCase,lowerCase,font{flatData{name}},fontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,backgroundColor,cta,tracking,slug{flatData{slug}},script}components{flatData{dynamic,componentType{flatData{code,name}},countdown{daysLiteral{flatData{code,text}},hoursLiteral{flatData{code,text}},minutesLiteral{flatData{code,text}},font{flatData{name}},fontColor,fontSizeTextDesktop,fontSizeTextTablet,fontSizeTextMobile,fontSizeNumbersDesktop,fontSizeNumbersTablet,fontSizeNumbersMobile,finalDate},images{tracking,trackingGA4,slug{flatData{slug}},script,assets{url,fileName,tags,metadata}},buttons{borderColor,underline,backgroundColor,backgroundColorTablet,backgroundColorMobile,boxShadowDesktop,boxShadowTablet,boxShadowMobile,selectedBackgroundColor,showCountriesModal,font{flatData{name}},fontColor,fontColorTablet,fontColorMobile,selectedFontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,literal{flatData{code,text}},upperCase,lowerCase,slug{flatData{slug}},script,tracking,trackingGA4},buttonsLayout,texts{textShadowDesktop,textShadowTablet,textShadowMobile,backgroundColor,cta,tracking,trackingGA4,slug{flatData{slug}},script,font{flatData{name}},marginTop,marginTopMobile,fontColor,fontColorMobile,fontColorTablet,fontSizeDesktop,fontSizeTablet,fontSizeMobile,literal{flatData{code,text}},upperCase,lowerCase,textType{flatData{code,name}}}}}}}}}}}`),this.fetchHomeMetas=(e,t,a)=>this.fetchService.cmsFetchGraphQL("GetHome",`query GetHome{queryHomesContents(filter:"status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}' and data/camperLab/iv eq ${a}",orderby:"created desc"){flatData{geography,countries{flatData{code,marketCode}},languages{flatData{code}},metas{flatData{pageTitle,metaDescription}}}}}`),this.fetchHomeById=e=>this.fetchService.cmsFetchGraphQL("GetHome","query GetHome($id:String!){findHomesContent(id: $id){flatData{geography,countries{flatData{code,marketCode}},languages{flatData{code}},groups{banners{flatData{name,onlyDesktop,bannerType{flatData{code,name}},layoutMobile,texts{textType{flatData{code,name}},literal{flatData{code,text}},upperCase,lowerCase,font{flatData{name}},fontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,backgroundColor,cta,tracking,slug{flatData{slug}},script}components{flatData{dynamic,componentType{flatData{code,name}},countdown{daysLiteral{flatData{code,text}},hoursLiteral{flatData{code,text}},minutesLiteral{flatData{code,text}},font{flatData{name}},fontColor,fontSizeTextDesktop,fontSizeTextTablet,fontSizeTextMobile,fontSizeNumbersDesktop,fontSizeNumbersTablet,fontSizeNumbersMobile,finalDate},images{tracking,trackingGA4,slug{flatData{slug}},script,assets{url,fileName,tags,metadata}},buttons{borderColor,underline,backgroundColor,backgroundColorTablet,backgroundColorMobile,boxShadowDesktop,boxShadowTablet,boxShadowMobile,selectedBackgroundColor,showCountriesModal,font{flatData{name}},fontColor, fontColorTablet,fontColorMobile,selectedFontColor,fontSizeDesktop,fontSizeTablet,fontSizeMobile,literal{flatData{code,text}},upperCase,lowerCase,slug{flatData{slug}},script,tracking,trackingGA4},buttonsLayout,texts{textShadowDesktop,textShadowTablet,textShadowMobile,backgroundColor,cta,tracking,trackingGA4,slug{flatData{slug}},script,font{flatData{name}},marginTop,marginTopMobile,fontColor,fontColorMobile,fontColorTablet,fontSizeDesktop,fontSizeTablet,fontSizeMobile,literal{flatData{code,text}},upperCase,lowerCase,textType{flatData{code,name}}}}}}}}}}}",{id:e}),this.fetchService=e}};ml=O([k(w.ContainerScoped),j("design:paramtypes",[te])],ml);let fl=class{constructor(e){this.fetchService=e}fetchLandingDetail(e,t,a){return this.fetchService.cmsFetchGraphQL("GetLanding",`query GetLanding{queryLandingsContents(filter:"status eq 'Published' and data/slug/iv eq '${e}' and data/countries/iv eq '${t}' and data/languages/iv eq '${a}'", orderby:"created desc"){flatData{slug{flatData{code,slug}},layout,geography,countries{flatData{code,marketCode}},languages{flatData{code}},literals{flatData{code,text}},slugs{flatData{code,slug}},assets{url,fileName,tags}}}}`)}fetchLandingMetas(e,t,a){return this.fetchService.cmsFetchGraphQL("GetLanding",`query GetLanding{queryLandingsContents(filter:"status eq 'Published' and data/slug/iv eq '${e}' and data/countries/iv eq '${t}' and data/languages/iv eq '${a}'", orderby:"created desc"){flatData{slug{flatData{code,slug}},layout,geography,countries{flatData{code,marketCode}},languages{flatData{code}},metas{flatData{pageTitle,metaDescription}}}}}`)}fetchLandingById(e){return this.fetchService.cmsFetchGraphQL("GetLanding","query GetLanding($id:String!){findLandingsContent(id:$id){flatData{slug{flatData{code,slug}},layout,geography,countries{flatData{code,marketCode}},languages{flatData{code}},literals{flatData{code,text}},slugs{flatData{code,slug}},assets{url,fileName,tags}}}}",{id:e})}fetchAllLandings(e,t){return this.fetchService.cmsFetchGraphQL("GetLanding",`query GetLanding {queryLandingsContents(filter:"status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}'",orderby:"created desc"){lastModified,flatData{geography,slug{flatData{code,slug}},}}}`)}};fl=O([k(w.ContainerScoped),j("design:paramtypes",[te])],fl);let gl=class{constructor(e){this.fetchSlug=(e,t)=>this.fetchService.cmsFetchGraphQL("GetSlug",`query GetSlug{querySlugsContents(filter:"status eq 'Published' and data/slug/${t} eq '${e}'",orderby:"created desc"){id,flatData{slug}}}`),this.fetchSlugById=e=>this.fetchService.cmsFetchGraphQL("GetSlug","query GetSlug($id: String!){findSlugsContent(id: $id){id,flatData{slug}}}",{id:e}),this.fetchService=e}};gl=O([D(),j("design:paramtypes",[te])],gl);let hl=class{constructor(e){this.fetchService=e}fetchSlug(e){return this.fetchService.cmsFetchRestGetQuery("slugs",{filter:{and:[{path:"status",op:"eq",value:"Published"},{path:"id",op:"eq",value:e}]},take:1})}fetchDynamicLandingDetail(e,t,a){return this.fetchService.cmsFetchRestGetQuery("dynamic-landings",{filter:{and:[{path:"status",op:"eq",value:"Published"},{path:"data.slug.iv",op:"eq",value:e},{path:"data.countries.iv",op:"eq",value:t},{path:"data.languages.iv",op:"eq",value:a}]},sort:[{path:"created",order:"descending"}],take:1})}fetchDynamicLandingsByTags(e){return this.fetchService.cmsFetchRestGetQuery("dynamic-landings",{filter:{and:[{path:"status",op:"eq",value:"Published"},{path:"data.tags.iv",op:"eq",value:e[0]}]},sort:[{path:"created",order:"descending"}]})}fetchDynamicLandingById(e){return this.fetchService.cmsFetchRestGetById("dynamic-landings",e)}fetchDynamicLandingMetas(e,t,a){return this.fetchService.cmsFetchGraphQL("GetDynamicLandingMetas",`query GetDynamicLandingMetas{queryDynamicLandingsContents(filter:"status eq 'Published' and data/slug/iv eq '${e}' and data/countries/iv eq '${t}' and data/languages/iv eq '${a}'", orderby:"created desc"){flatData{slug{flatData{code,slug}},geography,countries{flatData{code,marketCode}},languages{flatData{code}},metas{flatData{pageTitle,metaDescription,relatedImage{id,mimeType,url,metadata,tags}}}tags}}}`)}fetchMetasById(e){return this.fetchService.cmsFetchGraphQL("findMetasContent","query findMetasContent($id: String!) { findMetasContent(id: $id) { flatData { pageTitle metaDescription relatedImage { id mimeType url metadata tags } } }}",{id:e})}};hl=O([k(w.ContainerScoped),j("design:paramtypes",[te])],hl);const bl=e=>{var t;return null!==(t=xl(e,"Countries"))&&void 0!==t?t:xl(e,"Markets")},xl=(e,t)=>e.find((e=>e.flatData.geography===t)),vl=(e,t)=>e.find((e=>e.flatData.geography===t));let yl=class{constructor(e,t,a,o,n,i,l){this.getProps=e=>R(this,void 0,void 0,(function*(){var t,a,o,n,i,l,r,s,d,c,u,p,m;const f=yield this.languageService.fetchLanguageByCode(this.config.language),g=yield this.countryService.fetchCountryByCode(this.config.country),h=!1,b=""!==e?yield this.slugService.fetchSlug(e,this.config.language):[];let x;""===e&&(x=bl(yield this.homeService.fetchHomeMetas(null!==(a=null===(t=g[0])||void 0===t?void 0:t.id)&&void 0!==a?a:"",null!==(n=null===(o=f[0])||void 0===o?void 0:o.id)&&void 0!==n?n:"",h))),""===e||x||(x=(e=>{var t;return null!==(t=vl(e,"Countries"))&&void 0!==t?t:vl(e,"Markets")})(yield this.dynamicLandingService.fetchDynamicLandingMetas(null!==(l=null===(i=b[0])||void 0===i?void 0:i.id)&&void 0!==l?l:"",null!==(s=null===(r=g[0])||void 0===r?void 0:r.id)&&void 0!==s?s:"",null!==(c=null===(d=f[0])||void 0===d?void 0:d.id)&&void 0!==c?c:"")));var v="",y="";try{(v=null!==(u=null==x?void 0:x.flatData.metas[0].flatData.pageTitle)&&void 0!==u?u:"")&&""!==v&&(v=`${v} ${null===(p=g[0])||void 0===p?void 0:p.flatData.translatedName[0].flatData.text}`),y=null!==(m=null==x?void 0:x.flatData.metas[0].flatData.metaDescription)&&void 0!==m?m:""}finally{return{pageTitle:v,metaDescription:y}}})),this.config=o,this.languageService=a,this.countryService=t,this.homeService=e,this.slugService=n,this.landingService=i,this.dynamicLandingService=l}};yl=O([k(w.ContainerScoped),j("design:paramtypes",[ml,oe,ne,Q,gl,fl,hl])],yl);let kl=class{constructor(e){this.fetchRibbonDetail=(e,t)=>this.fetchService.cmsFetchGraphQL("GetRibbon",`query GetRibbon{queryRibbonContents(filter:"status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}'",orderby:"created desc") {\n        flatData {\n          countries {\n            flatData {\n              code\n              translatedName {\n                flatData {\n                  code\n                  text\n                }\n              }\n              marketCode\n              telephone\n              whatsapp\n              workingHours {\n                flatData {\n                  text\n                }\n              }\n              flag {\n                url\n                fileName\n              }\n            }\n          }\n          languages {\n            flatData {\n              code\n              translatedName\n            }\n          }\n          texts {\n            text {\n              flatData {\n                title {\n                  flatData {\n                    code\n                    text\n                  }\n                }\n                slug {\n                  flatData {\n                    slug\n                    paisIdioma\n                  }\n                }\n                event,\n                displayText {\n                  flatData {\n                    code\n                    text\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }`),this.fetchRibbonById=e=>this.fetchService.cmsFetchGraphQL("GetRibbon","query GetRibbon($id: String!) {\n        findRibbonContent(id: $id) {\n          flatData {\n            countries {\n              flatData {\n                code\n                translatedName {\n                  flatData {\n                    code\n                    text\n                  }\n                }\n                marketCode\n                telephone\n                whatsapp\n                workingHours {\n                  flatData {\n                    text\n                  }\n                }\n                flag {\n                  url\n                  fileName\n                }\n              }\n            }\n            languages {\n              flatData {\n                code\n                translatedName\n              }\n            }\n            texts {\n              text {\n                flatData {\n                  title {\n                    flatData {\n                      code\n                      text\n                    }\n                  }\n                  slug {\n                    flatData {\n                      slug\n                      paisIdioma\n                    }\n                  }\n                  event,\n                  displayText {\n                    flatData {\n                      code\n                      text\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      ",{id:e}),this.fetchService=e}};kl=O([k(w.ContainerScoped),j("design:paramtypes",[te])],kl);let wl=class{constructor(e,t,a,o){this.getProps=e=>R(this,void 0,void 0,(function*(){var t,a,o,n;const i=yield this.languageService.fetchLanguageByCode(this.config.language),l=yield this.countryService.fetchCountryByCode(this.config.country),r=e?yield this.ribbonService.fetchRibbonById(e):(yield this.ribbonService.fetchRibbonDetail(null!==(a=null===(t=l[0])||void 0===t?void 0:t.id)&&void 0!==a?a:"",null!==(n=null===(o=i[0])||void 0===o?void 0:o.id)&&void 0!==n?n:""))[0],s=null==r?void 0:r.flatData;let d=[];s.texts.forEach((e=>{let t={ribbon:[]},a=[];e.text.forEach((e=>{let t={title:"",slug:null,event:void 0,display:null};t.title=e.flatData.title[0].flatData.text,t.slug=e.flatData.slug?e.flatData.slug[0].flatData.slug:null,t.event=e.flatData.event,t.display=e.flatData.displayText?e.flatData.displayText[0].flatData.text:null,a.push(t)})),t.ribbon=a,d.push(t)}));const c={ribbons:[]};return c.ribbons=d,c})),this.config=t,this.ribbonService=e,this.languageService=o,this.countryService=a}};wl=O([k(w.ContainerScoped),j("design:paramtypes",[kl,Q,oe,ne])],wl);let Cl=class{constructor(e){this.fetchNotitficationAdDetail=(e,t)=>this.fetchService.cmsFetchGraphQL("GetNotificationAds",`query GetNotificationAds {\n        queryNotificationAdsContents(\n          filter: "status eq 'Published' and data/countries/iv eq '${e}' and data/languages/iv eq '${t}'"\n          orderby: "created desc"\n        ) {\n          id\n          flatData {\n            geography\n            countries {\n              flatData {\n                code\n                translatedName {\n                  flatData {\n                    code\n                    text\n                  }\n                }\n                marketCode\n                telephone\n                workingHours {\n                  flatData {\n                    code\n                    text\n                  }\n                }\n              }\n            }\n            languages {\n              flatData {\n                code\n                translatedName\n              }\n            }\n            image {\n              url\n              fileName\n              tags\n            }\n            tracking\n            camperCampaignCode {\n              flatData {\n                code\n                name\n              }\n            }\n            slug {\n              flatData {\n                slug\n              }\n            }\n            texts {\n              textType {\n                flatData {\n                  code\n                  name\n                }\n              }\n              literal {\n                flatData {\n                  code\n                  text\n                }\n              }\n              upperCase\n              lowerCase\n              icon {\n                url\n                fileName\n                tags\n              }\n              font {\n                flatData {\n                  name\n                }\n              }\n              fontColor\n              fontSizeDesktop\n              fontSizeTablet\n              fontSizeMobile\n              cta\n              tracking\n              slug {\n                flatData {\n                  slug\n                }\n              }\n              script\n            }\n          }\n        }\n      }\n      `),this.fetchNotificationAdLanguagesById=e=>this.fetchService.cmsFetchGraphQL("GetNotificationAds","query GetNotificationAds($id: String!) {findNotificationAdsContent(id: $id) {id, flatData {languages {flatData {code,translatedName}}}}}",{id:e}),this.fetchNotificationAdById=e=>this.fetchService.cmsFetchGraphQL("GetNotificationAds","query GetNotificationAds($id: String!) {\n        findNotificationAdsContent(id: $id) {\n          id\n          flatData {\n            geography\n            countries {\n              flatData {\n                code\n                translatedName {\n                  flatData {\n                    code\n                    text\n                  }\n                }\n                marketCode\n                telephone\n                workingHours {\n                  flatData {\n                    code\n                    text\n                  }\n                }\n              }\n            }\n            languages {\n              flatData {\n                code\n                translatedName\n              }\n            }\n            image {\n              url\n              fileName\n              tags\n            }\n            tracking\n            camperCampaignCode {\n              flatData {\n                code\n                name\n              }\n            }\n            slug {\n              flatData {\n                slug\n              }\n            }\n            texts {\n              textType {\n                flatData {\n                  code\n                  name\n                }\n              }\n              literal {\n                flatData {\n                  code\n                  text\n                }\n              }\n              upperCase\n              lowerCase\n              icon {\n                url\n                fileName\n                tags\n              }\n              font {\n                flatData {\n                  name\n                }\n              }\n              fontColor\n              fontSizeDesktop\n              fontSizeTablet\n              fontSizeMobile\n              cta\n              tracking\n              slug {\n                flatData {\n                  slug\n                }\n              }\n              script\n            }\n          }\n        }\n      }\n      ",{id:e}),this.fetchService=e}};Cl=O([k(w.ContainerScoped),j("design:paramtypes",[te])],Cl);let Dl=class{constructor(e,t,a,o){this.getProps=(e,t,a)=>R(this,void 0,void 0,(function*(){var o,n,i,l,r;const s=yield this.languageService.fetchLanguageByCode(t||this.config.language),d=yield this.countryService.fetchCountryByCode(a||this.config.country),c=e?yield this.notificationAdService.fetchNotificationAdById(e):(yield this.notificationAdService.fetchNotitficationAdDetail(null!==(n=null===(o=d[0])||void 0===o?void 0:o.id)&&void 0!==n?n:"",null!==(l=null===(i=s[0])||void 0===i?void 0:i.id)&&void 0!==l?l:""))[0];if(null==c)return;const u=c.id,p=null==c?void 0:c.flatData,m=null===(r=p.texts)||void 0===r?void 0:r.map((e=>{var t,a,o;return{fontName:e.font?null===(t=e.font[0])||void 0===t?void 0:t.flatData.name:null,fontColor:e.fontColor,fontColorTablet:e.fontColorTablet,fontColorMobile:e.fontColorMobile,fontSizeDesktop:e.fontSizeDesktop,fontSizeTablet:e.fontSizeTablet,fontSizeMobile:e.fontSizeMobile,textType:null===(a=e.textType[0])||void 0===a?void 0:a.flatData.name,literal:e.literal&&e.literal.length>0?null===(o=e.literal[0])||void 0===o?void 0:o.flatData.text:null,upperCase:e.upperCase,lowerCase:e.lowerCase,marginTop:e.marginTop,marginTopMobile:e.marginTopMobile}})),f=null==m?void 0:m.find((e=>"Claim"===e.textType)),g=null==m?void 0:m.find((e=>"Subclaim"===e.textType)),h=null==m?void 0:m.find((e=>"CTA"===e.textType.toLocaleUpperCase())),b=p.image;var x=be(a||this.config.country,t||this.config.language,this.config.urlBase,p.slug[0].flatData.slug,!1);return{claim:f,subclaim:g,cta:h,imageUrl:be(a||this.config.country,t||this.config.language,this.config.urlBase,Ce(b[0])),imageFileName:b[0].fileName,tracking:p.tracking,slug:x,language:t||this.config.language,country:a||this.config.country,id:u}})),this.config=t,this.notificationAdService=e,this.languageService=o,this.countryService=a}};Dl=O([k(w.ContainerScoped),j("design:paramtypes",[Cl,Q,oe,ne])],Dl);const Sl=e.div`
  width: 400px;
  height: 400px;
`,Tl=e.div`
  background-image: url(${e=>e.imageUrl});
  background-size: cover;
  height: 100%;
`,_l=e.div`
  box-sizing: border-box;
  padding: 50px;
  text-align: center;
  position: relative;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;let zl=class{constructor(e,t,a,o){this.getProps=e=>R(this,void 0,void 0,(function*(){var t,a,o,n;const i=yield this.languageService.fetchLanguageByCode(this.config.language),l=yield this.countryService.fetchCountryByCode(this.config.country),r=e?yield this.notificationAdService.fetchNotificationAdById(e):(yield this.notificationAdService.fetchNotitficationAdDetail(null!==(a=null===(t=l[0])||void 0===t?void 0:t.id)&&void 0!==a?a:"",null!==(n=null===(o=i[0])||void 0===o?void 0:o.id)&&void 0!==n?n:""))[0];if(null==r)return;const s=null==r?void 0:r.flatData,d=be(this.config.country,this.config.language,this.config.urlBase,"cms/api/assets/tiers-banners-homes/notificationad-"+r.id+"-"+this.config.language.toLocaleLowerCase()+".png");return{image:`<a href="${be(this.config.country,this.config.language,this.config.urlBase,s.slug[0].flatData.slug,!1)}" data-tracking="${s.tracking}">`+`<img src="${d}" id="img_${this.config.country}_${this.config.language}" alt="notificationad-${this.config.language.toLocaleLowerCase()}"></img>`+"</a>"}})),this.config=t,this.notificationAdService=e,this.languageService=o,this.countryService=a}};zl=O([k(w.ContainerScoped),j("design:paramtypes",[Cl,Q,oe,ne])],zl);let El=class{constructor(e){this.config=e,this.cmsAxios=v.create(),this.cmsAxios.interceptors.request.use((t=>(t.baseURL=e.urlBase+"/cms/",t.headers.authorization=`Bearer ${this.config.bearer}`,t.headers["X-languages"]=e.language,t.headers["X-Flatten"]="true",e.showUnpublishedContent&&(t.headers["X-unpublished"]=e.showUnpublishedContent),t)))}cmsInsertAsset(e){return R(this,void 0,void 0,(function*(){return yield this.cmsAxios.post(`${this.config.urlBase}/cms/api/apps/tiers-banners-homes/assets?parentId=${this.config.notificationadFolder}`,e,{headers:{"Content-Type":"multipart/form-data"}})}))}};El=O([k(w.ContainerScoped),j("design:paramtypes",[Q])],El);var Nl=Object.freeze({__proto__:null,get CMSServiceFetch(){return te},get CMSServiceNotificationAdFetch(){return El},Dialog:Ut,Footer:Tn,get FooterPropsService(){return Mn},get MetaPropsService(){return yl},NotificationAdComponent:function(e){var t,a,o,n,i,l,r,s,d,u,p,f,g,b,x,v,y,k,w,C,D,S,T,_,z,E,N,M,$,B,A,L,I,F,P,O;const j=h(null);return m((()=>{null!==(null==j?void 0:j.current)&&G(null==j?void 0:j.current,{cacheBust:!0}).then((t=>{const a=document.createElement("a");a.download=`${e.imageFileName}_${e.id}_${e.language}.png`,a.href=t,document.getElementById(`imgGenerated_${e.id}_${e.language}`).src=t,document.getElementById(`imgGenerated_${e.id}_${e.language}`).setAttribute("data-filename",`notificationAd_${e.id}_${e.language}.png`)})).catch((e=>{console.log(e)}))}),[j,e]),c.createElement(c.Fragment,null,c.createElement(Sl,{ref:j},c.createElement(Tl,Object.assign({},e),c.createElement(_l,null,c.createElement(Dt,{fontName:null===(t=e.claim)||void 0===t?void 0:t.fontName,fontColor:null===(a=e.claim)||void 0===a?void 0:a.fontColor,fontColorMobile:null===(o=e.claim)||void 0===o?void 0:o.fontColorMobile,fontColorTablet:null===(n=e.claim)||void 0===n?void 0:n.fontColorTablet,fontSizeDesktop:null===(i=e.claim)||void 0===i?void 0:i.fontSizeDesktop,fontSizeTablet:null===(l=e.claim)||void 0===l?void 0:l.fontSizeTablet,fontSizeMobile:null===(r=e.claim)||void 0===r?void 0:r.fontSizeMobile,upperCase:null===(s=e.claim)||void 0===s?void 0:s.upperCase,lowerCase:null===(d=e.claim)||void 0===d?void 0:d.lowerCase,marginTop:null===(u=e.claim)||void 0===u?void 0:u.marginTop,marginTopMobile:null===(p=e.claim)||void 0===p?void 0:p.marginTopMobile},null===(f=e.claim)||void 0===f?void 0:f.literal),c.createElement(Dt,{fontName:null===(g=e.subclaim)||void 0===g?void 0:g.fontName,fontColor:null===(b=e.subclaim)||void 0===b?void 0:b.fontColor,fontColorMobile:null===(x=e.subclaim)||void 0===x?void 0:x.fontColorMobile,fontColorTablet:null===(v=e.subclaim)||void 0===v?void 0:v.fontColorTablet,fontSizeDesktop:null===(y=e.subclaim)||void 0===y?void 0:y.fontSizeDesktop,fontSizeTablet:null===(k=e.subclaim)||void 0===k?void 0:k.fontSizeTablet,fontSizeMobile:null===(w=e.subclaim)||void 0===w?void 0:w.fontSizeMobile,upperCase:null===(C=e.subclaim)||void 0===C?void 0:C.upperCase,lowerCase:null===(D=e.subclaim)||void 0===D?void 0:D.lowerCase,marginTop:null===(S=e.subclaim)||void 0===S?void 0:S.marginTop,marginTopMobile:null===(T=e.subclaim)||void 0===T?void 0:T.marginTopMobile},null===(_=e.subclaim)||void 0===_?void 0:_.literal),c.createElement(Dt,{fontName:null===(z=e.cta)||void 0===z?void 0:z.fontName,fontColor:null===(E=e.cta)||void 0===E?void 0:E.fontColor,fontColorMobile:null===(N=e.cta)||void 0===N?void 0:N.fontColorMobile,fontColorTablet:null===(M=e.cta)||void 0===M?void 0:M.fontColorTablet,fontSizeDesktop:null===($=e.cta)||void 0===$?void 0:$.fontSizeDesktop,fontSizeTablet:null===(B=e.cta)||void 0===B?void 0:B.fontSizeTablet,fontSizeMobile:null===(A=e.cta)||void 0===A?void 0:A.fontSizeMobile,upperCase:null===(L=e.cta)||void 0===L?void 0:L.upperCase,lowerCase:null===(I=e.cta)||void 0===I?void 0:I.lowerCase,marginTop:null===(F=e.cta)||void 0===F?void 0:F.marginTop,marginTopMobile:null===(P=e.cta)||void 0===P?void 0:P.marginTopMobile,style:{position:"absolute",bottom:"50px",left:"50%",transform:"translateX(-50%)"}},null===(O=e.cta)||void 0===O?void 0:O.literal)))),c.createElement("a",{href:e.slug,"data-tracking":e.tracking},c.createElement("img",{src:"",id:`imgGenerated_${e.id}_${e.language}`,className:"imgGenerated"})),c.createElement("hr",null))},get NotificationAdService(){return Cl},get NotificationAdsImageService(){return zl},get NotificationAdsPropsService(){return Dl},Products:Xt,get RibbonPropsService(){return wl},Slider:ea,get TNMPropsService(){return pl},TierBannerComponent:e=>{const t=e.type,a=[{cta:!1,fontColor:"",fontSizeDesktop:1,fontSizeMobile:1,fontSizeTablet:1,font:[],literal:[],textType:[]}],o={components:e.components,name:e.name,blur:!0,bannerType:e.variant,campaign:[],texts:a,layoutMobile:e.layoutMobile};return c.createElement(Fo,{data:o,market:e.market,position:0,type:t})},get TierBannerPropsService(){return Ni},TierComponent:mi,get TierPropsService(){return ki},TnmComponent:al,TnmFooterComponent:Bi,initialSliderSettings:Zt,tnmTransformSquidexResponseToComponentProps:ul,transformSquidexResponseToComponentProps:yi});let Ml=class{constructor(e){this.fetchDataAuthor=e=>this.fetchService.cmsFetchGraphQL("GetAuthor","query GetAuthor($id:String!) { findAuthorContent(id:$id){ flatData { name avatar { url fileName tags metadata } instagram slug { flatData { slug } } } }}",{id:e}),this.fetchService=e}};Ml=O([k(w.ContainerScoped),j("design:paramtypes",[te])],Ml);let $l=class{constructor(e){this.authorService=e}getProps(e,t,a,o){return R(this,void 0,void 0,(function*(){try{const n=yield this.authorService.fetchDataAuthor(o);let i={name:n.flatData.name,instagram:n.flatData.instagram,url:n.flatData.slug[0].flatData.slug,datePublished:t,images:n.flatData.avatar.map((e=>Object.assign(Object.assign({},e),{url:e.url.concat(e.fileName),metadata:Object.assign(Object.assign({},e.metadata),{pixelWidth:60,pixelHeight:60})}))),text:a,articleBody:e.flatData.metaDescription,headline:e.flatData.pageTitle,imageArticle:e.flatData.relatedImage[0].url+e.flatData.relatedImage[0].fileName};try{return i}catch(e){throw console.error("Error obteniendo los datos del autor del posts"+JSON.stringify(i)+", error: "+e.toString()),e}}catch(e){throw console.error("Cant load author props of this ID: "+JSON.stringify({id:o})+", error: "+e.toString()),e}}))}};$l=O([k(w.ContainerScoped),j("design:paramtypes",[Ml])],$l);let Bl=class{constructor(e,t,a,o,n,i){this.config=o,this.languageService=a,this.countryService=t,this.dynamicLandingService=e,this.slugService=n,this.authorService=i}modifyRootComponent(e,t,a){var o;return R(this,void 0,void 0,(function*(){if(a.hasOwnProperty("name")&&"LatestPosts"===a.name&&a.args){const e=yield this.dynamicLandingService.fetchDynamicLandingsByTags(a.args.tags),t=[];for(const a of e){const e=yield this.dynamicLandingService.fetchMetasById(a.data.metas[0]),o=yield this.slugService.fetchSlugById(a.data.slug[0]);t.push({id:a.id,name:a.data.name,slug:o.flatData.slug,label:e.flatData.pageTitle,image:e.flatData.relatedImage,tags:a.data.tags||[]})}a.args.items=t,a.args.preview=!1}if(a.hasOwnProperty("name")&&"Author"===a.name&&a.args&&(a.args=yield this.authorService.getProps(e,t,null!==(o=a.args.text)&&void 0!==o?o:"",a.args.id),a.args.preview=!1),a.hasOwnProperty("children"))for(let o in a.children)yield this.modifyRootComponent(e,t,a.children[o]);return a.hasOwnProperty("args")&&(yield this.modifyRootComponent(e,t,a.args)),a}))}getProps(e,t){var a,o,n,i,l,r,s,d,c,u,p,m,f,g,h,b,x;return R(this,void 0,void 0,(function*(){if(!t&&!e)return null;const v=yield this.languageService.fetchLanguageByCode(this.config.language),y=yield this.countryService.fetchCountryByCode(this.config.country),k=e?yield this.slugService.fetchSlug(e,this.config.language):[],w=t?yield this.dynamicLandingService.fetchDynamicLandingById(t):(yield this.dynamicLandingService.fetchDynamicLandingDetail(null!==(o=null===(a=k[0])||void 0===a?void 0:a.id)&&void 0!==o?o:"",null!==(i=null===(n=y[0])||void 0===n?void 0:n.id)&&void 0!==i?i:"",null!==(r=null===(l=v[0])||void 0===l?void 0:l.id)&&void 0!==r?r:""))[0],C=yield this.dynamicLandingService.fetchSlug(null!==(c=(null!==(d=null===(s=w.data)||void 0===s?void 0:s.urlRedirect)&&void 0!==d?d:[""])[0])&&void 0!==c?c:""),D=yield this.dynamicLandingService.fetchMetasById(w.data.metas[0]);return{id:w.id,created:w.created,rootComponent:yield this.modifyRootComponent(D,w.data.datePublished,w.data.rootComponent),market:null===(p=null===(u=y[0])||void 0===u?void 0:u.flatData)||void 0===p?void 0:p.marketCode,redirect:null!==(f=null===(m=w.data)||void 0===m?void 0:m.redirect)&&void 0!==f&&f,url:C?null===(h=null===(g=C[0])||void 0===g?void 0:g.data)||void 0===h?void 0:h.slug:null,isPrivate:null!==(x=null===(b=w.data)||void 0===b?void 0:b.isPrivate)&&void 0!==x&&x}}))}};Bl=O([D(),j("design:paramtypes",[hl,oe,ne,Q,gl,$l])],Bl);const Al=e.div`
  width: 100%;
  height: 100%;

  &.banner-group--2 {
    display: flex;
    flex-wrap: wrap;

    > div {
      width: 100%;

      @media (min-width: 1024px) {
        width: 50%;
      }
    }
  }
`;function Ll({data:e,market:t,position:a,showI18nModal:o,slots:n}){return c.createElement(Al,{className:`banner-group--${e.banners.length}`},e.banners.map(((e,i)=>c.createElement(Fo,{key:`banner_group_${i}`,data:e.flatData,market:t,position:a+i,type:e.flatData.bannerType[0].flatData.name,showI18nModal:o,slots:n}))))}const Il=e.div`
  width: 100%;
  height: 100%;
  font-size: initial;
  font-family: initial;
  line-height: initial;
  font-feature-settings: initial;
  font-variant: initial;
`;function Fl({data:e,market:t,showI18nModal:a,slots:o}){const n=g((()=>{const t=[1];for(let a=1;a<(null==e?void 0:e.groups.length);a++)t.push(t[a-1]+e.groups[a-1].banners.length);return t}),[e]);return m((()=>{if(window&&"undefined"==typeof window)return;const e=window.location.href;$t(`script_home_${window.location.pathname}`,"scriptHome",e)}),[]),m((()=>{let e=ve("usrhash");if(""!==e){let t=document.getElementsByClassName("slugwithparameters");for(const a of t){let t=a.getAttribute("href");-1===(null==t?void 0:t.indexOf("&usrhash="))&&a.setAttribute("href",`${t}&usrhash=${e}`)}}}),[]),c.createElement(Il,null,null==e?void 0:e.groups.map(((e,i)=>c.createElement(Ll,{key:`home_group_${i}`,data:e,market:t,position:n[i],showI18nModal:a,slots:o}))))}let Gl=class{constructor(e,t,a,o){this.config=o,this.languageService=a,this.countryService=t,this.homeService=e}getProps(e,t){var a,o,n,i;return R(this,void 0,void 0,(function*(){const l=yield this.languageService.fetchLanguageByCode(this.config.language),r=yield this.countryService.fetchCountryByCode(this.config.country),s=t?yield this.homeService.fetchHomeById(t):bl(yield this.homeService.fetchHomeDetail(null!==(o=null===(a=r[0])||void 0===a?void 0:a.id)&&void 0!==o?o:"",null!==(i=null===(n=l[0])||void 0===n?void 0:n.id)&&void 0!==i?i:"",null!=e&&e));return{data:null==s?void 0:s.flatData,market:r[0].flatData.marketCode}}))}};Gl=O([k(w.ContainerScoped),j("design:paramtypes",[ml,oe,ne,Q])],Gl);var Pl=Object.freeze({__proto__:null,DynamicLanding:Sa,get DynamicLandingPropsService(){return Bl},HomeComponent:Fl,get HomePropsService(){return Gl}});export{Ht as ATOMS,Fo as Banner,ie as BannerPropsService,V as CMSConfig,Q as CMSConfiguration,K as CMSContainer,ee as CMSProvider,Da as DYNAMIC,Sa as DynamicLanding,Bl as DynamicLandingPropsService,X as EShopAxios,Tn as Footer,Mn as FooterPropsService,Fl as HomeComponent,Gl as HomePropsService,Y as IsArialLanguage,Vo as MOLECULES,Nl as ORGANISMS,Pl as PAGES,Uo as PdpDynamicComponent,Ho as PdpDynamicComponentPropsService,J as PublicEShopAxios,pl as TNMPropsService,mi as TierComponent,ki as TierPropsService,al as TnmComponent,W as defaultConfig};
//# sourceMappingURL=index.esm.js.map
